import { createNamedContext, isDefined, useStableCallback, hasUtilClass, ExpandMoreIcon, ChevronRightIcon, useForkedRef, scrollIntoView, MiniCloseIcon, CrossInCircleIcon, ExclamationIcon, CheckInCircleIcon, InfoIcon, CrossIcon, useId, useDefaultSvgProps, getDocumentDimensions, noop, callAll, createArray, forEach, isPrimitive, isSimilarArray, useSplitClass, isNil, formatDateUtc, isString, isFunction, dedupeArray, CalendarIcon, padStart, ClockIcon, ChevronUpIcon, padEnd, formatDate, formatDateRange, pickAndOmit, usePrevious, MinusIcon, CheckIcon, SearchIcon, getComputedStyle, MiniDescendingIcon, MiniAscendingIcon, MiniUnsortedIcon, FilterIcon, titleCase, ChevronDoubleRightIcon, MenuIcon, formatMoney, isEmptyObject, useForceUpdate, ToggleIcon, useImageDimensions, DocIcon, FilledStarIcon, StarIcon, PreviewIcon, ReloadIcon, TrashIcon, UploadIcon, formatFileSize, DotVerticalIcon, ZoomInIcon, useImageFileDimensions, DotHorizontalIcon, featureCheck, getId, ArrowLeftIcon, isNumber, useComposedRefs, useConstant, arrayMove, useRefs, MiniChevronDownIcon, HistoryIcon, useUpdateEffect, usePaginationState, isEmptyValue, useSortState, flattenArray, stringifyQueryString, createFillSlot } from '@setel/web-utils';
export { ArrowLeftIcon, BadgeIcon, BankIcon, BellIcon, BookIcon, BoxIcon, BusinessIcon, CalendarIcon, CameraIcon, CardIcon, CardsIcon, CartIcon, CheckIcon, CheckInCircleIcon, CheckInCircleOutlineIcon, ChevronDoubleRightIcon, ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, CircleIcon, ClockIcon, CogIcon, CompassIcon, ContactBookIcon, CookiesIcon, CreditCardIcon, CrossIcon, CrossInCircleIcon, DiamondIcon, DocIcon, DocumentIcon, DotHorizontalIcon, DotVerticalIcon, DownloadIcon, EditIcon, EngineIcon, ErrorIcon, ExclamationIcon, ExpandLessIcon, ExpandMoreIcon, ExternalIcon, EyeHideIcon, EyeShowIcon, FamilyIcon, FilledStarIcon, FilterIcon, FuelTankIcon, GasTankIcon, HeartIcon, HelpIcon, HistoryIcon, ImageIcon, InboxIcon, InfoIcon, InfoOutlineIcon, InviteIcon, LanguageIcon, LifebuoyIcon, LinkIcon, ListIcon, LocationIcon, LockIcon, LogoutIcon, LoudspeakerIcon, MailIcon, MapIcon, MembershipIcon, MenuIcon, MesraCardIcon, MessageIcon, MeterIcon, MiniAscendingIcon, MiniChevronDownIcon, MiniCloseIcon, MiniDescendingIcon, MiniUnsortedIcon, MinusIcon, MoreIcon, OrderIcon, PetronasGreenIcon, PetronasWhiteIcon, Phone1Icon, PlusIcon, PreviewIcon, PumpIcon, ReceiptIcon, ReloadIcon, ReplayIcon, RewardsIcon, ScanIcon, SearchIcon, SetelIcon, SettlementsIcon, ShareIcon, ShoppingBagIcon, SparklesIcon, SpinIcon, StarIcon, SyncIcon, TopupIcon, TransmissionIcon, TrashIcon, UploadIcon, UserCircleIcon, UserIcon, VehicleIcon, VerifiedIcon, VoidSalesIcon, VoucherIcon, WalletIcon, WarningIcon, ZoomInIcon, arrayMove, callAll, createAjaxOperation, createArray, createEventBus, createFillSlot, createNamedContext, createUploadFileOperation, dedupeArray, flattenArray, forEach, formatDate, formatDateRange, formatDateUtc, formatFileSize, formatMoney, getId, hasUtilClass, insertThousandSeparator, isBoolean, isDefined, isEmail, isEmptyObject, isEmptyValue, isFunction, isNil, isNumber, isPrimitive, isSimilarArray, isString, noop, omit, padEnd, padStart, parseQueryString, pick, pickAndOmit, scrollIntoView, splitClass, stringifyQueryString, throttle, titleCase, useAjaxOperations, useConstant, useDebounce, useFileUploads, useId, useInterval, useListState, useOtp, usePaginationState, useRefs, useSortState, useSplitClass, useStableCallback, useTransientState, withDefaultSvgProps } from '@setel/web-utils';
import { Disclosure, useDisclosureContext, DisclosurePanel, DisclosureButton } from '@reach/disclosure';
export { Disclosure, DisclosureButton, DisclosurePanel } from '@reach/disclosure';
import cx from 'classnames';
import { useState, useCallback, useEffect, useMemo, createElement, useContext, Fragment, forwardRef, useRef, isValidElement, cloneElement, Children, memo, useReducer, useLayoutEffect } from 'react';
import AnimateHeight from 'react-animate-height';
export { default as AnimateHeight } from 'react-animate-height';
import { Transition } from '@headlessui/react';
export { Transition } from '@headlessui/react';
import { matchSorter } from 'match-sorter';
export { matchSorter } from 'match-sorter';
import { SortableElement, SortableContainer, SortableHandle } from 'react-sortable-hoc';
export { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import ReachAlert from '@reach/alert';
import ReachPopover, { positionMatchWidth, getCollisions, positionRight } from '@reach/popover';
export { positionDefault, positionMatchWidth, positionRight } from '@reach/popover';
import { createDescendantContext, useDescendant, useDescendants, useDescendantsInit, DescendantProvider } from '@reach/descendants';
import Portal from '@reach/portal';
import { useTooltip, TooltipPopup } from '@reach/tooltip';
import { ListboxInput, ListboxButton, ListboxPopover, ListboxList, ListboxGroup, ListboxGroupLabel, ListboxOption } from '@reach/listbox';
import addMs from 'date-fns/addMilliseconds';
import endOfDay from 'date-fns/endOfDay';
import endOfYear from 'date-fns/endOfYear';
import startOfDay from 'date-fns/startOfDay';
import startOfYear from 'date-fns/startOfYear';
import subDays from 'date-fns/subDays';
import subMs from 'date-fns/subMilliseconds';
import subYears from 'date-fns/subYears';
import { tabbable } from 'tabbable';
import { DialogOverlay, DialogContent as DialogContent$1 } from '@reach/dialog';
import dayDiff from 'date-fns/differenceInCalendarDays';
import addMinutes from 'date-fns/addMinutes';
import isAfter from 'date-fns/isAfter';
import setDate from 'date-fns/set';
import ReactDayPicker, { DateUtils } from 'react-day-picker';
import isBefore from 'date-fns/isBefore';
import isFuture from 'date-fns/isFuture';
import isLastDayOfMonth from 'date-fns/isLastDayOfMonth';
import { useCombobox, useMultipleSelection, useSelect } from 'downshift';
import { useQueryClient, useQuery } from 'react-query';
import Highlighter from 'react-highlight-words';
import { useRifm } from 'rifm';
import endOfMonth from 'date-fns/endOfMonth';
import startOfMonth from 'date-fns/startOfMonth';
import { AlertDialogOverlay, AlertDialogContent, AlertDialogLabel, AlertDialogDescription } from '@reach/alert-dialog';
import { MenuItem, MenuPopover, MenuItems, Menu, MenuButton } from '@reach/menu-button';
import { MixedCheckbox } from '@reach/checkbox';
import TextareaAutosize from 'react-textarea-autosize';
import { useTabsContext, Tab as Tab$1, TabList as TabList$1, TabPanels, TabPanel, Tabs as Tabs$1, TabsKeyboardActivation } from '@reach/tabs';
import { useRect } from '@reach/rect';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var CardContext = /*#__PURE__*/createNamedContext('Card', {
  expandable: false,
  isInCard: false
});

var _excluded = ["loading", "isLoading", "render", "isOpen", "onToggleOpen", "expandable", "defaultIsOpen"];
/**
 * `<Card />` is used to create a visual section. It is usually used with `<CardHeading />` and `<CardContent />`.
 *
 * Other than the specified props, it also accepts all props that is accepted by `<div />` element.
 */

var Card = function Card(_ref) {
  var loading = _ref.loading,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? loading : _ref$isLoading,
      render = _ref.render,
      isOpenProp = _ref.isOpen,
      onToggleOpenProp = _ref.onToggleOpen,
      _ref$expandable = _ref.expandable,
      expandable = _ref$expandable === void 0 ? isDefined(isOpenProp) : _ref$expandable,
      _ref$defaultIsOpen = _ref.defaultIsOpen,
      defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = cx('pu-bg-white pu-overflow-hidden pu-shadow sm:pu-rounded-lg', isLoading && 'pu-animate-pulse', props.className);
  var isControlled = isDefined(isOpenProp);

  var _React$useState = useState(function () {
    return isControlled ? isOpenProp : defaultIsOpen;
  }),
      isOpen = _React$useState[0],
      setIsOpen = _React$useState[1];

  var onToggleOpenCb = useStableCallback(onToggleOpenProp);
  var onToggleOpen = useCallback(function () {
    if (isControlled) {
      onToggleOpenCb();
    } else {
      setIsOpen(function (o) {
        return !o;
      });
    }
  }, [onToggleOpenCb, isControlled]);
  useEffect(function () {
    // is the component is controlled, we will sync the state
    if (isControlled && isOpenProp !== isOpen) {
      setIsOpen(isOpenProp);
    }
  }, [isControlled, isOpenProp, isOpen]);
  var contextValue = useMemo(function () {
    return {
      expandable: expandable,
      isInCard: true
    };
  }, [expandable]);
  var children = render ? render({
    className: classes,
    children: props.children
  }) : createElement("div", Object.assign({}, props, {
    className: classes
  }));
  return expandable ? createElement(Disclosure, {
    open: isOpen,
    onChange: onToggleOpen
  }, createElement(CardContext.Provider, {
    value: contextValue
  }, children)) : children;
};

var CardCollapsible = function CardCollapsible(_ref) {
  var children = _ref.children;
  var cardContext = useContext(CardContext);
  var disclosure = useDisclosureContext();
  return cardContext.expandable ? createElement(AnimateHeight, {
    height: disclosure.open ? 'auto' : 0,
    easing: "ease-in-out"
  }, createElement(DisclosurePanel, {
    className: "pu-block focus:pu-outline-none focus-visible:pu-shadow-outline-gray pu-border-t pu-border-gray-200"
  }, children)) : createElement(Fragment, null, children);
};

var _excluded$1 = ["className"];
var CardContent = function CardContent(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var children = createElement("div", Object.assign({
    className: cx(!hasUtilClass(className, 'pu-p[x|y]?-') && 'pu-px-4 pu-py-5 sm:pu-px-7', className)
  }, props));
  return createElement(CardCollapsible, null, children);
};

var _excluded$2 = ["type", "render"];
var IconButton = /*#__PURE__*/forwardRef(function IconButton(_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      render = _ref.render,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var className = cx('pu-inline-flex pu-justify-center pu-items-center pu-rounded-full pu-transform', !hasUtilClass(buttonProps.className, 'pu-p-') && 'pu-p-1.5', !hasUtilClass(buttonProps.className, 'focus:pu-') && 'focus-visible-ring', !hasUtilClass(buttonProps.className, 'active:pu-') && !buttonProps.disabled && 'active:pu-translate-y-px', buttonProps.disabled && 'pu-cursor-default', buttonProps.className);

  if (render) {
    return render({
      className: className,
      children: buttonProps.children
    });
  }

  return createElement("button", Object.assign({
    type: type
  }, buttonProps, {
    className: className,
    ref: ref
  }));
});

var _excluded$3 = ["children"],
    _excluded2 = ["className", "title", "children", "borderBottom"];
var CardHeading = function CardHeading(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var context = useContext(CardContext);
  var disclosure = useDisclosureContext();
  return createElement(CardHeadingImpl, Object.assign({}, props, {
    borderBottom: !context.expandable
  }), children, context.expandable && createElement(DisclosureButton, {
    as: IconButton,
    className: "pu-ml-2 active:pu-translate-y-0",
    "aria-label": disclosure.open ? 'Collapse' : 'Expand'
  }, createElement(ExpandMoreIcon, {
    className: cx('pu-w-6 pu-h-6 pu-text-gray-400 pu-transform pu-transition-transform pu-duration-200', disclosure.open ? 'pu-rotate-180' : 'pu-rotate-0')
  })));
};

var CardHeadingImpl = function CardHeadingImpl(_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      children = _ref2.children,
      borderBottom = _ref2.borderBottom,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return createElement("div", Object.assign({
    className: cx('pu-px-4 pu-py-4 sm:pu-px-7', borderBottom && 'pu-border-b pu-border-gray-200', className)
  }, props), createElement("div", {
    className: "pu-flex pu-items-center pu-justify-between pu-flex-wrap sm:pu-flex-no-wrap"
  }, createElement("div", {
    className: "pu-text-xl pu-leading-6 pu-pr-2 pu-py-2 pu-font-medium pu-text-gray-900"
  }, title), children && createElement("div", {
    className: "pu-flex pu-items-center"
  }, children)));
};

var _excluded$4 = ["variant", "description", "dismissable", "feature", "accentBorder", "children", "type", "leftIcon", "action", "scrollIntoView"];
/**
 * `<Alert />` shows message that user should be aware of.
 *
 * Screen-reader-friendly ♿
 */

var Alert = /*#__PURE__*/forwardRef(function Alert(_ref, forwardedRef) {
  var variant = _ref.variant,
      description = _ref.description,
      dismissable = _ref.dismissable,
      _ref$feature = _ref.feature,
      feature = _ref$feature === void 0 ? dismissable ? 'dismissable' : undefined : _ref$feature,
      accentBorder = _ref.accentBorder,
      children = _ref.children,
      type = _ref.type,
      _ref$leftIcon = _ref.leftIcon,
      leftIcon = _ref$leftIcon === void 0 ? iconByVariant[variant] : _ref$leftIcon,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? feature === 'button' ? createElement("div", {
    className: buttonByVariant[variant]
  }, createElement(ChevronRightIcon, {
    className: "pu-w-4 pu-pu-h-4"
  })) : undefined : _ref$action,
      shouldScrollIntoView = _ref.scrollIntoView,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  var _React$useState = useState(false),
      isDimissed = _React$useState[0],
      setIsDimissed = _React$useState[1];

  var selfRef = useRef(null);
  var mergedRef = useForkedRef(selfRef, forwardedRef);
  useEffect(function () {
    if (shouldScrollIntoView) {
      if (selfRef.current) {
        scrollIntoView(selfRef.current, {
          scrollMode: 'if-needed',
          behavior: 'smooth'
        });
      }
    }
  }, [shouldScrollIntoView]);

  if (isDimissed) {
    return null;
  }

  var Icon = leftIcon;
  var content = createElement(Fragment, null, Icon && createElement("div", {
    className: "pu-flex-shrink-0 pu-pt-0.25 pu-mr-3"
  }, createElement(Icon, {
    className: cx('pu-h-4 pu-w-4 pu-block', iconColorByVariant[variant])
  })), createElement("div", {
    className: "pu-text-left"
  }, description && createElement("h3", {
    className: cx('pu-text-sm pu-leading-5 pu-align-middle', textByVariant[variant])
  }, description), children && createElement("div", {
    className: cx('pu-mt-2 pu-text-sm pu-leading-5 pu-font-light', textByVariant[variant])
  }, children)), feature === 'dismissable' ? createElement("div", {
    className: "pu-ml-auto pu-pl-3"
  }, createElement("div", {
    className: "pu--mx-1.5 pu--my-1"
  }, createElement("button", {
    onClick: function onClick() {
      return setIsDimissed(true);
    },
    className: cx('pu-inline-flex pu-rounded-md pu-p-1.5 focus:pu-outline-none focus-visible:pu-ring-1 pu-transition pu-ease-in-out pu-duration-150', buttonByVariant[variant], btnRingByVariant[variant]),
    "aria-label": "Dismiss",
    type: "button"
  }, createElement(MiniCloseIcon, {
    className: "pu-h-4 pu-w-4"
  })))) : action ? createElement("div", {
    className: "pu-ml-auto pu-pl-3"
  }, createElement("div", {
    className: "pu--mx-1.5 pu--my-1.5"
  }, action)) : null);
  var isButton = feature === 'button';
  var containerClass = cx('pu-rounded-md pu-px-4 pu-py-3', bgByVariant[variant], accentBorder && ['pu-border-l-4', borderColorByVariant[variant]]);
  return createElement(ReachAlert, Object.assign({}, props, {
    type: type,
    className: cx(!isButton && containerClass, props.className),
    ref: mergedRef
  }), feature === 'button' ? createElement("button", {
    className: cx('pu-flex pu-items-center pu-w-full focus:pu-outline-none focus-visible:pu-ring-1', btnRingByVariant[variant], containerClass),
    type: "button"
  }, content) : createElement("div", {
    className: "pu-flex"
  }, content));
});
var bgByVariant = {
  error: 'pu-bg-error-100',
  warning: 'pu-bg-warning-100',
  success: 'pu-bg-success-100',
  info: 'pu-bg-info-100'
};
var btnRingByVariant = {
  error: 'focus-visible:pu-ring-error-500',
  warning: 'focus-visible:pu-ring-warning-500',
  success: 'focus-visible:pu-ring-success-500',
  info: 'focus-visible:pu-ring-info-500'
};
var textByVariant = {
  error: 'pu-text-error-500',
  warning: 'pu-text-warning-700',
  success: 'pu-text-success-700',
  info: 'pu-text-info-500'
};
var iconColorByVariant = {
  error: 'pu-text-error-500',
  warning: 'pu-text-warning-500',
  success: 'pu-text-success-500',
  info: 'pu-text-info-500'
};
var borderColorByVariant = {
  error: 'pu-border-error-500',
  warning: 'pu-border-warning-500',
  success: 'pu-border-success-500',
  info: 'pu-border-info-500'
};
var buttonByVariant = {
  error: 'pu-text-error-500',
  warning: 'pu-text-warning-500',
  success: 'pu-text-success-500',
  info: 'pu-text-info-500'
};
var iconByVariant = {
  error: CrossInCircleIcon,
  warning: ExclamationIcon,
  success: CheckInCircleIcon,
  info: InfoIcon
};

var _excluded$5 = ["messages"];
/**
 * Used as children of `Alert` component to render a list of messages
 */

var AlertMessages = function AlertMessages(_ref) {
  var messages = _ref.messages,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  if (!messages.length) {
    return null;
  }

  return createElement("ul", Object.assign({}, props, {
    className: cx('pu-list-disc pu-pl-5', props.className)
  }), messages.filter(Boolean).map(function (msg, index) {
    return createElement("li", {
      className: cx(index !== 0 && 'pu-mt-1'),
      key: index
    }, msg);
  }));
};

var FilterContext = /*#__PURE__*/createNamedContext('FilterContext', false);

var _excluded$6 = ["size", "color", "rounded", "children", "onDismiss", "className", "weight", "compact"];
var Badge = /*#__PURE__*/forwardRef(function Badge(_ref, ref) {
  var size = _ref.size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'grey' : _ref$color,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? 'rounded' : _ref$rounded,
      children = _ref.children,
      onDismiss = _ref.onDismiss,
      className = _ref.className,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? rounded === 'rounded' ? 'bold' : 'normal' : _ref$weight,
      compact = _ref.compact,
      spanProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  var isInFilter = useContext(FilterContext);
  var appliedSize = isDefined(size) ? size : isInFilter ? 'large' : 'small';
  return createElement("span", Object.assign({}, spanProps, {
    className: cx('pu-inline-flex pu-items-center focus:pu-outline-none focus-visible:pu-ring focus-visible:pu-ring-opacity-50', !compact && 'pu-tracking-1', weight === 'bold' ? 'pu-font-bold' : 'pu-font-normal', rounded === 'full' ? 'pu-rounded-full' : 'pu-rounded', wrapperClassByColor[color], rounded === 'full' ? wrapperClassBySize[appliedSize] : roundedWrapperClassBySize[appliedSize], className),
    ref: ref
  }), children, onDismiss && createElement("button", {
    onClick: onDismiss,
    type: "button",
    className: cx('pu-flex-shrink-0 pu-ml-1.5 pu-inline-flex focus:pu-outline-none focus-visible:pu-ring focus-visible:pu-ring-opacity-50', btnClassByColor[color])
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Dismiss"), createElement(CrossIcon, {
    className: iconClassBySize[appliedSize]
  })));
});
var wrapperClassBySize = {
  small: 'pu-px-2.5 pu-py-0.5 pu-text-xs pu-leading-4',
  large: 'pu-px-3 pu-py-1 pu-text-sm pu-leading-5'
};
var roundedWrapperClassBySize = {
  small: 'pu-px-2 pu-py-1 pu-text-xs pu-leading-4',
  large: 'pu-px-2 pu-py-1 pu-text-sm'
};
var wrapperClassByColor = {
  turquoise: 'pu-bg-turquoise-100 pu-text-turquoise-800 focus-visible:pu-ring-teal-400',
  purple: 'pu-bg-purple-100 pu-text-purple-800 focus-visible:pu-ring-indigo-400',
  lemon: 'pu-bg-lemon-100 pu-text-lemon-800 focus-visible:pu-ring-orange-400',
  success: 'pu-bg-success-100 pu-text-success-700 focus-visible:pu-ring-green-400',
  info: 'pu-bg-info-100 pu-text-info-500 focus-visible:pu-ring-orange-400',
  warning: 'pu-bg-yellow-100 pu-text-warning-500 focus-visible:pu-ring-orange-400',
  error: 'pu-bg-red-100 pu-text-error-500 focus-visible:pu-ring-orange-400',
  grey: 'pu-bg-offwhite pu-text-mediumgrey focus-visible:pu-ring-gray-400',
  blue: 'pu-bg-blue-100 pu-text-blue-800 focus-visible:pu-ring-blue-400',
  offwhite: 'pu-bg-offwhite pu-text-mediumgrey focus-visible:pu-ring-gray-400'
};
var btnClassByColor = {
  turquoise: 'pu-text-turquoise-500 focus:pu-text-turquoise-700 focus-visible:pu-ring-teal-400',
  purple: 'pu-text-purple-500 focus:pu-text-purple-700 focus-visible:pu-ring-indigo-400',
  lemon: 'pu-text-lemon-500 focus:pu-text-lemon-700 focus-visible:pu-ring-orange-400',
  success: 'pu-text-success-500 focus:pu-text-success-700 focus-visible:pu-ring-green-400',
  info: 'pu-text-info-500 focus:pu-text-info-700 focus-visible:pu-ring-orange-400',
  warning: 'pu-text-warning-500 focus:pu-text-warning-700 focus-visible:pu-ring-orange-400',
  error: 'pu-text-error-500 focus:pu-text-error-700 focus-visible:pu-ring-orange-400',
  blue: 'pu-text-blue-500 focus:pu-text-blue-800 focus-visible:pu-ring-blue-400',
  grey: 'pu-text-mediumgrey focus:pu-text-darkgrey focus-visible:pu-ring-gray-400',
  offwhite: 'pu-text-mediumgrey focus:pu-text-darkgrey focus-visible:pu-ring-gray-400'
};
var iconClassBySize = {
  small: 'pu-h-2 pu-w-2',
  large: 'pu-h-3 pu-w-3'
};

/**
 * `<BareButton />` is meant to wrap text that act as a button with minimal styling.
 *
 * It accept same props as `button` element.
 */

var BareButton = /*#__PURE__*/forwardRef(function BareButton(props, ref) {
  var className = cx('pu-text-xs pu-font-bold pu-tracking-1 focus-visible-ring disabled:pu-text-gray-300', props.disabled && 'pu-cursor-default', props.className);

  if (props.render) {
    return props.render({
      className: className,
      children: props.children
    });
  }

  return createElement("button", Object.assign({
    type: "button"
  }, props, {
    className: className,
    ref: ref
  }));
});

var PortalAccountsIcons = /*#__PURE__*/forwardRef(function PortalAccountsIcons(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "-1",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 -1H0V23H24V-1Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M19.2676 6.01172H20.7441V16.4883H19.2676V6.01172ZM16.2441 16.4883V6.01172H17.7559V16.4883H16.2441ZM13.9941 6.01172C14.2051 6.01172 14.3809 6.08203 14.5215 6.22266C14.6855 6.36328 14.7676 6.53906 14.7676 6.75V15.75C14.7676 15.9609 14.6855 16.1367 14.5215 16.2773C14.3809 16.418 14.2051 16.4883 13.9941 16.4883H4.99414C4.80664 16.4883 4.63086 16.418 4.4668 16.2773C4.32617 16.1367 4.25586 15.9609 4.25586 15.75V6.75C4.25586 6.53906 4.32617 6.36328 4.4668 6.22266C4.63086 6.08203 4.80664 6.01172 4.99414 6.01172H13.9941ZM10.6895 8.54297C10.3613 8.21484 9.96289 8.05078 9.49414 8.05078C9.02539 8.05078 8.62695 8.21484 8.29883 8.54297C7.9707 8.87109 7.80664 9.26953 7.80664 9.73828C7.80664 10.207 7.9707 10.6055 8.29883 10.9336C8.62695 11.2617 9.02539 11.4258 9.49414 11.4258C9.96289 11.4258 10.3613 11.2617 10.6895 10.9336C11.0176 10.6055 11.1816 10.207 11.1816 9.73828C11.1816 9.26953 11.0176 8.87109 10.6895 8.54297ZM12.8691 15.0117V14.4492C12.8691 13.9336 12.4824 13.5234 11.709 13.2188C10.9355 12.9141 10.1973 12.7617 9.49414 12.7617C8.79102 12.7617 8.05273 12.9141 7.2793 13.2188C6.50586 13.5234 6.11914 13.9336 6.11914 14.4492V15.0117H12.8691Z",
    fill: "currentColor"
  }))), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "24",
    height: "24",
    fill: "currentColor"
  }))));
});

var PortalAcquirersIcon = /*#__PURE__*/forwardRef(function PortalAcquirersIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M4 5.77778V18.2222C4 19.2 4.8 20 5.77778 20H18.2222C19.2 20 20 19.2 20 18.2222V5.77778C20 4.8 19.2 4 18.2222 4H5.77778C4.8 4 4 4.8 4 5.77778ZM14.6667 9.33333C14.6667 10.8444 13.5111 12 12 12C10.4889 12 9.33333 10.8444 9.33333 9.33333C9.33333 7.82222 10.4889 6.66667 12 6.66667C13.5111 6.66667 14.6667 7.82222 14.6667 9.33333ZM6.66667 16.4444C6.66667 14.6667 10.2222 13.6889 12 13.6889C13.7778 13.6889 17.3333 14.6667 17.3333 16.4444V17.3333H6.66667V16.4444Z",
    fill: "currentColor"
  }));
});

var PortalApiIcon = /*#__PURE__*/forwardRef(function PortalApiIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M20 7.78125V5.4375C20 4.66209 19.3692 4.03125 18.5938 4.03125H5.40625C4.63084 4.03125 4 4.66209 4 5.4375V7.78125H20ZM14.8125 5.90625H17.625C17.8839 5.90625 18.0938 6.11613 18.0938 6.375C18.0938 6.63387 17.8839 6.84375 17.625 6.84375H14.8125C14.5536 6.84375 14.3438 6.63387 14.3438 6.375C14.3438 6.11613 14.5536 5.90625 14.8125 5.90625ZM10.125 5.90625C10.3839 5.90625 10.5938 6.11613 10.5938 6.375C10.5938 6.63387 10.3839 6.84375 10.125 6.84375C9.86613 6.84375 9.65625 6.63387 9.65625 6.375C9.65625 6.11613 9.86613 5.90625 10.125 5.90625ZM8.25 5.90625C8.50887 5.90625 8.71875 6.11613 8.71875 6.375C8.71875 6.63387 8.50887 6.84375 8.25 6.84375C7.99113 6.84375 7.78125 6.63387 7.78125 6.375C7.78125 6.11613 7.99113 5.90625 8.25 5.90625ZM6.375 5.90625C6.63387 5.90625 6.84375 6.11613 6.84375 6.375C6.84375 6.63387 6.63387 6.84375 6.375 6.84375C6.11613 6.84375 5.90625 6.63387 5.90625 6.375C5.90625 6.11613 6.11613 5.90625 6.375 5.90625Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M4 8.71875V18.5625C4 19.3379 4.63084 19.9688 5.40625 19.9688H18.5938C19.3692 19.9688 20 19.3379 20 18.5625V8.71875H4ZM9.48031 15.384C9.6825 15.5457 9.71525 15.8407 9.55353 16.0428C9.39184 16.2449 9.09681 16.2778 8.89469 16.116L6.55094 14.241C6.31659 14.0536 6.31644 13.6965 6.55094 13.5089L8.89469 11.6339C9.09675 11.4722 9.39178 11.505 9.55353 11.7071C9.71525 11.9093 9.6825 12.2043 9.48031 12.366L7.59413 13.875L9.48031 15.384ZM13.8371 10.7784L11.0246 17.3409C10.9226 17.5788 10.6471 17.6891 10.4091 17.5871C10.1712 17.4851 10.0609 17.2095 10.1629 16.9716L12.9754 10.4091C13.0774 10.1712 13.353 10.0609 13.5909 10.1629C13.8288 10.2649 13.9391 10.5404 13.8371 10.7784ZM17.4491 14.241L15.1053 16.116C14.9035 16.2775 14.6084 16.2453 14.4465 16.0428C14.2847 15.8407 14.3175 15.5457 14.5197 15.384L16.4059 13.875L14.5197 12.366C14.3175 12.2043 14.2847 11.9093 14.4465 11.7072C14.6082 11.505 14.9032 11.4722 15.1053 11.634L17.4491 13.509C17.6834 13.6964 17.6836 14.0535 17.4491 14.241Z",
    fill: "currentColor"
  }));
});

var PortalAttributionIcon = /*#__PURE__*/forwardRef(function PortalAttributionIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M18.2608 15.8954V14.2609C18.2608 13.3978 17.5587 12.6957 16.6956 12.6957H12.5217V11.2627C14.2887 11.0082 15.6521 9.48841 15.6521 7.65219C15.6521 5.63841 14.0138 4 11.9999 4C9.98602 4 8.34773 5.63841 8.34773 7.65219C8.34773 9.48841 9.71117 11.0082 11.4782 11.2627V12.6957H7.30427C6.44117 12.6957 5.73905 13.3978 5.73905 14.2609V15.8954C4.84052 16.128 4.17383 16.9427 4.17383 17.913C4.17383 19.0639 5.10998 20 6.2608 20C7.41161 20 8.34776 19.0639 8.34776 17.913C8.34776 16.9427 7.68108 16.128 6.78255 15.8954V14.2609C6.78255 13.9732 7.01661 13.7391 7.3043 13.7391H11.4782V15.8947C10.5795 16.1273 9.91298 16.9427 9.91298 17.9131C9.91295 19.0639 10.8491 20 11.9999 20C13.1507 20 14.0869 19.0639 14.0869 17.913C14.0869 16.9426 13.4204 16.1273 12.5217 15.8947V13.7391H16.6956C16.9833 13.7391 17.2173 13.9732 17.2173 14.2608V15.8953C16.3188 16.128 15.6521 16.9427 15.6521 17.913C15.6521 19.0638 16.5882 20 17.7391 20C18.8899 20 19.826 19.0638 19.826 17.913C19.826 16.9427 19.1593 16.128 18.2608 15.8954Z",
    fill: "currentColor"
  }));
});

var PortalBadgeCampaignsIcon = /*#__PURE__*/forwardRef(function PortalBadgeCampaignsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M8.49023 19.5383C8.49023 19.6949 8.56958 19.8407 8.70129 19.926C8.83276 20.0108 8.99829 20.0235 9.14136 19.9592L10.3364 19.4214V17.026C9.69055 16.8678 9.06934 16.6187 8.49023 16.2832V19.5383Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.2598 17.1892V19.0061L12.0289 18.6599L12.7982 19.0061V17.1892C12.5437 17.2169 12.2871 17.2307 12.0289 17.2307C11.7708 17.2307 11.5142 17.2169 11.2598 17.1892Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.7207 19.4214L14.9158 19.9592C14.9765 19.9863 15.041 19.9998 15.1054 19.9998C15.193 19.9998 15.2802 19.9749 15.3558 19.926C15.4876 19.8407 15.5669 19.6949 15.5669 19.5383V16.283C14.9878 16.6187 14.3666 16.8678 13.7207 17.026V19.4214Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M18.1826 10.1538C18.1826 6.76062 15.422 4 12.0288 4C8.63562 4 5.875 6.76062 5.875 10.1538C5.875 12.171 6.84827 14.0341 8.49036 15.1882V15.1889C8.49939 15.1952 8.50867 15.2014 8.5177 15.2077C8.53223 15.2178 8.54676 15.2278 8.5614 15.2377C8.60486 15.2675 8.64868 15.2968 8.69312 15.3254C8.69605 15.3274 8.69898 15.3294 8.70203 15.3313C8.76538 15.3722 8.82935 15.4116 8.89392 15.4501C8.89807 15.4525 8.90222 15.4548 8.90637 15.4573C8.93433 15.4738 8.96228 15.49 8.99036 15.506C8.99842 15.5106 9.00659 15.515 9.01477 15.5197C9.03894 15.5333 9.06324 15.5469 9.08765 15.5602C9.09766 15.5657 9.10767 15.5709 9.1178 15.5763C9.14051 15.5885 9.16333 15.6008 9.18616 15.6128C9.19678 15.6183 9.20728 15.6235 9.2179 15.629C9.24048 15.6406 9.26294 15.6522 9.28565 15.6635C9.29639 15.6688 9.30713 15.674 9.318 15.6793C9.34058 15.6904 9.36328 15.7015 9.38611 15.7124C9.39673 15.7174 9.40735 15.7223 9.41785 15.7273C9.44104 15.7382 9.46424 15.749 9.48755 15.7597C9.49768 15.7642 9.50769 15.7686 9.5177 15.7731C9.54187 15.7838 9.56604 15.7946 9.59021 15.8051C9.59937 15.8091 9.60865 15.8129 9.6178 15.8168C9.64319 15.8275 9.66846 15.8383 9.69397 15.8486C9.70203 15.8521 9.71021 15.8552 9.71839 15.8585C9.74512 15.8694 9.77185 15.8801 9.79883 15.8906C9.80555 15.8932 9.81238 15.8958 9.81922 15.8984C9.84766 15.9093 9.8761 15.9202 9.90479 15.9307C9.91004 15.9326 9.91541 15.9345 9.92078 15.9364C9.95105 15.9474 9.98133 15.9583 10.0117 15.9689C10.0155 15.9701 10.0192 15.9713 10.0228 15.9727C10.0552 15.9838 10.0875 15.9946 10.12 16.0051C10.1218 16.0057 10.1235 16.0064 10.1254 16.007C10.23 16.0409 10.3356 16.072 10.4419 16.1004C10.448 16.1021 10.4542 16.1036 10.4603 16.1052C10.4883 16.1126 10.5164 16.1198 10.5444 16.1267C10.557 16.1299 10.5696 16.1329 10.5822 16.136C10.6039 16.1412 10.6256 16.1463 10.6473 16.1513C10.6647 16.1553 10.6821 16.1593 10.6996 16.1631C10.7163 16.1669 10.7333 16.1704 10.75 16.174C10.7716 16.1785 10.7931 16.1831 10.8147 16.1874C10.8269 16.1898 10.8392 16.1921 10.8514 16.1946C10.877 16.1995 10.9026 16.2045 10.9282 16.2091C10.9353 16.2103 10.9424 16.2116 10.9493 16.2128C11.0523 16.2311 11.1558 16.247 11.2598 16.2599C11.2662 16.2608 11.273 16.2612 11.2795 16.2621C11.3284 16.268 11.3773 16.2733 11.4263 16.2781C11.4386 16.2793 11.4509 16.2805 11.4634 16.2816C11.5167 16.2866 11.5702 16.2907 11.6238 16.2942C11.6361 16.2949 11.6483 16.2957 11.6606 16.2964C11.7155 16.2997 11.7704 16.3024 11.8254 16.3041C11.8346 16.3045 11.8439 16.3046 11.8532 16.3048C11.9116 16.3065 11.9702 16.3075 12.0291 16.3075C12.0878 16.3075 12.1464 16.3065 12.2048 16.3048C12.2141 16.3046 12.2234 16.3045 12.2325 16.3041C12.2876 16.3024 12.3425 16.2997 12.3973 16.2964C12.4097 16.2957 12.4219 16.2949 12.4342 16.2942C12.4878 16.2907 12.5413 16.2866 12.5946 16.2816C12.6071 16.2805 12.6194 16.2793 12.6317 16.2781C12.6807 16.2732 12.7296 16.268 12.7786 16.2621C12.785 16.2612 12.7918 16.2608 12.7983 16.2599C12.9021 16.247 13.0054 16.2311 13.1082 16.2129C13.1154 16.2116 13.1227 16.2103 13.1299 16.2091C13.1553 16.2045 13.1807 16.1996 13.2059 16.1946C13.2185 16.1921 13.2311 16.1898 13.2435 16.1874C13.2648 16.1831 13.286 16.1786 13.3073 16.1741C13.3245 16.1704 13.3417 16.1669 13.3588 16.1631C13.376 16.1593 13.393 16.1554 13.41 16.1515C13.4321 16.1464 13.4542 16.1412 13.4763 16.1359C13.4885 16.1329 13.5007 16.1299 13.5129 16.1268C13.5415 16.1198 13.57 16.1126 13.5984 16.1051C13.6041 16.1035 13.6097 16.1021 13.6155 16.1006C13.7225 16.072 13.8287 16.0407 13.934 16.0065C13.9351 16.0061 13.9362 16.0059 13.9371 16.0055C13.9705 15.9946 14.0035 15.9835 14.0366 15.9721L14.0454 15.9691C14.0767 15.9583 14.1079 15.9472 14.139 15.9358C14.1434 15.9341 14.1478 15.9326 14.1524 15.9309C14.1819 15.9201 14.2114 15.9089 14.2409 15.8976C14.2466 15.8954 14.2524 15.8932 14.2582 15.891C14.2861 15.8801 14.314 15.869 14.3418 15.8577C14.3489 15.8547 14.3561 15.8519 14.3632 15.849C14.3898 15.8381 14.4163 15.8269 14.4428 15.8157C14.4507 15.8123 14.4587 15.8088 14.4668 15.8054C14.4924 15.7943 14.518 15.7831 14.5433 15.7716C14.552 15.7677 14.5607 15.7639 14.5693 15.76C14.5942 15.7488 14.6189 15.7372 14.6437 15.7256C14.6527 15.7213 14.6619 15.7172 14.6709 15.7128C14.6953 15.7012 14.7196 15.6893 14.7438 15.6774C14.7529 15.6729 14.7622 15.6685 14.7715 15.6638C14.7958 15.6517 14.8198 15.6393 14.844 15.627C14.853 15.6223 14.8621 15.6178 14.871 15.613C14.8958 15.6002 14.9203 15.587 14.9448 15.5737C14.953 15.5693 14.9613 15.5651 14.9695 15.5606C14.9962 15.546 15.0227 15.5311 15.0492 15.5162C15.0551 15.5129 15.061 15.5097 15.0669 15.5064C15.0978 15.4888 15.1284 15.471 15.1591 15.4528C15.1605 15.4519 15.1619 15.4512 15.1633 15.4503C15.2282 15.4119 15.2922 15.3723 15.3557 15.3314C15.3588 15.3295 15.3617 15.3274 15.3648 15.3253C15.4092 15.2968 15.453 15.2673 15.4965 15.2377C15.511 15.2278 15.5254 15.2178 15.5398 15.2079C15.549 15.2015 15.5582 15.1952 15.5674 15.1889V15.1882C17.2095 14.0339 18.1826 12.171 18.1826 10.1538ZM15.5817 9.75892L14.1401 11.1642L14.4805 13.1484C14.5101 13.3215 14.439 13.4966 14.2968 13.5999C14.2164 13.6582 14.1212 13.688 14.0255 13.688C13.952 13.688 13.8783 13.6704 13.8108 13.6349L12.0288 12.6981L10.2468 13.6349C10.0914 13.7167 9.90296 13.7031 9.76075 13.5999C9.61866 13.4966 9.54749 13.3215 9.57715 13.1484L9.91748 11.1642L8.47595 9.75892C8.3501 9.63636 8.30481 9.45289 8.35913 9.28589C8.41345 9.11878 8.55786 8.99695 8.73169 8.97168L10.724 8.68225L11.615 6.87696C11.6928 6.71936 11.8532 6.61963 12.0288 6.61963C12.2045 6.61963 12.365 6.71936 12.4428 6.87696L13.3336 8.68225L15.3259 8.97168C15.4998 8.99695 15.6443 9.11878 15.6985 9.28589C15.7528 9.45289 15.7075 9.63636 15.5817 9.75892Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.6124 9.30835L12.028 8.12402L11.4435 9.30835C11.3762 9.44458 11.2462 9.53894 11.0959 9.56079L9.78906 9.75073L10.7347 10.6726C10.8435 10.7786 10.8932 10.9314 10.8674 11.081L10.6442 12.3828L11.8132 11.7682C11.8804 11.7329 11.9542 11.7152 12.028 11.7152C12.1017 11.7152 12.1755 11.7329 12.2427 11.7682L13.4116 12.3828L13.1885 11.081C13.1627 10.9314 13.2124 10.7786 13.3212 10.6726L14.2668 9.75073L12.9598 9.56079C12.8096 9.53894 12.6796 9.44458 12.6124 9.30835Z",
    fill: "currentColor"
  }));
});

var PortalBannerIcon = /*#__PURE__*/forwardRef(function PortalBannerIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M19.5363 5H4.65646C4.36299 5 4.125 5.21155 4.125 5.47241V15.4139C4.125 15.6748 4.36299 15.8864 4.65646 15.8864H8.44221C8.45554 15.8855 8.46899 15.8845 8.48245 15.8845H15.7104C15.724 15.8845 15.7373 15.8855 15.7506 15.8864H19.5363C19.83 15.8864 20.0678 15.6748 20.0678 15.4139V5.47241C20.0678 5.21155 19.83 5 19.5363 5V5ZM5.73257 13.9364V6.94995C5.73257 6.68909 5.97057 6.47754 6.26404 6.47754H17.9288C18.2222 6.47754 18.4602 6.68909 18.4602 6.94995V13.9364C18.4602 14.1973 18.2222 14.4088 17.9288 14.4088H6.26404C5.97057 14.4088 5.73257 14.1973 5.73257 13.9364Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.75 17V19.6602C9.75 19.8478 10.0457 20 10.4104 20H13.5896C13.9545 20 14.25 19.8478 14.25 19.6602V17H9.75Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.2911 7.42236H6.68945V13.4637H17.2911V7.42236ZM8.16162 9.89758H12.3481C12.6416 9.89758 12.8796 10.1091 12.8796 10.3701C12.8796 10.631 12.6416 10.8425 12.3481 10.8425H8.16162C7.86815 10.8425 7.63016 10.631 7.63016 10.3701C7.63016 10.1091 7.86815 9.89758 8.16162 9.89758ZM15.3895 12.5476H8.16162C7.86815 12.5476 7.63016 12.3361 7.63016 12.0752C7.63016 11.8143 7.86815 11.6028 8.16162 11.6028H15.3895C15.683 11.6028 15.921 11.8143 15.921 12.0752C15.921 12.3361 15.683 12.5476 15.3895 12.5476Z",
    fill: "currentColor"
  }));
});

var PortalBillingsIcon = /*#__PURE__*/forwardRef(function PortalBillingsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M17 15.0117V13.5H8V15.0117H17ZM17 11.9883V10.5117H8V11.9883H17ZM17 9V7.48828H8V9H17ZM5.75 18.7383V3.76172L6.875 4.88672L8 3.76172L9.125 4.88672L10.25 3.76172L11.375 4.88672L12.5 3.76172L13.625 4.88672L14.75 3.76172L15.875 4.88672L17 3.76172L18.125 4.88672L19.25 3.76172V18.7383L18.125 17.6133L17 18.7383L15.875 17.6133L14.75 18.7383L13.625 17.6133L12.5 18.7383L11.375 17.6133L10.25 18.7383L9.125 17.6133L8 18.7383L6.875 17.6133L5.75 18.7383Z",
    fill: "currentColor"
  })));
});

var PortalBillsAndReloadIcons = /*#__PURE__*/forwardRef(function PortalBillsAndReloadIcons(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M12.5176 6.01172C14.1582 6.01172 15.5645 6.59766 16.7363 7.76953C17.9082 8.94141 18.4941 10.3594 18.4941 12.0234C18.4941 13.6641 17.9082 15.0703 16.7363 16.2422C15.5645 17.4141 14.1465 18 12.4824 18C10.8418 18 9.43555 17.4141 8.26367 16.2422C7.0918 15.0703 6.50586 13.6523 6.50586 11.9883H8.01758C8.01758 13.2305 8.45117 14.2969 9.31836 15.1875C10.209 16.0547 11.2754 16.4883 12.5176 16.4883C13.7598 16.4883 14.8145 16.0547 15.6816 15.1875C16.5723 14.2969 17.0176 13.2305 17.0176 11.9883C17.0176 10.7461 16.5723 9.69141 15.6816 8.82422C14.8145 7.93359 13.7598 7.48828 12.5176 7.48828V10.5117L8.75586 6.75L12.5176 2.98828V6.01172Z",
    fill: "currentColor"
  })));
});

var PortalBudgetingIcon = /*#__PURE__*/forwardRef(function PortalBudgetingIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M17.3125 4H8.44219C8.31787 4 8.19863 4.04941 8.11075 4.13731L6.35606 5.892C6.26812 5.97991 6.21875 6.09909 6.21875 6.22344V19.5312C6.21875 19.7901 6.42862 20 6.6875 20H17.3125C17.5714 20 17.7812 19.7901 17.7812 19.5312V4.46875C17.7812 4.20987 17.5714 4 17.3125 4ZM10.4456 8.05456C10.4456 7.19056 11.0851 6.77559 11.8062 6.67353V6.48306C11.8062 6.38781 11.915 6.29938 12.0647 6.29938C12.1939 6.29938 12.3232 6.38781 12.3232 6.48306V6.65313C12.745 6.66672 13.5409 6.77556 13.5409 7.24497C13.5409 7.42866 13.4185 7.80281 13.1192 7.80281C12.8947 7.80281 12.7654 7.58509 12.3232 7.55109V8.54434C12.9423 8.77566 13.6634 9.09541 13.6634 10.0138C13.6634 10.8574 13.1192 11.3676 12.3232 11.4969V11.6942C12.3232 11.7894 12.194 11.8778 12.0647 11.8778C11.915 11.8778 11.8062 11.7894 11.8062 11.6942V11.5241C10.9898 11.4969 10.3231 11.0751 10.3231 10.6397C10.3231 10.4084 10.5272 10.0682 10.7857 10.0682C11.0715 10.0682 11.3028 10.4696 11.8062 10.558V9.45594C11.1803 9.21781 10.4456 8.92528 10.4456 8.05456ZM15.4375 17.75H8.5625C8.30363 17.75 8.09375 17.5401 8.09375 17.2812C8.09375 17.0224 8.30363 16.8125 8.5625 16.8125H15.4375C15.6964 16.8125 15.9062 17.0224 15.9062 17.2812C15.9062 17.5401 15.6964 17.75 15.4375 17.75ZM15.4375 15.875H8.5625C8.30363 15.875 8.09375 15.6651 8.09375 15.4062C8.09375 15.1474 8.30363 14.9375 8.5625 14.9375H15.4375C15.6964 14.9375 15.9062 15.1474 15.9062 15.4062C15.9062 15.6651 15.6964 15.875 15.4375 15.875ZM15.4375 14H12.9375C12.6786 14 12.4688 13.7901 12.4688 13.5312C12.4688 13.2724 12.6786 13.0625 12.9375 13.0625H15.4375C15.6964 13.0625 15.9062 13.2724 15.9062 13.5312C15.9062 13.7901 15.6964 14 15.4375 14Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.6708 10.1227C12.6708 9.89818 12.5008 9.75534 12.2559 9.63965V10.5512C12.4871 10.4968 12.6708 10.3676 12.6708 10.1227Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.8729 7.57129C11.5668 7.63251 11.4375 7.78898 11.4375 7.95226C11.4375 8.14957 11.6144 8.27201 11.8729 8.38085V7.57129Z",
    fill: "currentColor"
  }));
});

var PortalCardCategoriesIcon = /*#__PURE__*/forwardRef(function PortalCardCategoriesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M16.4923 9.88029C16.6855 9.88029 16.872 9.90973 17.0476 9.96423L18.647 8.36482L17.9015 7.61938L15.6406 9.88029H16.4923Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.7257 9.44159L19.3117 9.02759L17.8633 10.476C18.1767 10.8113 18.3692 11.2611 18.3692 11.7552V12.124L19.7257 10.7674C20.0919 10.4013 20.0919 9.80771 19.7257 9.44159Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.2402 6.95641L14.5584 4.27459C14.1923 3.90847 13.5987 3.90847 13.2326 4.27459L7.62695 9.88022H14.3164L17.2402 6.95641Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.46094 13.7896H7.88912V14.8437H6.46094V13.7896Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.4939 10.8176H4.9375C4.41972 10.8176 4 11.2373 4 11.7551V19.0624C4 19.5802 4.41972 19.9999 4.9375 19.9999H16.4939C17.0116 19.9999 17.4314 19.5802 17.4314 19.0624V11.7551C17.4314 11.2373 17.0116 10.8176 16.4939 10.8176ZM5.52294 12.8519H8.82613V15.7811H5.52294V12.8519ZM7.34672 17.9656H5.49378V17.0281H7.34672V17.9656ZM10.2103 17.9656H8.35738V17.0281H10.2103V17.9656ZM13.074 17.9656H11.221V17.0281H13.074V17.9656ZM15.9376 17.9656H14.0847V17.0281H15.9376V17.9656Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalCardIssuingIcon = /*#__PURE__*/forwardRef(function PortalCardIssuingIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.4941 5.23828C18.916 5.23828 19.2676 5.39062 19.5488 5.69531C19.8535 5.97656 20.0059 6.32812 20.0059 6.75V15.75C20.0059 16.1719 19.8535 16.5352 19.5488 16.8398C19.2676 17.1211 18.916 17.2617 18.4941 17.2617H6.50586C6.08398 17.2617 5.7207 17.1211 5.41602 16.8398C5.13477 16.5352 4.99414 16.1719 4.99414 15.75V6.75C4.99414 6.32812 5.13477 5.97656 5.41602 5.69531C5.7207 5.39062 6.08398 5.23828 6.50586 5.23828H18.4941ZM18.4941 15.75V11.25H6.50586V15.75H18.4941ZM18.4941 8.26172V6.75H6.50586V8.26172H18.4941Z",
    fill: "currentColor"
  })));
});

var PortalCardholdersIcon = /*#__PURE__*/forwardRef(function PortalCardholdersIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M8.83875 14.3956V13.711L11.5677 10.982C11.5848 10.9649 11.6014 10.9475 11.6176 10.9297C11.8595 10.6631 11.9918 10.3208 11.9918 9.95831C11.9918 9.59578 11.8595 9.25357 11.6176 8.98689C11.6014 8.9691 11.5848 8.95166 11.5677 8.93459L11.4891 8.85593C11.4498 8.81657 11.4037 8.81069 11.3798 8.81069C11.3559 8.81069 11.3099 8.81657 11.2705 8.85596L9.14044 10.986L8.81527 11.3112L8.15207 10.648L8.47725 10.3228L8.83875 9.96132V7.15991L6.10938 10.093V20H12.0007V17.7914L13.0443 16.7479H11.191C9.89398 16.7479 8.83875 15.6926 8.83875 14.3956Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.2225 4C10.4257 4 9.77741 4.64828 9.77741 5.44512V6.15196L9.77734 6.15202V9.02345L10.6079 8.19284C10.8143 7.98647 11.0887 7.87283 11.3805 7.87283C11.6723 7.87283 11.9467 7.9865 12.153 8.19284L12.2317 8.2715C12.2598 8.29967 12.2872 8.3284 12.3138 8.35769C12.7123 8.79704 12.9304 9.36094 12.9304 9.95835C12.9304 10.5558 12.7123 11.1197 12.3137 11.5591C12.2872 11.5884 12.2598 11.6171 12.2316 11.6453L10.5782 13.2987L9.77737 14.0995V14.3956C9.77737 15.1755 10.4119 15.81 11.1917 15.81H13.9829L13.983 15.8099H14.7536V4H11.2225Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.4495 4H15.6914V15.8099H16.4495C17.2464 15.8099 17.8946 15.1616 17.8946 14.3648V5.44512C17.8946 4.64828 17.2464 4 16.4495 4Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalCardsIcon = /*#__PURE__*/forwardRef(function PortalCardsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.4941 5.23828C18.916 5.23828 19.2676 5.39062 19.5488 5.69531C19.8535 5.97656 20.0059 6.32812 20.0059 6.75V15.75C20.0059 16.1719 19.8535 16.5352 19.5488 16.8398C19.2676 17.1211 18.916 17.2617 18.4941 17.2617H6.50586C6.08398 17.2617 5.7207 17.1211 5.41602 16.8398C5.13477 16.5352 4.99414 16.1719 4.99414 15.75V6.75C4.99414 6.32812 5.13477 5.97656 5.41602 5.69531C5.7207 5.39062 6.08398 5.23828 6.50586 5.23828H18.4941ZM18.4941 15.75V11.25H6.50586V15.75H18.4941ZM18.4941 8.26172V6.75H6.50586V8.26172H18.4941Z",
    fill: "currentColor"
  })));
});

var PortalCatalogueIcon = /*#__PURE__*/forwardRef(function PortalCatalogueIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.0156 5H5.98437C5.44083 5 5 5.44072 5 5.98437V18.0156C5 18.5593 5.44083 19 5.98437 19H18.0156C18.5593 19 19 18.5593 19 18.0156V5.98437C19 5.44072 18.5593 5 18.0156 5ZM8.41992 16.1335C7.87694 16.1335 7.43533 15.6917 7.43533 15.1487C7.43533 14.6058 7.87694 14.1641 8.41992 14.1641C8.9629 14.1641 9.40474 14.6058 9.40474 15.1487C9.40474 15.6917 8.9629 16.1335 8.41992 16.1335ZM8.41992 13.1804C7.87694 13.1804 7.43533 12.7386 7.43533 12.1956C7.43533 11.6527 7.87694 11.211 8.41992 11.211C8.9629 11.211 9.40474 11.6527 9.40474 12.1956C9.40474 12.7386 8.9629 13.1804 8.41992 13.1804ZM8.41992 10.2273C7.87694 10.2273 7.43533 9.78554 7.43533 9.24245C7.43533 8.69958 7.87694 8.25786 8.41992 8.25786C8.9629 8.25786 9.40474 8.69958 9.40474 9.24245C9.40474 9.78554 8.9629 10.2273 8.41992 10.2273ZM16.7411 15.5H11.0469C10.8657 15.5 10.7187 15.3531 10.7187 15.1718C10.7187 14.9905 10.8657 14.8437 11.0469 14.8437H16.7411C16.9223 14.8437 17.0692 14.9905 17.0692 15.1718C17.0692 15.3531 16.9223 15.5 16.7411 15.5ZM16.7411 12.5469H11.0469C10.8657 12.5469 10.7187 12.4 10.7187 12.2187C10.7187 12.0374 10.8657 11.8906 11.0469 11.8906H16.7411C16.9223 11.8906 17.0692 12.0374 17.0692 12.2187C17.0692 12.3998 16.9223 12.5469 16.7411 12.5469ZM16.7411 9.59379H11.0469C10.8657 9.59379 10.7187 9.44685 10.7187 9.26563C10.7187 9.0843 10.8657 8.93747 11.0469 8.93747H16.7411C16.9223 8.93747 17.0692 9.0843 17.0692 9.26563C17.0692 9.44674 16.9223 9.59379 16.7411 9.59379Z",
    fill: "currentColor"
  })));
});

var PortalCdpIcon = /*#__PURE__*/forwardRef(function PortalCdpIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M17.7383 5.23828C18.1602 5.23828 18.5117 5.39062 18.793 5.69531C19.0977 5.97656 19.25 6.32812 19.25 6.75V17.2617C19.25 17.6602 19.0977 18 18.793 18.2812C18.5117 18.5859 18.1602 18.7383 17.7383 18.7383H7.26172C6.83984 18.7383 6.47656 18.5859 6.17188 18.2812C5.89062 18 5.75 17.6602 5.75 17.2617V6.75C5.75 6.32812 5.89062 5.97656 6.17188 5.69531C6.47656 5.39062 6.83984 5.23828 7.26172 5.23828H10.3906C10.5547 4.79297 10.8242 4.44141 11.1992 4.18359C11.5977 3.90234 12.0312 3.76172 12.5 3.76172C12.9688 3.76172 13.3906 3.90234 13.7656 4.18359C14.1641 4.44141 14.4453 4.79297 14.6094 5.23828H17.7383ZM13.0273 5.48438C12.8867 5.32031 12.7109 5.23828 12.5 5.23828C12.2891 5.23828 12.1133 5.32031 11.9727 5.48438C11.832 5.625 11.7617 5.80078 11.7617 6.01172C11.7617 6.19922 11.832 6.375 11.9727 6.53906C12.1133 6.67969 12.2891 6.75 12.5 6.75C12.7109 6.75 12.8867 6.67969 13.0273 6.53906C13.168 6.375 13.2383 6.19922 13.2383 6.01172C13.2383 5.80078 13.168 5.625 13.0273 5.48438ZM14.0117 15.75V14.2383H8.73828V15.75H14.0117ZM16.2617 12.7617V11.25H8.73828V12.7617H16.2617ZM16.2617 9.73828V8.26172H8.73828V9.73828H16.2617Z",
    fill: "currentColor"
  })));
});

var PortalCirclesIcon = /*#__PURE__*/forwardRef(function PortalCirclesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M9.51172 9.73828V11.25H7.26172V13.5H5.75V11.25H3.5V9.73828H5.75V7.48828H7.26172V9.73828H9.51172ZM17 10.5117C16.7656 10.5117 16.543 10.4766 16.332 10.4062C16.7773 9.75 17 9.03516 17 8.26172C17 7.46484 16.7773 6.75 16.332 6.11719C16.543 6.04688 16.7656 6.01172 17 6.01172C17.6328 6.01172 18.1602 6.23437 18.582 6.67969C19.0273 7.10156 19.25 7.62891 19.25 8.26172C19.25 8.87109 19.0273 9.39844 18.582 9.84375C18.1602 10.2891 17.6328 10.5117 17 10.5117ZM14.8203 9.84375C14.3984 10.2891 13.8711 10.5117 13.2383 10.5117C12.6289 10.5117 12.1016 10.2891 11.6562 9.84375C11.2109 9.39844 10.9883 8.87109 10.9883 8.26172C10.9883 7.62891 11.2109 7.10156 11.6562 6.67969C12.1016 6.23437 12.6289 6.01172 13.2383 6.01172C13.8711 6.01172 14.3984 6.23437 14.8203 6.67969C15.2656 7.10156 15.4883 7.62891 15.4883 8.26172C15.4883 8.87109 15.2656 9.39844 14.8203 9.84375ZM18.2305 12.1289C19.0977 12.2695 19.8594 12.5273 20.5156 12.9023C21.1719 13.2773 21.5 13.7227 21.5 14.2383V15.75H19.25V14.2383C19.25 13.4414 18.9102 12.7383 18.2305 12.1289ZM10.2852 12.6211C11.3164 12.1992 12.3008 11.9883 13.2383 11.9883C14.1758 11.9883 15.1602 12.1992 16.1914 12.6211C17.2227 13.043 17.7383 13.582 17.7383 14.2383V15.75H8.73828V14.2383C8.73828 13.582 9.25391 13.043 10.2852 12.6211Z",
    fill: "currentColor"
  })));
});

var PortalCompaniesIcon = /*#__PURE__*/forwardRef(function PortalCompaniesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.4941 6.75C18.916 6.75 19.2676 6.90234 19.5488 7.20703C19.8535 7.48828 20.0059 7.83984 20.0059 8.26172V16.4883C20.0059 16.9102 19.8535 17.2734 19.5488 17.5781C19.2676 17.8594 18.916 18 18.4941 18H6.50586C6.08398 18 5.7207 17.8594 5.41602 17.5781C5.13477 17.2734 4.99414 16.9102 4.99414 16.4883V8.26172C4.99414 7.83984 5.13477 7.48828 5.41602 7.20703C5.7207 6.90234 6.08398 6.75 6.50586 6.75H9.49414V5.23828C9.49414 4.83984 9.63477 4.5 9.91602 4.21875C10.2207 3.91406 10.584 3.76172 11.0059 3.76172H13.9941C14.416 3.76172 14.7676 3.91406 15.0488 4.21875C15.3535 4.5 15.5059 4.83984 15.5059 5.23828V6.75H18.4941ZM13.9941 6.75V5.23828H11.0059V6.75H13.9941Z",
    fill: "currentColor"
  })));
});

var PortalComplianceIcon = /*#__PURE__*/forwardRef(function PortalComplianceIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M16.8125 14.6172C14.6416 14.6172 12.875 16.2734 12.875 18.3086C12.875 20.3067 14.5976 22 16.8125 22C18.9834 22 20.75 20.3438 20.75 18.3086C20.75 16.2734 18.9834 14.6172 16.8125 14.6172ZM18.3352 17.8904L16.6477 19.4724C16.428 19.6784 16.072 19.6785 15.8523 19.4724L15.0085 18.6814C14.7888 18.4754 14.7888 18.1417 15.0085 17.9357C15.2282 17.7297 15.5842 17.7297 15.8039 17.9357L16.25 18.3539L17.5398 17.1447C17.7595 16.9387 18.1155 16.9387 18.3352 17.1447C18.5549 17.3507 18.5549 17.6844 18.3352 17.8904Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.8125 4H5.5625C5.25159 4 5 4.23586 5 4.52734V19.3633C5 19.6548 5.25159 19.8906 5.5625 19.8906H12.0507C12.0486 19.8851 12.0454 19.8802 12.0433 19.8747C11.8544 19.4215 11.75 18.8802 11.75 18.3086C11.75 15.6915 14.0209 13.5625 16.8125 13.5625C17.0051 13.5625 17.1879 13.596 17.375 13.6158V4.52734C17.375 4.23586 17.1234 4 16.8125 4ZM7.8125 14.6172C7.50185 14.6172 7.25 14.3811 7.25 14.0898C7.25 13.7985 7.50185 13.5625 7.8125 13.5625C8.12315 13.5625 8.375 13.7985 8.375 14.0898C8.375 14.3811 8.12315 14.6172 7.8125 14.6172ZM7.8125 12.5078C7.50185 12.5078 7.25 12.2717 7.25 11.9805C7.25 11.6892 7.50185 11.4531 7.8125 11.4531C8.12315 11.4531 8.375 11.6892 8.375 11.9805C8.375 12.2717 8.12315 12.5078 7.8125 12.5078ZM7.8125 10.3984C7.50185 10.3984 7.25 10.1623 7.25 9.87109C7.25 9.57979 7.50185 9.34375 7.8125 9.34375C8.12315 9.34375 8.375 9.57979 8.375 9.87109C8.375 10.1623 8.12315 10.3984 7.8125 10.3984ZM7.8125 8.28906C7.50185 8.28906 7.25 8.05295 7.25 7.76172C7.25 7.47041 7.50185 7.23438 7.8125 7.23438C8.12315 7.23438 8.375 7.47041 8.375 7.76172C8.375 8.05295 8.12315 8.28906 7.8125 8.28906ZM12.3125 14.6172H10.0625C9.75159 14.6172 9.5 14.3813 9.5 14.0898C9.5 13.7984 9.75159 13.5625 10.0625 13.5625H12.3125C12.6234 13.5625 12.875 13.7984 12.875 14.0898C12.875 14.3813 12.6234 14.6172 12.3125 14.6172ZM14.5625 12.5078H10.0625C9.75159 12.5078 9.5 12.2719 9.5 11.9805C9.5 11.689 9.75159 11.4531 10.0625 11.4531H14.5625C14.8734 11.4531 15.125 11.689 15.125 11.9805C15.125 12.2719 14.8734 12.5078 14.5625 12.5078ZM14.5625 10.3984H10.0625C9.75159 10.3984 9.5 10.1626 9.5 9.87109C9.5 9.57961 9.75159 9.34375 10.0625 9.34375H14.5625C14.8734 9.34375 15.125 9.57961 15.125 9.87109C15.125 10.1626 14.8734 10.3984 14.5625 10.3984ZM14.5625 8.28906H10.0625C9.75159 8.28906 9.5 8.0532 9.5 7.76172C9.5 7.47024 9.75159 7.23438 10.0625 7.23438H14.5625C14.8734 7.23438 15.125 7.47024 15.125 7.76172C15.125 8.0532 14.8734 8.28906 14.5625 8.28906Z",
    fill: "currentColor"
  }));
});

var PortalCreditNotesIcon = /*#__PURE__*/forwardRef(function PortalCreditNotesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M7.28203 5.59375H6.07422C6.21997 5.01375 6.73691 4.53125 7.47516 4.53125C7.33503 4.89088 7.27266 5.28412 7.28203 5.59375Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.4986 6.99338C11.5008 7.2665 11.2846 7.4685 11.0326 7.4685C5.10071 7.4685 5.49167 7.46712 5.45202 7.471C5.18171 7.49537 4.93734 7.72287 4.93734 7.99974C4.93734 8.17252 5.0939 8.25349 5.0939 8.48286C5.0939 8.96005 4.45703 9.13661 4.2214 8.72161C4.09641 8.5013 3.99547 8.24568 4.00016 7.9738C4.01422 7.16881 4.71984 6.53101 5.52483 6.53101H11.0326C11.2885 6.53104 11.4966 6.73744 11.4986 6.99338Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.21937 5.59374C8.21875 5.58343 8.21875 5.57311 8.21875 5.56249C8.21875 5.18281 8.33094 4.82875 8.52312 4.53125H11.7268C11.9243 4.83687 12.0375 5.20187 12.0309 5.59374H8.21937Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.43749 10.5312C8.66375 10.5312 8.03375 11.1597 8.03125 11.9328V12.5312H19.9999V11.9375C19.9999 11.1621 19.3691 10.5312 18.5937 10.5312H9.43749Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.2188 9.5937H17.2187V5.93749C17.2187 5.16209 16.5879 4.53125 15.8125 4.53125H15.2188V9.5937Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M7.09374 11.9299C7.0978 10.6418 8.14935 9.5937 9.43747 9.5937H14.2812V4.53125H12.7751C13.5015 6.39176 12.1197 8.40621 10.125 8.40621H6.03125V16.9999C6.03125 17.2588 6.24112 17.4686 6.5 17.4686H7.09374V11.9299Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.03125 15.4688V18.0625C8.03125 18.8378 8.66218 19.4687 9.43749 19.4687H18.5937C19.369 19.4687 19.9999 18.8378 19.9999 18.0625V15.4688H8.03125ZM13 17.4687H10.5C10.2412 17.4687 10.0312 17.2587 10.0312 17C10.0312 16.7412 10.2412 16.5312 10.5 16.5312H13C13.2587 16.5312 13.4687 16.7412 13.4687 17C13.4687 17.2587 13.2587 17.4687 13 17.4687ZM17.4999 17.4687H16.9999C16.7412 17.4687 16.5312 17.2587 16.5312 17C16.5312 16.7412 16.7412 16.5312 16.9999 16.5312H17.4999C17.7587 16.5312 17.9687 16.7412 17.9687 17C17.9687 17.2587 17.7587 17.4687 17.4999 17.4687Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.03125 13.4688H19.9999V14.5312H8.03125V13.4688Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalCustomersIcon = /*#__PURE__*/forwardRef(function PortalCustomersIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M12 10.4375C13.5015 10.4375 14.7188 9.22027 14.7188 7.71875C14.7188 6.21723 13.5015 5 12 5C10.4985 5 9.28125 6.21723 9.28125 7.71875C9.28125 9.22027 10.4985 10.4375 12 10.4375Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.5 10.4375C18.4492 10.4375 19.2188 9.66799 19.2188 8.71875C19.2188 7.76951 18.4492 7 17.5 7C16.5508 7 15.7812 7.76951 15.7812 8.71875C15.7812 9.66799 16.5508 10.4375 17.5 10.4375Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.5 10.4375C7.44924 10.4375 8.21875 9.66799 8.21875 8.71875C8.21875 7.76951 7.44924 7 6.5 7C5.55076 7 4.78125 7.76951 4.78125 8.71875C4.78125 9.66799 5.55076 10.4375 6.5 10.4375Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.19344 11.981C7.51688 11.4267 6.90416 11.5 6.12188 11.5C4.95188 11.5 4 12.4463 4 13.6091V17.0219C4 17.5269 4.41219 17.9375 4.91906 17.9375C7.10738 17.9375 6.84375 17.9771 6.84375 17.8432C6.84375 15.4249 6.55731 13.6514 8.19344 11.981Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.7442 11.5125C11.3778 11.3985 10.1901 11.5138 9.16572 12.3593C7.45144 13.7325 7.78134 15.5813 7.78134 17.8431C7.78134 18.4415 8.26822 18.9375 8.87572 18.9375C15.472 18.9375 15.7346 19.1502 16.1257 18.284C16.254 17.9911 16.2188 18.0842 16.2188 15.2818C16.2188 13.056 14.2916 11.5125 12.7442 11.5125Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.8782 11.5C17.0916 11.5 16.4823 11.4273 15.8066 11.9809C17.4305 13.6389 17.1563 15.2914 17.1563 17.8431C17.1563 17.9779 16.9375 17.9375 19.0482 17.9375C19.5732 17.9375 20.0001 17.5122 20.0001 16.9893V13.609C20.0001 12.4462 19.0482 11.5 17.8782 11.5Z",
    fill: "currentColor"
  })));
});

var PortalDealCampaignsIcon = /*#__PURE__*/forwardRef(function PortalDealCampaignsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M19.6694 13.178C19.8678 12.4746 20 11.7271 20 10.9577C20 10.0565 19.8457 9.19913 19.5592 8.38577C18.4793 5.24224 15.5041 3 12 3C7.57025 3 4 6.5612 4 10.9577C4 13.6836 5.45455 16.2776 7.7686 17.7064C7.9449 17.8164 8.09917 17.9043 8.27548 17.9922C7.98898 18.8276 7.43802 19.6189 6.46832 20.3664C8.16529 20.1465 9.22314 19.8388 10.3691 18.7616C10.5014 18.7836 10.6116 18.8056 10.7438 18.8276C11.1405 18.8935 11.5592 18.9155 11.978 18.9155C12.7273 18.9155 13.4545 18.8056 14.1377 18.6297C15.4821 18.256 16.6722 17.5526 17.6198 16.6073C18.5895 15.6621 19.2948 14.497 19.6694 13.178ZM9.77411 10.0125V14.3651H7.72452V10.0125H9.77411ZM10.2149 10.2543C10.6556 9.99051 11.9118 9.1112 12.1102 7.7043V7.63836C12.1543 7.37456 12.1763 7.11077 12.1983 6.82499C12.1983 6.73706 12.1983 6.67112 12.1983 6.58318C12.1983 6.27543 12.1983 6.07758 12.4187 5.96767C12.5289 5.90172 12.6391 5.90172 12.7493 5.9237C12.8595 5.96767 12.9477 6.07758 13.0358 6.23146C13.3884 7.02284 13.3003 8.53965 12.8815 9.15516L12.7713 9.33103H15.5262C15.9008 9.33103 16.2094 9.35301 16.3416 9.66077C16.4077 9.83663 16.4077 10.0125 16.3196 10.1664C16.2314 10.3422 16.0331 10.4741 15.8127 10.5181L15.2397 10.65L15.8347 10.7599C16.0551 10.8039 16.1873 10.8918 16.2534 11.0677C16.3196 11.2435 16.3196 11.3974 16.2314 11.5513C16.1433 11.7271 15.9449 11.859 15.7466 11.881L15.1515 12.0129L15.7686 12.1228C15.989 12.1668 16.1212 12.2547 16.1873 12.4306C16.2534 12.5845 16.2534 12.7603 16.1873 12.8922C16.0992 13.0681 15.9008 13.178 15.7025 13.222L15.0854 13.3319L15.7025 13.4418C15.9229 13.4858 16.0331 13.5737 16.1212 13.7276C16.2094 13.9474 16.1653 14.1233 16.0992 14.2112C15.989 14.3871 15.7466 14.497 15.5262 14.497H12.0882C12.022 14.497 11.9559 14.497 11.8898 14.497C11.7576 14.497 11.6253 14.5189 11.5152 14.497C11.2727 14.453 11.0303 14.2552 10.8099 13.9254C10.6997 13.7496 10.4353 13.6396 10.2149 13.5957V10.2543Z",
    fill: "currentColor"
  })));
});

var PortalDealOrdersIcon = /*#__PURE__*/forwardRef(function PortalDealOrdersIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M13.379 4.41378H13.1833C13.0769 4.17031 12.8342 4 12.5514 4H11.402C11.1193 4 10.8766 4.17031 10.7701 4.41378H10.5744C10.1935 4.41378 9.88477 4.72791 9.88477 5.10878C9.88477 5.18553 9.89783 5.24137 9.92095 5.33334H14.0325C14.0556 5.24137 14.0687 5.18553 14.0687 5.10878C14.0687 4.72791 13.7599 4.41378 13.379 4.41378Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.9416 6.02295H16.3683V18.241C16.3683 18.4314 16.2316 18.5746 16.0412 18.5746H7.95978C7.76931 18.5746 7.63266 18.4314 7.63266 18.241V6.02295H7.05931C6.48178 6.02295 6.02344 6.4821 6.02344 7.05963V18.9749C6.02344 19.5525 6.48178 19.9999 7.05931 19.9999H16.9416C17.5192 19.9999 17.9775 19.5524 17.9775 18.9749V7.05963C17.9775 6.4821 17.5191 6.02295 16.9416 6.02295Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.32227 6.02295V17.885H15.6786V6.02295H8.32227ZM10.1154 12.7356H9.79352C9.60305 12.7356 9.44871 12.5812 9.44871 12.3908C9.44871 12.2003 9.60305 12.0459 9.79352 12.0459H10.1154C10.3058 12.0459 10.4602 12.2003 10.4602 12.3908C10.4602 12.5812 10.3059 12.7356 10.1154 12.7356ZM10.1154 11.0804H9.79352C9.60305 11.0804 9.44871 10.926 9.44871 10.7356C9.44871 10.5452 9.60305 10.3908 9.79352 10.3908H10.1154C10.3058 10.3908 10.4602 10.5452 10.4602 10.7356C10.4602 10.926 10.3059 11.0804 10.1154 11.0804ZM10.1154 9.42523H9.79352C9.60305 9.42523 9.44871 9.27086 9.44871 9.08042C9.44871 8.88998 9.60305 8.73561 9.79352 8.73561H10.1154C10.3058 8.73561 10.4602 8.88998 10.4602 9.08042C10.4602 9.27086 10.3059 9.42523 10.1154 9.42523ZM14.2073 12.7356H11.8625C11.6721 12.7356 11.5177 12.5812 11.5177 12.3908C11.5177 12.2003 11.6721 12.0459 11.8625 12.0459H14.2073C14.3978 12.0459 14.5522 12.2003 14.5522 12.3908C14.5522 12.5812 14.3978 12.7356 14.2073 12.7356ZM14.2073 11.0804H11.8625C11.6721 11.0804 11.5177 10.926 11.5177 10.7356C11.5177 10.5452 11.6721 10.3908 11.8625 10.3908H14.2073C14.3978 10.3908 14.5522 10.5452 14.5522 10.7356C14.5522 10.926 14.3978 11.0804 14.2073 11.0804ZM14.2073 9.42523H11.8625C11.6721 9.42523 11.5177 9.27086 11.5177 9.08042C11.5177 8.88998 11.6721 8.73561 11.8625 8.73561H14.2073C14.3978 8.73561 14.5522 8.88998 14.5522 9.08042C14.5522 9.27086 14.3978 9.42523 14.2073 9.42523Z",
    fill: "currentColor"
  }));
});

var PortalDealsIcon = /*#__PURE__*/forwardRef(function PortalDealsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M16.4801 4.85132H11.5676C11.2566 4.85132 10.958 4.9751 10.7381 5.19509L4.34363 11.5883C3.88546 12.0465 3.88546 12.7892 4.34363 13.248L9.25619 18.1605C9.71436 18.6187 10.4571 18.6187 10.9152 18.1605L17.3096 11.7673C17.5296 11.5467 17.6534 11.2481 17.6534 10.9366V6.02461C17.6534 5.37637 17.1284 4.85132 16.4801 4.85132ZM14.4269 8.95783C13.9411 8.95783 13.5469 8.56361 13.5469 8.07786C13.5469 7.59212 13.9411 7.1979 14.4269 7.1979C14.9126 7.1979 15.3068 7.59212 15.3068 8.07786C15.3068 8.56361 14.9126 8.95783 14.4269 8.95783Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M18.8267 6.02466L18.8262 11.4857C18.8262 11.7562 18.7188 12.0161 18.527 12.2073L12.0293 18.705L12.129 18.8047C12.5872 19.2629 13.3299 19.2629 13.7881 18.8047L19.6557 12.9383C19.8763 12.7183 20 12.4197 20 12.1087V7.19795C20 6.54971 19.475 6.02466 18.8267 6.02466Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalDevicesIcon = /*#__PURE__*/forwardRef(function PortalDevicesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M16.2441 3.02344C16.666 3.02344 17.0176 3.16406 17.2988 3.44531C17.6035 3.72656 17.7559 4.07812 17.7559 4.5V18C17.7559 18.4219 17.6035 18.7734 17.2988 19.0547C17.0176 19.3594 16.666 19.5117 16.2441 19.5117H8.75586C8.33398 19.5117 7.9707 19.3594 7.66602 19.0547C7.38477 18.7734 7.24414 18.4219 7.24414 18V4.5C7.24414 4.07812 7.38477 3.72656 7.66602 3.44531C7.9707 3.14062 8.33398 2.98828 8.75586 2.98828L16.2441 3.02344ZM16.2441 16.4883V6.01172H8.75586V16.4883H16.2441ZM15.5059 11.9883L12.4824 15.0117L9.49414 11.9883H11.7441V8.26172H13.2559V11.9883H15.5059Z",
    fill: "currentColor"
  })));
});

var PortalDiscountsIcon = /*#__PURE__*/forwardRef(function PortalDiscountsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M15.683 8.31769C15.4974 8.13206 15.2057 8.13206 15.0201 8.31769C14.8345 8.50331 14.8345 8.79494 15.0201 8.9806C15.2057 9.16623 15.4974 9.16623 15.683 8.9806C15.8686 8.79497 15.8686 8.50331 15.683 8.31769Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.0404 10.3065C10.8548 10.1208 10.5631 10.1208 10.3775 10.3065C10.1919 10.4921 10.1919 10.7837 10.3775 10.9694C10.5631 11.155 10.8548 11.155 11.0404 10.9694C11.226 10.7837 11.226 10.4921 11.0404 10.3065Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.7045 14.9468C11.5188 14.7612 11.2272 14.7612 11.0416 14.9468C10.856 15.1324 10.8559 15.4241 11.0416 15.6098C11.2272 15.7954 11.5189 15.7954 11.7045 15.6098C11.8901 15.4241 11.8901 15.1325 11.7045 14.9468Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.653 10.6712L18.5923 6.42859C18.5658 6.33578 18.5327 6.24959 18.4929 6.17006L16.6168 8.04612C16.8622 8.56981 16.776 9.21281 16.3451 9.64371C15.7949 10.1939 14.9066 10.1939 14.3563 9.64371C13.8061 9.09349 13.8061 8.20515 14.3563 7.65497C14.7872 7.22406 15.4302 7.13787 15.9539 7.38319L17.83 5.50713C17.7504 5.46731 17.6643 5.43422 17.5714 5.40769L13.3288 4.34707C12.8515 4.22775 12.3411 4.36694 11.9897 4.71828L4.41265 12.2954C3.86247 12.8455 3.86243 13.7339 4.41265 14.2841L9.71595 19.5874C10.2662 20.1376 11.1545 20.1376 11.7047 19.5874L19.2817 12.0103C19.6331 11.6589 19.7723 11.1485 19.653 10.6712ZM9.71595 9.64371C10.2662 9.09349 11.1545 9.09349 11.7047 9.64371C12.2549 10.1939 12.2549 11.0822 11.7047 11.6325C11.1545 12.1826 10.2662 12.1827 9.71595 11.6325C9.1657 11.0822 9.16577 10.1939 9.71595 9.64371ZM12.3676 16.2728C11.8174 16.823 10.9291 16.823 10.3789 16.2728C9.82864 15.7226 9.82867 14.8343 10.3789 14.2841C10.9291 13.7339 11.8174 13.7339 12.3676 14.2841C12.9178 14.8343 12.9178 15.7226 12.3676 16.2728ZM14.0767 13.0929L8.11046 13.7558C7.96318 13.7717 7.8243 13.7183 7.7269 13.6209C7.6544 13.5484 7.60486 13.4516 7.59255 13.3415C7.5644 13.0842 7.74955 12.8524 8.00686 12.8236L13.9731 12.1607C14.2301 12.1335 14.4622 12.3177 14.491 12.575C14.5191 12.8324 14.334 13.0641 14.0767 13.0929Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.8609 4.13922C19.6752 3.95359 19.3836 3.95359 19.198 4.13922L17.8301 5.50709C18.1284 5.64631 18.3604 5.87831 18.493 6.17L19.8609 4.80212C20.0465 4.6165 20.0465 4.32484 19.8609 4.13922Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalDrawerSessionsIcon = /*#__PURE__*/forwardRef(function PortalDrawerSessionsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M19.5299 4H11.9986C11.7395 4 11.5299 4.20966 11.5299 4.46875V8.25C11.5299 8.50909 11.7395 8.71875 11.9986 8.71875H15.2799V9.65625H11.0611V13.4062C11.3202 13.4062 11.5299 13.6159 11.5299 13.875C11.5299 14.1341 11.3202 14.3438 11.0611 14.3438H6.37363C6.11453 14.3438 5.90488 14.1341 5.90488 13.875C5.90488 13.6159 6.11453 13.4062 6.37363 13.4062V9.65625H5.40488C5.176 9.65625 4.98006 9.82197 4.94253 10.0481L4.07031 15.2812H19.9269L19.0547 10.0481C19.0172 9.82197 18.8212 9.65625 18.5924 9.65625H16.2174V8.71875H19.5299C19.789 8.71875 19.9986 8.50909 19.9986 8.25V4.46875C19.9986 4.20966 19.789 4 19.5299 4ZM13.8736 14.3438H12.9361C12.677 14.3438 12.4674 14.1341 12.4674 13.875C12.4674 13.6159 12.677 13.4062 12.9361 13.4062H13.8736C14.1327 13.4062 14.3424 13.6159 14.3424 13.875C14.3424 14.1341 14.1327 14.3438 13.8736 14.3438ZM13.8736 12.4688H12.9361C12.677 12.4688 12.4674 12.2591 12.4674 12C12.4674 11.7409 12.677 11.5312 12.9361 11.5312H13.8736C14.1327 11.5312 14.3424 11.7409 14.3424 12C14.3424 12.2591 14.1327 12.4688 13.8736 12.4688ZM16.6861 14.3438H15.7486C15.4895 14.3438 15.2799 14.1341 15.2799 13.875C15.2799 13.6159 15.4895 13.4062 15.7486 13.4062H16.6861C16.9452 13.4062 17.1549 13.6159 17.1549 13.875C17.1549 14.1341 16.9452 14.3438 16.6861 14.3438ZM16.6861 11.5312C16.9452 11.5312 17.1549 11.7409 17.1549 12C17.1549 12.2591 16.9452 12.4688 16.6861 12.4688H15.7486C15.4895 12.4688 15.2799 12.2591 15.2799 12C15.2799 11.7409 15.4895 11.5312 15.7486 11.5312H16.6861ZM15.7486 6.84375C15.4897 6.84375 15.2799 6.63387 15.2799 6.375C15.2799 6.11606 15.4897 5.90625 15.7486 5.90625C16.0075 5.90625 16.2174 6.11606 16.2174 6.375C16.2174 6.63387 16.0075 6.84375 15.7486 6.84375ZM17.6236 6.84375C17.3647 6.84375 17.1549 6.63387 17.1549 6.375C17.1549 6.11606 17.3647 5.90625 17.6236 5.90625C17.8825 5.90625 18.0924 6.11606 18.0924 6.375C18.0924 6.63387 17.8825 6.84375 17.6236 6.84375Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.65625 7.78125H7.78125C7.52237 7.78125 7.3125 7.99106 7.3125 8.25V13.4062H10.125V8.25C10.125 7.99106 9.91512 7.78125 9.65625 7.78125Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M4 19.5312C4 19.7903 4.20966 20 4.46875 20H19.5312C19.7903 20 20 19.7903 20 19.5312V16.2188H4V19.5312ZM11.0625 17.625H12.9375C13.1966 17.625 13.4062 17.8347 13.4062 18.0938C13.4062 18.3528 13.1966 18.5625 12.9375 18.5625H11.0625C10.8034 18.5625 10.5938 18.3528 10.5938 18.0938C10.5938 17.8347 10.8034 17.625 11.0625 17.625Z",
    fill: "currentColor"
  }));
});

var PortalDriveIcon = /*#__PURE__*/forwardRef(function PortalDriveIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M11.5254 10.4702V13.4133C10.9042 13.6124 10.4531 14.1953 10.4531 14.8818C10.4531 15.732 11.1448 16.4236 11.995 16.4236C12.8451 16.4236 13.5368 15.732 13.5368 14.8818C13.5368 14.1953 13.0858 13.6124 12.4646 13.4133V10.4702H11.5254Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.73828 17.4768H14.2518V18.416H9.73828V17.4768Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.5307 6.02197C10.4122 6.08663 9.35531 6.38032 8.40625 6.85735L9.68991 9.08069C10.2571 8.81504 10.8774 8.64428 11.5307 8.58857V6.02197Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.4688 6.02124V8.58852C13.1209 8.64471 13.7407 8.81696 14.3076 9.08405L15.5954 6.85349C14.6455 6.37799 13.5879 6.08524 12.4688 6.02124Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.4107 7.32251L15.1211 9.55613C15.6436 9.92313 16.0993 10.379 16.4659 10.9014L18.7005 9.61129C18.101 8.70026 17.3206 7.92101 16.4107 7.32251Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.4332 13.5521H20.0001C19.9358 12.4299 19.644 11.3726 19.1696 10.4248L16.9375 11.7135C17.2048 12.2809 17.3768 12.9009 17.4332 13.5521Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M5.30664 9.61467L7.53002 10.8983C7.89677 10.3744 8.35311 9.91773 8.87711 9.55098L7.59345 7.32764C6.68498 7.92689 5.90592 8.7062 5.30664 9.61467Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M7.05891 11.7112L4.83538 10.4275C4.35831 11.3766 4.06466 12.4335 4 13.552H6.56666C6.62241 12.8987 6.79325 12.2784 7.05891 11.7112Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.4328 14.4912C17.3723 15.2008 17.1764 15.8718 16.8701 16.4778C16.5624 17.0867 16.7783 17.8294 17.3692 18.1705C18.0047 18.5374 18.8188 18.2966 19.1509 17.6422C19.6359 16.6863 19.9347 15.6201 20 14.4912H17.4328Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.56697 14.4912H4C4.06534 15.6216 4.36497 16.689 4.85109 17.6459C5.18275 18.2986 5.99678 18.5366 6.63091 18.1705C7.22019 17.8302 7.4395 17.089 7.13206 16.482C6.82463 15.8749 6.62766 15.2025 6.56697 14.4912Z",
    fill: "currentColor"
  })));
});

var PortalDropInIcon = /*#__PURE__*/forwardRef(function PortalDropInIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M15.7151 4H8.28492C7.55866 4 7 4.50473 7 5.16088V18.8391C7 19.4953 7.55866 20 8.28492 20H15.7151C16.4413 20 17 19.4953 17 18.8391V5.16088C17 4.50473 16.4413 4 15.7151 4ZM16.0503 16.9716H7.94972V5.96845H16.0503V16.9716ZM13.7598 5.16088H10.2961V4.85804H13.7598V5.16088ZM15.2123 5.00946C15.2123 5.16088 15.0447 5.3123 14.8771 5.3123C14.7095 5.3123 14.5419 5.16088 14.5419 5.00946C14.5419 4.85804 14.7095 4.70662 14.8771 4.70662C15.0447 4.70662 15.2123 4.85804 15.2123 5.00946ZM13.5922 18.7382H10.4637V17.8801H13.5922V18.7382Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.5352 10.0567C13.0324 9.29962 12.4738 8.64347 12.1386 8.29016C12.1386 8.23968 12.0827 8.18921 12.0269 8.18921C11.971 8.18921 11.9151 8.23968 11.8593 8.23968C11.5799 8.54252 10.9654 9.24915 10.4626 10.0062C9.79223 11.0157 9.45703 11.8233 9.45703 12.429C9.45703 13.6908 10.5743 14.7507 12.0269 14.7507C13.4794 14.7507 14.5967 13.7413 14.5967 12.429C14.5408 11.8233 14.2056 11.0157 13.5352 10.0567ZM12.3621 13.9432C12.1945 13.9936 12.0827 13.9936 11.9151 13.9936C10.9654 13.9936 10.1833 13.3375 10.1833 12.5299C10.1833 12.328 10.2392 12.1261 10.3509 11.8738C10.3509 11.8233 10.4068 11.8233 10.4626 11.8233C10.5185 11.8233 10.5743 11.8738 10.5185 11.9242C10.5185 11.9747 10.5185 12.0252 10.5185 12.0756C10.5185 12.9337 11.3006 13.6908 12.3062 13.7413C12.3621 13.7413 12.4179 13.7917 12.4179 13.8422C12.4179 13.8927 12.4179 13.8927 12.3621 13.9432Z",
    fill: "currentColor"
  }));
});

var PortalEcommerceIcon = /*#__PURE__*/forwardRef(function PortalEcommerceIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M19.8594 7.63638C19.7408 7.49075 19.5628 7.40625 19.375 7.40625H8.05447L8.00781 6.97988C8.00731 6.97544 8.00678 6.971 8.00622 6.96656C7.78431 5.27538 6.33072 4 4.625 4C4.27981 4 4 4.27981 4 4.625C4 4.97019 4.27981 5.25 4.625 5.25C5.70338 5.25 6.62269 6.05472 6.76603 7.12294L7.66459 15.3345C7.74728 16.09 8.15884 16.7351 8.74769 17.1338C7.93085 18.3352 8.8181 20.0087 10.2813 20C11.5243 20.0172 12.4428 18.7304 12.0269 17.5625H14.7231C14.3073 18.7306 15.2255 20.0172 16.4688 20C18.9146 19.8988 18.9141 16.4135 16.4687 16.3125H10.1498C9.51088 16.3125 8.97666 15.8336 8.90716 15.1985L8.88888 15.0313H16.5342C17.7149 15.0313 18.7447 14.1919 18.9828 13.0354L19.3116 11.4385C19.3495 11.2545 19.3026 11.0632 19.1839 10.9176C19.0652 10.772 18.8873 10.6875 18.6994 10.6875H15.8883L16.0508 8.65625H18.6082L18.5956 8.71772C18.526 9.05581 18.7436 9.38631 19.0817 9.45591C19.1242 9.46466 19.1666 9.46888 19.2084 9.46888C19.4988 9.46885 19.759 9.26535 19.8199 8.96978L19.9872 8.15728C20.025 7.97328 19.9781 7.78197 19.8594 7.63638ZM16.4688 17.5625C16.7962 17.5625 17.0625 17.8288 17.0625 18.1563C17.0299 18.9439 15.9075 18.9437 15.875 18.1563C15.875 17.8288 16.1413 17.5625 16.4688 17.5625ZM10.2813 17.5625C10.6087 17.5625 10.875 17.8288 10.875 18.1563C10.8424 18.9439 9.72 18.9437 9.6875 18.1563C9.6875 17.8288 9.95385 17.5625 10.2813 17.5625ZM8.19125 8.65625H10.6367L10.7992 10.6875H8.41353L8.19125 8.65625ZM8.7521 13.7813L8.55034 11.9375H10.8993L11.0468 13.7813H8.7521ZM14.3867 13.7813H12.3007L12.1532 11.9375H14.5342L14.3867 13.7813ZM14.6342 10.6875H12.0532L11.8907 8.65625H14.7967L14.6342 10.6875ZM17.9327 11.9375L17.7585 12.7833C17.6394 13.3616 17.1246 13.7813 16.5342 13.7813H15.6407L15.7882 11.9375H17.9327Z",
    fill: "currentColor"
  })));
});

var PortalExperienceIcon = /*#__PURE__*/forwardRef(function PortalExperienceIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M14.75 9V13.5H10.25V9H14.75ZM13.2383 11.9883V10.5117H11.7617V11.9883H13.2383ZM19.25 10.5117H17.7383V11.9883H19.25V13.5H17.7383V15.0117C17.7383 15.4102 17.5859 15.7617 17.2812 16.0664C17 16.3477 16.6602 16.4883 16.2617 16.4883H14.75V18H13.2383V16.4883H11.7617V18H10.25V16.4883H8.73828C8.33984 16.4883 7.98828 16.3477 7.68359 16.0664C7.40234 15.7617 7.26172 15.4102 7.26172 15.0117V13.5H5.75V11.9883H7.26172V10.5117H5.75V9H7.26172V7.48828C7.26172 7.08984 7.40234 6.75 7.68359 6.46875C7.98828 6.16406 8.33984 6.01172 8.73828 6.01172H10.25V4.5H11.7617V6.01172H13.2383V4.5H14.75V6.01172H16.2617C16.6602 6.01172 17 6.16406 17.2812 6.46875C17.5859 6.75 17.7383 7.08984 17.7383 7.48828V9H19.25V10.5117ZM16.2617 15.0117V7.48828H8.73828V15.0117H16.2617Z",
    fill: "currentColor"
  })));
});

var PortalFraudControlsIcon = /*#__PURE__*/forwardRef(function PortalFraudControlsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M7.17383 5.97656C8.65039 4.5 10.4199 3.76172 12.4824 3.76172C14.5684 3.76172 16.3379 4.5 17.791 5.97656C19.2676 7.42969 20.0059 9.1875 20.0059 11.25C20.0059 13.3125 19.2676 15.082 17.791 16.5586C16.3379 18.0117 14.5684 18.7383 12.4824 18.7383C10.4199 18.7383 8.65039 18.0117 7.17383 16.5586C5.7207 15.082 4.99414 13.3125 4.99414 11.25C4.99414 9.1875 5.7207 7.42969 7.17383 5.97656ZM13.2559 15.0117V13.5H11.7441V15.0117H13.2559ZM13.2559 11.9883V7.48828H11.7441V11.9883H13.2559Z",
    fill: "currentColor"
  })));
});

var PortalFuelOrdersIcon = /*#__PURE__*/forwardRef(function PortalFuelOrdersIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M16.4819 14.6985C15.3359 18.387 11.2663 20.0554 8.09687 18.0467C6.83031 17.2435 5.9621 16.0606 5.53085 14.6934C4.53602 15.2529 4 15.9639 4 16.7493C4 17.6905 4.78085 18.5413 6.19873 19.1448C8.87611 20.2844 13.1263 20.285 15.8052 19.1448C17.223 18.5413 18.0039 17.6905 18.0039 16.7493C18.0039 15.9662 17.471 15.2572 16.4819 14.6985Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M14.9387 9.62623C11.58 4.17086 11.7242 4.40467 11.7164 4.39305C11.3531 3.84864 10.5993 3.88567 10.2763 4.40576L7.02689 9.65558C5.37636 12.1421 6.00302 15.6295 8.50184 17.2133C10.8855 18.7237 13.7673 17.86 15.1419 15.5415C16.2168 13.7285 16.132 11.3758 14.9387 9.62623Z",
    fill: "currentColor"
  }));
});

var PortalFuelTankActivitiesIcon = /*#__PURE__*/forwardRef(function PortalFuelTankActivitiesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M15.459 3H5.49805C5.22246 3 5 3.22246 5 3.49805V17.5098C5 17.7854 5.22246 18.0078 5.49805 18.0078H11.2422C11.2389 18.0012 11.2389 17.9979 11.2355 17.9912C11.0695 17.5629 10.9766 17.0516 10.9766 16.5137C10.9766 14.0434 12.9887 12.0312 15.459 12.0312C15.6283 12.0312 15.791 12.0645 15.957 12.0811V3.49805C15.957 3.22246 15.7346 3 15.459 3ZM7.49023 13.0273C7.21465 13.0273 6.99219 12.8049 6.99219 12.5293C6.99219 12.2537 7.21465 12.0312 7.49023 12.0312C7.76582 12.0312 7.98828 12.2537 7.98828 12.5293C7.98828 12.8049 7.76582 13.0273 7.49023 13.0273ZM7.49023 11.0352C7.21465 11.0352 6.99219 10.8127 6.99219 10.5371C6.99219 10.2615 7.21465 10.0391 7.49023 10.0391C7.76582 10.0391 7.98828 10.2615 7.98828 10.5371C7.98828 10.8127 7.76582 11.0352 7.49023 11.0352ZM7.49023 9.04297C7.21465 9.04297 6.99219 8.82051 6.99219 8.54492C6.99219 8.26934 7.21465 8.04688 7.49023 8.04688C7.76582 8.04688 7.98828 8.26934 7.98828 8.54492C7.98828 8.82051 7.76582 9.04297 7.49023 9.04297ZM7.49023 7.05078C7.21465 7.05078 6.99219 6.82832 6.99219 6.55273C6.99219 6.27715 7.21465 6.05469 7.49023 6.05469C7.76582 6.05469 7.98828 6.27715 7.98828 6.55273C7.98828 6.82832 7.76582 7.05078 7.49023 7.05078ZM11.4746 13.0273H9.48242C9.20684 13.0273 8.98437 12.8049 8.98437 12.5293C8.98437 12.2537 9.20684 12.0312 9.48242 12.0312H11.4746C11.7502 12.0312 11.9727 12.2537 11.9727 12.5293C11.9727 12.8049 11.7502 13.0273 11.4746 13.0273ZM13.4668 11.0352H9.48242C9.20684 11.0352 8.98437 10.8127 8.98437 10.5371C8.98437 10.2615 9.20684 10.0391 9.48242 10.0391H13.4668C13.7424 10.0391 13.9648 10.2615 13.9648 10.5371C13.9648 10.8127 13.7424 11.0352 13.4668 11.0352ZM13.4668 9.04297H9.48242C9.20684 9.04297 8.98437 8.82051 8.98437 8.54492C8.98437 8.26934 9.20684 8.04688 9.48242 8.04688H13.4668C13.7424 8.04688 13.9648 8.26934 13.9648 8.54492C13.9648 8.82051 13.7424 9.04297 13.4668 9.04297ZM13.4668 7.05078H9.48242C9.20684 7.05078 8.98437 6.82832 8.98437 6.55273C8.98437 6.27715 9.20684 6.05469 9.48242 6.05469H13.4668C13.7424 6.05469 13.9648 6.27715 13.9648 6.55273C13.9648 6.82832 13.7424 7.05078 13.4668 7.05078Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.2432 12.5293C13.1846 12.5293 11.5078 14.2061 11.5078 16.2646C11.5078 18.3232 13.1846 20 15.2432 20C17.3018 20 18.9785 18.3232 18.9785 16.2646C18.9785 14.2061 17.3018 12.5293 15.2432 12.5293ZM17.0195 18.1971C16.9598 18.2568 16.8801 18.2867 16.8004 18.2867C16.7207 18.2867 16.641 18.2568 16.5812 18.1971L15.024 16.6398C14.9643 16.5801 14.9344 16.5037 14.9344 16.4207V14.3986C14.9344 14.226 15.0738 14.0865 15.2465 14.0865C15.4191 14.0865 15.5586 14.226 15.5586 14.3986V16.2945L17.0229 17.7588C17.1424 17.8783 17.1424 18.0742 17.0195 18.1971Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "13.9785",
    height: "17",
    fill: "currentColor",
    transform: "translate(5 3)"
  }))));
});

var PortalFuelTankIcon = /*#__PURE__*/forwardRef(function PortalFuelTankIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.125 7.66406C18.5 8.03906 18.6875 8.48438 18.6875 9V16.1367C18.6875 16.6523 18.5 17.0977 18.125 17.4727C17.7734 17.8242 17.3398 18 16.8242 18C16.3086 18 15.8633 17.8242 15.4883 17.4727C15.1133 17.0977 14.9258 16.6523 14.9258 16.1367V12.375H13.8008V18H6.3125V6.01172C6.3125 5.58984 6.45312 5.23828 6.73438 4.95703C7.03906 4.65234 7.40234 4.5 7.82422 4.5H12.3242C12.7227 4.5 13.0625 4.65234 13.3438 4.95703C13.6484 5.23828 13.8008 5.58984 13.8008 6.01172V11.25H14.5742C14.9727 11.25 15.3125 11.4023 15.5938 11.707C15.8984 11.9883 16.0508 12.3398 16.0508 12.7617V16.1367C16.0508 16.3242 16.1211 16.5 16.2617 16.6641C16.4258 16.8047 16.6016 16.875 16.7891 16.875C17 16.875 17.1758 16.8047 17.3164 16.6641C17.4805 16.5 17.5625 16.3242 17.5625 16.1367V10.7227C17.3047 10.8164 17.0586 10.8633 16.8242 10.8633C16.3086 10.8633 15.8633 10.6875 15.4883 10.3359C15.1133 9.96094 14.9258 9.51562 14.9258 9C14.9258 8.60156 15.0312 8.25 15.2422 7.94531C15.4766 7.61719 15.7812 7.38281 16.1562 7.24219L14.5742 5.66016L15.3477 4.88672L18.1602 7.66406H18.125ZM12.3242 9.73828V6.01172H7.82422V9.73828H12.3242ZM16.2617 9.52734C16.4258 9.66797 16.6016 9.73828 16.7891 9.73828C17 9.73828 17.1758 9.66797 17.3164 9.52734C17.4805 9.38672 17.5625 9.21094 17.5625 9C17.5625 8.78906 17.4805 8.61328 17.3164 8.47266C17.1758 8.33203 17 8.26172 16.7891 8.26172C16.6016 8.26172 16.4258 8.33203 16.2617 8.47266C16.1211 8.61328 16.0508 8.78906 16.0508 9C16.0508 9.21094 16.1211 9.38672 16.2617 9.52734Z",
    fill: "currentColor"
  })));
});

var PortalFuellingIcon = /*#__PURE__*/forwardRef(function PortalFuellingIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M12.7052 4.57645C12.2468 3.79443 11.7614 3.82139 11.303 4.57645C9.1996 7.70454 6.01758 12.3967 6.01758 14.7427C6.01758 16.3877 6.69174 17.8978 7.77039 18.9764C8.84904 20.0551 10.3592 20.7293 12.0041 20.7293C13.649 20.7293 15.1592 20.0551 16.2378 18.9764C17.3165 17.8978 17.9906 16.3877 17.9906 14.7427C17.9906 12.3697 14.8086 7.70454 12.7052 4.57645ZM16.3187 17.4124C15.8872 18.1135 15.267 18.7338 14.512 19.1652C14.1614 19.354 13.7299 19.2461 13.5412 18.8955C13.3254 18.518 13.4603 18.0866 13.8108 17.8978C14.3502 17.6012 14.7816 17.1697 15.1052 16.6573C15.4288 16.145 15.6176 15.5517 15.6445 14.9315C15.6715 14.527 15.9951 14.2304 16.3996 14.2573C16.8041 14.2843 17.1007 14.6079 17.0738 15.0124C17.0198 15.8753 16.7502 16.6843 16.3187 17.4124Z",
    fill: "currentColor"
  })));
});

var PortalFulfillmentIcon = /*#__PURE__*/forwardRef(function PortalFulfillmentIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M17.5155 9H6.48633V13.9093H17.5155V9Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M18.6019 6H5.39806C4.62716 6 4 6.76231 4 7.69935V15.252C4 16.189 4.62716 16.9514 5.39806 16.9514H18.6019C19.3728 16.9514 20 16.1891 20 15.252V7.69935C20 6.76231 19.3728 6 18.6019 6ZM18.4466 14.4967C18.4466 14.8096 18.2379 15.0632 17.9806 15.0632H6.01941C5.76203 15.0632 5.55338 14.8096 5.55338 14.4967V8.4546C5.55338 8.14176 5.76203 7.88814 6.01941 7.88814H17.9806C18.2379 7.88814 18.4466 8.14176 18.4466 8.4546V14.4967Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M14.5638 19.1263H13.7871V17.8835H10.3697V19.1263H9.59298C9.33561 19.1263 9.12695 19.3349 9.12695 19.5923C9.12695 19.8497 9.33561 20.0583 9.59298 20.0583H14.5639C14.8212 20.0583 15.0299 19.8497 15.0299 19.5923C15.0299 19.3349 14.8212 19.1263 14.5638 19.1263Z",
    fill: "currentColor"
  }));
});

var PortalGamificationIcon = /*#__PURE__*/forwardRef(function PortalGamificationIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M18.125 4.9375C17.782 4.9375 17.4331 5.03678 17.1562 5.19825V4.46875C17.1562 4.20981 16.9464 4 16.6875 4H7.3125C7.05363 4 6.84375 4.20981 6.84375 4.46875V5.19825C6.56687 5.03678 6.21803 4.9375 5.875 4.9375C4.84091 4.9375 4 5.77841 4 6.8125V8.40369C4 9.03219 4.31219 9.61538 4.83497 9.96375L7.0525 11.4212C7.06056 11.4266 7.07041 11.4244 7.07872 11.4292C7.42491 12.3888 8.15228 13.1635 9.22553 13.6648C9.92203 13.9903 10.3811 14.6409 10.5272 15.3125H13.449C13.5474 14.6627 13.9186 14.0185 14.4962 13.6918C15.6214 13.055 16.472 12.3854 16.882 11.4412C16.9033 11.4312 16.9273 11.4347 16.9475 11.4213L19.1651 9.96375C19.6878 9.61538 20 9.03219 20 8.40369V6.8125C20 5.77841 19.1591 4.9375 18.125 4.9375ZM5.35497 9.18372C5.09359 9.00931 4.9375 8.71772 4.9375 8.40369V6.8125C4.9375 6.29569 5.35819 5.875 5.875 5.875C6.39181 5.875 6.84375 6.29569 6.84375 6.8125V10.0938C6.84375 10.1158 6.84781 10.1363 6.84816 10.1583L5.35497 9.18372ZM14.6628 8.37622L13.6713 9.34256L13.9052 10.7067C13.9354 10.8825 13.8631 11.0601 13.7189 11.1649C13.5737 11.2709 13.3808 11.283 13.2254 11.2006L12 10.557L10.7746 11.2006C10.618 11.2839 10.4257 11.2702 10.2811 11.1649C10.1369 11.0601 10.0646 10.8825 10.0948 10.7067L10.3287 9.34256L9.33716 8.37622C9.20944 8.25172 9.16366 8.06541 9.21859 7.89603C9.27397 7.72619 9.42047 7.60259 9.59716 7.57697L10.9668 7.37784L11.5797 6.13637C11.7372 5.81594 12.2627 5.81594 12.4202 6.13637L13.0331 7.37784L14.4028 7.57697C14.5794 7.60259 14.7259 7.72619 14.7813 7.89603C14.8363 8.06541 14.7905 8.25172 14.6628 8.37622ZM19.0625 8.40369H19.0625C19.0625 8.71772 18.9064 9.00931 18.645 9.18372L17.1511 10.1588C17.1515 10.1362 17.1563 10.1167 17.1563 10.0938V6.8125C17.1563 6.29569 17.6082 5.875 18.125 5.875C18.6418 5.875 19.0625 6.29569 19.0625 6.8125V8.40369Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.75 18.5938H13.875C13.6159 18.5938 13.4062 18.3841 13.4062 18.125C13.4062 17.8659 13.6159 17.6562 13.875 17.6562H15.2812V17.1875C15.2812 16.6697 14.8615 16.25 14.3438 16.25H9.65625C9.13847 16.25 8.71875 16.6697 8.71875 17.1875V17.6562H10.125C10.3841 17.6562 10.5938 17.8659 10.5938 18.125C10.5938 18.3841 10.3841 18.5938 10.125 18.5938H8.25C7.99112 18.5938 7.78125 18.8036 7.78125 19.0625V19.5312C7.78125 19.7901 7.99112 20 8.25 20H15.75C16.0089 20 16.2188 19.7901 16.2188 19.5312V19.0625C16.2188 18.8036 16.0089 18.5938 15.75 18.5938Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.3278 8.36805L12.6545 8.27008C12.5016 8.24814 12.3697 8.15198 12.3015 8.01377L11.9998 7.40308L11.6982 8.01373C11.63 8.15198 11.4982 8.24811 11.3452 8.27008L10.6719 8.36805L11.1594 8.84321C11.2697 8.95077 11.3201 9.10596 11.294 9.25793L11.1791 9.92946L11.782 9.61268C11.918 9.54055 12.0817 9.54055 12.2177 9.61268L12.8206 9.92946L12.7057 9.25793C12.6796 9.10596 12.73 8.95077 12.8403 8.84321L13.3278 8.36805Z",
    fill: "currentColor"
  }));
});

var PortalGatewayIcon = /*#__PURE__*/forwardRef(function PortalGatewayIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M18.8582 5.14307H5.14357C4.51106 5.14307 4 5.65236 4 6.28488V17.7153C4 18.3455 4.51106 18.8571 5.14357 18.8571H18.8582C19.4866 18.8571 20 18.3455 20 17.7153V6.28488C20 5.65236 19.4872 5.14307 18.8582 5.14307ZM9.46555 6.00148C9.78004 6.00148 10.0353 6.25436 10.0353 6.57238C10.0353 6.88747 9.78004 7.14329 9.46555 7.14329C9.14988 7.14329 8.89171 6.88747 8.89171 6.57238C8.89171 6.25436 9.14988 6.00148 9.46555 6.00148ZM7.71587 6.00148C8.02978 6.00148 8.28677 6.25436 8.28677 6.57238C8.28677 6.88747 8.02978 7.14329 7.71587 7.14329C7.39844 7.14329 7.14262 6.88747 7.14262 6.57238C7.14262 6.25436 7.39844 6.00148 7.71587 6.00148ZM5.99963 6.00148C6.31589 6.00148 6.57112 6.25436 6.57112 6.57238C6.57112 6.88747 6.31589 7.14329 5.99963 7.14329C5.68514 7.14329 5.42932 6.88747 5.42932 6.57238C5.42932 6.25436 5.68514 6.00148 5.99963 6.00148ZM18.8582 17.7159H5.14357V8.01285H18.8582V17.7159Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M18.8572 8.01294H5.14258V17.716H18.8572V8.01294Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.12496 9.57178H6.45508V11.2446H8.12496V9.57178Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M10.5005 9.57178H8.83008V11.2446H10.5005V9.57178Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.8638 9.57178H11.1934V11.2446H12.8638V9.57178Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.12496 11.7522H6.45508V13.4238H8.12496V11.7522Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M10.5005 11.7522H8.83008V13.4238H10.5005V11.7522Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.8638 11.7522H11.1934V13.4238H12.8638V11.7522Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.13199 14.01H6.46094V15.6817H8.13199V14.01Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M10.5072 14.01H8.83789V15.6817H10.5072V14.01Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.8697 14.01H11.1992V15.6817H12.8697V14.01Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.1779 9.57178H13.5098V11.2446H15.1779V9.57178Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.541 9.57178H15.8711V11.2446H17.541V9.57178Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.1779 11.7522H13.5098V13.4238H15.1779V11.7522Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.541 11.7522H15.8711V13.4238H17.541V11.7522Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.1836 14.01H13.5137V15.6817H15.1836V14.01Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.5462 14.01H15.877V15.6817H17.5462V14.01Z",
    fill: "currentColor"
  }));
});

var PortalGiftIcon = /*#__PURE__*/forwardRef(function PortalGiftIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M12.4824 18.2461L11.3926 17.2617C10.4082 16.3711 9.68164 15.7148 9.21289 15.293C8.74414 14.8477 8.18164 14.2734 7.52539 13.5703C6.86914 12.8672 6.38867 12.293 6.08398 11.8477C5.80273 11.4023 5.54492 10.8984 5.31055 10.3359C5.09961 9.75 4.99414 9.17578 4.99414 8.61328C4.99414 7.46484 5.39258 6.49219 6.18945 5.69531C6.98633 4.89844 7.95898 4.5 9.10742 4.5C10.4668 4.5 11.5918 5.02734 12.4824 6.08203C13.373 5.02734 14.498 4.5 15.8574 4.5C17.0293 4.5 18.0137 4.89844 18.8105 5.69531C19.6074 6.49219 20.0059 7.46484 20.0059 8.61328C20.0059 9.17578 19.8887 9.75 19.6543 10.3359C19.4199 10.8984 19.1621 11.4023 18.8809 11.8477C18.5996 12.293 18.1191 12.8672 17.4395 13.5703C16.7832 14.2734 16.2207 14.8477 15.752 15.293C15.3066 15.7148 14.5801 16.3828 13.5723 17.2969L12.4824 18.2461Z",
    fill: "currentColor"
  })));
});

var PortalGiftsIcon = /*#__PURE__*/forwardRef(function PortalGiftsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.4941 6.75C18.916 6.75 19.2676 6.90234 19.5488 7.20703C19.8535 7.48828 20.0059 7.83984 20.0059 8.26172V16.4883C20.0059 16.9102 19.8535 17.2734 19.5488 17.5781C19.2676 17.8594 18.916 18 18.4941 18H6.50586C6.08398 18 5.7207 17.8594 5.41602 17.5781C5.13477 17.2734 4.99414 16.9102 4.99414 16.4883V8.26172C4.99414 7.83984 5.13477 7.48828 5.41602 7.20703C5.7207 6.90234 6.08398 6.75 6.50586 6.75H8.12305C8.0293 6.49219 7.98242 6.24609 7.98242 6.01172C7.98242 5.37891 8.20508 4.85156 8.65039 4.42969C9.0957 3.98437 9.62305 3.76172 10.2324 3.76172C11.0293 3.76172 11.6621 4.08984 12.1309 4.74609L12.4824 5.27344L12.8691 4.74609C13.3145 4.08984 13.9355 3.76172 14.7324 3.76172C15.3652 3.76172 15.8926 3.98437 16.3145 4.42969C16.7598 4.85156 16.9824 5.37891 16.9824 6.01172C16.9824 6.24609 16.9355 6.49219 16.8418 6.75H18.4941ZM15.2598 5.48438C15.1191 5.32031 14.9434 5.23828 14.7324 5.23828C14.5449 5.23828 14.3691 5.32031 14.2051 5.48438C14.0645 5.625 13.9941 5.80078 13.9941 6.01172C13.9941 6.19922 14.0645 6.375 14.2051 6.53906C14.3691 6.67969 14.5449 6.75 14.7324 6.75C14.9434 6.75 15.1191 6.67969 15.2598 6.53906C15.4238 6.375 15.5059 6.19922 15.5059 6.01172C15.5059 5.80078 15.4238 5.625 15.2598 5.48438ZM10.7598 5.48438C10.6191 5.32031 10.4434 5.23828 10.2324 5.23828C10.0449 5.23828 9.86914 5.32031 9.70508 5.48438C9.56445 5.625 9.49414 5.80078 9.49414 6.01172C9.49414 6.19922 9.56445 6.375 9.70508 6.53906C9.86914 6.67969 10.0449 6.75 10.2324 6.75C10.4434 6.75 10.6191 6.67969 10.7598 6.53906C10.9238 6.375 11.0059 6.19922 11.0059 6.01172C11.0059 5.80078 10.9238 5.625 10.7598 5.48438ZM18.4941 16.4883V15.0117H6.50586V16.4883H18.4941ZM18.4941 12.7617V8.26172H14.6973L16.2441 10.3711L15.0137 11.25L13.2559 8.82422L12.4824 7.80469L11.7441 8.82422L9.95117 11.25L8.75586 10.3711L10.3027 8.26172H6.50586V12.7617H18.4941Z",
    fill: "currentColor"
  })));
});

var PortalHomeIcon = /*#__PURE__*/forwardRef(function PortalHomeIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M11.0059 17.2617H7.24414V11.25H4.99414L12.4824 4.5L20.0059 11.25H17.7559V17.2617H13.9941V12.7617H11.0059V17.2617Z",
    fill: "currentColor"
  })));
});

var PortalHome2Icon = /*#__PURE__*/forwardRef(function PortalHome2Icon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M11.9995 7.20386L6.29321 11.9081C6.29321 11.9148 6.29155 11.9245 6.28821 11.9378C6.28494 11.951 6.2832 11.9606 6.2832 11.9674V16.731C6.2832 16.903 6.34608 17.0521 6.47181 17.1776C6.5975 17.3032 6.74635 17.3664 6.91837 17.3664H10.7291V13.5554H13.27V17.3665H17.0807C17.2527 17.3665 17.4017 17.3034 17.5273 17.1776C17.653 17.0522 17.7161 16.903 17.7161 16.731V11.9674C17.7161 11.941 17.7125 11.9211 17.7061 11.9081L11.9995 7.20386Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.8896 10.8363L17.7163 9.03006V4.98097C17.7163 4.88841 17.6866 4.81228 17.6269 4.7527C17.5676 4.69319 17.4915 4.66344 17.3987 4.66344H15.4933C15.4007 4.66344 15.3246 4.69319 15.265 4.7527C15.2055 4.81228 15.1758 4.88844 15.1758 4.98097V6.91617L12.7543 4.89157C12.5428 4.71954 12.2914 4.63354 12.0002 4.63354C11.7091 4.63354 11.4577 4.71954 11.246 4.89157L4.11028 10.8363C4.04413 10.8891 4.00788 10.9602 4.00113 11.0495C3.99442 11.1388 4.01754 11.2168 4.07055 11.2829L4.68584 12.0173C4.73884 12.0768 4.80823 12.1132 4.89426 12.1265C4.97368 12.1332 5.05311 12.11 5.13254 12.0571L12 6.33063L18.8676 12.057C18.9206 12.1032 18.99 12.1262 19.076 12.1262H19.1058C19.1917 12.1132 19.2609 12.0765 19.3142 12.0172L19.9296 11.2829C19.9825 11.2166 20.0057 11.1388 19.9988 11.0494C19.992 10.9603 19.9556 10.8892 19.8896 10.8363Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 3)"
  }))));
});

var PortalInventoryIcon = /*#__PURE__*/forwardRef(function PortalInventoryIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M11.0059 5.23828L12.4824 6.75H18.4941C18.916 6.75 19.2676 6.90234 19.5488 7.20703C19.8535 7.48828 20.0059 7.83984 20.0059 8.26172V15.75C20.0059 16.1719 19.8535 16.5352 19.5488 16.8398C19.2676 17.1211 18.916 17.2617 18.4941 17.2617H6.50586C6.08398 17.2617 5.7207 17.1211 5.41602 16.8398C5.13477 16.5352 4.99414 16.1719 4.99414 15.75V6.75C4.99414 6.32812 5.13477 5.97656 5.41602 5.69531C5.7207 5.39062 6.08398 5.23828 6.50586 5.23828H11.0059Z",
    fill: "currentColor"
  })));
});

var PortalInvoicesIcon = /*#__PURE__*/forwardRef(function PortalInvoicesIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M17.9019 7.43059L14.5694 4.09806C14.5091 4.03753 14.4257 4 14.3333 4H7.33334C6.59831 4 6 4.59797 6 5.33334V18.6667C6 19.402 6.59831 20 7.33334 20H16.6667C17.4017 20 18 19.402 18 18.6667V7.66666C18 7.57434 17.9625 7.49094 17.9019 7.43059ZM9 8.66666C8.44856 8.66666 8 8.21809 8 7.66666C8 7.23266 8.2795 6.86612 8.66666 6.72806V6.66666C8.66666 6.48241 8.81575 6.33331 9 6.33331C9.18425 6.33331 9.33334 6.48241 9.33334 6.66666H9.66669C9.85091 6.66666 10 6.81575 10 7C10 7.18425 9.85091 7.33334 9.66666 7.33334H9C8.81641 7.33334 8.66666 7.48275 8.66666 7.66669C8.66666 7.85059 8.81641 8.00003 9 8.00003C9.55144 8.00003 10 8.44859 10 9.00003C10 9.43403 9.7205 9.80056 9.33334 9.93862V10C9.33334 10.1842 9.18425 10.3333 9 10.3333C8.81575 10.3333 8.66666 10.1842 8.66666 10H8.33331C8.14906 10 7.99997 9.85091 7.99997 9.66666C7.99997 9.48241 8.14906 9.33331 8.33331 9.33331H9C9.18359 9.33331 9.33334 9.18391 9.33334 8.99997C9.33334 8.81603 9.18359 8.66666 9 8.66666ZM12.3333 18H8.33334C8.14909 18 8 17.8509 8 17.6667C8 17.4824 8.14909 17.3333 8.33334 17.3333H12.3333C12.5176 17.3333 12.6667 17.4824 12.6667 17.6667C12.6667 17.8509 12.5176 18 12.3333 18ZM15.6667 16H8.33334C8.14909 16 8 15.8509 8 15.6667C8 15.4824 8.14909 15.3333 8.33334 15.3333H15.6667C15.8509 15.3333 16 15.4824 16 15.6667C16 15.8509 15.8509 16 15.6667 16ZM15.6667 14H8.33334C8.14909 14 8 13.8509 8 13.6667C8 13.4824 8.14909 13.3333 8.33334 13.3333H15.6667C15.8509 13.3333 16 13.4824 16 13.6667C16 13.8509 15.8509 14 15.6667 14ZM15.6667 12H8.33334C8.14909 12 8 11.8509 8 11.6667C8 11.4824 8.14909 11.3333 8.33334 11.3333H15.6667C15.8509 11.3333 16 11.4824 16 11.6667C16 11.8509 15.8509 12 15.6667 12ZM15.6667 10H11.6667C11.4824 10 11.3333 9.85091 11.3333 9.66666C11.3333 9.48241 11.4824 9.33331 11.6667 9.33331H15.6667C15.8509 9.33331 16 9.48241 16 9.66666C16 9.85091 15.8509 10 15.6667 10ZM15.3333 7.33334C14.9655 7.33334 14.6667 7.03419 14.6667 6.66669V5.13803L16.862 7.33334H15.3333Z",
    fill: "currentColor"
  }));
});

var PortalItemCategoriesIcon = /*#__PURE__*/forwardRef(function PortalItemCategoriesIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M18.2857 4H5.71428C4.76751 4 4 4.76751 4 5.71428V18.2857C4 19.2325 4.76751 20 5.71428 20H18.2857C19.2325 20 20 19.2325 20 18.2857V5.71428C20 4.76751 19.2325 4 18.2857 4ZM9.14285 16.5714H7.42857C7.11297 16.5714 6.85713 16.3156 6.85713 16C6.85713 15.6844 7.11297 15.4286 7.42857 15.4286H9.14285C9.45846 15.4286 9.71429 15.6844 9.71429 16C9.71429 16.3156 9.45846 16.5714 9.14285 16.5714ZM9.14285 12.5714H7.42857C7.11297 12.5714 6.85713 12.3156 6.85713 12C6.85713 11.6844 7.11297 11.4285 7.42857 11.4285H9.14285C9.45846 11.4285 9.71429 11.6844 9.71429 12C9.71429 12.3156 9.45846 12.5714 9.14285 12.5714ZM9.14285 8.57141H7.42857C7.11297 8.57141 6.85713 8.31558 6.85713 7.99997C6.85713 7.68437 7.11297 7.42857 7.42857 7.42857H9.14285C9.45846 7.42857 9.71429 7.68441 9.71429 8.00001C9.71429 8.31561 9.45846 8.57141 9.14285 8.57141ZM16.5714 16.5714H11.4286C11.113 16.5714 10.8571 16.3156 10.8571 16C10.8571 15.6844 11.113 15.4286 11.4286 15.4286H16.5714C16.887 15.4286 17.1429 15.6844 17.1429 16C17.1429 16.3156 16.887 16.5714 16.5714 16.5714ZM16.5714 12.5714H11.4286C11.113 12.5714 10.8571 12.3156 10.8571 12C10.8571 11.6844 11.113 11.4285 11.4286 11.4285H16.5714C16.887 11.4285 17.1429 11.6844 17.1429 12C17.1429 12.3156 16.887 12.5714 16.5714 12.5714ZM16.5714 8.57141H11.4286C11.113 8.57141 10.8571 8.31558 10.8571 7.99997C10.8571 7.68437 11.113 7.42854 11.4286 7.42854H16.5714C16.887 7.42854 17.1429 7.68437 17.1429 7.99997C17.1429 8.31558 16.887 8.57141 16.5714 8.57141Z",
    fill: "currentColor"
  }));
});

var PortalItemModifiersIcon = /*#__PURE__*/forwardRef(function PortalItemModifiersIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M10.4161 16.3474C10.3721 16.3908 10.3414 16.4461 10.3274 16.5068L9.60074 19.5908C9.57407 19.7028 9.60807 19.8214 9.6894 19.9028C9.75273 19.9654 9.83807 20.0001 9.9254 20.0001C9.95073 20.0001 9.97673 19.9974 10.0021 19.9908L13.0854 19.2641C13.1454 19.2501 13.2007 19.2194 13.2447 19.1754L17.6054 14.8148L14.7767 11.9861L10.4161 16.3474Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.609 10.9261L18.6664 9.98347C18.1624 9.47947 17.2844 9.47947 16.7804 9.98347L15.4844 11.2795L18.313 14.1081L19.609 12.8121C19.861 12.5601 19.9997 12.2255 19.9997 11.8695C19.9997 11.5128 19.861 11.1781 19.609 10.9261Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M8.56 16.6667H5.66667C5.48267 16.6667 5.33333 16.5173 5.33333 16.3333V14.6667H10.3333C10.7013 14.6667 11 14.368 11 14V11.3333H13.7133C14.0813 11.3333 14.38 11.0347 14.38 10.6667C14.38 10.2987 14.0813 10 13.7133 10H11V8H15.3333V8.66667C15.3333 9.03467 15.632 9.33333 16 9.33333C16.368 9.33333 16.6667 9.03467 16.6667 8.66667V5.5C16.6667 4.67267 15.994 4 15.1667 4H5.5C4.67267 4 4 4.67267 4 5.5V16.3333C4 17.252 4.748 18 5.66667 18H8.56C8.928 18 9.22667 17.7013 9.22667 17.3333C9.22667 16.9653 8.928 16.6667 8.56 16.6667ZM9.66667 13.3333H5.33333V11.3333H9.66667V13.3333ZM9.66667 10H5.33333V8H9.66667V10Z",
    fill: "currentColor"
  }));
});

var PortalItemOptionsIcon = /*#__PURE__*/forwardRef(function PortalItemOptionsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M18.5938 5.90625H5.40625C4.63081 5.90625 4 6.53706 4 7.3125V16.6875C4 17.4629 4.63081 18.0938 5.40625 18.0938H18.5938C19.3692 18.0938 20 17.4629 20 16.6875V7.3125C20 6.53706 19.3692 5.90625 18.5938 5.90625ZM6.84375 14.8125C6.84375 15.0716 6.63409 15.2812 6.375 15.2812C6.11591 15.2812 5.90625 15.0716 5.90625 14.8125V9.1875C5.90625 8.92841 6.11591 8.71875 6.375 8.71875C6.63409 8.71875 6.84375 8.92841 6.84375 9.1875V14.8125ZM8.25 15.2812C7.99113 15.2812 7.78125 15.0714 7.78125 14.8125C7.78125 14.5536 7.99113 14.3438 8.25 14.3438C8.50887 14.3438 8.71875 14.5536 8.71875 14.8125C8.71875 15.0714 8.50887 15.2812 8.25 15.2812ZM8.71875 12.9375C8.71875 13.1966 8.50909 13.4062 8.25 13.4062C7.99091 13.4062 7.78125 13.1966 7.78125 12.9375V9.1875C7.78125 8.92841 7.99091 8.71875 8.25 8.71875C8.50909 8.71875 8.71875 8.92841 8.71875 9.1875V12.9375ZM10.125 15.2812C9.86613 15.2812 9.65625 15.0714 9.65625 14.8125C9.65625 14.5536 9.86613 14.3438 10.125 14.3438C10.3839 14.3438 10.5938 14.5536 10.5938 14.8125C10.5938 15.0714 10.3839 15.2812 10.125 15.2812ZM10.5938 12.9375C10.5938 13.1966 10.3841 13.4062 10.125 13.4062C9.86591 13.4062 9.65625 13.1966 9.65625 12.9375V9.1875C9.65625 8.92841 9.86591 8.71875 10.125 8.71875C10.3841 8.71875 10.5938 8.92841 10.5938 9.1875V12.9375ZM12 15.2812C11.7411 15.2812 11.5312 15.0714 11.5312 14.8125C11.5312 14.5536 11.7411 14.3438 12 14.3438C12.2589 14.3438 12.4688 14.5536 12.4688 14.8125C12.4688 15.0714 12.2589 15.2812 12 15.2812ZM12.4688 12.9375C12.4688 13.1966 12.2591 13.4062 12 13.4062C11.7409 13.4062 11.5312 13.1966 11.5312 12.9375V9.1875C11.5312 8.92841 11.7409 8.71875 12 8.71875C12.2591 8.71875 12.4688 8.92841 12.4688 9.1875V12.9375ZM13.875 15.2812C13.6161 15.2812 13.4062 15.0714 13.4062 14.8125C13.4062 14.5536 13.6161 14.3438 13.875 14.3438C14.1339 14.3438 14.3438 14.5536 14.3438 14.8125C14.3438 15.0714 14.1339 15.2812 13.875 15.2812ZM14.3438 12.9375C14.3438 13.1966 14.1341 13.4062 13.875 13.4062C13.6159 13.4062 13.4062 13.1966 13.4062 12.9375V9.1875C13.4062 8.92841 13.6159 8.71875 13.875 8.71875C14.1341 8.71875 14.3438 8.92841 14.3438 9.1875V12.9375ZM15.75 15.2812C15.4911 15.2812 15.2812 15.0714 15.2812 14.8125C15.2812 14.5536 15.4911 14.3438 15.75 14.3438C16.0089 14.3438 16.2188 14.5536 16.2188 14.8125C16.2188 15.0714 16.0089 15.2812 15.75 15.2812ZM16.2188 12.9375C16.2188 13.1966 16.0091 13.4062 15.75 13.4062C15.4909 13.4062 15.2812 13.1966 15.2812 12.9375V9.1875C15.2812 8.92841 15.4909 8.71875 15.75 8.71875C16.0091 8.71875 16.2188 8.92841 16.2188 9.1875V12.9375ZM18.0938 14.8125C18.0938 15.0716 17.8841 15.2812 17.625 15.2812C17.3659 15.2812 17.1562 15.0716 17.1562 14.8125V9.1875C17.1562 8.92841 17.3659 8.71875 17.625 8.71875C17.8841 8.71875 18.0938 8.92841 18.0938 9.1875V14.8125Z",
    fill: "currentColor"
  }));
});

var PortalItemsIcon = /*#__PURE__*/forwardRef(function PortalItemsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M8.83398 15.1267C8.41089 14.884 8.125 14.4281 8.125 13.9062C8.125 11.7523 9.87732 10 12.0312 10H13.641L13.7168 8.75H4.5957L5.25085 19.5596C5.26587 19.807 5.47083 20 5.71875 20H8.59497C8.30005 19.608 8.125 19.121 8.125 18.5938C8.125 17.986 8.5127 17.467 9.05371 17.2711C8.86194 16.9771 8.75 16.6265 8.75 16.25C8.75 15.8732 8.86218 15.5222 9.05432 15.2279C8.90149 15.1935 8.81665 15.1597 8.83398 15.1267Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.15576 7.81262C9.15613 7.81262 9.15649 7.8125 9.15686 7.8125H13.8438C14.1027 7.8125 14.3125 7.60266 14.3125 7.34375C14.3125 7.08484 14.1027 6.875 13.8438 6.875H10.0216L11.2852 4.9375H12.9062C13.1652 4.9375 13.375 4.72766 13.375 4.46875C13.375 4.20984 13.1652 4 12.9062 4H11.0312C10.8728 4 10.7251 4.07996 10.6387 4.21265L8.90234 6.875H4.46875C4.20984 6.875 4 7.08484 4 7.34375C4 7.60266 4.20984 7.8125 4.46875 7.8125H9.15405C9.15466 7.8125 9.15527 7.81262 9.15576 7.81262Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.0625 13.9062C9.0625 14.1652 9.27234 14.375 9.53125 14.375H19.5312C19.7902 14.375 20 14.1652 20 13.9062C20 12.2693 18.6682 10.9375 17.0312 10.9375H12.0312C10.3943 10.9375 9.0625 12.2693 9.0625 13.9062Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M10.625 15.3125C10.1072 15.3125 9.6875 15.7322 9.6875 16.25C9.6875 16.7678 10.1072 17.1875 10.625 17.1875H18.4375C18.9553 17.1875 19.375 16.7678 19.375 16.25C19.375 15.7322 18.9553 15.3125 18.4375 15.3125H10.625Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.5312 18.125H9.53125C9.27234 18.125 9.0625 18.3348 9.0625 18.5938C9.0625 19.3691 9.69336 20 10.4688 20H18.5938C19.3691 20 20 19.3691 20 18.5938C20 18.3348 19.7902 18.125 19.5312 18.125Z",
    fill: "currentColor"
  }));
});

var PortalLeadsIcon = /*#__PURE__*/forwardRef(function PortalLeadsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M16.2441 4.5C16.666 4.5 17.0176 4.65234 17.2988 4.95703C17.6035 5.23828 17.7559 5.58984 17.7559 6.01172V18L12.4824 15.75L7.24414 18V6.01172C7.24414 5.58984 7.38477 5.23828 7.66602 4.95703C7.9707 4.65234 8.33398 4.5 8.75586 4.5H16.2441Z",
    fill: "currentColor"
  })));
});

var PortalLinksIcon = /*#__PURE__*/forwardRef(function PortalLinksIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M9.92436 8.02976C8.03908 9.98035 8.45048 13.2174 10.61 14.6514C10.6812 14.6987 10.7759 14.6893 10.837 14.6296C11.2916 14.1854 11.6762 13.7551 12.013 13.2078C12.0645 13.1241 12.0325 13.0155 11.946 12.9686C11.6166 12.7902 11.2889 12.4556 11.1044 12.1021L11.1041 12.1022C10.8831 11.6621 10.8078 11.1687 10.9249 10.6592C10.925 10.6592 10.9251 10.6592 10.9252 10.6592C11.0599 10.0069 11.7602 9.40003 12.2951 8.83881C12.294 8.83844 12.2929 8.83803 12.2918 8.83766L14.2959 6.79218C15.0946 5.97703 16.4083 5.97031 17.2152 6.77727C18.0304 7.5759 18.0438 8.89624 17.2452 9.71136L16.0313 10.9597C15.9751 11.0174 15.9569 11.1017 15.9832 11.1779C16.2627 11.9884 16.3314 13.1313 16.1441 13.9947C16.1389 14.0189 16.1687 14.0347 16.186 14.0171L18.7696 11.3801C20.42 9.69563 20.406 6.95303 18.7385 5.28547C17.0367 3.58368 14.2662 3.59784 12.5819 5.31689L9.93471 8.0187C9.93121 8.02239 9.92789 8.02614 9.92436 8.02976Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M14.756 15.0228C14.756 15.0228 14.7559 15.0229 14.7559 15.023C14.7575 15.0223 14.7591 15.0217 14.7607 15.021C15.288 14.0568 15.3918 12.951 15.1447 11.8731L15.1435 11.8743L15.1423 11.8737C14.9077 10.9136 14.2639 9.96027 13.3895 9.37329C13.3142 9.3228 13.1941 9.32865 13.1237 9.38561C12.6807 9.74374 12.2472 10.203 11.9611 10.789C11.9162 10.881 11.9499 10.9915 12.0384 11.0429C12.3704 11.2357 12.6702 11.5179 12.871 11.8925L12.8713 11.8923C13.0277 12.1569 13.1819 12.6591 13.082 13.1987C13.082 13.1987 13.0819 13.1987 13.0818 13.1987C12.9886 13.914 12.2662 14.5702 11.692 15.1614L11.6923 15.1617C11.2551 15.6087 10.1439 16.7416 9.69897 17.1961C8.90034 18.0112 7.58 18.0247 6.76488 17.2261C5.94977 16.4274 5.93629 15.1071 6.73493 14.292L7.95244 13.0399C8.00762 12.9832 8.02638 12.9007 8.00184 12.8255C7.7315 11.996 7.65744 10.8789 7.82808 10.0164C7.83283 9.99238 7.80325 9.97703 7.78609 9.99454L5.24136 12.5918C3.57398 14.2936 3.58812 17.0643 5.27281 18.749C6.97451 20.4163 9.73096 20.3881 11.3983 18.6864C11.9775 18.0385 14.457 15.7428 14.756 15.0228Z",
    fill: "currentColor"
  }));
});

var PortalLocationIcon = /*#__PURE__*/forwardRef(function PortalLocationIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M8.75586 5.30859C9.78711 4.27734 11.0293 3.76172 12.4824 3.76172C13.9355 3.76172 15.1777 4.27734 16.209 5.30859C17.2402 6.31641 17.7559 7.54688 17.7559 9C17.7559 9.72656 17.5684 10.5703 17.1934 11.5312C16.8418 12.4688 16.4082 13.3477 15.8926 14.168C15.377 14.9648 14.8613 15.7266 14.3457 16.4531C13.8301 17.1562 13.3965 17.7188 13.0449 18.1406L12.4824 18.7383C12.3418 18.5977 12.1543 18.3867 11.9199 18.1055C11.6855 17.8242 11.2637 17.2852 10.6543 16.4883C10.0684 15.668 9.54102 14.8828 9.07227 14.1328C8.60352 13.3594 8.18164 12.4922 7.80664 11.5312C7.43164 10.5703 7.24414 9.72656 7.24414 9C7.24414 7.54688 7.74805 6.31641 8.75586 5.30859ZM11.1465 10.3359C11.5215 10.6875 11.9668 10.8633 12.4824 10.8633C12.998 10.8633 13.4434 10.6875 13.8184 10.3359C14.1934 9.96094 14.3809 9.51562 14.3809 9C14.3809 8.48438 14.1934 8.05078 13.8184 7.69922C13.4434 7.32422 12.998 7.13672 12.4824 7.13672C11.9668 7.13672 11.5215 7.32422 11.1465 7.69922C10.7949 8.05078 10.6191 8.48438 10.6191 9C10.6191 9.51562 10.7949 9.96094 11.1465 10.3359Z",
    fill: "currentColor"
  })));
});

var PortalLoyaltyAffiliateIcon = /*#__PURE__*/forwardRef(function PortalLoyaltyAffiliateIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("path", {
    d: "M17 17.6667H15C14.724 17.6667 14.5 17.4427 14.5 17.1667V16.196C14.5 15.9247 14.3387 15.7013 14.2033 15.562C13.638 14.9787 13.3967 14.1827 13.5413 13.3767C13.7213 12.3747 14.5467 11.5513 15.548 11.374C16.2867 11.2407 17.038 11.4413 17.606 11.918C18.1747 12.3947 18.5 13.0927 18.5 13.834C18.5 14.502 18.2367 15.1293 17.7587 15.6007C17.6407 15.7173 17.5 15.9053 17.5 16.1393V17.1673C17.5 17.4427 17.276 17.6667 17 17.6667Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.5 20H12.5C12.224 20 12 19.776 12 19.5V18.2553C12 17.668 12.4393 17.1707 13.022 17.098L15.1047 16.8373L16.8333 16.8333L18.978 17.0973C19.5607 17.17 20 17.668 20 18.2553V19.5C20 19.776 19.776 20 19.5 20Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.5 4H5.83333C4.82 4 4 4.82 4 5.83333V15.5C4 16.5133 4.82 17.3333 5.83333 17.3333H10.8467C11.16 16.5533 11.86 15.96 12.72 15.8067C12.6133 15.6267 12.52 15.44 12.4467 15.2467C12.3667 15.3 12.2667 15.3333 12.1667 15.3333H7.16667C6.89333 15.3333 6.66667 15.1067 6.66667 14.8333C6.66667 14.56 6.89333 14.3333 7.16667 14.3333H12.1667C12.18 14.3333 12.1867 14.3333 12.2 14.34C12.1467 13.9467 12.1533 13.5467 12.2267 13.14C12.26 12.9667 12.3067 12.7933 12.36 12.6267C12.3 12.6533 12.2333 12.6667 12.1667 12.6667H7.16667C6.89333 12.6667 6.66667 12.44 6.66667 12.1667C6.66667 11.8933 6.89333 11.6667 7.16667 11.6667H12.1667C12.3867 11.6667 12.5733 11.8067 12.6333 12.0067C13.1867 11.0067 14.1733 10.26 15.3133 10.06H15.3333V5.83333C15.3333 4.82 14.5133 4 13.5 4ZM12.1667 10H7.16667C6.89067 10 6.66667 9.776 6.66667 9.5C6.66667 9.224 6.89067 9 7.16667 9H12.1667C12.4427 9 12.6667 9.224 12.6667 9.5C12.6667 9.776 12.4427 10 12.1667 10ZM12.1667 7.33333H7.16667C6.89067 7.33333 6.66667 7.10933 6.66667 6.83333C6.66667 6.55733 6.89067 6.33333 7.16667 6.33333H12.1667C12.4427 6.33333 12.6667 6.55733 12.6667 6.83333C12.6667 7.10933 12.4427 7.33333 12.1667 7.33333Z",
    fill: "currentColor"
  }));
});

var PortalLoyaltyIcon = /*#__PURE__*/forwardRef(function PortalLoyaltyIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M12.9009 9.75921L13.899 8.80984L12.5085 8.61238C12.3475 8.5895 12.2075 8.48933 12.134 8.3439L11.5013 7.09204L10.8685 8.3439C10.7951 8.48933 10.655 8.5895 10.494 8.61238L9.10352 8.80984L10.1015 9.75921C10.2222 9.8745 10.2776 10.0423 10.2489 10.2062L10.0106 11.5616L11.2736 10.9133C11.4166 10.8404 11.5859 10.8404 11.7288 10.9133L12.9919 11.5616L12.7535 10.2062C12.7249 10.0422 12.7803 9.8745 12.9009 9.75921Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.4997 3C7.92987 3 5.02539 5.90448 5.02539 9.47431C5.02539 13.0441 7.92987 15.9486 11.4997 15.9486C15.0695 15.9486 17.974 13.0441 17.974 9.47431C17.974 5.90448 15.0695 3 11.4997 3ZM15.3293 8.8221L13.7797 10.2967L14.145 12.3764C14.2156 12.78 13.7919 13.095 13.4266 12.9055L11.4997 11.9163L9.57279 12.9056C9.20855 13.0926 8.78332 12.7831 8.85444 12.3764L9.21971 10.2968L7.67019 8.82213C7.369 8.53473 7.53299 8.02616 7.94351 7.96808L10.0951 7.66265L11.0552 5.76346C11.2245 5.42788 11.775 5.42788 11.9443 5.76346L12.9043 7.66265L15.056 7.96808C15.4664 8.02612 15.6304 8.53473 15.3293 8.8221Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.4998 16.9447C10.2409 16.9447 9.05535 16.6287 8.01367 16.0764V19.5012C8.01367 19.8997 8.45972 20.1358 8.78794 19.9155L11.4998 18.1078L14.2117 19.9156C14.5415 20.1354 14.986 19.8992 14.986 19.5013V16.0764C13.9443 16.6287 12.7588 16.9447 11.4998 16.9447Z",
    fill: "currentColor"
  }));
});

var PortalMaintenanceIcon = /*#__PURE__*/forwardRef(function PortalMaintenanceIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M20.5508 16.4883C20.6914 16.6055 20.7617 16.7812 20.7617 17.0156C20.7617 17.2266 20.668 17.4023 20.4805 17.543L18.7578 19.2656C18.5938 19.4297 18.4062 19.5117 18.1953 19.5117C18.0078 19.5117 17.8438 19.4297 17.7031 19.2656L10.8828 12.4453C10.0156 12.7969 9.10156 12.8789 8.14062 12.6914C7.20312 12.4805 6.38281 12.0234 5.67969 11.3203C4.95312 10.5703 4.49609 9.69141 4.30859 8.68359C4.12109 7.65234 4.26172 6.67969 4.73047 5.76562L8.03516 9L10.2852 6.75L7.05078 3.51562C7.94141 3.09375 8.90234 2.97656 9.93359 3.16406C10.9648 3.32813 11.8555 3.77344 12.6055 4.5C13.3086 5.20312 13.7539 6.03516 13.9414 6.99609C14.1523 7.93359 14.082 8.82422 13.7305 9.66797L20.5508 16.4883Z",
    fill: "currentColor"
  })));
});

var PortalMerchantsIcon = /*#__PURE__*/forwardRef(function PortalMerchantsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.5117 5.23828V6.75H6.48828V5.23828H18.5117ZM19.25 12.7617H18.5117V17.2617H17V12.7617H14.0117V17.2617H6.48828V12.7617H5.75V11.25L6.48828 7.48828H18.5117L19.25 11.25V12.7617ZM12.5 15.75V12.7617H8V15.75H12.5Z",
    fill: "currentColor"
  })));
});

var PortalMileagesIcon = /*#__PURE__*/forwardRef(function PortalMileagesIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M12.0001 13.5981C11.7061 13.5981 11.4668 13.8374 11.4668 14.1315C11.4668 14.4256 11.7061 14.6648 12.0001 14.6648C12.2942 14.6648 12.5335 14.4256 12.5335 14.1315C12.5335 13.8374 12.2942 13.5981 12.0001 13.5981Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.2267 8.07657C15.7831 6.82857 13.9484 6.153 12.0498 6.13525C7.62887 6.13525 4 9.61366 4 14.1281V14.1317C4 15.3193 4.25956 16.4926 4.77156 17.5628C4.86044 17.7477 5.04534 17.865 5.25156 17.865H18.7484C18.9547 17.865 19.1396 17.7477 19.2284 17.5628C19.7333 16.5033 20 15.3157 20 14.1317C20 11.6971 18.8865 9.48769 17.2267 8.07657ZM5.75287 14.665H5.09156C5.06313 14.313 5.06313 13.9539 5.088 13.5983H5.75287C6.048 13.5983 6.28622 13.8366 6.28622 14.1317C6.28622 14.4268 6.048 14.665 5.75287 14.665ZM11.4667 7.21613C11.8258 7.19125 12.1813 7.19125 12.5333 7.21969V7.73169C12.5333 8.02682 12.2951 8.26504 12 8.26504C11.7048 8.26504 11.4666 8.02682 11.4666 7.73169V7.21613H11.4667ZM6.73066 9.61613C6.95822 9.34591 7.21422 9.09347 7.48444 8.86235L7.85422 9.23213C8.06044 9.43835 8.06044 9.77613 7.85422 9.98591C7.64881 10.1913 7.312 10.1975 7.10041 9.98591L6.73066 9.61613ZM16.6486 15.3313C16.5738 15.6227 16.2756 15.788 15.9993 15.7146C15.7139 15.6413 15.5423 15.3504 15.616 15.0653C15.6938 14.7625 15.7333 14.4486 15.7333 14.1316C15.7333 13.2944 15.453 12.5233 14.9859 11.8999L13.4397 13.4461C13.5395 13.6547 13.6 13.8853 13.6 14.1316C13.6 15.0139 12.8823 15.7316 12 15.7316C11.1178 15.7316 10.4 15.0139 10.4 14.1316C10.4 13.2493 11.1178 12.5316 12 12.5316C12.2463 12.5316 12.477 12.5921 12.6855 12.6919L14.2317 11.1458C13.6083 10.6786 12.8372 10.3983 12 10.3983C9.94134 10.3983 8.26666 12.073 8.26666 14.1317C8.26666 14.4487 8.30622 14.7626 8.38403 15.0653C8.45762 15.3504 8.28612 15.6414 8.00072 15.7147C7.716 15.7893 7.42469 15.6164 7.35141 15.3313C7.25106 14.9417 7.2 14.5383 7.2 14.1317C7.2 11.4848 9.35313 9.33166 12 9.33166C14.6469 9.33166 16.8 11.4848 16.8 14.1317C16.8 14.5383 16.7489 14.9418 16.6486 15.3313ZM16.8996 9.98591C16.6972 10.1883 16.3679 10.2006 16.1458 9.98591C15.9395 9.77613 15.9395 9.43835 16.1458 9.23213L16.512 8.86591C16.5191 8.87304 16.5226 8.88013 16.5297 8.88369C16.7964 9.11482 17.0418 9.36013 17.2622 9.62325L16.8996 9.98591ZM18.912 14.665H18.4C18.1049 14.665 17.8667 14.4268 17.8667 14.1317C17.8667 13.8365 18.1049 13.5983 18.4 13.5983H18.912C18.9262 13.7725 18.9333 13.9539 18.9333 14.1317C18.9333 14.3095 18.9262 14.4873 18.912 14.665Z",
    fill: "currentColor"
  }));
});

var PortalMiniAppIcon = /*#__PURE__*/forwardRef(function PortalMiniAppIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M9.65625 9.03125H10.5938V9.96875H9.65625V9.03125Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.4062 9.03125H14.3438V9.96875H13.4062V9.03125Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.65625 12.7812H10.5938V13.7188H9.65625V12.7812Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.53125 16.875V18.9496C6.53125 19.5288 7.02185 20 7.625 20H16.375C16.9781 20 17.4688 19.5288 17.4688 18.9496V16.875H6.53125ZM12.9375 18.75H11.0625C10.8036 18.75 10.5938 18.5402 10.5938 18.2812C10.5938 18.0223 10.8036 17.8125 11.0625 17.8125H12.9375C13.1964 17.8125 13.4062 18.0223 13.4062 18.2812C13.4062 18.5402 13.1964 18.75 12.9375 18.75Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.4688 5.875V5.09375C17.4688 4.4906 16.9781 4 16.375 4H7.625C7.02185 4 6.53125 4.4906 6.53125 5.09375V5.875H17.4688Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.4688 6.8125H6.53125V15.9375H17.4688V6.8125ZM11.5312 14.1875C11.5312 14.4464 11.3214 14.6562 11.0625 14.6562H9.1875C8.92859 14.6562 8.71875 14.4464 8.71875 14.1875V12.3125C8.71875 12.0536 8.92859 11.8438 9.1875 11.8438H11.0625C11.3214 11.8438 11.5312 12.0536 11.5312 12.3125V14.1875ZM11.5312 10.4375C11.5312 10.6964 11.3214 10.9062 11.0625 10.9062H9.1875C8.92859 10.9062 8.71875 10.6964 8.71875 10.4375V8.5625C8.71875 8.30359 8.92859 8.09375 9.1875 8.09375H11.0625C11.3214 8.09375 11.5312 8.30359 11.5312 8.5625V10.4375ZM15.2812 14.1875C15.2812 14.4464 15.0714 14.6562 14.8125 14.6562H12.9375C12.6786 14.6562 12.4688 14.4464 12.4688 14.1875C12.4688 13.9286 12.6786 13.7188 12.9375 13.7188H14.3438V12.3125C14.3438 12.0536 14.5536 11.8438 14.8125 11.8438C15.0714 11.8438 15.2812 12.0536 15.2812 12.3125V14.1875ZM14.8125 10.9062H12.9375C12.6786 10.9062 12.4688 10.6964 12.4688 10.4375V8.5625C12.4688 8.30359 12.6786 8.09375 12.9375 8.09375H14.8125C15.0714 8.09375 15.2812 8.30359 15.2812 8.5625V10.4375C15.2812 10.6964 15.0714 10.9062 14.8125 10.9062Z",
    fill: "currentColor"
  }));
});

var PortalMobileIcon = /*#__PURE__*/forwardRef(function PortalMobileIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M15.5059 2.98828C16.0215 2.98828 16.4551 3.17578 16.8066 3.55078C17.1816 3.92578 17.3691 4.37109 17.3691 4.88672V17.6133C17.3691 18.1289 17.1816 18.5742 16.8066 18.9492C16.4551 19.3242 16.0215 19.5117 15.5059 19.5117H9.49414C8.97852 19.5117 8.5332 19.3242 8.1582 18.9492C7.80664 18.5742 7.63086 18.1289 7.63086 17.6133V4.88672C7.63086 4.37109 7.80664 3.92578 8.1582 3.55078C8.5332 3.17578 8.97852 2.98828 9.49414 2.98828H15.5059ZM11.709 18.4219C11.9199 18.6328 12.1777 18.7383 12.4824 18.7383C12.8105 18.7383 13.0801 18.6328 13.291 18.4219C13.5254 18.2109 13.6426 17.9531 13.6426 17.6484C13.6426 17.3203 13.5254 17.0508 13.291 16.8398C13.0801 16.6055 12.8105 16.4883 12.4824 16.4883C12.1777 16.4883 11.9199 16.6055 11.709 16.8398C11.498 17.0508 11.3926 17.3203 11.3926 17.6484C11.3926 17.9531 11.498 18.2109 11.709 18.4219ZM15.8926 15.75V5.23828H9.14258V15.75H15.8926Z",
    fill: "currentColor"
  })));
});

var PortalOrdersIcon = /*#__PURE__*/forwardRef(function PortalOrdersIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M7.32837 9.17749C6.78483 9.46031 6.13744 9.46031 5.59375 9.17749V18.8688C5.59566 19.4927 6.10106 19.9981 6.72502 20H7.70546C7.46035 19.6739 7.32808 19.2768 7.32837 18.8688V9.17749Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.4856 8.89089V7.12607C16.4869 6.12943 16.0122 5.19186 15.2081 4.60294C14.4038 4.01418 13.3667 3.84478 12.4169 4.14705C11.4671 3.84478 10.4299 4.01418 9.62564 4.60294C8.82138 5.19186 8.34662 6.12943 8.34795 7.12607V8.89089H8.08398V18.8688C8.0859 19.4928 8.59129 19.9981 9.21526 20.0001H17.285C17.9091 19.9981 18.4145 19.4928 18.4163 18.8688V8.89089H16.4856ZM10.2297 8.89089H9.09845V7.12607C9.09977 5.87504 10.0711 4.83936 11.3195 4.75805C10.6288 5.35109 10.2308 6.21575 10.2297 7.12607V8.89089ZM10.9839 7.12607C10.9846 6.1801 11.5457 5.32443 12.413 4.9466C13.2811 5.32354 13.8426 6.17981 13.8423 7.12607V8.89089H10.9801V7.12607H10.9839ZM15.7314 8.89089H14.6002V7.12607C14.6007 6.21531 14.2026 5.34991 13.5104 4.75805C14.7582 4.84069 15.7288 5.87563 15.7314 7.12607V8.89089Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalPaymentControllerIcon = /*#__PURE__*/forwardRef(function PortalPaymentControllerIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M17.5498 4.00464H6.45039C5.93179 4.00464 5.50977 4.42667 5.50977 4.94527V16.5777H8.51977V14.477C8.51977 13.9584 8.9418 13.5363 9.4604 13.5363H14.5398C15.0584 13.5363 15.4804 13.9584 15.4804 14.477V16.5777H18.4904V4.94527C18.4904 4.42667 18.0684 4.00464 17.5498 4.00464ZM8.73925 11.7178H7.98675C7.72714 11.7178 7.51644 11.5071 7.51644 11.2475C7.51644 10.9879 7.72714 10.7772 7.98675 10.7772H8.73925C8.99886 10.7772 9.20956 10.9879 9.20956 11.2475C9.20956 11.5071 8.99886 11.7178 8.73925 11.7178ZM8.73925 9.71111H7.98675C7.72714 9.71111 7.51644 9.50041 7.51644 9.2408C7.51644 8.98118 7.72714 8.77048 7.98675 8.77048H8.73925C8.99886 8.77048 9.20956 8.98118 9.20956 9.2408C9.20956 9.50041 8.99886 9.71111 8.73925 9.71111ZM8.73925 7.70444H7.98675C7.72714 7.70444 7.51644 7.49374 7.51644 7.23412C7.51644 6.97451 7.72714 6.76381 7.98675 6.76381H8.73925C8.99886 6.76381 9.20956 6.97451 9.20956 7.23412C9.20956 7.49374 8.99886 7.70444 8.73925 7.70444ZM12.441 11.7795V11.9953C12.441 12.2552 12.2303 12.4656 11.9706 12.4656C11.711 12.4656 11.5003 12.2552 11.5003 11.9953V11.8219C11.1763 11.7885 10.9071 11.7099 10.5023 11.466C10.28 11.3315 10.2092 11.0424 10.3437 10.8201C10.4782 10.5978 10.7673 10.5269 10.9896 10.6615C11.3503 10.8762 11.4827 10.9015 11.9678 10.8985C12.1635 10.8972 12.3464 10.8455 12.5037 10.7251C12.8875 10.3999 12.9224 9.85358 12.3334 9.66063C11.1489 9.2735 10.412 8.95854 10.412 8.0139C10.4242 7.37077 10.8868 6.80805 11.4815 6.66661C11.5078 6.65874 11.5003 6.6896 11.5003 6.48162C11.5003 6.09622 11.9416 5.87357 12.2519 6.10474C12.4643 6.27252 12.441 6.46178 12.441 6.63212C12.7471 6.6938 13.0143 6.82316 13.1856 6.9557C13.2021 6.97213 13.4139 7.07575 13.4139 7.35985C13.4139 7.73146 12.986 8.0003 12.6181 7.70601C12.6129 7.7008 12.5594 7.66412 12.5021 7.63671C12.0837 7.44821 11.4551 7.48662 11.3596 7.96499C11.328 8.13333 11.3799 8.22526 11.5003 8.29735C11.5003 8.28374 11.6428 8.44847 12.626 8.76672C14.2753 9.30451 13.9454 11.3981 12.441 11.7795ZM16.0134 11.7178H15.2609C15.0013 11.7178 14.7906 11.5071 14.7906 11.2475C14.7906 10.9879 15.0013 10.7772 15.2609 10.7772H16.0134C16.273 10.7772 16.4837 10.9879 16.4837 11.2475C16.4837 11.5071 16.273 11.7178 16.0134 11.7178ZM16.0134 9.71111H15.2609C15.0013 9.71111 14.7906 9.50041 14.7906 9.2408C14.7906 8.98118 15.0013 8.77048 15.2609 8.77048H16.0134C16.273 8.77048 16.4837 8.98118 16.4837 9.2408C16.4837 9.50041 16.273 9.71111 16.0134 9.71111ZM16.0134 7.70444H15.2609C15.0013 7.70444 14.7906 7.49374 14.7906 7.23412C14.7906 6.97451 15.0013 6.76381 15.2609 6.76381H16.0134C16.273 6.76381 16.4837 6.97451 16.4837 7.23412C16.4837 7.49374 16.273 7.70444 16.0134 7.70444Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.4707 14.4771H14.5401V16.5778H12.4707V14.4771Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.46094 14.4771H11.5303V16.5778H9.46094V14.4771Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.8689 17.5183C18.0026 17.5183 6.03804 17.5183 4.13095 17.5183C3.96286 17.8078 4.00459 17.9631 4.00459 19.0547C4.00459 19.5733 4.42662 19.9953 4.94522 19.9953H19.0546C19.5732 19.9953 19.9953 19.5733 19.9953 19.0547C19.9953 17.9985 20.0377 17.809 19.8689 17.5183Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalPaymentsIcon = /*#__PURE__*/forwardRef(function PortalPaymentsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M12.7988 10.4414C13.877 10.6992 14.7324 11.0742 15.3652 11.5664C15.998 12.0586 16.3145 12.7734 16.3145 13.7109C16.3145 14.4609 16.0684 15.0586 15.5762 15.5039C15.1074 15.9492 14.4863 16.2422 13.7129 16.3828V18H11.4629V16.3828C10.666 16.2188 10.0098 15.8906 9.49414 15.3984C9.00195 14.9062 8.73242 14.2734 8.68555 13.5H10.3379C10.4316 14.5547 11.1816 15.082 12.5879 15.082C13.3145 15.082 13.8301 14.9414 14.1348 14.6602C14.4395 14.3789 14.5918 14.0742 14.5918 13.7461C14.5918 13.3477 14.4277 12.9961 14.0996 12.6914C13.7949 12.3867 13.209 12.1289 12.3418 11.918C9.99805 11.3555 8.82617 10.3242 8.82617 8.82422C8.82617 8.14453 9.07227 7.57031 9.56445 7.10156C10.0566 6.60938 10.6895 6.28125 11.4629 6.11719V4.5H13.7129V6.15234C14.4629 6.33984 15.0371 6.69141 15.4355 7.20703C15.8574 7.72266 16.0801 8.32031 16.1035 9H14.4512C14.4043 7.94531 13.7832 7.41797 12.5879 7.41797C11.9551 7.41797 11.4512 7.54688 11.0762 7.80469C10.7246 8.0625 10.5488 8.40234 10.5488 8.82422C10.5488 9.17578 10.7129 9.48047 11.041 9.73828C11.3691 9.97266 11.9551 10.207 12.7988 10.4414Z",
    fill: "currentColor"
  })));
});

var PortalPointTransactionsIcon = /*#__PURE__*/forwardRef(function PortalPointTransactionsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M19.1655 14.4342L17.2816 16.8977C16.9047 17.3906 16.3196 17.6797 15.6991 17.6797H12.2012C11.9261 17.6797 11.7031 17.4568 11.7031 17.1817C11.7031 16.9066 11.9261 16.6837 12.2012 16.6837H15.2329C15.8845 16.6837 16.4302 16.1504 16.4178 15.4989C16.4057 14.8675 15.8901 14.3594 15.2559 14.3594H11.7695C10.7686 13.397 9.22388 13.2843 8.09388 14.0915L7.71875 14.3594V20.004H11.0391H11.7031H16.3802C17.3971 20.004 18.3441 19.4869 18.8939 18.6316L20.8376 15.6081C20.9436 15.4432 21 15.2513 21 15.0552C21 14.0775 19.7594 13.6576 19.1655 14.4342Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.22461 13.3633H4.49805C4.22299 13.3633 4 13.5863 4 13.8613V20.502C4 20.777 4.22299 21 4.49805 21H6.22461C6.49966 21 6.72266 20.777 6.72266 20.502V13.8613C6.72266 13.5863 6.49966 13.3633 6.22461 13.3633Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.5056 6.75269C13.4043 6.83038 13.3485 6.94802 13.3293 7.05005C13.3027 7.1908 13.3363 7.32155 13.4148 7.38311C13.4425 7.40479 13.473 7.42611 13.5056 7.44706V6.75269Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M13.8613 12.3008C16.1499 12.3008 18.0117 10.4389 18.0117 8.15039C18.0117 5.86187 16.1499 4 13.8613 4C11.5728 4 9.71094 5.86187 9.71094 8.15039C9.71094 10.4389 11.5728 12.3008 13.8613 12.3008ZM12.605 9.50737C12.7053 9.35397 12.9111 9.31081 13.0646 9.41128C13.2439 9.52859 13.3563 9.57945 13.5064 9.60054V8.19834C13.2943 8.10115 13.1358 8.00762 13.0057 7.90558C12.7302 7.68946 12.6044 7.31454 12.6774 6.92702C12.757 6.50474 13.0509 6.16876 13.4445 6.05023C13.4653 6.04395 13.4859 6.03821 13.5064 6.03279V5.82617C13.5064 5.64282 13.6551 5.49414 13.8384 5.49414C14.0218 5.49414 14.1704 5.64282 14.1704 5.82617V5.9964C14.4928 6.05222 14.7207 6.21093 14.831 6.3376C14.9515 6.47586 14.937 6.6856 14.7988 6.80603C14.6612 6.92583 14.453 6.91221 14.3322 6.77598C14.3246 6.76831 14.2719 6.71751 14.1704 6.68009V7.75295C14.2294 7.77483 14.2883 7.79605 14.3461 7.8165C14.9297 8.02282 15.2544 8.56311 15.1539 9.16093C15.0758 9.62561 14.7222 10.0969 14.1704 10.2368V10.4746C14.1704 10.658 14.0218 10.8066 13.8384 10.8066C13.6551 10.8066 13.5064 10.658 13.5064 10.4746V10.2687C13.2383 10.2455 13.0161 10.1731 12.701 9.967C12.5476 9.86659 12.5046 9.66083 12.605 9.50737Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M14.4985 9.05083C14.5203 8.92104 14.5293 8.61176 14.1699 8.46045V9.52697C14.3567 9.41999 14.4683 9.23079 14.4985 9.05083Z",
    fill: "currentColor"
  }));
});

var PortalPosIcon = /*#__PURE__*/forwardRef(function PortalPosIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M16.6562 6C17.0312 6 17.3438 6.13542 17.5938 6.40625C17.8646 6.65625 18 6.96875 18 7.34375V16.6562C18 17.0312 17.8646 17.3542 17.5938 17.625C17.3438 17.875 17.0312 18 16.6562 18H7.34375C6.96875 18 6.64583 17.875 6.375 17.625C6.125 17.3542 6 17.0312 6 16.6562V7.34375C6 6.96875 6.125 6.65625 6.375 6.40625C6.64583 6.13542 6.96875 6 7.34375 6H16.6562ZM10 15.3438V10.6562H8.65625V15.3438H10ZM12.6562 15.3438V8.65625H11.3438V15.3438H12.6562ZM15.3438 15.3438V12.6562H14V15.3438H15.3438Z",
    fill: "currentColor"
  })));
});

var PortalPriceBookIcon = /*#__PURE__*/forwardRef(function PortalPriceBookIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M14.8889 4L6 6.31111V19.6148L14.8889 17.3926V4Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.2587 20.0001V6.07422H15.4809V17.8668L6.91797 20.0001H17.2587Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "11.2593",
    height: "16",
    fill: "currentColor",
    transform: "translate(6 4)"
  }))));
});

var PortalPricingIcon = /*#__PURE__*/forwardRef(function PortalPricingIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M12.2207 4.27539V7.51367L15.4681 7.52276L12.2207 4.27539Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M10.3382 16.0157C10.3382 13.1165 12.8409 10.8373 15.7343 11.1125V8.46494L12.2193 8.4549C11.7017 8.4549 11.2794 8.03263 11.2794 7.51373V4H5.69508C5.17618 4 4.75391 4.42227 4.75391 4.94118V19.0588C4.75391 19.5777 5.17618 20 5.69508 20H12.3708C11.1398 19.1037 10.3382 17.6515 10.3382 16.0157ZM8.98795 7.02933C9.22544 7.13475 9.33242 7.41271 9.22732 7.6502L7.65461 11.1965C7.54951 11.4334 7.27227 11.5413 7.03375 11.4359C6.79595 11.3305 6.68897 11.0525 6.79406 10.8147L8.36677 7.26871C8.47218 7.03122 8.75014 6.92392 8.98795 7.02933ZM6.74826 7.23137C7.1561 7.23137 7.48771 7.57522 7.48771 7.9978C7.48771 8.42039 7.1561 8.76392 6.74826 8.76392C6.34042 8.76392 6.00881 8.42039 6.00881 7.9978C6.00881 7.57522 6.34042 7.23137 6.74826 7.23137ZM8.9892 17.7412H6.22842C5.96865 17.7412 5.75783 17.5304 5.75783 17.2706C5.75783 17.0108 5.96865 16.8 6.22842 16.8H8.9892C9.24897 16.8 9.45979 17.0108 9.45979 17.2706C9.45979 17.5304 9.24897 17.7412 8.9892 17.7412ZM5.75783 15.2627C5.75783 15.003 5.96865 14.7922 6.22842 14.7922H8.48724C8.747 14.7922 8.95783 15.003 8.95783 15.2627C8.95783 15.5225 8.747 15.7333 8.45587 15.7333H6.19704C5.96865 15.7333 5.75783 15.5225 5.75783 15.2627ZM8.9892 13.7255H6.22842C5.96865 13.7255 5.75783 13.5147 5.75783 13.2549C5.75783 12.9951 5.96865 12.7843 6.22842 12.7843H8.9892C9.24897 12.7843 9.45979 12.9951 9.45979 13.2549C9.45979 13.5147 9.24897 13.7255 8.9892 13.7255ZM9.22669 11.2424C8.81885 11.2424 8.48724 10.8988 8.48724 10.4762C8.48724 10.0536 8.81885 9.7098 9.22669 9.7098C9.63453 9.7098 9.96614 10.0536 9.96614 10.4762C9.96614 10.8988 9.63453 11.2424 9.22669 11.2424Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.2636 12.0315C13.0666 12.0315 11.2793 13.8188 11.2793 16.0158C11.2793 18.2128 13.0666 20.0001 15.2636 20.0001C17.4606 20.0001 19.2479 18.2128 19.2479 16.0158C19.2479 13.8188 17.4606 12.0315 15.2636 12.0315ZM15.7144 17.6111C15.6937 17.8458 15.5005 18.0315 15.262 18.0393C15.0451 18.0518 14.8298 17.8935 14.7842 17.6588C14.6239 17.6274 14.4702 17.5687 14.281 17.4627C14.0542 17.336 13.9729 17.0492 14.1 16.8224C14.2271 16.5956 14.5138 16.5146 14.7403 16.6414C14.9245 16.7443 14.985 16.7524 15.2432 16.7509C15.4275 16.7509 15.5343 16.6485 15.5453 16.5733C15.563 16.4513 14.9828 16.4203 14.5006 16.0974C13.8981 15.693 14.0316 14.7385 14.7798 14.4497C14.8093 14.2185 15.0067 14.0393 15.246 14.0393C15.4716 14.0393 15.6663 14.2004 15.7082 14.4224C15.8296 14.4594 15.9262 14.5062 15.9949 14.5457C16.1706 14.6157 16.2948 14.7869 16.2948 14.9877C16.2948 15.3894 15.8279 15.6072 15.5202 15.3576C15.3628 15.2686 15.1317 15.3024 15.0804 15.3491C15.3055 15.4331 15.1841 15.3879 15.6878 15.5753C16.7846 15.9071 16.7084 17.2483 15.7144 17.6111Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalPurchaseOrdersIcon = /*#__PURE__*/forwardRef(function PortalPurchaseOrdersIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M15.4371 11.2333C13.5071 11.2333 11.9371 12.8033 11.9371 14.7333C11.9371 16.6633 13.5071 18.2333 15.4371 18.2333C17.3671 18.2333 18.9371 16.6633 18.9371 14.7333C18.9371 12.8033 17.3671 11.2333 15.4371 11.2333ZM15.3575 14.4291L15.6757 14.5285C16.0115 14.6334 16.2371 14.9403 16.2371 15.2921V15.4C16.2371 15.784 15.9651 16.1055 15.6037 16.1824V16.2667C15.6037 16.4139 15.4843 16.5333 15.3371 16.5333C15.1898 16.5333 15.0704 16.4139 15.0704 16.2667V16.1107C14.8133 15.9775 14.6371 15.709 14.6371 15.4C14.6371 15.2527 14.7565 15.1333 14.9037 15.1333C15.051 15.1333 15.1704 15.2527 15.1704 15.4C15.1704 15.547 15.29 15.6667 15.4371 15.6667C15.5841 15.6667 15.7037 15.547 15.7037 15.4V15.2921C15.7037 15.1748 15.6285 15.0726 15.5166 15.0376L15.1985 14.9382C14.8627 14.8332 14.6371 14.5264 14.6371 14.1746V14.0667C14.6371 13.719 14.86 13.4226 15.1704 13.3125V13.2C15.1704 13.0527 15.2898 12.9333 15.4371 12.9333C15.5843 12.9333 15.7037 13.0527 15.7037 13.2V13.3125C16.0141 13.4226 16.2371 13.719 16.2371 14.0667C16.2371 14.2139 16.1177 14.3333 15.9704 14.3333C15.8231 14.3333 15.7037 14.2139 15.7037 14.0667C15.7037 13.9196 15.5841 13.8 15.4371 13.8C15.29 13.8 15.1704 13.9196 15.1704 14.0667V14.1746C15.1704 14.2918 15.2456 14.3941 15.3575 14.4291ZM9.30374 10.7667H7.80374C7.65647 10.7667 7.53707 10.6473 7.53707 10.5V9.33333C7.53707 9.18607 7.65647 9.06667 7.80374 9.06667H9.30374C9.45101 9.06667 9.57041 9.18607 9.57041 9.33333V10.5C9.57041 10.6473 9.45101 10.7667 9.30374 10.7667ZM14.1663 6.56667V4.79933C14.1663 4.56183 14.4534 4.44283 14.6214 4.61067L16.658 6.64467C16.8262 6.8126 16.7073 7.1 16.4696 7.1H14.6996C14.4051 7.1 14.1663 6.86123 14.1663 6.56667ZM9.57041 11.5667V12.7333C9.57041 12.8806 9.45101 13 9.30374 13H7.80374C7.65647 13 7.53707 12.8806 7.53707 12.7333V11.5667C7.53707 11.4194 7.65647 11.3 7.80374 11.3H9.30374C9.45101 11.3 9.57041 11.4194 9.57041 11.5667ZM10.1037 10.5V9.33333C10.1037 9.18607 10.2231 9.06667 10.3704 9.06667H11.9704C12.1177 9.06667 12.2371 9.18607 12.2371 9.33333V10.5C12.2371 10.6473 12.1177 10.7667 11.9704 10.7667H10.3704C10.2231 10.7667 10.1037 10.6473 10.1037 10.5ZM10.1037 12.7333V11.5667C10.1037 11.4194 10.2231 11.3 10.3704 11.3H11.9704C12.1177 11.3 12.2371 11.4194 12.2371 11.5667V12.7333C12.2371 12.8806 12.1177 13 11.9704 13H10.3704C10.2231 13 10.1037 12.8806 10.1037 12.7333ZM14.8037 9.33333V10.5C14.8037 10.6473 14.6843 10.7667 14.5371 10.7667H13.0371C12.8898 10.7667 12.7704 10.6473 12.7704 10.5V9.33333C12.7704 9.18607 12.8898 9.06667 13.0371 9.06667H14.5371C14.6843 9.06667 14.8037 9.18607 14.8037 9.33333ZM11.499 13.8575C11.5364 13.6912 11.4093 13.5333 11.2389 13.5333H7.80374C7.36191 13.5333 7.00374 13.1752 7.00374 12.7333V9.33333C7.00374 8.8915 7.36191 8.53333 7.80374 8.53333H14.5371C14.9789 8.53333 15.3371 8.8915 15.3371 9.33333V10.4369C15.3371 10.5803 15.4506 10.6975 15.5939 10.703C16.0436 10.7203 16.485 10.812 16.9036 10.9759C17.0797 11.0449 17.2704 10.9182 17.2704 10.729V7.9C17.2704 7.75273 17.151 7.63333 17.0037 7.63333H14.6996C14.1105 7.63333 13.633 7.15577 13.633 6.56667V4.26667C13.633 4.1194 13.5136 4 13.3663 4H6.13307C5.54397 4 5.06641 4.47757 5.06641 5.06667V18.9333C5.06641 19.5224 5.54397 20 6.13307 20H16.1997C16.7877 20 17.2664 19.5213 17.2664 18.9333L17.2665 18.7393C17.2666 18.552 17.0783 18.4222 16.9039 18.4906C13.8854 19.6732 10.7988 16.9678 11.499 13.8575ZM7.27041 14.7333H9.87041C10.0177 14.7333 10.1371 14.8527 10.1371 15C10.1371 15.1473 10.0177 15.2667 9.87041 15.2667H7.27041C7.12314 15.2667 7.00374 15.1473 7.00374 15C7.00374 14.8527 7.12314 14.7333 7.27041 14.7333ZM10.5371 17.2667H7.27041C7.12314 17.2667 7.00374 17.1473 7.00374 17C7.00374 16.8527 7.12314 16.7333 7.27041 16.7333H10.5371C10.6843 16.7333 10.8037 16.8527 10.8037 17C10.8037 17.1473 10.6843 17.2667 10.5371 17.2667Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalReachIcon = /*#__PURE__*/forwardRef(function PortalReachIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M5.38086 18V15.75H19.6191V18H5.38086ZM18.8809 8.26172C19.0918 8.26172 19.2676 8.33203 19.4082 8.47266C19.5488 8.61328 19.6191 8.78906 19.6191 9V13.5C19.6191 13.7109 19.5488 13.8867 19.4082 14.0273C19.2676 14.168 19.0918 14.2383 18.8809 14.2383H6.11914C5.93164 14.2383 5.75586 14.168 5.5918 14.0273C5.45117 13.8867 5.38086 13.7109 5.38086 13.5V9C5.38086 8.78906 5.45117 8.61328 5.5918 8.47266C5.75586 8.33203 5.93164 8.26172 6.11914 8.26172H18.8809ZM5.38086 4.5H19.6191V6.75H5.38086V4.5Z",
    fill: "currentColor"
  })));
});

var PortalRefuellingIcon = /*#__PURE__*/forwardRef(function PortalRefuellingIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78957 4.96931C9.73997 5.24068 10.59 5.54129 11.4702 5.01081C15.3575 6.01652 17.3918 9.26131 19.2902 12.6005L17.2459 14.1827L17.0217 13.9739L15.3227 15.6199L15.2015 15.7648L14.986 15.7728L13.6072 15.9003L13.3414 15.9229L13.1674 15.6995L10.439 12.8761L10.2944 12.7538L10.2503 12.6022L10.1827 12.1833L9.09041 12.1726L7.84565 10.8906L7.65329 7.98637L8.78957 4.96931ZM7.53897 7.03293L8.25207 5.18068L6.39279 4.40657L6.26295 4.33475L6.09763 4.32808C5.15589 4.27346 4.27908 4.25475 3.36678 4.3012C2.56961 4.36893 1.67203 4.4659 0.824647 4.54826L1.08272 6.5562C1.86518 6.43793 2.66236 6.3702 3.52445 6.33838C4.27143 6.28527 5.03312 6.28269 5.80953 6.33064L7.53897 7.03293ZM11.5061 11.3045L11.6767 12.0771C12.1432 11.996 12.7249 11.9363 12.84 11.9575C12.9049 11.9934 13.4027 13.3286 13.7473 14.3246L13.8269 14.411L14.6241 14.3433C14.315 13.2821 13.6406 11.3406 13.2805 11.2262C12.9854 11.1477 12.138 11.2301 11.5061 11.3045ZM19.337 13.1351L17.8007 14.4048C18.5495 15.6668 18.4128 16.6934 18.2614 17.6694C18.1455 18.5802 18.0148 19.4406 18.33 20.3355L20.2056 19.2958C20.138 18.877 20.2211 18.4142 20.2539 17.9661C20.4382 16.542 20.6432 15.0022 19.337 13.1351ZM16.2253 13.1095L13.3523 10.1638C12.9775 9.99884 12.6174 9.88445 11.9674 10.4575L11.1963 11.1755L11.4257 12.1502L13.8503 14.6783L14.7626 14.6319L16.2253 13.1095Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "20",
    fill: "currentColor",
    transform: "translate(0.523438 4.63599) rotate(-16.2388)"
  }))));
});

var PortalReloadVariationsIcon = /*#__PURE__*/forwardRef(function PortalReloadVariationsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M12 4C7.58887 4 4 7.58887 4 12C4 16.4111 7.58887 20 12 20C16.4111 20 20 16.4111 20 12C20 7.58887 16.4111 4 12 4ZM7.20834 12.2542C7.15084 12.3013 7.08022 12.3333 7 12.3333C6.81575 12.3333 6.66666 12.1842 6.66666 12C6.66666 11.6141 6.71922 11.2335 6.80078 10.8599C6.80078 10.8599 6.86641 10.5643 6.86916 10.5567C7.50884 8.28578 9.61597 6.66666 12 6.66666C13.9331 6.66666 15.7267 7.73181 16.6617 9.40734C16.754 9.57284 16.6783 9.78419 16.5072 9.86541L15.9035 10.1519C15.7429 10.2282 15.5577 10.1606 15.4688 10.0065C14.7598 8.77803 13.4309 8 12 8C10.6108 8 9.34744 8.73319 8.627 9.85775L9.10547 10.0173C9.22006 10.0553 9.305 10.1527 9.32747 10.2715C9.34994 10.3903 9.30631 10.512 9.21353 10.5895L7.21353 12.2562C7.21187 12.2576 7.21 12.2533 7.20834 12.2542ZM17.2339 13.1401C17.2339 13.1401 17.1683 13.4357 17.1655 13.4433C16.5258 15.7142 14.4187 17.3333 12.0346 17.3333C10.1015 17.3333 8.30797 16.2682 7.373 14.5926C7.28069 14.4271 7.35631 14.2158 7.5275 14.1346L8.13112 13.8481C8.29178 13.7718 8.47691 13.8394 8.56581 13.9934C9.27481 15.222 10.6037 16 12.0347 16C13.4238 16 14.6872 15.2668 15.4077 14.1423L14.9292 13.9827C14.8146 13.9447 14.7297 13.8473 14.7072 13.7285C14.6847 13.6097 14.7283 13.488 14.8211 13.4105L16.8211 11.7438C16.8228 11.7425 16.8247 11.7467 16.8263 11.7458C16.8838 11.6988 16.9545 11.6667 17.0347 11.6667C17.2189 11.6667 17.368 11.8158 17.368 12.0001C17.368 12.3859 17.3154 12.7664 17.2339 13.1401Z",
    fill: "currentColor"
  }));
});

var PortalReportsIcon = /*#__PURE__*/forwardRef(function PortalReportsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M17.6634 5.81128H17.1955V17.305C17.1955 18.0686 16.574 18.6901 15.8104 18.6901H11.0702H7.30078V19.1162C7.30078 19.6041 7.69677 20.0001 8.18466 20.0001H12.9232H17.6617C18.1496 20.0001 18.5456 19.6041 18.5456 19.1162V6.69516C18.5456 6.20727 18.1513 5.81128 17.6634 5.81128Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.0719 18.1888H15.8104C16.2983 18.1888 16.6943 17.7928 16.6943 17.305V5.8112V4.88388C16.6943 4.39599 16.2983 4 15.8104 4H11.0719H9.49629V4.2924C9.49961 4.32247 9.5013 4.35422 9.5013 4.38597V6.31245V6.80702C9.5013 7.49374 8.94324 8.0518 8.25652 8.0518H7.76195H5.83547C5.8104 8.0518 5.78367 8.05013 5.75861 8.04846H5.45117V17.305C5.45117 17.7928 5.84716 18.1888 6.33505 18.1888H7.30414H11.0719ZM11.2507 15.1846H8.16128C7.93071 15.1846 7.74357 14.9975 7.74357 14.7669C7.74357 14.5363 7.93071 14.3492 8.16128 14.3492H11.2523C11.4829 14.3492 11.6701 14.5363 11.6701 14.7669C11.6701 14.9975 11.4813 15.1846 11.2507 15.1846ZM14.3417 13.0527H8.16128C7.93071 13.0527 7.74357 12.8655 7.74357 12.6349C7.74357 12.4044 7.93071 12.2172 8.16128 12.2172H14.3417C14.5723 12.2172 14.7595 12.4044 14.7595 12.6349C14.7595 12.8655 14.5723 13.0527 14.3417 13.0527ZM8.16128 9.95322H14.3417C14.5723 9.95322 14.7595 10.1404 14.7595 10.3709C14.7595 10.6015 14.5723 10.7886 14.3417 10.7886H8.16128C7.93071 10.7886 7.74357 10.6015 7.74357 10.3709C7.74357 10.1404 7.93071 9.95322 8.16128 9.95322Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M5.83444 7.55061H8.25548C8.25715 7.55061 8.26049 7.55061 8.26217 7.55061C8.66651 7.54727 8.99399 7.21978 8.99733 6.81544C8.99733 6.81376 8.99733 6.81042 8.99733 6.80875V4.38603C8.99733 4.16213 8.81354 4.01343 8.62308 4.01343C8.53119 4.01343 8.43929 4.04684 8.36243 4.1237L5.57044 6.91569C5.33653 7.1496 5.50194 7.55061 5.83444 7.55061Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalRetailIcon = /*#__PURE__*/forwardRef(function PortalRetailIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.125 7.66406C18.5 8.03906 18.6875 8.48438 18.6875 9V16.1367C18.6875 16.6523 18.5 17.0977 18.125 17.4727C17.7734 17.8242 17.3398 18 16.8242 18C16.3086 18 15.8633 17.8242 15.4883 17.4727C15.1133 17.0977 14.9258 16.6523 14.9258 16.1367V12.375H13.8008V18H6.3125V6.01172C6.3125 5.58984 6.45312 5.23828 6.73438 4.95703C7.03906 4.65234 7.40234 4.5 7.82422 4.5H12.3242C12.7227 4.5 13.0625 4.65234 13.3438 4.95703C13.6484 5.23828 13.8008 5.58984 13.8008 6.01172V11.25H14.5742C14.9727 11.25 15.3125 11.4023 15.5938 11.707C15.8984 11.9883 16.0508 12.3398 16.0508 12.7617V16.1367C16.0508 16.3242 16.1211 16.5 16.2617 16.6641C16.4258 16.8047 16.6016 16.875 16.7891 16.875C17 16.875 17.1758 16.8047 17.3164 16.6641C17.4805 16.5 17.5625 16.3242 17.5625 16.1367V10.7227C17.3047 10.8164 17.0586 10.8633 16.8242 10.8633C16.3086 10.8633 15.8633 10.6875 15.4883 10.3359C15.1133 9.96094 14.9258 9.51562 14.9258 9C14.9258 8.60156 15.0312 8.25 15.2422 7.94531C15.4766 7.61719 15.7812 7.38281 16.1562 7.24219L14.5742 5.66016L15.3477 4.88672L18.1602 7.66406H18.125ZM12.3242 9.73828V6.01172H7.82422V9.73828H12.3242ZM16.2617 9.52734C16.4258 9.66797 16.6016 9.73828 16.7891 9.73828C17 9.73828 17.1758 9.66797 17.3164 9.52734C17.4805 9.38672 17.5625 9.21094 17.5625 9C17.5625 8.78906 17.4805 8.61328 17.3164 8.47266C17.1758 8.33203 17 8.26172 16.7891 8.26172C16.6016 8.26172 16.4258 8.33203 16.2617 8.47266C16.1211 8.61328 16.0508 8.78906 16.0508 9C16.0508 9.21094 16.1211 9.38672 16.2617 9.52734Z",
    fill: "currentColor"
  })));
});

var PortalRewardsIcon = /*#__PURE__*/forwardRef(function PortalRewardsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M13.5547 6.32812C13.2734 6.60938 12.9219 6.75 12.5 6.75C12.0781 6.75 11.7148 6.60938 11.4102 6.32812C11.1289 6.02344 10.9883 5.66016 10.9883 5.23828C10.9883 4.95703 11.0703 4.69922 11.2344 4.46484L12.5 2.25L13.7656 4.46484C13.9297 4.69922 14.0117 4.95703 14.0117 5.23828C14.0117 5.66016 13.8594 6.02344 13.5547 6.32812ZM15.9453 14.2383C16.4609 14.7539 17.0703 15.0117 17.7734 15.0117C18.3125 15.0117 18.8047 14.8594 19.25 14.5547V18C19.25 18.2109 19.168 18.3867 19.0039 18.5273C18.8633 18.668 18.6992 18.7383 18.5117 18.7383H6.48828C6.30078 18.7383 6.125 18.668 5.96094 18.5273C5.82031 18.3867 5.75 18.2109 5.75 18V14.5547C6.19531 14.8594 6.6875 15.0117 7.22656 15.0117C7.92969 15.0117 8.53906 14.7539 9.05469 14.2383L9.86328 13.4297L10.6719 14.2383C11.1641 14.7305 11.7734 14.9766 12.5 14.9766C13.2266 14.9766 13.8359 14.7305 14.3281 14.2383L15.1367 13.4297L15.9453 14.2383ZM17 9C17.6328 9 18.1602 9.22266 18.582 9.66797C19.0273 10.0898 19.25 10.6172 19.25 11.25V12.4102C19.25 12.8086 19.0977 13.1602 18.793 13.4648C18.5117 13.7461 18.1719 13.8867 17.7734 13.8867C17.375 13.8867 17.0352 13.7461 16.7539 13.4648L15.1367 11.8477L13.5195 13.4648C13.2617 13.7227 12.9219 13.8516 12.5 13.8516C12.0781 13.8516 11.7266 13.7227 11.4453 13.4648L9.86328 11.8477L8.24609 13.4648C7.96484 13.7461 7.625 13.8867 7.22656 13.8867C6.82812 13.8867 6.47656 13.7461 6.17188 13.4648C5.89062 13.1602 5.75 12.8086 5.75 12.4102V11.25C5.75 10.6172 5.96094 10.0898 6.38281 9.66797C6.82812 9.22266 7.36719 9 8 9H11.7617V7.48828H13.2383V9H17Z",
    fill: "currentColor"
  })));
});

var PortalRoutingIcon = /*#__PURE__*/forwardRef(function PortalRoutingIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M16.0346 6.136H16.4917C16.6347 6.96972 17.3563 7.60564 18.2307 7.60564C19.2078 7.60564 20 6.81352 20 5.83639V5.76922C20 4.79205 19.2079 4 18.2308 4C17.3564 4 16.6348 4.63578 16.4918 5.46934H16.0346C14.8751 5.46934 13.932 6.42768 13.932 7.60574V11.6666H10.8214C10.6566 9.89903 9.19675 8.51615 7.41897 8.51615C5.53072 8.51615 4 10.0759 4 12C4 13.9241 5.53072 15.4839 7.41897 15.4839C9.19675 15.4839 10.6566 14.1009 10.8214 12.3333H13.932V16.3945C13.932 17.5722 14.8751 18.5306 16.0346 18.5306H16.4918C16.6348 19.3642 17.3564 20 18.2308 20C19.2079 20 20 19.2079 20 18.2308V18.1636C20 17.1865 19.2079 16.3944 18.2308 16.3944C17.3564 16.3944 16.6347 17.0302 16.4918 17.8639H16.0346C15.2429 17.8639 14.5987 17.2047 14.5987 16.3945V12.3333H16.4918C16.6347 13.1669 17.3563 13.8029 18.2308 13.8029C19.2079 13.8029 20 13.0107 20 12.0337V11.9664C20 10.9893 19.2079 10.1972 18.2308 10.1972C17.3564 10.1972 16.6348 10.833 16.4918 11.6667H14.5987V7.60574C14.5987 6.79517 15.2429 6.136 16.0346 6.136Z",
    fill: "currentColor"
  }));
});

var PortalSettingsIcon = /*#__PURE__*/forwardRef(function PortalSettingsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M19.122 10.2627L17.8687 10.1033C17.7653 9.78533 17.638 9.47867 17.4893 9.18733L18.2633 8.19067C18.5767 7.78733 18.54 7.218 18.182 6.87133L17.132 5.82133C16.782 5.46 16.2127 5.424 15.8087 5.73667L14.8133 6.51067C14.522 6.362 14.2153 6.23467 13.8967 6.13133L13.7373 4.88C13.6773 4.378 13.2513 4 12.7467 4H11.2533C10.7487 4 10.3227 4.378 10.2627 4.878L10.1033 6.13133C9.78467 6.23467 9.478 6.36133 9.18667 6.51067L8.19067 5.73667C7.788 5.424 7.21867 5.46 6.87133 5.818L5.82133 6.86733C5.46 7.218 5.42333 7.78733 5.73667 8.19133L6.51067 9.18733C6.36133 9.47867 6.23467 9.78533 6.13133 10.1033L4.88 10.2627C4.378 10.3227 4 10.7487 4 11.2533V12.7467C4 13.2513 4.378 13.6773 4.878 13.7373L6.13133 13.8967C6.23467 14.2147 6.362 14.5213 6.51067 14.8127L5.73667 15.8093C5.42333 16.2127 5.46 16.782 5.818 17.1287L6.868 18.1787C7.21867 18.5393 7.78733 18.5753 8.19133 18.2627L9.18733 17.4887C9.47867 17.638 9.78533 17.7653 10.1033 17.868L10.2627 19.1187C10.3227 19.622 10.7487 20 11.2533 20H12.7467C13.2513 20 13.6773 19.622 13.7373 19.122L13.8967 17.8687C14.2147 17.7653 14.5213 17.638 14.8127 17.4893L15.8093 18.2633C16.2127 18.5767 16.782 18.54 17.1287 18.182L18.1787 17.132C18.54 16.7813 18.5767 16.2127 18.2633 15.8087L17.4893 14.8127C17.6387 14.5213 17.766 14.2147 17.8687 13.8967L19.1193 13.7373C19.6213 13.6773 19.9993 13.2513 19.9993 12.7467V11.2533C20 10.7487 19.622 10.3227 19.122 10.2627ZM12 15.3333C10.162 15.3333 8.66667 13.838 8.66667 12C8.66667 10.162 10.162 8.66667 12 8.66667C13.838 8.66667 15.3333 10.162 15.3333 12C15.3333 13.838 13.838 15.3333 12 15.3333Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalSettlementSummariesIcon = /*#__PURE__*/forwardRef(function PortalSettlementSummariesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M14.6667 5.96667C12.7367 5.96667 11.1667 7.53667 11.1667 9.46667C11.1667 11.3967 12.7367 12.9667 14.6667 12.9667C16.5967 12.9667 18.1667 11.3967 18.1667 9.46667C18.1667 7.53667 16.5967 5.96667 14.6667 5.96667ZM14.5871 9.16243L14.9053 9.26183C15.2411 9.36677 15.4667 9.67363 15.4667 10.0254V10.1333C15.4667 10.5173 15.1947 10.8389 14.8333 10.9158V11C14.8333 11.1473 14.7139 11.2667 14.5667 11.2667C14.4194 11.2667 14.3 11.1473 14.3 11V10.844C14.0429 10.7108 13.8667 10.4423 13.8667 10.1333C13.8667 9.98607 13.9861 9.86667 14.1333 9.86667C14.2806 9.86667 14.4 9.98607 14.4 10.1333C14.4 10.2804 14.5196 10.4 14.6667 10.4C14.8137 10.4 14.9333 10.2804 14.9333 10.1333V10.0254C14.9333 9.90817 14.8581 9.8059 14.7462 9.7709L14.4281 9.6715C14.0923 9.56657 13.8667 9.2597 13.8667 8.90793V8.8C13.8667 8.45237 14.0896 8.15597 14.4 8.04587V7.93333C14.4 7.78607 14.5194 7.66667 14.6667 7.66667C14.8139 7.66667 14.9333 7.78607 14.9333 7.93333V8.04587C15.2437 8.15597 15.4667 8.45237 15.4667 8.8C15.4667 8.94727 15.3473 9.06667 15.2 9.06667C15.0527 9.06667 14.9333 8.94727 14.9333 8.8C14.9333 8.65297 14.8137 8.53333 14.6667 8.53333C14.5196 8.53333 14.4 8.65297 14.4 8.8V8.9079C14.4 9.02517 14.4752 9.12743 14.5871 9.16243ZM17.1242 19.4666C16.3931 19.4617 15.8 18.8656 15.8 18.1333V13.6789C15.8 13.5102 15.6453 13.3834 15.4802 13.4178C13.0045 13.9339 10.6333 12.0314 10.6333 9.46667C10.6333 6.90263 13.0037 4.99917 15.4802 5.5155C15.6453 5.54993 15.8 5.42307 15.8 5.25443V5.06667C15.8 4.47757 15.3224 4 14.7333 4H6.06667C5.47757 4 5 4.47757 5 5.06667V18.1333C5 19.1643 5.83573 20 6.86667 20H17.1333C17.2877 20 17.4114 19.8689 17.3992 19.712C17.3883 19.5717 17.2649 19.4676 17.1242 19.4666ZM7.6 7.9H9.86667C10.0139 7.9 10.1333 8.0194 10.1333 8.16667C10.1333 8.31393 10.0139 8.43333 9.86667 8.43333H7.6C7.45273 8.43333 7.33333 8.31393 7.33333 8.16667C7.33333 8.0194 7.45273 7.9 7.6 7.9ZM7.6 10.9H9.86667C10.0139 10.9 10.1333 11.0194 10.1333 11.1667C10.1333 11.3139 10.0139 11.4333 9.86667 11.4333H7.6C7.45273 11.4333 7.33333 11.3139 7.33333 11.1667C7.33333 11.0194 7.45273 10.9 7.6 10.9ZM13.2 17.2333H7.6C7.45273 17.2333 7.33333 17.1139 7.33333 16.9667C7.33333 16.8194 7.45273 16.7 7.6 16.7H13.2C13.3473 16.7 13.4667 16.8194 13.4667 16.9667C13.4667 17.1139 13.3473 17.2333 13.2 17.2333ZM13.2 14.4333H7.6C7.45273 14.4333 7.33333 14.3139 7.33333 14.1667C7.33333 14.0194 7.45273 13.9 7.6 13.9H13.2C13.3473 13.9 13.4667 14.0194 13.4667 14.1667C13.4667 14.3139 13.3473 14.4333 13.2 14.4333ZM18.999 17.7327C19 18.4697 18.4027 19.067 17.6667 19.067C16.9312 19.067 16.3343 18.471 16.3343 17.7347C16.3343 15.2716 16.3326 14.3119 16.3342 13.9319C16.3348 13.7851 16.454 13.6667 16.6008 13.6667H17.9333C18.4867 13.6667 18.9417 14.088 18.9947 14.6273L18.999 17.7327Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalSettlementsIcon = /*#__PURE__*/forwardRef(function PortalSettlementsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M17.6634 5.81128H17.1955V17.305C17.1955 18.0686 16.574 18.6901 15.8104 18.6901H11.0702H7.30078V19.1162C7.30078 19.6041 7.69677 20.0001 8.18466 20.0001H12.9232H17.6617C18.1496 20.0001 18.5456 19.6041 18.5456 19.1162V6.69516C18.5456 6.20727 18.1513 5.81128 17.6634 5.81128Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.0719 18.1888H15.8104C16.2983 18.1888 16.6943 17.7928 16.6943 17.305V5.8112V4.88388C16.6943 4.39599 16.2983 4 15.8104 4H11.0719H9.49629V4.2924C9.49961 4.32247 9.5013 4.35422 9.5013 4.38597V6.31245V6.80702C9.5013 7.49374 8.94324 8.0518 8.25652 8.0518H7.76195H5.83547C5.8104 8.0518 5.78367 8.05013 5.75861 8.04846H5.45117V17.305C5.45117 17.7928 5.84716 18.1888 6.33505 18.1888H7.30414H11.0719ZM11.2507 15.1846H8.16128C7.93071 15.1846 7.74357 14.9975 7.74357 14.7669C7.74357 14.5363 7.93071 14.3492 8.16128 14.3492H11.2523C11.4829 14.3492 11.6701 14.5363 11.6701 14.7669C11.6701 14.9975 11.4813 15.1846 11.2507 15.1846ZM14.3417 13.0527H8.16128C7.93071 13.0527 7.74357 12.8655 7.74357 12.6349C7.74357 12.4044 7.93071 12.2172 8.16128 12.2172H14.3417C14.5723 12.2172 14.7595 12.4044 14.7595 12.6349C14.7595 12.8655 14.5723 13.0527 14.3417 13.0527ZM8.16128 9.95322H14.3417C14.5723 9.95322 14.7595 10.1404 14.7595 10.3709C14.7595 10.6015 14.5723 10.7886 14.3417 10.7886H8.16128C7.93071 10.7886 7.74357 10.6015 7.74357 10.3709C7.74357 10.1404 7.93071 9.95322 8.16128 9.95322Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M5.83444 7.55061H8.25548C8.25715 7.55061 8.26049 7.55061 8.26217 7.55061C8.66651 7.54727 8.99399 7.21978 8.99733 6.81544C8.99733 6.81376 8.99733 6.81042 8.99733 6.80875V4.38603C8.99733 4.16213 8.81354 4.01343 8.62308 4.01343C8.53119 4.01343 8.43929 4.04684 8.36243 4.1237L5.57044 6.91569C5.33653 7.1496 5.50194 7.55061 5.83444 7.55061Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalShiftsIcon = /*#__PURE__*/forwardRef(function PortalShiftsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M17.6569 6.34316C16.1459 4.83216 14.1369 4 12 4C9.86312 4 7.85413 4.83216 6.34313 6.34316C4.83213 7.85416 4 9.86312 4 12C4 14.1369 4.83213 16.1459 6.34313 17.6568C7.85413 19.1678 9.86312 20 12 20C14.1369 20 16.1459 19.1678 17.6569 17.6568C19.1679 16.1458 20 14.1369 20 12C20 9.86312 19.1679 7.85413 17.6569 6.34316ZM12 18.4298C8.45459 18.4298 5.57025 15.5454 5.57025 12C5.57025 11.9942 5.57044 11.9884 5.57047 11.9827C5.57047 11.9812 5.57025 11.9798 5.57025 11.9783C5.57025 11.9759 5.57056 11.9735 5.57062 11.9711C5.58622 8.46816 8.41706 5.61825 11.9126 5.57138C11.9199 5.57103 11.9272 5.57028 11.9346 5.57028C11.939 5.57028 11.9433 5.57081 11.9478 5.57094C11.9652 5.57081 11.9826 5.57028 12 5.57028C15.5454 5.57028 18.4298 8.45466 18.4298 12C18.4298 15.5454 15.5454 18.4298 12 18.4298Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.8834 12.3863C16.622 12.3863 16.4101 12.1744 16.4101 11.9129C16.4101 11.6515 16.622 11.4396 16.8834 11.4396H17.454C17.186 8.8122 15.0552 6.72791 12.4074 6.53223V7.02895C12.4074 7.29038 12.1955 7.50232 11.934 7.50232C11.6726 7.50232 11.4607 7.29038 11.4607 7.02895V6.54354C8.85203 6.79916 6.77413 8.89048 6.53903 11.505H7.05003C7.31147 11.505 7.52341 11.7169 7.52341 11.9784C7.52341 12.2398 7.31147 12.4517 7.05003 12.4517H6.53516C6.75281 15.1083 8.87238 17.2344 11.5261 17.4624V16.8623C11.5261 16.6009 11.738 16.3889 11.9995 16.3889C12.2609 16.3889 12.4728 16.6009 12.4728 16.8623V17.4624C15.1483 17.2325 17.2808 15.0733 17.4687 12.3863H16.8834ZM13.9157 10.7533L12.3342 12.3348C12.2454 12.4236 12.1251 12.4734 11.9995 12.4734C11.874 12.4734 11.7535 12.4236 11.6648 12.3348L8.91188 9.58188C8.727 9.39704 8.727 9.09732 8.91188 8.91245C9.09672 8.72757 9.39644 8.72757 9.58131 8.91245L11.9995 11.3306L13.2463 10.0838C13.4312 9.89895 13.7309 9.89895 13.9158 10.0838C14.1006 10.2687 14.1006 10.5684 13.9157 10.7533Z",
    fill: "currentColor"
  }));
});

var PortalShipmentsIcon = /*#__PURE__*/forwardRef(function PortalShipmentsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M14 6.88351V6.87951L16.994 8.22051L20 7.09351L12 4.09351L4 7.09351L12 10.0935L14.994 8.97051L12 7.73651V7.73351L14 6.88351Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M4 8.09351V17.0935L11.5 19.9065V10.9065L4 8.09351ZM8 17.1265L6 16.3765V15.3095L8 16.0595V17.1265Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17 9.21851V11.7235L15 12.4735V9.96851L12.5 10.9065V19.9065L20 17.0935V8.09351L17 9.21851Z",
    fill: "currentColor"
  }));
});

var PortalShippingIcon = /*#__PURE__*/forwardRef(function PortalShippingIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M14 6.88351V6.87951L16.994 8.22051L20 7.09351L12 4.09351L4 7.09351L12 10.0935L14.994 8.97051L12 7.73651V7.73351L14 6.88351Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M4 8.09351V17.0935L11.5 19.9065V10.9065L4 8.09351ZM8 17.1265L6 16.3765V15.3095L8 16.0595V17.1265Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17 9.21851V11.7235L15 12.4735V9.96851L12.5 10.9065V19.9065L20 17.0935V8.09351L17 9.21851Z",
    fill: "currentColor"
  }));
});

var PortalSpinIcon = /*#__PURE__*/forwardRef(function SpinIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props, {
    ref: ref
  }), createElement("circle", {
    className: "pu-opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), createElement("path", {
    className: "pu-opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
});

var PortalStockActionsIcon = /*#__PURE__*/forwardRef(function PortalStockActionsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M15.2812 13.4375C13.4722 13.4375 12 14.9097 12 16.7188C12 18.4948 13.4355 20 15.2812 20C17.0903 20 18.5625 18.5278 18.5625 16.7188C18.5625 14.9097 17.0903 13.4375 15.2812 13.4375ZM16.5502 16.347L15.1439 17.7533C14.9608 17.9364 14.6642 17.9364 14.4811 17.7533L13.7779 17.0502C13.5948 16.8671 13.5948 16.5704 13.7779 16.3873C13.961 16.2042 14.2577 16.2042 14.4408 16.3873L14.8125 16.759L15.8873 15.6842C16.0704 15.5011 16.3671 15.5011 16.5502 15.6842C16.7333 15.8673 16.7333 16.1639 16.5502 16.347Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.2812 4H5.90625C5.64716 4 5.4375 4.20966 5.4375 4.46875V17.6562C5.4375 17.9153 5.64716 18.125 5.90625 18.125H11.3131C11.3113 18.1201 11.3087 18.1157 11.3069 18.1108C11.1495 17.708 11.0625 17.2269 11.0625 16.7188C11.0625 14.3924 12.9549 12.5 15.2812 12.5C15.4417 12.5 15.5941 12.5298 15.75 12.5474V4.46875C15.75 4.20966 15.5403 4 15.2812 4ZM7.78125 13.4375C7.52238 13.4375 7.3125 13.2276 7.3125 12.9688C7.3125 12.7098 7.52238 12.5 7.78125 12.5C8.04012 12.5 8.25 12.7098 8.25 12.9688C8.25 13.2276 8.04012 13.4375 7.78125 13.4375ZM7.78125 11.5625C7.52238 11.5625 7.3125 11.3526 7.3125 11.0938C7.3125 10.8348 7.52238 10.625 7.78125 10.625C8.04012 10.625 8.25 10.8348 8.25 11.0938C8.25 11.3526 8.04012 11.5625 7.78125 11.5625ZM7.78125 9.6875C7.52238 9.6875 7.3125 9.47762 7.3125 9.21875C7.3125 8.95981 7.52238 8.75 7.78125 8.75C8.04012 8.75 8.25 8.95981 8.25 9.21875C8.25 9.47762 8.04012 9.6875 7.78125 9.6875ZM7.78125 7.8125C7.52238 7.8125 7.3125 7.60262 7.3125 7.34375C7.3125 7.08481 7.52238 6.875 7.78125 6.875C8.04012 6.875 8.25 7.08481 8.25 7.34375C8.25 7.60262 8.04012 7.8125 7.78125 7.8125ZM11.5312 13.4375H9.65625C9.39716 13.4375 9.1875 13.2278 9.1875 12.9688C9.1875 12.7097 9.39716 12.5 9.65625 12.5H11.5312C11.7903 12.5 12 12.7097 12 12.9688C12 13.2278 11.7903 13.4375 11.5312 13.4375ZM13.4062 11.5625H9.65625C9.39716 11.5625 9.1875 11.3528 9.1875 11.0938C9.1875 10.8347 9.39716 10.625 9.65625 10.625H13.4062C13.6653 10.625 13.875 10.8347 13.875 11.0938C13.875 11.3528 13.6653 11.5625 13.4062 11.5625ZM13.4062 9.6875H9.65625C9.39716 9.6875 9.1875 9.47784 9.1875 9.21875C9.1875 8.95966 9.39716 8.75 9.65625 8.75H13.4062C13.6653 8.75 13.875 8.95966 13.875 9.21875C13.875 9.47784 13.6653 9.6875 13.4062 9.6875ZM13.4062 7.8125H9.65625C9.39716 7.8125 9.1875 7.60284 9.1875 7.34375C9.1875 7.08466 9.39716 6.875 9.65625 6.875H13.4062C13.6653 6.875 13.875 7.08466 13.875 7.34375C13.875 7.60284 13.6653 7.8125 13.4062 7.8125Z",
    fill: "currentColor"
  }));
});

var PortalStockLocationsIcon = /*#__PURE__*/forwardRef(function PortalStockLocationsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M13.4688 9.5C13.4688 9.75888 13.2589 9.96875 13 9.96875C12.7411 9.96875 12.5313 9.75888 12.5313 9.5V9.21875H11.4688V9.5C11.4688 9.75888 11.2589 9.96875 11 9.96875C10.7411 9.96875 10.5313 9.75888 10.5313 9.5V9.21875H9.71875V12C9.71875 12.4308 10.0692 12.7812 10.5 12.7812H13.5C13.9308 12.7812 14.2813 12.4308 14.2813 12V9.21875H13.4688V9.5Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.5313 7.75C12.5313 7.45706 12.2929 7.21875 12 7.21875C11.7071 7.21875 11.4688 7.45706 11.4688 7.75V8.28125H12.5313V7.75Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.0004 4C8.28991 4 5.46588 7.27531 5.80728 10.7722C6.03319 13.13 7.72294 15.5745 9.26559 17.3687C10.658 15.5859 13.3425 15.5854 14.7353 17.3687C16.2791 15.5731 17.9678 13.1291 18.1936 10.7731C18.5339 7.28488 15.7211 4 12.0004 4V4ZM15.2192 12C15.2192 12.9477 14.4482 13.7188 13.5004 13.7188H10.5004C9.55272 13.7188 8.78169 12.9477 8.78169 12V8.75C8.78169 8.49113 8.99156 8.28125 9.25044 8.28125H10.5317V7.75C10.5317 6.94012 11.1906 6.28125 12.0004 6.28125C12.8103 6.28125 13.4692 6.94012 13.4692 7.75V8.28125H14.7504C15.0093 8.28125 15.2192 8.49113 15.2192 8.75V12Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M9.90234 18.0842C10.8844 19.1484 11.6559 19.8535 11.692 19.8849C11.8684 20.0383 12.1308 20.0383 12.3072 19.8849C12.8157 19.4436 13.6425 18.5767 14.0969 18.0842C13.0905 16.5982 10.9095 16.597 9.90234 18.0842Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalStockTakesIcon = /*#__PURE__*/forwardRef(function PortalStockTakesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M16.7623 19.9999V6.46143H7.47656V19.9999H16.7623ZM8.40513 8.30758H15.8337V8.92296H8.40513V8.30758ZM8.40513 10.1537H15.8337V10.7691H8.40513V10.1537ZM8.40513 11.9999H15.8337V12.6153H8.40513V11.9999ZM8.40513 13.846H15.8337V14.4614H8.40513V13.846ZM8.40513 15.6922H15.8337V16.3076H8.40513V15.6922ZM8.40513 17.5383H15.8337V18.1537H8.40513V17.5383Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.0708 5.84615C17.597 5.84615 17.9993 5.44615 17.9993 4.92308C17.9993 4.4 17.597 4 17.0708 4H16.7613H7.16602C7.35173 4.24615 7.47554 4.58462 7.47554 4.92308C7.47554 5.32308 7.38268 5.63077 7.25887 5.84615H16.7613H17.0708Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.23828 6.43071V15.3846V15.9999V19.2307L6.85733 19.6922V6.24609C6.70257 6.3384 6.51685 6.39994 6.36209 6.43071C6.33114 6.43071 6.26923 6.43071 6.23828 6.43071Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M5.92857 4C5.40238 4 5 4.4 5 4.92308V5.23077V15.3846H5.61905V5.84615H5.68095H5.99048C6.08333 5.84615 6.17619 5.84615 6.26905 5.81538C6.57857 5.78462 6.85714 5.63077 6.85714 4.92308C6.85714 4.4 6.45476 4 5.92857 4Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "13",
    height: "16",
    fill: "currentColor",
    transform: "translate(5 4)"
  }))));
});

var PortalStockIcons = /*#__PURE__*/forwardRef(function PortalStockIcons(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M11.3333 13.1667C11.3333 12.8914 11.108 12.6667 10.8333 12.6667H8.33333V14.6667C8.33333 15.0347 8.03467 15.3334 7.66667 15.3334C7.29867 15.3334 7 15.0347 7 14.6667V12.6667H4.5C4.22467 12.6667 4 12.8914 4 13.1667V19.5001C4 19.7754 4.22467 20.0001 4.5 20.0001H10.8333C11.108 20.0001 11.3333 19.7754 11.3333 19.5001V13.1667Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.9993 13.1667C19.9993 12.8914 19.774 12.6667 19.4993 12.6667H16.9993V14.6667C16.9993 15.0347 16.7007 15.3334 16.3327 15.3334C15.9647 15.3334 15.666 15.0347 15.666 14.6667V12.6667H13.166C12.8907 12.6667 12.666 12.8914 12.666 13.1667V19.5001C12.666 19.7754 12.8907 20.0001 13.166 20.0001H19.4993C19.774 20.0001 19.9993 19.7754 19.9993 19.5001V13.1667Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M15.6673 4.5C15.6673 4.22533 15.442 4 15.1673 4H12.6673V6C12.6673 6.368 12.3686 6.66667 12.0006 6.66667C11.6326 6.66667 11.334 6.368 11.334 6V4H8.83398C8.55865 4 8.33398 4.22533 8.33398 4.5V10.8333C8.33398 11.1087 8.55865 11.3333 8.83398 11.3333H15.1673C15.442 11.3333 15.6673 11.1087 15.6673 10.8333V4.5Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalStoreOrdersIcon = /*#__PURE__*/forwardRef(function PortalStoreOrdersIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M19.9099 9.21021L17.41 5.71024C17.31 5.58024 17.16 5.50024 17 5.50024H7.00005C6.84005 5.50024 6.69006 5.58024 6.59006 5.71024L4.09008 9.21021C4.06008 9.30021 4.03008 9.39021 4.00008 9.48021C3.99008 10.5902 4.89007 11.5002 6.00006 11.5002C6.60006 11.5002 7.13005 11.2402 7.50005 10.8202C7.87004 11.2402 8.40004 11.5002 9.00003 11.5002C9.60003 11.5002 10.13 11.2402 10.5 10.8202C10.87 11.2402 11.4 11.5002 12 11.5002C12.6 11.5002 13.13 11.2402 13.5 10.8202C13.87 11.2402 14.4 11.5002 15 11.5002C15.6 11.5002 16.13 11.2402 16.5 10.8202C16.87 11.2402 17.4 11.5002 17.9999 11.5002C19.1099 11.5002 20.0099 10.5902 19.9999 9.48021C19.9699 9.39021 19.9399 9.30021 19.9099 9.21021Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.9999 12.5002C17.4689 12.5002 16.9519 12.3582 16.4999 12.0962C15.5959 12.6192 14.4039 12.6192 13.4999 12.0962C12.5959 12.6192 11.4029 12.6192 10.4999 12.0962C9.59695 12.6192 8.40297 12.6192 7.49998 12.0962C6.74898 12.5322 5.81899 12.5882 5 12.3052V17.5001C5 18.0521 5.448 18.5001 5.99999 18.5001H13.9999V13.5002H16.9999V18.5001H17.9999C18.5519 18.5001 18.9999 18.0521 18.9999 17.5001V12.3172C18.6819 12.4302 18.3469 12.5002 17.9999 12.5002ZM10.9999 16.5001H6.99998V13.5002H10.9999V16.5001Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var PortalSubsidyIcon = /*#__PURE__*/forwardRef(function PortalSubsidyIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M12.4688 14.2797C13.0077 14.1473 13.4062 13.8005 13.4062 13.4018C13.4062 13.0031 13.0077 12.6563 12.4688 12.5239V14.2797Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12 6.84375C9.15684 6.84375 6.84375 9.15684 6.84375 12C6.84375 14.8432 9.15684 17.1562 12 17.1562C14.8432 17.1562 17.1562 14.8432 17.1562 12C17.1562 9.15684 14.8432 6.84375 12 6.84375ZM14.3438 13.4017C14.3438 14.3073 13.5372 15.0646 12.4688 15.2388V15.75C12.4688 16.0091 12.2591 16.2188 12 16.2188C11.7409 16.2188 11.5312 16.0091 11.5312 15.75V15.2388C10.4628 15.0646 9.65625 14.3073 9.65625 13.4017C9.65625 13.1426 9.86591 12.9329 10.125 12.9329C10.3841 12.9329 10.5938 13.1426 10.5938 13.4017C10.5938 13.8003 10.9923 14.1472 11.5312 14.2796V12.4263C10.4628 12.2521 9.65625 11.4948 9.65625 10.5892C9.65625 9.68356 10.4628 8.92631 11.5312 8.75212V8.24544C11.5312 7.98634 11.7409 7.77669 12 7.77669C12.2591 7.77669 12.4688 7.98634 12.4688 8.24544V8.75212C13.5372 8.92631 14.3438 9.68356 14.3438 10.5892C14.3438 10.8483 14.1341 11.0579 13.875 11.0579C13.6159 11.0579 13.4062 10.8483 13.4062 10.5892C13.4062 10.1905 13.0077 9.84366 12.4688 9.71131V11.5646C13.5372 11.7388 14.3438 12.496 14.3438 13.4017Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M11.5312 9.71118C10.9923 9.84353 10.5938 10.1904 10.5938 10.5891C10.5938 10.9877 10.9923 11.3346 11.5312 11.4669V9.71118Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12 4C7.60594 4 4 7.60594 4 12C4 16.3941 7.60594 20 12 20C16.3941 20 20 16.3941 20 12C20 7.60594 16.3941 4 12 4ZM12 18.0938C8.64 18.0938 5.90625 15.36 5.90625 12C5.90625 8.64 8.64 5.90625 12 5.90625C15.36 5.90625 18.0938 8.64 18.0938 12C18.0938 15.36 15.36 18.0938 12 18.0938Z",
    fill: "currentColor"
  })));
});

var PortalSuppliersIcon = /*#__PURE__*/forwardRef(function PortalSuppliersIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M20 7.65093V12.4943C20 12.4943 18.9634 12.6985 18.7499 12.7254C18.537 12.7522 17.868 12.9682 17.3832 12.5022C16.6355 11.7856 13.9791 9.14381 13.9791 9.14381C13.9791 9.14381 13.5211 8.69437 12.7856 9.0828C12.1105 9.43862 11.1098 9.96008 10.6918 10.1631C9.90163 10.5837 9.24671 9.91643 9.24671 9.40814C9.24671 9.01387 9.49273 8.74628 9.84442 8.54949C10.7975 7.97169 12.8064 6.84409 13.6431 6.39953C14.1517 6.12903 14.5181 6.10585 15.2164 6.69407C16.0763 7.4173 16.8416 8.07655 16.8416 8.07655C16.8416 8.07655 17.0912 8.28487 17.4893 8.20097C18.4668 7.99429 20 7.65093 20 7.65093ZM9.42665 15.8575C9.5553 15.527 9.5123 15.1574 9.26566 14.9038C9.04404 14.6769 8.72047 14.6171 8.41194 14.6878C8.49823 14.3818 8.45058 14.0561 8.22777 13.8263C8.00547 13.6 7.68252 13.539 7.37402 13.6103C7.45967 13.3048 7.41215 12.9791 7.1892 12.7499C6.8401 12.3919 6.23625 12.4072 5.83956 12.7854C5.44497 13.164 5.1922 13.85 5.54437 14.2538C5.89596 14.6556 6.29995 14.4111 6.60792 14.3409C6.52224 14.6465 6.26553 14.9307 6.58168 15.3307C6.89753 15.7308 7.33722 15.488 7.64552 15.4185C7.55955 15.7229 7.31404 16.0356 7.61805 16.4065C7.9248 16.7784 8.42721 16.5803 8.75905 16.4772C8.63098 16.8064 8.35687 17.1613 8.70904 17.5591C9.06066 17.9597 9.87325 17.7743 10.2702 17.3956C10.666 17.017 10.704 16.4169 10.3558 16.0577C10.1155 15.8112 9.75713 15.7539 9.42665 15.8575ZM16.6691 13.3378C13.7998 10.4684 15.1494 11.8186 13.6053 10.2712C13.6053 10.2712 13.1412 9.80916 12.5296 10.0775C12.1002 10.2657 11.5474 10.5221 11.1315 10.7179C10.6744 10.9575 10.3455 11.0317 10.1911 11.0307C9.3075 11.0249 8.59063 10.3147 8.59063 9.432C8.59063 8.85937 8.89463 8.36083 9.34804 8.07784C9.98563 7.63663 11.4532 6.85604 11.4532 6.85604C11.4532 6.85604 11.0061 6.28951 10.0267 6.28951C9.04762 6.28951 7.002 7.62963 7.002 7.62963C7.002 7.62963 6.42168 8.00133 5.59444 7.66653L4 7.1113V12.6535C4 12.6535 4.45528 12.7853 4.86437 12.9524C4.95676 12.6889 5.10584 12.4456 5.31265 12.2446C5.99132 11.5982 7.11625 11.5915 7.73372 12.2273C7.91973 12.4205 8.04954 12.6511 8.11578 12.906C8.36458 12.9828 8.58995 13.1188 8.77105 13.3054C8.95762 13.4974 9.08694 13.7292 9.15373 13.9828C9.40225 14.0597 9.62729 14.1962 9.80901 14.383C10.0136 14.594 10.15 14.8489 10.2136 15.1251C10.4734 15.2008 10.7082 15.3415 10.8973 15.5348C11.2683 15.916 11.4001 16.4331 11.3203 16.932C11.3209 16.932 11.3221 16.932 11.3227 16.9331C11.3288 16.941 11.5526 17.1906 11.6922 17.3313C11.9658 17.6052 12.4125 17.6052 12.6869 17.3313C12.9595 17.0576 12.9607 16.6118 12.6869 16.3367C12.6771 16.3269 11.6999 15.3048 11.7786 15.2256C11.8566 15.1469 13.1015 16.4422 13.1247 16.4659C13.3979 16.7392 13.8443 16.7392 14.1188 16.4659C14.3926 16.1922 14.392 15.7464 14.1188 15.4719C14.1053 15.4591 14.0493 15.4055 14.0285 15.3841C14.0285 15.3841 12.7942 14.2845 12.8882 14.1906C12.9833 14.0961 14.5164 15.5268 14.5189 15.5268C14.7945 15.775 15.219 15.7732 15.4842 15.5079C15.7421 15.25 15.7477 14.842 15.519 14.567C15.5141 14.5524 14.3505 13.3364 14.4413 13.2449C14.5335 13.1522 15.6848 14.3377 15.6873 14.3402C15.9599 14.6134 16.4069 14.6134 16.6813 14.3402C16.9545 14.067 16.9545 13.6206 16.6813 13.3449C16.6776 13.3426 16.6727 13.3401 16.6691 13.3378Z",
    fill: "currentColor"
  }));
});

var PortalTeamsIcon = /*#__PURE__*/forwardRef(function PortalTeamsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M17.0879 9.84375C16.666 10.2891 16.1387 10.5117 15.5059 10.5117C14.873 10.5117 14.334 10.2891 13.8887 9.84375C13.4668 9.39844 13.2559 8.87109 13.2559 8.26172C13.2559 7.62891 13.4668 7.10156 13.8887 6.67969C14.334 6.23437 14.873 6.01172 15.5059 6.01172C16.1387 6.01172 16.666 6.23437 17.0879 6.67969C17.5332 7.10156 17.7559 7.62891 17.7559 8.26172C17.7559 8.87109 17.5332 9.39844 17.0879 9.84375ZM11.0762 9.84375C10.6543 10.2891 10.127 10.5117 9.49414 10.5117C8.88477 10.5117 8.35742 10.2891 7.91211 9.84375C7.4668 9.39844 7.24414 8.87109 7.24414 8.26172C7.24414 7.62891 7.4668 7.10156 7.91211 6.67969C8.35742 6.23437 8.88477 6.01172 9.49414 6.01172C10.127 6.01172 10.6543 6.23437 11.0762 6.67969C11.5215 7.10156 11.7441 7.62891 11.7441 8.26172C11.7441 8.87109 11.5215 9.39844 11.0762 9.84375ZM7.34961 12.2695C8.14648 12.082 8.86133 11.9883 9.49414 11.9883C10.1504 11.9883 10.8652 12.082 11.6387 12.2695C12.4121 12.457 13.127 12.7617 13.7832 13.1836C14.4395 13.6055 14.7676 14.0859 14.7676 14.625V16.4883H4.25586V14.625C4.25586 14.0859 4.57227 13.6055 5.20508 13.1836C5.86133 12.7617 6.57617 12.457 7.34961 12.2695ZM15.5059 11.9883C16.1621 11.9883 16.877 12.082 17.6504 12.2695C18.4238 12.457 19.127 12.7617 19.7598 13.1836C20.416 13.6055 20.7441 14.0859 20.7441 14.625V16.4883H16.2441V14.625C16.2441 13.6172 15.752 12.75 14.7676 12.0234C15.0723 12 15.3184 11.9883 15.5059 11.9883Z",
    fill: "currentColor"
  })));
});

var PortalTerminalsIcon = /*#__PURE__*/forwardRef(function PortalTerminalsIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M8.73828 20.25V18.7383H10.25V20.25H8.73828ZM11.7617 20.25V18.7383H13.2383V20.25H11.7617ZM14.75 20.25V18.7383H16.2617V20.25H14.75ZM15.4883 2.25C15.9102 2.25 16.2617 2.40234 16.543 2.70703C16.8477 2.98828 17 3.33984 17 3.76172V15.75C17 16.1719 16.8477 16.5352 16.543 16.8398C16.2617 17.1211 15.9102 17.2617 15.4883 17.2617H9.51172C9.08984 17.2617 8.72656 17.1211 8.42188 16.8398C8.14062 16.5352 8 16.1719 8 15.75V3.76172C8 3.33984 8.14062 2.98828 8.42188 2.70703C8.72656 2.40234 9.08984 2.25 9.51172 2.25H15.4883ZM15.4883 14.2383V5.23828H9.51172V14.2383H15.4883Z",
    fill: "currentColor"
  })));
});

var PortalTransactionsIcon = /*#__PURE__*/forwardRef(function PortalTransactionsIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M14 4V8H18L14 4Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M14 9C13.449 9 13 8.551 13 8V4H7C6.449 4 6 4.449 6 5V19C6 19.552 6.449 20 7 20H17C17.552 20 18 19.552 18 19V9H14ZM9.5 7.062V6.5C9.5 6.224 9.724 6 10 6C10.276 6 10.5 6.224 10.5 6.5V7.063C10.813 7.134 11.105 7.266 11.346 7.462C11.561 7.636 11.593 7.951 11.418 8.165C11.243 8.38 10.928 8.411 10.715 8.237C10.526 8.084 10.272 8 10 8C9.458 8 9 8.343 9 8.75C9 9.157 9.458 9.5 10 9.5C11.103 9.5 12 10.285 12 11.25C12 12.063 11.36 12.742 10.5 12.938V13.5C10.5 13.776 10.276 14 10 14C9.724 14 9.5 13.776 9.5 13.5V12.937C9.187 12.866 8.895 12.734 8.654 12.538C8.439 12.363 8.407 12.048 8.582 11.834C8.757 11.618 9.071 11.588 9.285 11.762C9.474 11.916 9.728 12 10 12C10.542 12 11 11.657 11 11.25C11 10.843 10.542 10.5 10 10.5C8.897 10.5 8 9.715 8 8.75C8 7.937 8.64 7.258 9.5 7.062ZM15.5 18H8.5C8.224 18 8 17.776 8 17.5C8 17.224 8.224 17 8.5 17H15.5C15.776 17 16 17.224 16 17.5C16 17.776 15.776 18 15.5 18ZM15.5 16H8.5C8.224 16 8 15.776 8 15.5C8 15.224 8.224 15 8.5 15H15.5C15.776 15 16 15.224 16 15.5C16 15.776 15.776 16 15.5 16ZM15.5 14H13.5C13.224 14 13 13.776 13 13.5C13 13.224 13.224 13 13.5 13H15.5C15.776 13 16 13.224 16 13.5C16 13.776 15.776 14 15.5 14ZM15.5 12H13.5C13.224 12 13 11.776 13 11.5C13 11.224 13.224 11 13.5 11H15.5C15.776 11 16 11.223 16 11.5C16 11.776 15.776 12 15.5 12Z",
    fill: "currentColor"
  }));
});

var PortalTreasuryIcon = /*#__PURE__*/forwardRef(function PortalTreasuryIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M6.89258 9.73828H9.14258V15.0117H6.89258V9.73828ZM11.3926 9.73828H13.6426V15.0117H11.3926V9.73828ZM5.38086 18.7383V16.4883H19.6191V18.7383H5.38086ZM15.8926 9.73828H18.1426V15.0117H15.8926V9.73828ZM12.5176 2.98828L19.6191 6.75V8.26172H5.38086V6.75L12.5176 2.98828Z",
    fill: "currentColor"
  })));
});

var PortalUsersIcon = /*#__PURE__*/forwardRef(function PortalUsersIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M16.6562 7C17.0312 7 17.3438 7.13542 17.5938 7.40625C17.8646 7.65625 18 7.96875 18 8.34375V17.6562C18 18.0312 17.8646 18.3542 17.5938 18.625C17.3438 18.875 17.0312 19 16.6562 19H7.34375C6.96875 19 6.64583 18.875 6.375 18.625C6.125 18.3542 6 18.0312 6 17.6562V8.34375C6 7.96875 6.125 7.65625 6.375 7.40625C6.64583 7.13542 6.96875 7 7.34375 7H10.125C10.2708 6.60417 10.5104 6.28125 10.8438 6.03125C11.1979 5.78125 11.5833 5.65625 12 5.65625C12.4167 5.65625 12.7917 5.78125 13.125 6.03125C13.4792 6.28125 13.7292 6.60417 13.875 7H16.6562ZM12.4688 7.21875C12.3438 7.07292 12.1875 7 12 7C11.8125 7 11.6562 7.07292 11.5312 7.21875C11.4062 7.34375 11.3438 7.5 11.3438 7.6875C11.3438 7.85417 11.4062 8.01042 11.5312 8.15625C11.6562 8.28125 11.8125 8.34375 12 8.34375C12.1875 8.34375 12.3438 8.28125 12.4688 8.15625C12.5938 8.01042 12.6562 7.85417 12.6562 7.6875C12.6562 7.5 12.5938 7.34375 12.4688 7.21875ZM13.4062 10.25C13.0312 9.85417 12.5625 9.65625 12 9.65625C11.4375 9.65625 10.9583 9.85417 10.5625 10.25C10.1875 10.6458 10 11.125 10 11.6875C10 12.2292 10.1875 12.6979 10.5625 13.0938C10.9583 13.4688 11.4375 13.6562 12 13.6562C12.5625 13.6562 13.0312 13.4688 13.4062 13.0938C13.8021 12.6979 14 12.2292 14 11.6875C14 11.125 13.8021 10.6458 13.4062 10.25ZM16 17.6562V16.7188C16 16.3229 15.75 15.9583 15.25 15.625C14.7708 15.2917 14.2292 15.0521 13.625 14.9062C13.0208 14.7396 12.4792 14.6562 12 14.6562C11.5208 14.6562 10.9792 14.7396 10.375 14.9062C9.77083 15.0521 9.21875 15.2917 8.71875 15.625C8.23958 15.9583 8 16.3229 8 16.7188V17.6562H16Z",
    fill: "currentColor"
  })));
});

var PortalVehicleDirectoryIcon = /*#__PURE__*/forwardRef(function PortalVehicleDirectoryIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M6.89935 8.21875C6.89935 6.58187 8.24852 5.25 9.90666 5.25H15.6889C15.4806 4.53062 14.8165 4 14.0219 4H6.74107C5.78063 4 5 4.77062 5 5.71875V15.4062C5 16.3544 5.78063 17.125 6.74107 17.125H6.89935V8.21875Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M17.1879 6.5H9.90709C8.94665 6.5 8.16602 7.27062 8.16602 8.21875V17.2812C8.16602 18.2294 8.94665 19 9.90709 19H17.1879C18.1484 19 18.929 18.2294 18.929 17.2812V8.21875C18.929 7.27062 18.1484 6.5 17.1879 6.5ZM15.9217 17.125H11.1733C10.9112 17.125 10.6985 16.915 10.6985 16.6562C10.6985 16.3975 10.9112 16.1875 11.1733 16.1875H15.9217C16.1838 16.1875 16.3965 16.3975 16.3965 16.6562C16.3965 16.915 16.1838 17.125 15.9217 17.125ZM15.9217 14.625H11.1733C10.9112 14.625 10.6985 14.415 10.6985 14.1562C10.6985 13.8975 10.9112 13.6875 11.1733 13.6875H15.9217C16.1838 13.6875 16.3965 13.8975 16.3965 14.1562C16.3965 14.415 16.1838 14.625 15.9217 14.625ZM15.9217 12.4375H11.1733C10.9112 12.4375 10.6985 12.2275 10.6985 11.9688C10.6985 11.71 10.9112 11.5 11.1733 11.5H15.9217C16.1838 11.5 16.3965 11.71 16.3965 11.9688C16.3965 12.2275 16.1838 12.4375 15.9217 12.4375ZM15.9217 9.9375H11.1733C10.9112 9.9375 10.6985 9.7275 10.6985 9.46875C10.6985 9.21 10.9112 9 11.1733 9H15.9217C16.1838 9 16.3965 9.21 16.3965 9.46875C16.3965 9.7275 16.1838 9.9375 15.9217 9.9375Z",
    fill: "currentColor"
  })));
});

var PortalVehiclesIcon = /*#__PURE__*/forwardRef(function PortalVehiclesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.4941 8.26172L20.7441 11.25V15.0117H19.2676C19.2676 15.6211 19.0449 16.1484 18.5996 16.5938C18.1543 17.0391 17.6152 17.2617 16.9824 17.2617C16.373 17.2617 15.8457 17.0391 15.4004 16.5938C14.9785 16.1484 14.7676 15.6211 14.7676 15.0117H10.2676C10.2676 15.6211 10.0449 16.1484 9.59961 16.5938C9.1543 17.0391 8.61523 17.2617 7.98242 17.2617C7.37305 17.2617 6.8457 17.0391 6.40039 16.5938C5.97852 16.1484 5.76758 15.6211 5.76758 15.0117H4.25586V6.75C4.25586 6.32812 4.39648 5.97656 4.67773 5.69531C4.98242 5.39062 5.3457 5.23828 5.76758 5.23828H16.2441V8.26172H18.4941ZM7.20898 15.8203C7.41992 16.0312 7.67773 16.1367 7.98242 16.1367C8.31055 16.1367 8.58008 16.0312 8.79102 15.8203C9.02539 15.5859 9.14258 15.3164 9.14258 15.0117C9.14258 14.6836 9.02539 14.4141 8.79102 14.2031C8.58008 13.9922 8.31055 13.8867 7.98242 13.8867C7.67773 13.8867 7.41992 13.9922 7.20898 14.2031C6.99805 14.4141 6.89258 14.6836 6.89258 15.0117C6.89258 15.3164 6.99805 15.5859 7.20898 15.8203ZM18.1426 9.38672H16.2441V11.25H19.584L18.1426 9.38672ZM16.209 15.8203C16.4199 16.0312 16.6777 16.1367 16.9824 16.1367C17.3105 16.1367 17.5801 16.0312 17.791 15.8203C18.0254 15.5859 18.1426 15.3164 18.1426 15.0117C18.1426 14.6836 18.0254 14.4141 17.791 14.2031C17.5801 13.9922 17.3105 13.8867 16.9824 13.8867C16.6777 13.8867 16.4199 13.9922 16.209 14.2031C15.998 14.4141 15.8926 14.6836 15.8926 15.0117C15.8926 15.3164 15.998 15.5859 16.209 15.8203Z",
    fill: "currentColor"
  })));
});

var PortalVoucherBatchesIcon = /*#__PURE__*/forwardRef(function PortalVoucherBatchesIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M11.1259 13.0884V13.7313C10.1338 13.7325 9.17982 13.3489 8.46484 12.6611V16.3785H19.0731C19.6057 16.3785 20.0375 15.9467 20.0375 15.4141V12.1995H8.91141C9.50693 12.7707 10.3005 13.0893 11.1259 13.0884ZM17.7873 14.4497H18.4302V15.0926H17.7873V14.4497ZM16.5014 14.4497H17.1443V15.0926H16.5014V14.4497ZM15.2156 14.4497H15.8585V15.0926H15.2156V14.4497ZM13.9297 14.4497H14.5726V15.0926H13.9297V14.4497Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M6.29931 9.3064C5.94959 9.31001 5.65104 9.55958 5.58543 9.90302C5.51966 10.2465 5.70535 10.5885 6.02886 10.7208L7.60996 11.3557L6.97661 9.76599C6.86689 9.48816 6.59817 9.30577 6.29931 9.3064Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M16.7383 19.1877C16.9428 19.2857 17.1778 19.2981 17.3913 19.2221C17.6049 19.1463 17.7793 18.9884 17.876 18.7834L18.7151 17.0215H12.2246L16.7383 19.1877Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M3.96289 8.34207V11.5567H6.38218L5.78979 11.3187C5.20636 11.0877 4.85319 10.4911 4.93136 9.86839C5.00953 9.24572 5.49894 8.75489 6.1213 8.675C6.74382 8.5951 7.34138 8.94654 7.57416 9.52919L7.82044 10.1473V7.37769H4.92728C4.3947 7.37769 3.96289 7.80949 3.96289 8.34207Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M7.2608 4.88992C7.05643 4.79197 6.82145 4.77973 6.60798 4.85554C6.39435 4.93151 6.21997 5.08942 6.12312 5.29441L5.4375 6.73487H11.1052L7.2608 4.88992Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M5.24874 13.0884C6.07406 13.0893 6.86767 12.7707 7.46334 12.1995H3.96289V15.4141C3.96289 15.9467 4.3947 16.3785 4.92728 16.3785H7.82044V12.7427C7.11551 13.3798 6.19884 13.7322 5.24874 13.7313V13.0884Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M3.3206 12.7214V11.1831L3.08327 11.6821C2.9125 12.0415 3.0106 12.4715 3.3206 12.7214Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M20.6797 11.3564V12.8944L20.9168 12.3957C21.0877 12.0361 20.9897 11.6063 20.6797 11.3564Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19.0731 7.37769H8.46484V10.3718L8.80043 9.52919C9.03478 8.95 9.63062 8.60201 10.2502 8.68222C10.8698 8.76258 11.3572 9.2509 11.4363 9.87075C11.5153 10.4904 11.1662 11.0855 10.5865 11.3187L9.99242 11.5567H20.0375V8.34207C20.0375 7.80949 19.6057 7.37769 19.0731 7.37769ZM14.5726 9.62793H13.9297V8.34207H14.5726V9.62793ZM15.8585 9.62793H15.2156V8.34207H15.8585V9.62793ZM17.1443 9.62793H16.5014V8.34207H17.1443V9.62793ZM18.4302 9.62793H17.7873V8.34207H18.4302V9.62793Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M10.8036 10.0403C10.8059 9.68947 10.5579 9.38669 10.2134 9.31982C9.86885 9.25295 9.52557 9.44115 9.39655 9.76748L8.76367 11.3571L10.3446 10.7209C10.6227 10.6098 10.8047 10.3399 10.8036 10.0403Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "18",
    height: "18",
    fill: "currentColor",
    transform: "translate(3 3)"
  }))));
});

var PortalVouchersIcon = /*#__PURE__*/forwardRef(function PortalVouchersIcon(providedProps, ref) {
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    ref: ref
  }), createElement("path", {
    d: "M15.5 14.5C15.7761 14.5 16 14.2761 16 14C16 13.7239 15.7761 13.5 15.5 13.5C15.2239 13.5 15 13.7239 15 14C15 14.2761 15.2239 14.5 15.5 14.5Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M12.5 10.5C12.7761 10.5 13 10.2761 13 10C13 9.72386 12.7761 9.5 12.5 9.5C12.2239 9.5 12 9.72386 12 10C12 10.2761 12.2239 10.5 12.5 10.5Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M19 6.5H9.5C9.367 6.5 9.24 6.553 9.146 6.646L8.5 7.293L7.854 6.646C7.76 6.553 7.633 6.5 7.5 6.5H5C4.449 6.5 4 6.949 4 7.5V16.5C4 17.052 4.449 17.5 5 17.5H7.5C7.633 17.5 7.76 17.447 7.854 17.354L8.5 16.707L9.146 17.353C9.24 17.447 9.367 17.5 9.5 17.5H19C19.552 17.5 20 17.052 20 16.5V7.5C20 6.949 19.552 6.5 19 6.5ZM9 15.5H8V14.5H9V15.5ZM9 13.5H8V12.5H9V13.5ZM9 11.5H8V10.5H9V11.5ZM9 9.5H8V8.5H9V9.5ZM12.5 8.5C13.327 8.5 14 9.173 14 10C14 10.827 13.327 11.5 12.5 11.5C11.673 11.5 11 10.827 11 10C11 9.173 11.673 8.5 12.5 8.5ZM11.5 15.5C11.387 15.5 11.274 15.462 11.18 15.384C10.968 15.207 10.939 14.892 11.116 14.68L16.116 8.68C16.294 8.467 16.609 8.441 16.82 8.616C17.032 8.793 17.06 9.108 16.883 9.321L11.883 15.321C11.785 15.438 11.643 15.5 11.5 15.5ZM15.5 15.5C14.673 15.5 14 14.827 14 14C14 13.173 14.673 12.5 15.5 12.5C16.327 12.5 17 13.173 17 14C17 14.827 16.327 15.5 15.5 15.5Z",
    fill: "currentColor"
  }));
});

var PortalWalletIcon = /*#__PURE__*/forwardRef(function PortalWalletIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("mask", {
    id: id + "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "currentColor"
  })), createElement("g", {
    mask: "url(#" + id + "mask0)"
  }, createElement("path", {
    d: "M18.8809 15.75V16.4883C18.8809 16.9102 18.7285 17.2734 18.4238 17.5781C18.1426 17.8594 17.791 18 17.3691 18H6.89258C6.4707 18 6.10742 17.8594 5.80273 17.5781C5.52148 17.2734 5.38086 16.9102 5.38086 16.4883V6.01172C5.38086 5.58984 5.52148 5.23828 5.80273 4.95703C6.10742 4.65234 6.4707 4.5 6.89258 4.5H17.3691C17.791 4.5 18.1426 4.65234 18.4238 4.95703C18.7285 5.23828 18.8809 5.58984 18.8809 6.01172V6.75H12.1309C11.709 6.75 11.3457 6.90234 11.041 7.20703C10.7598 7.48828 10.6191 7.83984 10.6191 8.26172V14.2383C10.6191 14.6602 10.7598 15.0234 11.041 15.3281C11.3457 15.6094 11.709 15.75 12.1309 15.75H18.8809ZM12.1309 14.2383V8.26172H19.6191V14.2383H12.1309ZM14.3105 12.0586C14.5449 12.2695 14.8145 12.375 15.1191 12.375C15.4473 12.375 15.7168 12.2695 15.9277 12.0586C16.1387 11.8242 16.2441 11.5547 16.2441 11.25C16.2441 10.9453 16.1387 10.6875 15.9277 10.4766C15.7168 10.2422 15.4473 10.125 15.1191 10.125C14.8145 10.125 14.5449 10.2422 14.3105 10.4766C14.0996 10.6875 13.9941 10.9453 13.9941 11.25C13.9941 11.5547 14.0996 11.8242 14.3105 12.0586Z",
    fill: "currentColor"
  })));
});

var PortalWebhooksIcon = /*#__PURE__*/forwardRef(function PortalWebhooksIcon(providedProps, ref) {
  var id = useId(providedProps.id);
  var props = useDefaultSvgProps(providedProps);
  return createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props, {
    id: id,
    ref: ref
  }), createElement("g", {
    clipPath: "url(#" + id + "clip0)"
  }, createElement("path", {
    d: "M18.1667 4H5.83333C4.822 4 4 4.822 4 5.83333V8.66667H20V5.83333C20 4.822 19.178 4 18.1667 4ZM13.6667 7.33333C13.1147 7.33333 12.6667 6.88533 12.6667 6.33333C12.6667 5.78133 13.1147 5.33333 13.6667 5.33333C14.2187 5.33333 14.6667 5.78133 14.6667 6.33333C14.6667 6.88533 14.2187 7.33333 13.6667 7.33333ZM17 7.33333C16.448 7.33333 16 6.88533 16 6.33333C16 5.78133 16.448 5.33333 17 5.33333C17.552 5.33333 18 5.78133 18 6.33333C18 6.88533 17.552 7.33333 17 7.33333Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M4 10V14H20V10H4ZM13.6667 13C13.1147 13 12.6667 12.552 12.6667 12C12.6667 11.448 13.1147 11 13.6667 11C14.2187 11 14.6667 11.448 14.6667 12C14.6667 12.552 14.2187 13 13.6667 13ZM17 13C16.448 13 16 12.552 16 12C16 11.448 16.448 11 17 11C17.552 11 18 11.448 18 12C18 12.552 17.552 13 17 13Z",
    fill: "currentColor"
  }), createElement("path", {
    d: "M4 15.3333V18.1666C4 19.1779 4.822 19.9999 5.83333 19.9999H18.1667C19.178 19.9999 20 19.1779 20 18.1666V15.3333H4ZM13.6667 18.6666C13.1147 18.6666 12.6667 18.2186 12.6667 17.6666C12.6667 17.1146 13.1147 16.6666 13.6667 16.6666C14.2187 16.6666 14.6667 17.1146 14.6667 17.6666C14.6667 18.2186 14.2187 18.6666 13.6667 18.6666ZM17 18.6666C16.448 18.6666 16 18.2186 16 17.6666C16 17.1146 16.448 16.6666 17 16.6666C17.552 16.6666 18 17.1146 18 17.6666C18 18.2186 17.552 18.6666 17 18.6666Z",
    fill: "currentColor"
  })), createElement("defs", null, createElement("clipPath", {
    id: id + "clip0"
  }, createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor",
    transform: "translate(4 4)"
  }))));
});

var _excluded$7 = ["variant", "isLoading", "size", "minWidth", "children", "leftIcon", "rightIcon", "render", "className"];
/**
 * `<Button />` is a wrapper over `<button />` html element.
 *
 * Other than the specified props, it also accepts all props that is accepted by `<button />` element.
 *
 * `ref` will be forwarded to the underlying `<button />` element.
 */

var Button = /*#__PURE__*/forwardRef(function Button(_ref, ref) {
  var variant = _ref.variant,
      isLoading = _ref.isLoading,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? size : _ref$minWidth,
      children = _ref.children,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      render = _ref.render,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  var enabled = !props.disabled && !isLoading;
  var isSmall = size === 'small';
  var leftIconNode = null;

  if (leftIcon && isValidElement(leftIcon)) {
    var leftIconProps = leftIcon.props;
    leftIconNode = cloneElement(leftIcon, {
      className: cx(!hasUtilClass(leftIconProps.className, 'pu-w-') && 'pu-w-4', !hasUtilClass(leftIconProps.className, 'pu-h-') && 'pu-h-4', 'pu-mr-1.5 pu-flex-shrink-0 pu--ml-1 pu--my-1', leftIconProps.className)
    });
  }

  var rightIconNode = null;

  if (rightIcon && isValidElement(rightIcon)) {
    var rightIconProps = rightIcon.props;
    rightIconNode = cloneElement(rightIcon, {
      className: cx(!hasUtilClass(rightIconProps.className, 'pu-w-') && 'pu-w-4', !hasUtilClass(rightIconProps.className, 'pu-h-') && 'pu-h-4', 'pu-ml-1.5 pu-flex-shrink-0 pu--mr-1 pu--my-1', rightIconProps.className)
    });
  }

  var btnClass = cx('pu-inline-flex pu-justify-center pu-items-center pu-font-bold pu-align-middle pu-transform', !hasUtilClass(className, 'pu-rounded') && (isSmall ? 'pu-rounded' : 'pu-rounded-md'), !hasUtilClass(className, 'focus:pu-') && 'focus-visible-ring', !hasUtilClass(className, 'pu-shadow') && 'pu-shadow-sm', enabled && !hasUtilClass(className, 'active:pu-') && 'active:pu-translate-y-px', !enabled && 'pu-cursor-default', isLoading ? variant ? loadingByVariant[variant] : 'pu-bg-white pu-shadow' : props.disabled ? variant ? disabledClassByVariant[variant] : 'pu-text-lightgrey pu-bg-gray-300' : variant ? classByVariant[variant] : 'pu-bg-white pu-text-darkgrey pu-shadow hover:pu-bg-gray-100');
  var sizeClass = cx(classBySize[size], classByMinWidth[minWidth], !hasUtilClass(className, 'pu-px-', 'pu-py-', 'pu-p-') && (leftIconNode || rightIconNode ? paddingBySize.normal : paddingBySize[size]));
  var content = isLoading ? createElement(PortalSpinIcon, {
    className: cx('pu-animate-spin pu-inline-block pu-m-0', size === 'small' ? 'pu-w-4 pu-h-4' : 'pu-w-4.5 pu-h-4.5', variant && spinnerByVariant[variant])
  }) : createElement(Fragment, null, leftIconNode, children, rightIconNode);

  if (render) {
    return render({
      className: cx(btnClass, sizeClass, leftIcon && 'pu-flex pu-items-center', className),
      children: content
    });
  }

  return createElement("button", Object.assign({
    type: "button"
  }, props, {
    disabled: !enabled,
    className: cx(btnClass, sizeClass, className),
    ref: ref
  }), content);
});
var classByVariant = {
  primary: 'pu-bg-brand-500 pu-text-white hover:pu-bg-brand-800',
  outline: 'pu-border pu-border-brand-500 pu-bg-white pu-text-brand-500 pu-bg-opacity-0 hover:pu-bg-opacity-25 active:pu-bg-opacity-50',
  carbon: 'pu-bg-carbon-700 active:pu-bg-carbon-800 pu-text-offwhite',
  error: 'pu-bg-error-500 pu-text-white hover:pu-bg-error-800',
  'error-outline': 'pu-border pu-border-error pu-bg-white pu-text-error pu-bg-opacity-0 hover:pu-bg-opacity-25 active:pu-bg-opacity-50'
};
var disabledClass = 'pu-bg-gray-200 pu-text-white';
var disabledClassByVariant = {
  primary: disabledClass,
  outline: 'pu-border pu-border-offwhite pu-bg-white pu-text-offwhite',
  carbon: disabledClass,
  error: disabledClass,
  'error-outline': 'pu-border pu-border-error-100 pu-bg-white pu-text-error-100'
};
var loadingByVariant = {
  primary: 'pu-bg-brand-500 pu-text-white',
  outline: 'pu-border pu-border-brand-500 pu-bg-transparent pu-text-brand-500',
  carbon: 'pu-bg-carbon-700 active:pu-bg-carbon-800 pu-text-offwhite',
  error: 'pu-bg-error-500 pu-text-white',
  'error-outline': 'pu-border pu-border-error pu-bg-transparent pu-text-error'
};
var spinnerByVariant = {
  primary: 'pu-text-white',
  outline: 'pu-text-brand',
  carbon: 'pu-text-white',
  error: 'pu-text-white',
  'error-outline': 'pu-text-error'
};
var paddingBySize = {
  small: 'pu-px-3 pu-py-2',
  normal: 'pu-px-4'
};
var classBySize = {
  small: 'pu-text-xs pu-leading-3',
  normal: 'pu-text-xs pu-leading-4 pu-h-10 pu-tracking-1'
};
var classByMinWidth = {
  small: 'pu-min-w-20',
  normal: 'pu-min-w-28',
  none: ''
};

var positionTopCenter = function positionTopCenter(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }

  return {
    left: targetRect.left - (popoverRect.width - targetRect.width) / 2 + window.pageXOffset + "px",
    top: targetRect.top - popoverRect.height - OFFSET + window.pageYOffset + "px"
  };
};
var OFFSET = 8;

var _excluded$8 = ["isOpen", "className", "position", "children"];
var CardPopoverImpl = /*#__PURE__*/forwardRef(function CardPopover(_ref, ref) {
  var isOpen = _ref.isOpen,
      className = _ref.className,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? positionTopCenter : _ref$position,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  return createElement(ReachPopover, Object.assign({}, props, {
    position: position,
    className: cx('pu-bg-white pu-rounded pu-shadow-lg pu-transition pu-transform pu-duration-200 pu-ease-in-out pu-border pu-border-gray-100 pu-font-sans', isOpen ? 'pu-opacity-100 pu-translate-y-0' : 'pu-opacity-0 pu-translate-y-1', className),
    ref: ref
  }), children, createElement("div", {
    className: "pu-absolute pu--bottom-2 pu-border-white pu-border-t-8 pu-left-1/2 pu-transform pu--translate-x-1/2",
    style: {
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent'
    }
  }));
});

var CardPopoverContent = function CardPopoverContent(props) {
  return createElement("div", Object.assign({}, props, {
    className: cx('pu-p-4', props.className)
  }));
};
/**
 * CardPopover shows a Card above target when open.
 *
 * @todo handle collision with window top. Current complication is knowing how to draw the triangle.
 */


var CardPopover = /*#__PURE__*/Object.assign(CardPopoverImpl, {
  Content: CardPopoverContent
});

var _excluded$9 = ["label", "children", "id", "position", "title"];
/**
 * Tooltip is used to show some non-critical information for user.
 *
 * Note: it expects single element as children and this children must expose `ref`.
 */

var Tooltip = /*#__PURE__*/forwardRef(function Tooltip(_ref, forwardedRef) {
  var label = _ref.label,
      children = _ref.children,
      id = _ref.id,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var child = Children.only(children);

  var _useTooltip = useTooltip({
    id: id,
    onMouseEnter: child.props.onMouseEnter,
    onMouseMove: child.props.onMouseMove,
    onMouseLeave: child.props.onMouseLeave,
    onFocus: child.props.onFocus,
    onBlur: child.props.onBlur,
    onKeyDown: child.props.onKeyDown,
    onMouseDown: child.props.onMouseDown,
    ref: child.ref
  }),
      trigger = _useTooltip[0],
      tooltip = _useTooltip[1];

  var isVisible = tooltip.isVisible,
      triggerRect = tooltip.triggerRect;
  return createElement(Fragment, null, cloneElement(child, trigger), isVisible && createElement(Portal, null, createElement("div", {
    className: "pu-absolute pu-border-darkgrey pu-border-b-8",
    style: {
      left: triggerRect ? triggerRect.left - 10 + triggerRect.width / 2 : undefined,
      top: triggerRect ? triggerRect.bottom + window.scrollY : undefined,
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent'
    }
  })), createElement(TooltipPopup, Object.assign({
    className: "pu-rounded-md pu-shadow-lg pu-absolute pu-pointer-events-none pu-whitespace-no-wrap pu-font-sans",
    ref: forwardedRef,
    position: positionDefault,
    label: createElement("div", {
      className: cx('pu-text-offwhite pu-bg-darkgrey pu-text-sm pu-rounded-md pu-shadow-xs', title ? 'pu-p-4' : 'pu-px-3 pu-py-2', props.className)
    }, title && createElement("p", {
      className: "pu-text-lg pu-mb-1"
    }, title), createElement("div", {
      className: "pu-text-sm"
    }, label))
  }, tooltip, props)));
});
var OFFSET$1 = 8;

var positionDefault = function positionDefault(triggerRect, tooltipRect) {
  if (!triggerRect || !tooltipRect) {
    return {};
  }

  var _getDocumentDimension = getDocumentDimensions(),
      windowWidth = _getDocumentDimension.width,
      windowHeight = _getDocumentDimension.height;

  var collisions = {
    top: triggerRect.top - tooltipRect.height < 0,
    right: windowWidth < triggerRect.left + tooltipRect.width,
    bottom: windowHeight < triggerRect.bottom + tooltipRect.height + OFFSET$1,
    left: triggerRect.left - tooltipRect.width < 0
  };
  var directionRight = collisions.right && !collisions.left;
  return {
    left: directionRight ? triggerRect.right - tooltipRect.width + window.pageXOffset + OFFSET$1 + "px" : triggerRect.left + window.pageXOffset - OFFSET$1 + "px",
    top: triggerRect.top + OFFSET$1 + triggerRect.height + window.pageYOffset + "px"
  };
};

var DataTableContext = /*#__PURE__*/createNamedContext('DataTableContext', {
  responsive: false,
  hasTitle: false,
  headings: [],
  headingsAlign: [],
  striped: false,
  isLoading: false,
  skeletonRowNum: 5,
  sortable: false,
  onSortEnd: noop,
  useDragHandle: false,
  sortableClass: undefined,
  "native": false
});
var DataTableCellIndexContext = /*#__PURE__*/createNamedContext('DataTableCellIndex', 0);
var DataTableRowIndexContext = /*#__PURE__*/createNamedContext('DataTableRowIndex', 0);

/**
 * Equivalent to `caption` element.
 *
 * DataTableCaption accepts all props a `div` element would accept.
 *
 */

var DataTableCaption = function DataTableCaption(props) {
  var _React$useContext = useContext(DataTableContext),
      hasTitle = _React$useContext.hasTitle,
      _native = _React$useContext["native"];

  var Component = _native ? 'caption' : 'div';
  return createElement(Component, Object.assign({
    role: "caption"
  }, props, {
    className: cx('pu-table-caption pu-px-4 pu-text-sm', hasTitle && 'sm:pu-px-7', !hasUtilClass(props.className, 'pu-py-') && 'pu-py-2', props.className)
  }));
};

/**
 * Setel typography definition
 */
var classes = {
  /**
   * Used for: Header / Page titles
   */
  h1: 'pu-text-2xl pu-font-medium pu-leading-8',

  /**
   * Used for: Card title, Modal box title, Dialog title
   */
  h2: 'pu-text-xl pu-font-medium pu-leading-7',

  /**
   * Used for: Dialog body text
   */
  h3: 'pu-text-lg pu-font-medium pu-leading-relaxed',

  /**
   * Used for: Company/merchant/station name in sidebar navigation
   */
  h4: 'pu-text-base pu-font-normal pu-leading-normal',

  /**
   * Used for: body text, table data
   */
  body: 'pu-text-sm pu-font-normal pu-leading-snug',

  /**
   * Used for: supporting information, help text, secondary text link (sentence case), tags
   */
  bodySecondary: 'pu-text-xs pu-font-normal pu-leading-4',

  /**
   * Used for: Card subsection label, Table column title, primary text link (all caps), status badge
   */
  label: 'pu-text-xs pu-font-bold pu-leading-4 pu-tracking-wide'
};

var DataTableDescendantContext = /*#__PURE__*/createDescendantContext('DataTable');
var DataTableRowDescendantContext = /*#__PURE__*/createDescendantContext('DataTableRow');

var DataTableExpandableContextDefault = {
  isExpanded: false,
  toggleExpand: noop,
  expandControl: 'button'
};
var DataTableExpandableContext = /*#__PURE__*/createNamedContext('DataTableExpandableContext', DataTableExpandableContextDefault);
var DataTableExpandLevel = /*#__PURE__*/createNamedContext('DataTableExpandLevel', 0);
var DataTableMainRowRefContext = /*#__PURE__*/createNamedContext('DataTableMainRowRefContext', {
  current: null
});

var DataTableGroupTypeContext = /*#__PURE__*/createNamedContext('DataTableGroupType', 'tbody');

var _excluded$a = ["groupType"];
/**
 * Equivalent to `td` element.
 *
 * DataTableCell accepts all props a `div` element would accept.
 *
 */

var DataTableCell = function DataTableCell(props) {
  var groupType = useContext(DataTableGroupTypeContext);
  return groupType === 'thead' ? createElement(DataTableHeadingCell, Object.assign({}, props, {
    groupType: groupType
  })) : createElement(DataTableCellImpl, Object.assign({}, props, {
    groupType: groupType
  }));
};
var DataTableCellImpl = /*#__PURE__*/forwardRef(function DataTableCellImpl(_ref, ref) {
  var groupType = _ref.groupType,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  var _React$useContext = useContext(DataTableContext),
      responsive = _React$useContext.responsive,
      headings = _React$useContext.headings,
      hasTitle = _React$useContext.hasTitle,
      _native = _React$useContext["native"];

  var cellIndex = useContext(DataTableCellIndexContext); // index injected by DataTableRow

  var level = useContext(DataTableExpandLevel);
  var styleCs = cx('pu-px-4', hasTitle && 'sm:first:pu-pl-7 sm:last:pu-pr-7', groupType === 'tbody' ? ['pu-py-3.5 pu-whitespace-no-wrap', classes.body] : 'pu-py-4 pu-text-xs pu-leading-tight pu-tracking-1 pu-border-b pu-border-gray-300 pu-font-bold pu-text-lightgrey pu-bg-lightergrey pu-uppercase', cellIndex === 0 && padLeftForLevel[level], props.className);

  if (props.render && !_native) {
    return props.render({
      className: cx('pu-table-cell', styleCs),
      children: props.children,
      ref: ref
    }, {
      heading: headings[cellIndex],
      responsive: responsive || false
    });
  }

  var Component = _native ? 'td' : 'div';
  return responsive ? createElement(Fragment, null, groupType === 'tbody' && createElement("div", {
    className: "pu-flex pu-items-center pu-justify-between pu-px-2 sm:pu-hidden"
  }, createElement("div", {
    className: "pu-px-2 pu-py-3 pu-text-lightgrey pu-text-xs pu-font-medium pu-uppercase"
  }, headings[cellIndex]), createElement("div", {
    className: cx('pu-px-2 pu-py-3 pu-text-gray-500 pu-text-sm pu-leading-5', props.className)
  }, props.children)), createElement(Component, Object.assign({}, props, {
    className: cx('pu-hidden sm:pu-table-cell', styleCs, cellIndex === 0 && 'sm:pu-pl-7' // needed when in responsive this component no longer be the first but the above
    ),
    ref: ref
  }))) : createElement(Component, Object.assign({}, props, {
    className: cx('pu-table-cell', styleCs),
    ref: ref
  }));
});

var DataTableHeadingCell = function DataTableHeadingCell(props) {
  var headingCellRef = useRef(null);
  useDescendant({
    element: headingCellRef.current
  }, DataTableDescendantContext);
  return createElement(DataTableCellImpl, Object.assign({}, props, {
    ref: headingCellRef
  }));
};

var padLeftForLevel = ['', 'pu-pl-12 sm:pu-pl-16', 'pu-pl-20 sm:pu-pl-28', 'pu-pl-28 sm:pu-pl-40', 'pu-pl-36 sm:pu-pl-52', 'pu-pl-44 sm:pu-pl-64', 'pu-pl-52 sm:pu-pl-72'];

var _excluded$b = ["_excludeRow"],
    _excluded2$1 = ["sortable"],
    _excluded3 = ["children", "responsive", "striped", "useDragHandle", "groupType", "native", "rowIndex"];
/**
 * Equivalent to `tr` element.
 *
 * DataTableRow accepts all props a `div` element would accept.
 *
 */

var DataTableRow = function DataTableRow(_ref) {
  var _excludeRow = _ref._excludeRow,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  var cValue = useContext(DataTableContext);
  var groupType = useContext(DataTableGroupTypeContext);
  return _excludeRow ? createElement(DataTableSideRow, Object.assign({}, props, {
    groupType: groupType,
    responsive: cValue.responsive,
    striped: cValue.striped,
    useDragHandle: cValue.useDragHandle,
    "native": cValue["native"],
    sortable: cValue.sortable
  })) : createElement(DataTableRowInner, Object.assign({}, props, {
    groupType: groupType,
    responsive: cValue.responsive,
    striped: cValue.striped,
    useDragHandle: cValue.useDragHandle,
    "native": cValue["native"],
    sortable: cValue.sortable
  }));
};

var DataTableRowInner = function DataTableRowInner(_ref2) {
  var sortable = _ref2.sortable,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

  var rowIndex = useContext(DataTableRowIndexContext);
  return sortable && props.groupType !== 'thead' && !props["native"] ? createElement(SortableDataTableRow, Object.assign({
    index: rowIndex,
    rowIndex: rowIndex
  }, props)) : createElement(DataTableMainRow, Object.assign({}, props));
};

var DataTableMainRow = function DataTableMainRow(props) {
  var ref = useRef(null);
  var rowIndex = useDescendant({
    element: ref.current
  }, DataTableRowDescendantContext);
  var groupRef = useContext(DataTableMainRowRefContext);
  var combinedRef = useForkedRef(ref, groupRef);

  var _React$useContext = useContext(DataTableExpandableContext),
      toggleExpand = _React$useContext.toggleExpand,
      expandControl = _React$useContext.expandControl;

  var rowExpandable = expandControl === 'row';
  return createElement(DataTableRowImpl, Object.assign({
    rowIndex: rowIndex,
    tabIndex: rowExpandable ? 0 : undefined,
    onKeyDown: rowExpandable ? function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault();
        toggleExpand();
      }
    } : undefined
  }, props, {
    className: cx(rowExpandable && 'pu-cursor-pointer focus-visible-ring', props.className),
    onClick: callAll(props.onClick, rowExpandable && toggleExpand),
    ref: combinedRef
  }));
};

var DataTableSideRow = /*#__PURE__*/forwardRef(function (props, ref) {
  var groupRef = useContext(DataTableMainRowRefContext);
  var allRows = useDescendants(DataTableRowDescendantContext);
  var rowIndex = allRows.findIndex(function (r) {
    return r.element === groupRef.current;
  });
  return createElement(DataTableRowImpl, Object.assign({
    rowIndex: rowIndex
  }, props, {
    ref: ref
  }));
});
var DataTableRowImpl = /*#__PURE__*/forwardRef(function DataTableRowImpl(_ref3, ref) {
  var children = _ref3.children,
      responsive = _ref3.responsive,
      striped = _ref3.striped,
      _native = _ref3["native"],
      rowIndex = _ref3.rowIndex,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  var classes = cx(responsive ? 'pu-table pu-min-w-full sm:pu-table-row' : 'pu-table-row', responsive && isDefined(rowIndex) && rowIndex > 0 && 'pu-border-t pu-border-gray-200 sm:pu-border-none', !hasUtilClass(props.className, 'pu-bg-') && [striped && isDefined(rowIndex) && rowIndex % 2 === 1 ? 'pu-bg-lightergrey' : 'pu-bg-white', 'hover:pu-bg-gray-100'], props.className);
  var allChild = Children.map(children, function (child, index) {
    return createElement(DataTableCellIndexContext.Provider, {
      value: index
    }, child);
  });

  if (props.render && !_native) {
    return props.render({
      className: classes,
      children: allChild,
      ref: ref
    }, {
      index: rowIndex
    });
  }

  var Component = _native ? 'tr' : 'div';
  return createElement(Component, Object.assign({
    role: "row"
  }, props, {
    className: classes,
    ref: ref
  }), allChild);
});
var SortableDataTableRow = /*#__PURE__*/SortableElement(DataTableRowImpl);

var _excluded$c = ["width", "height", "bgClass", "heightClass", "widthClass", "className"];
/**
 * Provide a placeholder while you wait for content to load.
 *
 * It is recommended to tweak the width and height based on the common
 * content pattern to minimize layout flash.
 *
 * Work best in conjection with Tailwind `animate-pulse` class.
 *
 */

var Skeleton = function Skeleton(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'narrow' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'short' : _ref$height,
      _ref$bgClass = _ref.bgClass,
      bgClass = _ref$bgClass === void 0 ? 'pu-bg-gray-200' : _ref$bgClass,
      _ref$heightClass = _ref.heightClass,
      heightClass = _ref$heightClass === void 0 ? heightClasses[height] : _ref$heightClass,
      _ref$widthClass = _ref.widthClass,
      widthClass = _ref$widthClass === void 0 ? widthClasses[width] : _ref$widthClass,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return createElement("div", Object.assign({}, props, {
    className: cx(bgClass, heightClass, widthClass, className)
  }));
};
var widthClasses = {
  narrow: 'pu-w-12',
  medium: 'pu-w-32',
  wide: 'pu-w-48',
  full: 'pu-w-full'
};
var heightClasses = {
  "short": 'pu-h-4',
  medium: 'pu-h-6',
  tall: 'pu-h-9'
};

var _excluded$d = ["groupType", "native", "children"];

var DataTableRowGroupImpl = function DataTableRowGroupImpl(_ref) {
  var _ref$groupType = _ref.groupType,
      groupType = _ref$groupType === void 0 ? 'tbody' : _ref$groupType,
      _native = _ref["native"],
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  var _useDescendantsInit = useDescendantsInit(),
      rows = _useDescendantsInit[0],
      setRows = _useDescendantsInit[1];

  var Component = _native ? groupType : 'div'; // this row index is only used when it is non-native
  // for native we use DataTableRowDescendantContext
  // the reason for two different approach is because
  // - native allows <DataTableExpandableRow /> which need more advanced logic for index determination using DataTableRowDescendantContext
  // - however, DataTableRowDescendantContext breaks react-sortable-hoc, therefore we have to use <DataTableRowIndexContext /> for that.

  var renderedChildren = _native ? children : Children.map(children, function (child, index) {
    return createElement(DataTableRowIndexContext.Provider, {
      value: index
    }, child);
  });
  return createElement(DescendantProvider, {
    context: DataTableRowDescendantContext,
    items: rows,
    set: setRows
  }, createElement(DataTableGroupTypeContext.Provider, {
    value: groupType
  }, createElement(Component, Object.assign({}, props, {
    className: cx('pu-table-row-group', props.className)
  }), renderedChildren)));
};

var SortableTableRowGroup = /*#__PURE__*/SortableContainer(DataTableRowGroupImpl);

var getChildWidths = function getChildWidths(node) {
  var result = [];
  forEach(node.childNodes, function (childNode) {
    if (childNode instanceof HTMLElement) {
      result.push(childNode.clientWidth);
    }
  });
  return result;
};

var setChildWidths = function setChildWidths(node, widths) {
  forEach(node.childNodes, function (childNode, index) {
    if (childNode instanceof HTMLElement) {
      var childWidth = widths[index];

      if (childWidth) {
        childNode.style.width = childWidth + "px";
      }
    }
  });
};
/**
 * Equivalent to `thead` and `tbody` element.
 *
 * DataTableRow accepts all props a `div` element would accept.
 */


var DataTableRowGroup = function DataTableRowGroup(props) {
  var _React$useContext = useContext(DataTableContext),
      sortable = _React$useContext.sortable,
      _onSortEnd = _React$useContext.onSortEnd,
      useDragHandle = _React$useContext.useDragHandle,
      sortableClass = _React$useContext.sortableClass,
      isLoading = _React$useContext.isLoading,
      headingsAlign = _React$useContext.headingsAlign,
      skeletonRowNum = _React$useContext.skeletonRowNum,
      _native2 = _React$useContext["native"]; // we have to manually update the child width to avoid table cell width change


  var childWidthsRef = useRef([]);
  return sortable && props.groupType !== 'thead' ? createElement(SortableTableRowGroup, Object.assign({}, props, {
    updateBeforeSortStart: function updateBeforeSortStart(data) {
      return childWidthsRef.current = getChildWidths(data.node);
    },
    onSortStart: function onSortStart(data) {
      setChildWidths(data.helper, childWidthsRef.current);
    },
    onSortEnd: function onSortEnd(data) {
      if (_onSortEnd) {
        _onSortEnd(data);
      }

      childWidthsRef.current = [];
    },
    useDragHandle: useDragHandle,
    lockAxis: "y",
    lockToContainerEdges: true,
    helperClass: sortableClass,
    "native": _native2
  })) : props.groupType !== 'thead' && isLoading ? createElement(DataTableRowGroupImpl, Object.assign({}, props, {
    className: cx('pu-animate-pulse', props.className),
    "native": _native2
  }), props.children, createArray(skeletonRowNum).map(function (_, index) {
    return createElement(DataTableRow, {
      key: index
    }, headingsAlign.map(function (textAlign, colIndex) {
      return createElement(DataTableCell, {
        style: textAlign ? {
          textAlign: textAlign
        } : undefined,
        key: colIndex
      }, createElement(Skeleton, {
        className: cx(textAlign && 'pu-inline-block')
      }));
    }));
  })) : createElement(DataTableRowGroupImpl, Object.assign({}, props, {
    "native": _native2
  }));
};

var stripPropTypes = function stripPropTypes(component) {
  // eslint-disable-next-line react/forbid-foreign-prop-types
  if (component.propTypes) {
    component.propTypes = undefined;
  }
};

var ModalSelectDescentdantContext = /*#__PURE__*/createDescendantContext('ModalSelect');

var _excluded$e = ["highlighted", "selected", "label", "description", "leftIcon", "render"];
var Option = /*#__PURE__*/forwardRef(function Option(_ref, forwardedRef) {
  var highlighted = _ref.highlighted,
      selected = _ref.selected,
      label = _ref.label,
      description = _ref.description,
      leftIcon = _ref.leftIcon,
      render = _ref.render,
      divProps = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  var isDisabled = divProps.disabled || divProps['aria-disabled'] && divProps['aria-disabled'] !== 'false';
  var className = cx('pu-flex pu-items-center pu-px-4 pu-cursor-pointer pu-select-none focus:pu-outline-none', highlighted && 'pu-bg-gray-100', divProps.className);
  var children = createElement(Fragment, null, leftIcon, createElement("div", {
    className: cx('pu-py-2 pu-flex-1 pu-overflow-hidden', !!leftIcon && 'pu-pl-3')
  }, createElement("div", {
    className: cx('pu-text-sm pu-leading-snug pu-truncate', isDisabled ? 'pu-text-gray-500' : 'pu-text-black', selected && 'pu-font-medium')
  }, label), description && createElement("div", {
    className: "pu-text-xs pu-mt-1 pu-pb-0.5 pu-truncate pu-text-lightgrey"
  }, description)));

  if (render) {
    return render({
      children: children,
      className: className
    });
  }

  return createElement("div", Object.assign({}, divProps, {
    className: className,
    ref: forwardedRef
  }), children);
});
var OptGroupLabel = function OptGroupLabel(props) {
  return createElement("div", Object.assign({}, props, {
    className: cx('pu-px-4 pu-py-3 pu-mt-4 first:pu-mt-0 pu-text-xs pu-font-bold pu-tracking-1 pu-text-lightgrey pu-uppercase pu-select-none', props.className)
  }));
};

var normalizeOptions = function normalizeOptions(options) {
  var result = [];
  options.forEach(function (option) {
    if (isGroupOption(option)) {
      result.push(option);
    } else {
      if (result.length === 0 || result[result.length - 1].label !== '') {
        result.push({
          label: '',
          options: [option]
        });
      } else {
        result[result.length - 1].options.push(option);
      }
    }
  });
  return result;
};

var SELECT_ALL = '__REACT_SETEL_SELECT_ALL__';
var sortOptions = function sortOptions(options, searchValue, allowSelectAll, additionalFilter) {
  if (options.length === 0) {
    return {
      items: [],
      displayedItems: [],
      allItems: []
    };
  }

  return mapGroup(normalizeOptions(options), {
    allowSelectAll: allowSelectAll,
    filter: function filter(options) {
      var result = matchSorter(options, searchValue, {
        keys: ['label', 'description', 'metadata']
      });
      return additionalFilter ? result.filter(additionalFilter) : result;
    }
  });
};
var normalizePrimitiveOptions = function normalizePrimitiveOptions(options) {
  return options.map(function (option) {
    return isPrimitive(option) ? {
      label: String(option),
      value: option
    } : option;
  });
};
var mapOptions = function mapOptions(options) {
  return mapGroup(normalizeOptions(options), {
    allowSelectAll: false
  });
};
var selectAllOption = {
  value: SELECT_ALL,
  label: '',
  index: 0
};

var mapGroup = function mapGroup(groups, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$filter = _ref2.filter,
      filter = _ref2$filter === void 0 ? function (x) {
    return x;
  } : _ref2$filter,
      allowSelectAll = _ref2.allowSelectAll;

  var groupsWithSortedOptions = groups.filter(function (group) {
    return group.options.length !== 0;
  });
  var optionIndex = allowSelectAll ? 1 : 0;
  var mappedPrependOption = allowSelectAll ? selectAllOption : undefined;
  var result = mappedPrependOption ? {
    items: [mappedPrependOption],
    displayedItems: [{
      options: [mappedPrependOption]
    }],
    allItems: [mappedPrependOption]
  } : {
    items: [],
    displayedItems: [],
    allItems: []
  };
  groupsWithSortedOptions.forEach(function (group) {
    var finalOptions = [];
    var filteredOptions = filter(group.options);
    group.options.forEach(function (option) {
      if (filteredOptions.includes(option)) {
        var mappedOption = _extends({}, option, {
          index: optionIndex++
        });

        finalOptions.push(mappedOption);
        result.items.push(mappedOption);
        result.allItems.push(mappedOption);
      } else {
        result.allItems.push(option);
      }
    });

    if (finalOptions.length > 0) {
      result.displayedItems.push({
        groupLabel: group.label,
        options: finalOptions
      });
    }
  });

  if (allowSelectAll) {
    var totalOptionCount = result.displayedItems.reduce(function (total, group) {
      return total + group.options.length;
    }, 0);

    if (totalOptionCount <= 2) {
      // show when >= 2 options, but because SelectAll is part of options now, need to more than 2
      // remove select all
      result.items.splice(0, 1);
      result.displayedItems.splice(0, 1);
      result.allItems.splice(0, 1); // decrement index;

      result.items.forEach(function (item) {
        item.index--;
      });
    }
  }

  return result;
};

var isGroupOption = function isGroupOption(option) {
  return option.type === 'group';
};

var nestedOptionReducer = function nestedOptionReducer(state, action) {
  if (action.keys.length === 0) {
    return state;
  }

  switch (action.type) {
    case 'expand':
      return {
        expandedKeys: state.expandedKeys.concat([action.keys])
      };

    case 'collapse':
      return {
        expandedKeys: state.expandedKeys.filter(function (keys) {
          return !isSimilarArray(keys, action.keys);
        })
      };

    default:
      throw new Error("action not supported in nestedOptionReducer " + JSON.stringify(action));
  }
};
var getPathToOption = function getPathToOption(item) {
  var result = [item.value];
  var node = item.parent;

  while (node !== null) {
    result.unshift(node.value);
    node = node.parent;
  }

  return result;
};
var mapNestedOptionsWithSearch = function mapNestedOptionsWithSearch(options, searchValue) {
  if (!options) {
    return {
      items: [],
      displayedItems: [],
      allItems: []
    };
  }

  var items = [];
  var displayedItems = [];
  var allItems = [];

  function collectFlattenedItem(item, data) {
    var dataRecord = _extends({}, item, {
      parent: data.parent,
      children: [],
      index: allItems.length
    });

    allItems.push(dataRecord);

    if (data.parent) {
      data.parent.children.push(dataRecord);
    }

    if (Array.isArray(item.children)) {
      item.children.forEach(function (child) {
        return collectFlattenedItem(child, {
          parent: dataRecord
        });
      });
    }
  }

  options.forEach(function (option) {
    collectFlattenedItem(option, {
      parent: null
    });
  });

  if (searchValue) {
    var markRecordAndDescendantAsVisited = function markRecordAndDescendantAsVisited(dataRecord) {
      visited.push(dataRecord);
      dataRecord.children.forEach(markRecordAndDescendantAsVisited);
    };

    // construct a flat array of all the options
    // sort all items, regardless have child or not
    var sortedResult = matchSorter(allItems, searchValue, {
      keys: ['label', 'description']
    }); // once sorted, start constructring the list with the following rules
    // 1. when an option is added, all its ascendant and descendants should be added too
    // 2. once an option is added (due to its ascendant/descent was added), it should not be added anymore it is visited

    var visited = [];
    sortedResult.forEach(function collectDisplayedItems(dataRecord) {
      if (visited.includes(dataRecord)) {
        return;
      }

      markRecordAndDescendantAsVisited(dataRecord);
      var current = dataRecord;

      while (current.parent !== null) {
        if (visited.includes(current.parent)) {
          current.parent.children.push(current);
          return;
        } else {
          current.parent.children = [current];
          current = current.parent;
          visited.push(current);
        }
      }

      displayedItems.push(current);
    });
  } else {
    allItems.forEach(function (item) {
      if (item.parent === null) {
        displayedItems.push(item);
      }
    });
  } // constructing items


  displayedItems.forEach(function collectItem(displayedItem) {
    displayedItem.index = items.length;
    items.push(displayedItem);

    if (Array.isArray(displayedItem.children)) {
      displayedItem.children.forEach(collectItem);
    }
  });
  return {
    items: items,
    allItems: allItems,
    displayedItems: displayedItems
  };
};
var mapNestedOptions = function mapNestedOptions(options, values, nestedState) {
  var items = [];
  var displayedItems = [];
  var allItems = [];
  /**
   * collect items, displayedItems, and allItems.
   *
   * @returns if the current option is checked (true/false/mixed)
   */

  var collect = function collect(_ref3) {
    var option = _ref3.option,
        shouldCollect = _ref3.shouldCollect,
        pathToOption = _ref3.pathToOption,
        optionsToDisplay = _ref3.optionsToDisplay,
        forceCheck = _ref3.forceCheck,
        parent = _ref3.parent;
    var checked = forceCheck || values.includes(option.value);

    if (Array.isArray(option.children)) {
      var pathToCurrentOption = pathToOption.concat(option.value);
      var isExpanded = nestedState.expandedKeys.some(function (expandeds) {
        return isSimilarArray(expandeds, pathToCurrentOption);
      });
      var item = {
        value: option.value,
        label: option.label,
        description: option.description,
        icon: option.icon,
        checked: checked,
        isExpanded: isExpanded,
        parent: parent,
        index: items.length,
        children: []
      };
      allItems.push(item);

      if (shouldCollect) {
        items.push(item);
        optionsToDisplay.push(item);
      }

      var childrenChecked = option.children.map(function (opt) {
        return collect({
          option: opt,
          shouldCollect: isExpanded,
          pathToOption: pathToCurrentOption,
          optionsToDisplay: item.children,
          parent: item,
          forceCheck: checked
        });
      });

      if (!checked && childrenChecked.some(Boolean)) {
        item.checked = 'mixed';
      }

      return item.checked;
    } else {
      var _item = {
        value: option.value,
        label: option.label,
        description: option.description,
        icon: option.icon,
        index: items.length,
        checked: checked,
        parent: parent
      };
      allItems.push(_item);

      if (shouldCollect) {
        items.push(_item);
        optionsToDisplay.push(_item);
      }

      return checked;
    }
  };

  if (options) {
    options.forEach(function (option) {
      return collect({
        option: option,
        shouldCollect: true,
        pathToOption: [],
        optionsToDisplay: displayedItems,
        parent: null
      });
    });
  }

  return {
    items: items,
    displayedItems: displayedItems,
    allItems: allItems
  };
};
var deriveNextValues = function deriveNextValues(toggleItem, currentValues) {
  var result = currentValues.slice();
  var toggleItemIndex = result.indexOf(toggleItem);

  if (toggleItemIndex > -1) {
    // item was selected, remove it
    result.splice(toggleItemIndex, 1);
  } else {
    var selectedAncestor = findSelectedAncestor(toggleItem); // if it is descendant of any selected item, need to unselect the item and select the children of the parent

    if (selectedAncestor) {
      removeFromResult(selectedAncestor);
      selectDescendantsExcludePath(selectedAncestor, toggleItem);
    } else {
      // else, just add it into the selected item
      addToResult(toggleItem); // if any descentdent selected, remove them

      removeDescendants(toggleItem);
    }
  }

  function findSelectedAncestor(item) {
    if (!item.parent) {
      return null;
    }

    if (result.includes(item.parent)) {
      return item.parent;
    }

    return findSelectedAncestor(item.parent);
  }

  function selectDescendantsExcludePath(item, excludeTarget) {
    if (Array.isArray(item.children)) {
      item.children.forEach(function (child) {
        if (child !== excludeTarget) {
          if (isAncestor(excludeTarget, child)) {
            selectDescendantsExcludePath(child, excludeTarget);
          } else {
            result.push(child);
          }
        }
      });
    }
  }

  function removeDescendants(item) {
    if (Array.isArray(item.children)) {
      item.children.forEach(function (child) {
        removeFromResult(child);
        removeDescendants(child);
      });
    }
  }

  function addToResult(item) {
    if (item.parent) {
      // if siblings are all added
      if (item.parent.children.every(function (child) {
        return child === item || result.includes(child);
      })) {
        item.parent.children.forEach(removeFromResult);
        addToResult(item.parent);
      } else {
        result.push(item);
      }
    } else {
      result.push(item);
    }
  }

  function removeFromResult(item) {
    var itemIndex = result.indexOf(item);

    if (itemIndex > -1) {
      result.splice(itemIndex, 1);
    }
  }

  return result;
};

function isAncestor(item, maybeAncestor) {
  if (!item.parent) {
    return false;
  }

  if (item.parent === maybeAncestor) {
    return true;
  }

  return isAncestor(item.parent, maybeAncestor);
}

var borderByStatus = {
  error: 'pu-border-error-500',
  warning: 'pu-border-warning-500',
  success: 'pu-border-success-500'
};

var DEFAULT_CONTEXT = {
  inputId: undefined,
  setInputId: noop,
  status: undefined,
  hasHelpText: false,
  setHelpTextCount: noop
};
var FieldContext = /*#__PURE__*/createNamedContext('Field', DEFAULT_CONTEXT);
var useFieldControlContext = function useFieldControlContext(providedId) {
  var id = useId(providedId);

  var _React$useContext = useContext(FieldContext),
      inputId = _React$useContext.inputId,
      setInputId = _React$useContext.setInputId,
      status = _React$useContext.status,
      hasHelpText = _React$useContext.hasHelpText;

  useEffect(function () {
    if (id) {
      setInputId(id);
    }
  }, [id, setInputId]);
  return {
    inputId: id || inputId,
    status: status,
    hasHelpText: hasHelpText
  };
};

var _excluded$f = ["value", "options", "id", "placeholder", "onChangeValue", "className", "disabled", "menuClass", "usePortal"];
stripPropTypes(ListboxInput);
stripPropTypes(ListboxOption);
var BUTTON_CLASSES = ['pu-p(x|y|r|l|t|b)?-', 'pu-text-', 'pu-rounded'];
/**
 *
 *  `<DropdownSelect />` is like a `<select />` element.
 *
 * It accepts all props a `<button />` element in addition of the stated props.
 *
 * If there are many options, consider using `<SearchableDropdown />`
 *
 */

var DropdownSelect = function DropdownSelect(_ref) {
  var value = _ref.value,
      options = _ref.options,
      id = _ref.id,
      placeholder = _ref.placeholder,
      onChangeValue = _ref.onChangeValue,
      className = _ref.className,
      disabled = _ref.disabled,
      menuClass = _ref.menuClass,
      _ref$usePortal = _ref.usePortal,
      usePortal = _ref$usePortal === void 0 ? true : _ref$usePortal,
      btnProps = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var wrapperRef = useRef(null);
  useDescendant({
    element: wrapperRef.current
  }, ModalSelectDescentdantContext);
  var cleanOptions = useMemo(function () {
    return normalizePrimitiveOptions(options);
  }, [options]);
  var optionData = mapOptions(cleanOptions);
  var hasEmpty = optionData.allItems.some(function (item) {
    return item.value === '';
  });
  var classes = useSplitClass(className, BUTTON_CLASSES);
  return createElement(ListboxInput, {
    value: isNil(value) ? '' : hasEmpty ? wrapValue(value) : value,
    onChange: function onChange(v) {
      var newValue = unwrapValue(v);
      var selectedOption = optionData.allItems.find(function (item) {
        return item.value === newValue;
      });

      if (selectedOption && onChangeValue) {
        onChangeValue(selectedOption.value, selectedOption.label);
      }
    },
    disabled: disabled,
    className: cx(!hasUtilClass(classes.rest, 'pu-w-') && 'pu-w-full', classes.rest),
    ref: wrapperRef
  }, function (listboxState) {
    return createElement(Fragment, null, createElement(ListboxButton, Object.assign({
      id: inputId,
      className: cx('form-select pu-block pu-w-full pu-text-left pu-transition pu-ease-in-out pu-duration-150', status && borderByStatus[status], disabled && 'pu-bg-gray-200 pu-cursor-default pu-text-lightgrey', listboxState.expanded && 'pu-ring-1 pu-ring-brand-500 pu-ring-opacity-50 pu-border-brand-200', classes.matched)
    }, btnProps), createElement("span", {
      className: "pu-block pu-truncate"
    }, value || listboxState.value === EMPTY_VALUE ? listboxState.valueLabel : placeholder ? placeholder : createElement("div", {
      className: "pu-w-full pu-h-5"
    }))), createElement(ListboxPopover, {
      className: cx('pu-bg-white pu-rounded-md pu-shadow-lg pu-overflow-hidden pu-mt-px pu-border pu-border-gray-100 pu-font-sans', !usePortal && 'pu-absolute pu-top-full pu-inset-x-0', menuClass),
      portal: usePortal
    }, createElement(ListboxList, {
      className: "portal-ui-scrollbar pu-max-h-60 pu-rounded-md pu-py-1 pu-text-base pu-leading-6 pu-shadow-xs pu-overflow-auto focus:pu-outline-none sm:pu-text-sm sm:pu-leading-5"
    }, optionData.displayedItems.map(function (group, groupIndex) {
      if (group.groupLabel) {
        return createElement(ListboxGroup, {
          key: groupIndex
        }, createElement(ListboxGroupLabel, {
          as: OptGroupLabel
        }, group.groupLabel), group.options.map(function (option) {
          return createElement(Option, {
            render: function render(optProps) {
              return createElement(ListboxOption, Object.assign({
                value: wrapValue(option.value),
                label: option.label,
                disabled: option.disabled
              }, optProps));
            },
            label: option.label,
            description: option.description,
            leftIcon: option.icon,
            key: option.index
          });
        }));
      }

      return createElement(Fragment, {
        key: groupIndex
      }, group.options.map(function (option) {
        return createElement(Option, {
          render: function render(optProps) {
            return createElement(ListboxOption, Object.assign({
              value: wrapValue(option.value),
              label: option.label,
              disabled: option.disabled
            }, optProps));
          },
          label: option.label,
          description: option.description,
          leftIcon: option.icon,
          disabled: option.disabled,
          key: option.index
        });
      }));
    }))));
  });
};
var EMPTY_VALUE = ' ';

var wrapValue = function wrapValue(value) {
  return value === '' ? EMPTY_VALUE : value;
};

var unwrapValue = function unwrapValue(value) {
  return value === EMPTY_VALUE ? '' : value;
};

var _excluded$g = ["status"];
/**
 * `Field` is a component that provides contextual styling
 * of the `Input` and `Label` within it. In addition, it will
 * provides default props to `Input` and `Label` for accessibility.
 *
 * Props not specified will be spreaded to the underlying `div` element.
 */

function Field(_ref) {
  var status = _ref.status,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  var _React$useState = useState(''),
      inputId = _React$useState[0],
      setInputId = _React$useState[1];

  var _React$useState2 = useState(0),
      helpTextCount = _React$useState2[0],
      setHelpTextCount = _React$useState2[1];

  return createElement(FieldContext.Provider, {
    value: {
      inputId: inputId,
      setInputId: setInputId,
      status: status,
      hasHelpText: helpTextCount > 0,
      setHelpTextCount: setHelpTextCount
    }
  }, createElement("div", Object.assign({}, props)));
}

function HelpText(props) {
  var _React$useContext = useContext(FieldContext),
      inputId = _React$useContext.inputId,
      status = _React$useContext.status,
      setHelpTextCount = _React$useContext.setHelpTextCount;

  useEffect(function () {
    setHelpTextCount(function (x) {
      return x + 1;
    });
    return function () {
      return setHelpTextCount(function (x) {
        return x - 1;
      });
    };
  }, [setHelpTextCount]);
  return createElement("span", Object.assign({
    id: inputId + "-help"
  }, props, {
    className: cx(classes.bodySecondary, status ? colorByStatus[status] : 'pu-text-mediumgrey', props.className)
  }));
}
var colorByStatus = {
  error: 'pu-text-error-500',
  warning: 'pu-text-warning-800',
  success: 'pu-text-success-800'
};

var _excluded$h = ["size"];
/**
 * Label is just a wrapper around html `label` element.
 *
 * It accepts all props `label` element accepts.
 *
 * It will sync its `htmlFor` with the id of the input within same `Field` component
 */

function Label(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  var _React$useContext = useContext(FieldContext),
      inputId = _React$useContext.inputId;

  return createElement("label", Object.assign({
    htmlFor: inputId
  }, props, {
    className: cx('pu-block pu-leading-5 pu-text-mediumgrey', !hasUtilClass(props.className, 'pu-mb-') && 'pu-mb-1', size === 'small' && 'pu-text-sm', props.className)
  }));
}

/**
 * FieldContainer is a composition of `<Field />`, `<Label />`, and `<HelpText />`.
 *
 * If you need more control, compose them yourself.
 */

var FieldContainer = function FieldContainer(_ref) {
  var status = _ref.status,
      helpText = _ref.helpText,
      label = _ref.label,
      className = _ref.className,
      children = _ref.children,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'vertical' : _ref$layout,
      _ref$labelAlign = _ref.labelAlign,
      labelAlign = _ref$labelAlign === void 0 ? 'center' : _ref$labelAlign,
      forceShrink = _ref.forceShrink;
  var isFilter = useContext(FilterContext);
  var fClass = cx(!isFilter && !hasUtilClass(className, 'pu-mb-', 'pu-my-') && 'pu-mb-5', className);

  if (layout === 'vertical') {
    return createElement(Field, {
      status: status,
      className: fClass
    }, label && createElement(Label, null, label), children, helpText && createElement(HelpText, null, helpText));
  }

  if (layout === 'horizontal-responsive') {
    return createElement(Field, {
      status: status,
      className: fClass
    }, createElement("div", {
      className: cx('sm:pu-flex', labelAlign === 'center' && 'sm:pu-items-center')
    }, createElement(Label, {
      className: cx('sm:pu-mb-0 sm:pu-pr-3', !isFilter && 'pu-flex-1', labelAlign === 'start' && 'sm:pu-pt-2.5')
    }, label), createElement("div", {
      className: cx(!isFilter && 'pu-flex-2 lg:pu-flex-3', forceShrink && 'pu-w-0')
    }, children)), !!helpText && createElement("div", {
      className: "sm:pu-flex"
    }, createElement("div", {
      className: "pu-hidden sm:pu-block sm:pu-flex-1 sm:pu-pr-3"
    }), createElement("div", {
      className: "pu-flex-2 lg:pu-flex-3"
    }, createElement(HelpText, null, helpText))));
  }

  return createElement(Field, {
    status: status,
    className: fClass
  }, createElement("div", {
    className: cx('pu-flex', labelAlign === 'center' && 'pu-items-center')
  }, createElement(Label, {
    className: cx('pu-mb-0 pu-pr-3', !isFilter && 'pu-flex-1', labelAlign === 'start' && 'pu-pt-2.5')
  }, label), createElement("div", {
    className: cx(!isFilter && 'pu-flex-2 lg:pu-flex-3', forceShrink && 'pu-w-0')
  }, children)), !!helpText && createElement("div", {
    className: "pu-flex"
  }, createElement("div", {
    className: "pu-flex-1 pu-pr-3"
  }), createElement("div", {
    className: "pu-flex-2 lg:pu-flex-3"
  }, createElement(HelpText, null, helpText))));
};

function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
function focusFirstTabbable(el) {
  var tabs = tabbable(el);

  if (tabs.length > 0) {
    for (var _iterator = _createForOfIteratorHelperLoose(tabs), _step; !(_step = _iterator()).done;) {
      var target = _step.value;

      if (isFunction(target.focus)) {
        target.focus();
        break;
      }
    }
  }
}
var today = /*#__PURE__*/startOfDay( /*#__PURE__*/new Date());
var startOfThisYear = /*#__PURE__*/startOfYear(today);
var ONE_DAY_MINUS_ONE_MS = 86399999;
var ONE_MIN_MINUS_ONE_MS = 59999;
var DATES = {
  today: today,
  endOfToday: /*#__PURE__*/endOfDay(today),
  yesterday: /*#__PURE__*/subDays(today, 1),
  sevenDaysAgo: /*#__PURE__*/subDays(today, 6),
  thirtyDaysAgo: /*#__PURE__*/subDays(today, 29),
  startOfThisYear: startOfThisYear,
  startOfLastYear: /*#__PURE__*/subYears(startOfThisYear, 1)
};
var DATE_RANGES = {
  anyDate: ['', ''],
  today: [/*#__PURE__*/formatDateUtc(today), /*#__PURE__*/formatDateUtc(DATES.endOfToday)],
  yesterday: [/*#__PURE__*/formatDateUtc(DATES.yesterday), /*#__PURE__*/formatDateUtc( /*#__PURE__*/endOfDay(DATES.yesterday))],
  last7days: [/*#__PURE__*/formatDateUtc(DATES.sevenDaysAgo), /*#__PURE__*/formatDateUtc(DATES.endOfToday)],
  last30days: [/*#__PURE__*/formatDateUtc(DATES.thirtyDaysAgo), /*#__PURE__*/formatDateUtc(DATES.endOfToday)],
  thisYear: [/*#__PURE__*/formatDateUtc(DATES.startOfThisYear), /*#__PURE__*/formatDateUtc(DATES.endOfToday)],
  lastYear: [/*#__PURE__*/formatDateUtc(DATES.startOfLastYear), /*#__PURE__*/formatDateUtc( /*#__PURE__*/endOfYear(DATES.startOfLastYear))]
};
var DATE_RANGE_DROPDOWN_DEFAULT_OPTIONS = [{
  label: 'Any dates',
  value: DATE_RANGES.anyDate
}, {
  label: 'Today',
  value: DATE_RANGES.today
}, {
  label: 'Yesterday',
  value: DATE_RANGES.yesterday
}, {
  label: 'Last 7 days',
  value: DATE_RANGES.last7days
}, {
  label: 'Last 30 days',
  value: DATE_RANGES.last30days
}];
var DATE_RANGE_OPTIONS_WITHOUT_ANY = /*#__PURE__*/DATE_RANGE_DROPDOWN_DEFAULT_OPTIONS.slice(1);
var DATE_RANGE_OPTIONS_EXTENDED = /*#__PURE__*/DATE_RANGE_DROPDOWN_DEFAULT_OPTIONS.concat([{
  label: 'This year',
  value: DATE_RANGES.thisYear
}, {
  label: 'Last year',
  value: DATE_RANGES.lastYear
}]);
/**
 * As we add minutes/day to "To" for date range, we need to substract it back for display
 */

var getDisplayedTo = function getDisplayedTo(to, dayOnly) {
  if (!to) {
    return to;
  }

  return dayOnly ? subMs(to, ONE_DAY_MINUS_ONE_MS) : subMs(to, ONE_MIN_MINUS_ONE_MS);
};
var getActualToFromDisplayedValue = function getActualToFromDisplayedValue(to, dayOnly) {
  if (!to) {
    return to;
  }

  return dayOnly ? addMs(to, ONE_DAY_MINUS_ONE_MS) : addMs(to, ONE_MIN_MINUS_ONE_MS);
};
var normalizeDateRangeOptions = function normalizeDateRangeOptions(provided) {
  return provided.map(function (opt) {
    return {
      label: opt.label,
      value: isString(opt.value) ? [opt.value, ''] : opt.value,
      icon: opt.icon
    };
  });
};
var MONTHS_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var ModalContext = /*#__PURE__*/createNamedContext('ModalContext', {
  size: 'standard'
});

var ModalHeader = function ModalHeader(props) {
  var _React$useContext = useContext(ModalContext),
      size = _React$useContext.size;

  return createElement("div", Object.assign({}, props, {
    className: cx('pu-px-4 md:pu-px-6 lg:pu-px-8 pu-text-darkgrey pu-border-b pu-border-gray-200', classes.h2, classBySize$1[size], props.className)
  }));
};
var classBySize$1 = {
  large: 'pu-pt-5 pu-py-4',
  standard: 'pu-pt-5 pu-py-4',
  small: 'pu-pt-5 pu-py-4',
  tiny: 'pu-pt-3 pu-pb-2',
  none: ''
};

var _excluded$i = ["children", "size", "showCloseBtn", "isOpen", "onDismiss", "allowPinchZoom", "initialFocusRef", "overlayClassName", "dismissBtnVariant", "initialFocus", "header", "aria-label", "_noScroll"];
/**
 * `<Modal />` is a window positioned over everything else in the document and remove
 * scroll from the body.
 *
 * Clicking on the backdrop will automatically close the modal, so do pressing Esc key.
 *
 * In the `<Modal />`, use `<ModalHeader />`, `<ModalBody />`, or `<ModalFooter />` to wrap your
 * contents.
 */

var Modal = function Modal(_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'standard' : _ref$size,
      _ref$showCloseBtn = _ref.showCloseBtn,
      showCloseBtn = _ref$showCloseBtn === void 0 ? true : _ref$showCloseBtn,
      isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      allowPinchZoom = _ref.allowPinchZoom,
      initialFocusRef = _ref.initialFocusRef,
      overlayClassName = _ref.overlayClassName,
      _ref$dismissBtnVarian = _ref.dismissBtnVariant,
      dismissBtnVariant = _ref$dismissBtnVarian === void 0 ? 'transparent' : _ref$dismissBtnVarian,
      _ref$initialFocus = _ref.initialFocus,
      initialFocus = _ref$initialFocus === void 0 ? 'dismiss' : _ref$initialFocus,
      header = _ref.header,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? header : _ref$ariaLabel,
      _noScroll = _ref._noScroll,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$i);

  var _useDescendantsInit = useDescendantsInit(),
      selects = _useDescendantsInit[0],
      setSelects = _useDescendantsInit[1];

  var selectsCount = selects.length;
  var hasFocusedRef = useRef(false);
  var modalRef = useRef(null);
  useEffect(function () {
    if (isOpen && selectsCount > 0 && !hasFocusedRef.current) {
      // workaround to focus on the first element when focus lock is bypassed (which is another workaround for the bug from `reach-ui` below 😅).
      var tId = window.setTimeout(function () {
        if (modalRef.current) {
          focusFirstTabbable(modalRef.current);
          hasFocusedRef.current = true;
        }
      }, 0);
      return function () {
        return window.clearTimeout(tId);
      };
    }
  }, [selectsCount, isOpen]);
  var closeBtn = createElement("div", {
    className: cx('pu-absolute pu-top-0 pu-right-0', btnWrapperClasses[size])
  }, createElement(IconButton, {
    onClick: onDismiss,
    className: cx(dismissBtnVariant === 'semitransparent' && 'pu-bg-white pu-bg-opacity-75', size === 'tiny' && 'pu-p-1'),
    "aria-label": "Close"
  }, createElement(CrossIcon, {
    className: cx(dismissBtnVariant === 'semitransparent' ? 'pu-text-black' : 'pu-text-lightgrey', closeIconClasses[size])
  })));
  return createElement(ModalContext.Provider, {
    value: useMemo(function () {
      return {
        size: size
      };
    }, [size])
  }, createElement(DescendantProvider, {
    context: ModalSelectDescentdantContext,
    items: selects,
    set: setSelects
  }, createElement(DialogOverlay, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    allowPinchZoom: allowPinchZoom,
    initialFocusRef: initialFocusRef,
    className: cx(!hasUtilClass(overlayClassName, 'pu-px-') && 'pu-px-5', _noScroll && 'pu-flex pu-items-center pu-justify-center pu-pb-1/12', overlayClassName),
    dangerouslyBypassFocusLock: selectsCount > 0
  }, createElement(DialogContent$1, Object.assign({}, props, _noScroll ? {
    'data-setel-modal-content-noscroll': true
  } : {
    'data-setel-modal-content': true
  }, {
    className: cx('pu-relative pu-bg-white pu-overflow-hidden pu-font-sans', !hasUtilClass(props.className, 'pu-rounded') && 'pu-rounded-md', !hasUtilClass(props.className, 'pu-max-w-') && maxWidthClasses[size], props.className),
    "aria-label": ariaLabel,
    ref: modalRef
  }), showCloseBtn && initialFocus === 'dismiss' && closeBtn, header && createElement(ModalHeader, null, header), children, showCloseBtn && initialFocus === 'content' && closeBtn))));
};
var maxWidthClasses = {
  large: 'pu-max-w-7xl',
  standard: 'pu-max-w-modal-medium',
  small: 'pu-max-w-xl',
  tiny: 'pu-max-w-2xl'
};
var btnWrapperClasses = {
  large: 'pu-pt-3 pu-pr-5',
  standard: 'pu-pt-3 pu-pr-5',
  small: 'pu-pt-3 pu-pr-5',
  tiny: 'pu-pt-1.5 pu-pr-1.5'
};
var closeIconClasses = {
  large: 'pu-w-6 pu-h-6',
  standard: 'pu-w-6 pu-h-6',
  small: 'pu-w-6 pu-h-6',
  tiny: 'pu-w-4 pu-h-4'
};

var ModalBody = function ModalBody(props) {
  return createElement("div", Object.assign({}, props, {
    className: cx('pu-px-4 md:pu-px-6 lg:pu-px-8 pu-py-4', props.className)
  }));
};

var ModalFooter = function ModalFooter(props) {
  var _React$useContext = useContext(ModalContext),
      size = _React$useContext.size;

  return createElement("div", Object.assign({}, props, {
    className: cx('pu-px-4 md:pu-px-6 lg:pu-px-8 pu-bg-gray-50', classes$1[size], props.className)
  }));
};
var classes$1 = {
  large: 'pu-py-4',
  standard: 'pu-py-4',
  small: 'pu-py-4',
  tiny: 'pu-py-2',
  none: ''
};

var Modal$1 = /*#__PURE__*/Object.assign(Modal, {
  Body: ModalBody,
  Footer: ModalFooter,
  Header: ModalHeader
});

var _excluded$j = ["className", "onChangeValue", "onChange"];
/**
 * TextInput allow users to enter any combination of letters, numbers, or symbols.
 * The length of the text input provides a hint to users as to how much text to write.
 * Do not require users to write paragraphs of text into a single-line input box; use Textarea instead.
 *
 * It accepts all props that an `<input />` element accepts.
 */

var TextInput = /*#__PURE__*/forwardRef(function TextInput(_ref, forwardedRef) {
  var className = _ref.className,
      onChangeValue = _ref.onChangeValue,
      onChange = _ref.onChange,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  var _useFieldControlConte = useFieldControlContext(inputProps.id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status,
      hasHelpText = _useFieldControlConte.hasHelpText;

  return createElement("input", Object.assign({
    type: "text",
    className: cx('form-input pu-block pu-min-w-0', !hasUtilClass(className, 'pu-w-') && 'pu-w-full', status && borderByStatus[status], (inputProps.readOnly || inputProps.disabled) && !hasUtilClass(className, 'pu-bg-') && 'pu-bg-gray-200 pu-text-lightgrey', className),
    id: inputId,
    "aria-describedby": hasHelpText ? inputId + "-help" : undefined,
    onChange: callAll(onChange, onChangeValue && function (ev) {
      return onChangeValue(ev.target.value);
    })
  }, inputProps, {
    ref: forwardedRef
  }));
});

var useOptionCache = function useOptionCache(_ref) {
  var queryKey = _ref.queryKey,
      _ref$initialData = _ref.initialData,
      initialData = _ref$initialData === void 0 ? [] : _ref$initialData;
  var queryClient = useQueryClient();

  var _useQuery = useQuery({
    queryKey: [OPTION, queryKey],
    enabled: false,
    initialData: initialData
  }),
      data = _useQuery.data;

  return {
    data: data,
    addData: function addData(newOptions, _temp) {
      var _ref2 = _temp === void 0 ? {} : _temp,
          replace = _ref2.replace;

      return queryClient.setQueryData([OPTION, queryKey], replace ? newOptions : function (prevData) {
        if (prevData === void 0) {
          prevData = [];
        }

        return dedupeArray(prevData.concat(newOptions), 'value');
      });
    }
  };
};
var useGetOptionCache = function useGetOptionCache() {
  var queryClient = useQueryClient();
  return function getOptionCache(queryKey) {
    if (!queryKey) {
      return [];
    }

    return queryClient.getQueryData([OPTION, queryKey]) || [];
  };
};
var OPTION = 'portal-ui-option';

var _excluded$k = ["isOpen", "className"];
var Popover = /*#__PURE__*/forwardRef(function Popover(_ref, ref) {
  var isOpen = _ref.isOpen,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$k);

  return createElement(ReachPopover, Object.assign({}, props, {
    className: cx('pu-bg-white pu-rounded-md pu-shadow-lg pu-transition pu-transform pu-duration-200 pu-ease-in-out pu-overflow-hidden pu-border pu-border-gray-100 pu-font-sans', isOpen ? 'pu-opacity-100 pu-translate-y-0' : 'pu-opacity-0 pu--translate-y-1', className),
    ref: ref
  }));
});

/**
 * Wrapper of `react-highlight-words` with change of default.
 */

var TextHighlight = function TextHighlight(props) {
  return createElement(Highlighter, Object.assign({
    highlightClassName: "pu-bg-brand-100",
    autoEscape: true
  }, props));
};

var _excluded$l = ["value", "onChangeValue", "options", "wrapperClass", "id", "className", "onFocus", "onInputValueChange", "initialLabel", "popoverPosition", "menuClass", "popoverClass", "description", "noResultText", "usePortal", "_cacheKey"];
/**
 * `<SearchableDropdown />` works just like `<Dropdown />` component, with the additional functionality of filtering
 * options by entering text.
 *
 * Unspecified props will be spreaded to the underlying `input` element.
 */

var SearchableDropdown = function SearchableDropdown(_ref) {
  var value = _ref.value,
      onChangeValue = _ref.onChangeValue,
      options = _ref.options,
      wrapperClass = _ref.wrapperClass,
      id = _ref.id,
      className = _ref.className,
      onFocus = _ref.onFocus,
      onInputValueChange = _ref.onInputValueChange,
      _ref$initialLabel = _ref.initialLabel,
      initialLabel = _ref$initialLabel === void 0 ? value : _ref$initialLabel,
      _ref$popoverPosition = _ref.popoverPosition,
      popoverPosition = _ref$popoverPosition === void 0 ? positionMatchWidth : _ref$popoverPosition,
      menuClass = _ref.menuClass,
      popoverClass = _ref.popoverClass,
      description = _ref.description,
      _ref$noResultText = _ref.noResultText,
      noResultText = _ref$noResultText === void 0 ? 'No results found.' : _ref$noResultText,
      _ref$usePortal = _ref.usePortal,
      usePortal = _ref$usePortal === void 0 ? true : _ref$usePortal,
      _ref$_cacheKey = _ref._cacheKey,
      _cacheKey = _ref$_cacheKey === void 0 ? id : _ref$_cacheKey,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  var divRef = useRef(null);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var _React$useState = useState(value),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var trimmedInput = inputValue.trim();

  var _useOptionCache = useOptionCache({
    queryKey: _cacheKey || inputId,
    initialData: value ? [{
      value: value,
      label: initialLabel,
      index: 0
    }] : undefined
  }),
      _useOptionCache$data = _useOptionCache.data,
      cachedItem = _useOptionCache$data[0],
      addToCache = _useOptionCache.addData;

  var validCachedItem = cachedItem && (cachedItem.value === value ? cachedItem : undefined);
  var optionData = useMemo(function () {
    var removedOption = function findRemovedOption() {
      if (!validCachedItem) {
        // nothing cached
        return undefined;
      }

      if (!options) {
        // cached, but no options
        return validCachedItem;
      }

      for (var index = 0; index < options.length; index++) {
        // if the cache is still available in option, it is not "removed" option
        var option = options[index];

        if (option.type === 'group') {
          for (var oIndex = 0; oIndex < option.options.length; oIndex++) {
            var childOption = option.options[oIndex];

            if (childOption.value === validCachedItem.value) {
              return undefined;
            }
          }
        } else {
          if (option.value === validCachedItem.value) {
            return undefined;
          }
        }
      }

      return validCachedItem;
    }();

    if (!options) {
      return removedOption ? sortOptions([removedOption], trimmedInput, false) : undefined;
    }

    return sortOptions(removedOption ? options.concat(removedOption) : options, trimmedInput, false);
  }, [options, trimmedInput, validCachedItem]);
  var selectedItem = useMemo(function () {
    if (!value || !optionData) {
      return null;
    }

    return optionData.allItems.find(function (o) {
      return o.value === value;
    }) || null;
  }, [value, optionData]);
  var displayedValue = useMemo(function () {
    if (!optionData) {
      return '';
    }

    var selectedOption = optionData.allItems.find(function (item) {
      return item.value === value;
    });
    return selectedOption ? selectedOption.label : '';
  }, [optionData, value]);
  useEffect(function () {
    setInputValue(displayedValue);
  }, [displayedValue]);

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    selectedItem: selectedItem,
    items: optionData && optionData.items || [],
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    inputId: inputId,
    onSelectedItemChange: function onSelectedItemChange(changes) {
      var selectedItem = changes.selectedItem;

      if (selectedItem) {
        onChangeValue(selectedItem.value, selectedItem.label);
        addToCache([selectedItem], {
          replace: true
        });
      } else {
        onChangeValue('', '');
      }
    },
    onStateChange: function onStateChange(_ref2) {
      var type = _ref2.type;

      if (type === useCombobox.stateChangeTypes.InputBlur || type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
        if (inputValue !== displayedValue) {
          setInputValue(displayedValue);
        }
      }
    }
  }),
      isOpen = _useCombobox.isOpen,
      openMenu = _useCombobox.openMenu,
      highlightedIndex = _useCombobox.highlightedIndex,
      getToggleButtonProps = _useCombobox.getToggleButtonProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps,
      selectItem = _useCombobox.selectItem;

  var menuContent = createElement("div", Object.assign({}, getMenuProps({
    className: cx('portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-72 pu-overflow-auto', menuClass)
  }, {
    suppressRefError: true
  })), isOpen && (optionData ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, noResultText) : optionData.displayedItems.map(function (group, gIndex) {
    return createElement(Fragment, {
      key: gIndex
    }, group.groupLabel && createElement(OptGroupLabel, null, group.groupLabel), group.options.map(function (option) {
      return createElement(Option, Object.assign({
        key: option.value + "-" + option.index
      }, getItemProps({
        item: option,
        index: option.index,
        disabled: option.disabled
      }), {
        leftIcon: option.icon,
        highlighted: option.index === highlightedIndex,
        selected: option === selectedItem,
        label: createElement(TextHighlight, {
          searchWords: [trimmedInput],
          textToHighlight: option.label
        }),
        description: option.description && createElement(TextHighlight, {
          textToHighlight: option.description,
          searchWords: [trimmedInput]
        })
      }));
    }));
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }))));
  return createElement(Fragment, null, createElement("div", Object.assign({}, getComboboxProps({
    className: cx('pu-relative', wrapperClass),
    ref: divRef
  })), createElement(TextInput, Object.assign({
    onChangeValue: callAll(onInputValueChange && function (val) {
      return onInputValueChange(val.trim());
    }, setInputValue, function (newVal) {
      if (newVal === '' && selectedItem) {
        selectItem(null);
      }
    })
  }, getInputProps(_extends({
    value: inputValue,
    onFocus: callAll(onFocus, function () {
      if (!isOpen) {
        openMenu();
      }
    }),
    className: cx(status && borderByStatus[status], description && 'pu-pb-6', className)
  }, inputProps)))), description && createElement("div", Object.assign({}, getToggleButtonProps({
    className: 'pu-absolute pu-bottom-0 pu-inset-x-0 pu-text-xs pu-px-3 pu-pt-1 pu-pb-2.25 pu-text-lightgrey pu-truncate focus:pu-outline-none pu-border pu-border-transparent',
    disabled: inputProps.disabled
  })), description), !usePortal && createElement("div", {
    className: cx('pu-absolute pu-top-full pu-inset-x-0 pu-font-sans', isOpen && 'pu-shadow-lg pu-border pu-border-gray-100', popoverClass)
  }, menuContent)), usePortal && createElement(Popover, {
    targetRef: divRef,
    position: popoverPosition,
    isOpen: isOpen,
    className: cx('pu-mt-0.5', popoverClass)
  }, menuContent));
};

var _excluded$m = ["isRange", "showMonthYearDropdown", "disableFuture", "disabledDays", "minDate", "maxDate", "className", "onChangeValue"];
/**
 * This is [`react-day-picker`](https://react-day-picker.js.org/) with custom defaults and styles to fit Setel design.
 */

var DayPicker = /*#__PURE__*/forwardRef(function DayPicker(_ref, forwardedRef) {
  var isRange = _ref.isRange,
      showMonthYearDropdown = _ref.showMonthYearDropdown,
      disableFuture = _ref.disableFuture,
      disabledDays = _ref.disabledDays,
      _ref$minDate = _ref.minDate,
      minDate = _ref$minDate === void 0 ? showMonthYearDropdown ? MIN_YEAR : undefined : _ref$minDate,
      _ref$maxDate = _ref.maxDate,
      maxDate = _ref$maxDate === void 0 ? showMonthYearDropdown ? MAX_YEAR : undefined : _ref$maxDate,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'pu-inline-block' : _ref$className,
      onChangeValue = _ref.onChangeValue,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  var _React$useState = useState(function () {
    return props.selectedDays instanceof Date ? props.selectedDays : new Date();
  }),
      month = _React$useState[0],
      setMonth = _React$useState[1];

  var dateRangeFn = useMemo(function () {
    return isOutsideRange(minDate, maxDate);
  }, [minDate, maxDate]);
  var Navbar = useMemo(function () {
    return showMonthYearDropdown ? function Navbar() {
      return null;
    } : DayPickerNavbar;
  }, [showMonthYearDropdown]);
  var YearDropdown = useMemo(function () {
    return function YearDropdown(props) {
      var options = useMemo(function () {
        var yearOptions = [];

        if (minDate && maxDate) {
          var minYear = minDate.getFullYear();
          var maxYear = maxDate.getFullYear();

          for (var year = minYear; year <= maxYear; year++) {
            var yearValue = String(year);
            yearOptions.push({
              value: yearValue,
              label: yearValue
            });
          }
        }

        return yearOptions;
      }, [minDate, maxDate]);

      if (!showMonthYearDropdown || !minDate || !maxDate) {
        return null;
      }

      return createElement(SearchableDropdown, {
        value: String(props.value),
        options: options,
        onChangeValue: function onChangeValue(y) {
          return y && props.onChangeValue(Number(y));
        },
        wrapperClass: "pu-w-24 relative pu--left-px",
        className: "form-select pu-rounded-l-none",
        popoverClass: "pu-z-10",
        usePortal: false,
        "data-testid": "year-select"
      });
    };
  }, [minDate, maxDate, showMonthYearDropdown]);
  var Caption = useMemo(function () {
    return showMonthYearDropdown ? function Caption(_ref2) {
      var localeUtils = _ref2.localeUtils,
          date = _ref2.date;
      return createElement("div", {
        className: "pu-table-caption pu-px-3 pu-py-4 pu-text-lg"
      }, createElement("div", {
        className: "pu-flex"
      }, createElement("div", {
        className: "pu-relative pu-flex-1"
      }, createElement("div", {
        className: "pu-absolute pu-inset-y-0 pu-left-0 pu-flex pu-items-center pu-justify-center pu-px-2"
      }, createElement(CalendarIcon, {
        className: "pu-w-4 pu-text-lightgrey"
      })), createElement(DropdownSelect, {
        value: String(date.getMonth()),
        onChangeValue: function onChangeValue(monthVal) {
          setMonth(new Date(date.getFullYear(), Number(monthVal)));
        },
        options: localeUtils.getMonths().map(function (month, index) {
          return {
            label: month,
            value: String(index)
          };
        }),
        className: "pu-pl-8 pu-rounded-r-none",
        menuClass: "z-10",
        usePortal: false,
        "data-testid": "month-select"
      })), createElement(YearDropdown, {
        value: date.getFullYear(),
        onChangeValue: function onChangeValue(year) {
          return setMonth(new Date(year, date.getMonth()));
        }
      })));
    } : CaptionElement;
  }, [showMonthYearDropdown, YearDropdown]);
  var onChangeValueCb = useStableCallback(function (date) {
    if (onChangeValue) {
      onChangeValue(date);
    }
  });
  return createElement(ReactDayPicker, Object.assign({}, dayPickerDefault, props, {
    month: showMonthYearDropdown ? month : undefined,
    navbarElement: Navbar,
    captionElement: Caption,
    onDayClick: function onDayClick(date, modifiers) {
      if (!modifiers.disabled) {
        onChangeValueCb(date);
      }
    },
    disabledDays: minDate || maxDate ? dateRangeFn : disableFuture ? isFutureDate : disabledDays,
    className: cx(isRange && 'DayPicker--range', className),
    ref: forwardedRef
  }));
});

var isFutureDate = function isFutureDate(day) {
  return isFuture(startOfDay(day));
};

var isOutsideRange = function isOutsideRange(minDate, maxDate) {
  return function (day) {
    if (minDate && maxDate) {
      return isBefore(startOfDay(day), minDate) || isAfter(startOfDay(day), maxDate);
    }

    if (minDate) {
      return isBefore(startOfDay(day), minDate);
    }

    if (maxDate) {
      return isAfter(startOfDay(day), maxDate);
    }

    return false;
  };
};

var CaptionElement = function CaptionElement(props) {
  return createElement("div", {
    className: "pu-table-caption pu-px-3 pu-py-4 pu-text-lg pu-text-center"
  }, props.localeUtils.formatMonthTitle(props.date));
};

var DayPickerNavbar = function DayPickerNavbar(props) {
  return createElement(Fragment, null, props.showPreviousButton ? createElement("div", {
    className: "pu-absolute pu-top-0 pu-left-0 pu-pt-3 pu-pl-3"
  }, createElement(IconButton, {
    onClick: function onClick() {
      return props.onPreviousClick();
    }
  }, createElement("span", {
    className: "pu-sr-only"
  }, props.labels.previousMonth), createElement(ExpandMoreIcon, {
    className: "pu-w-6 pu-transform pu-rotate-90 pu-text-gray-400"
  }))) : createElement("span", null), props.showNextButton ? createElement("div", {
    className: "pu-absolute pu-top-0 pu-right-0 pu-pt-3 pu-pr-3"
  }, createElement(IconButton, {
    onClick: function onClick() {
      return props.onNextClick();
    }
  }, createElement("span", {
    className: "pu-sr-only"
  }, props.labels.nextMonth), createElement(ExpandMoreIcon, {
    className: "pu-w-6 pu-transform pu--rotate-90 pu-text-gray-400"
  }))) : createElement("span", null));
};

var WEEKDAYS_SHORT = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var dayPickerDefault = {
  firstDayOfWeek: 1,
  weekdaysShort: WEEKDAYS_SHORT,
  renderDay: function renderDay(date) {
    return createElement("div", {
      className: cx('DayPicker-DayOuter', isLastDayOfMonth(date) && 'DayPicker-DayOuter--lastDayOfMonth')
    }, createElement("span", {
      className: "DayPicker-DayInner pu-inline-flex pu-items-center pu-justify-center pu-w-8 pu-h-8 pu-rounded-full"
    }, date.getDate()));
  }
};
var MIN_YEAR = /*#__PURE__*/new Date(1900, 0);
var MAX_YEAR = /*#__PURE__*/new Date(2050, 11, 31);

var _excluded$n = ["onChangeValue", "hours", "minutes", "wrapperClass"];
var TimeInput = function TimeInput(_ref) {
  var _onChangeValue = _ref.onChangeValue,
      hours = _ref.hours,
      minutes = _ref.minutes,
      wrapperClass = _ref.wrapperClass,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$n);

  var isPm = hours >= 12;
  var displayedHour = hours % 12 === 0 ? 12 : isPm ? hours - 12 : hours;
  var displayedValue = useMemo(function () {
    return padStart((displayedHour || 0).toString(), 2, '0') + ":" + padStart((minutes || 0).toString(), 2, '0');
  }, [displayedHour, minutes]);

  var _React$useState = useState(displayedValue),
      v = _React$useState[0],
      setV = _React$useState[1];

  useEffect(function () {
    setV(displayedValue);
  }, [displayedValue]);
  var rifm = useRifm({
    value: v,
    onChange: setV,
    format: formatTime,
    mask: true,
    replace: addMask
  });
  return createElement("div", {
    className: cx('pu-inline-flex', wrapperClass)
  }, createElement("div", {
    className: "pu-relative pu-flex-1"
  }, createElement("div", {
    className: "pu-absolute pu-inset-y-0 pu-left-0 pu-px-1.5 pu-my-1 pu-ml-1 pu-rounded-full pu-flex pu-items-center pu-pointer-events-none",
    "aria-hidden": true
  }, createElement(ClockIcon, {
    className: "pu-w-4 pu-h-4 pu-text-gray-400"
  })), createElement(TextInput, Object.assign({
    value: rifm.value
  }, props, {
    onChange: callAll(rifm.onChange, props.onChange),
    onBlur: callAll(function (ev) {
      var newValue = parseValue(ev.target.value, isPm);

      if (hours !== newValue.hours || minutes !== newValue.minutes) {
        _onChangeValue(newValue);
      }
    }, props.onBlur),
    className: cx('pu-pl-8 pu-rounded-r-none', !hasUtilClass(props.className, 'pu-w-') && 'pu-w-28', props.className)
  })), createElement("div", {
    className: "pu-absolute pu-inset-y-0 pu-right-1 pu-flex pu-flex-col"
  }, createElement(MiniIconButton, {
    onClick: function onClick() {
      return _onChangeValue({
        hours: hours + 1,
        minutes: minutes
      });
    },
    disabled: props.disabled || hours === 23,
    className: "pu-pt-2 pu-rounded-t-xl"
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Increase hour"), createElement(ChevronUpIcon, {
    className: "pu-text-lightgrey pu-w-3 pu-h-3"
  })), createElement(MiniIconButton, {
    onClick: function onClick() {
      return _onChangeValue({
        hours: hours - 1,
        minutes: minutes
      });
    },
    disabled: props.disabled || hours === 0,
    className: "pu-pb-2 pu-rounded-b-xl"
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Decrease hour"), createElement(ChevronUpIcon, {
    className: "pu-text-lightgrey pu-w-3 pu-h-3 pu-transform pu-rotate-180"
  })))), createElement(DropdownSelect, {
    value: isPm ? 'PM' : 'AM',
    className: "pu-w-20 pu-rounded-l-none pu-pr-8",
    onChangeValue: function onChangeValue(value) {
      return _onChangeValue({
        hours: hours + (value === 'AM' ? -12 : 12),
        minutes: minutes
      });
    },
    disabled: props.disabled,
    options: amPmOptions
  }));
};

var MiniIconButton = function MiniIconButton(props) {
  return createElement("button", Object.assign({
    type: "button",
    tabIndex: -1,
    "aria-hidden": true
  }, props, {
    className: cx('pu-flex-1 pu-px-2 focus:pu-outline-none', !props.disabled && 'active:pu-bg-gray-100', props.className)
  }));
};

var amPmOptions = [{
  value: 'AM',
  label: 'AM'
}, {
  value: 'PM',
  label: 'PM'
}];

var parseTimeDigits = function parseTimeDigits(value) {
  return (value.match(/^(0[1-9]|1[0-2]):?([0-5][0-9]?)?/) || value.match(/^(0|1)/) || []).slice(1).join('');
};

var formatTime = function formatTime(value) {
  var digits = parseTimeDigits(value);
  var chars = digits.split('');
  return chars.reduce(function (r, v, index) {
    return index === 2 ? r + ":" + v : "" + r + v;
  }, '').substr(0, 5);
};

var addMask = function addMask(value) {
  var digits = parseTimeDigits(value);
  var hours = padEnd(digits.slice(0, 2), 2, '_');
  var minutes = padEnd(digits.slice(2, 4), 2, '_');
  return hours + ":" + minutes;
};

var parseValue = function parseValue(value, isPm) {
  var digits = parseTimeDigits(value);
  var hours = Number(padStart(digits.slice(0, 2), 2, '0'));
  var minutes = Number(padStart(digits.slice(2, 4), 2, '0'));
  return {
    hours: hours > 12 || hours === 0 ? hours : hours === 12 ? isPm ? 12 : 0 : isPm ? 12 + hours : hours,
    minutes: minutes
  };
};

/**
 * Allows you to select start and end date
 *
 */

var DateRangePicker = /*#__PURE__*/forwardRef(function DateRangePicker(_ref, forwardedRef) {
  var from = _ref.from,
      _ref$fromLabel = _ref.fromLabel,
      fromLabel = _ref$fromLabel === void 0 ? 'Start date' : _ref$fromLabel,
      providedOnFromChange = _ref.onFromChange,
      to = _ref.to,
      id = _ref.id,
      _ref$toLabel = _ref.toLabel,
      toLabel = _ref$toLabel === void 0 ? 'End date' : _ref$toLabel,
      providedOnToChange = _ref.onToChange,
      dayOnly = _ref.dayOnly,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? DATE_RANGE_OPTIONS_WITHOUT_ANY : _ref$options,
      _ref$wrapperClass = _ref.wrapperClass,
      wrapperClass = _ref$wrapperClass === void 0 ? 'pu-flex pu-flex-col pu-max-w-6xl pu-mx-auto' : _ref$wrapperClass,
      _inModal = _ref._inModal;
  var onFromChange = useStableCallback(providedOnFromChange);
  var onToChange = useStableCallback(providedOnToChange);
  var displayedTo = useMemo(function () {
    return getDisplayedTo(to, dayOnly);
  }, [to, dayOnly]);
  var handleDayClick = useStableCallback(function (day) {
    var newResult = DateUtils.addDayToRange(day, {
      from: from,
      to: displayedTo
    });

    if (isDifferentDay(from, newResult.from)) {
      onFromChange(newResult.from ? from ? setDate(from, extractDayInfo(newResult.from)) : setDate(newResult.from, {
        hours: 0,
        minutes: 0
      }) : undefined);
    }

    if (isDifferentDay(displayedTo, newResult.to)) {
      onToChange(getActualToFromDisplayedValue(newResult.to ? displayedTo ? setDate(displayedTo, extractDayInfo(newResult.to)) : setDate(newResult.to, {
        hours: 0,
        minutes: 0
      }) : undefined, dayOnly));
    }
  });
  var selectedDays = from ? [from, {
    from: from,
    to: displayedTo
  }] : undefined;
  return createElement("div", {
    className: wrapperClass,
    id: id
  }, createElement("div", {
    className: cx('pu-pb-5 pu-px-4 lg:pu-px-7 pu-space-y-3 sm:pu-flex sm:pu-items-center sm:pu-space-x-2 sm:pu-space-y-0 pu-border-b pu-border-gray-200', _inModal && 'pu-pr-16')
  }, createElement(DateDisplayWrapper, null, createElement(DateDisplay, {
    value: from ? formatDate(from, {
      formatType: 'dateOnly'
    }) : '',
    placeholder: fromLabel,
    fullWidth: dayOnly
  }), !dayOnly && createElement(TimeInput, {
    hours: from ? from.getHours() : 0,
    minutes: from ? from.getMinutes() : 0,
    disabled: !from,
    wrapperClass: "pu-w-full sm:pu-w-auto",
    className: "pu-w-full sm:pu-w-28",
    onChangeValue: function onChangeValue(timeValue) {
      if (from) {
        var newFrom = setDate(from, timeValue);
        onFromChange(newFrom);

        if (to && isAfter(newFrom, to)) {
          onToChange(setDate(to, timeValue));
        }
      }
    }
  })), createElement("span", {
    className: "pu-block pu-text-center sm:pu-inline"
  }, "\u2014"), createElement(DateDisplayWrapper, null, createElement(DateDisplay, {
    value: displayedTo ? formatDate(displayedTo, {
      formatType: 'dateOnly'
    }) : '',
    placeholder: toLabel,
    fullWidth: dayOnly
  }), !dayOnly && createElement(TimeInput, {
    hours: displayedTo ? displayedTo.getHours() : 0,
    minutes: displayedTo ? displayedTo.getMinutes() : 0,
    disabled: !displayedTo,
    wrapperClass: "pu-w-full sm:pu-w-auto",
    className: "pu-w-full sm:pu-w-28",
    onChangeValue: function onChangeValue(timeValue) {
      if (displayedTo) {
        onToChange(addMinutes(setDate(displayedTo, timeValue), 1));
      }
    }
  }))), createElement("div", {
    className: "sm:pu-flex"
  }, createElement("div", {
    className: "pu-hidden sm:pu-block pu-px-4 lg:pu-px-7 pu-py-4 pu-border-r pu-border-gray-200"
  }, options.map(function (option, index) {
    return createElement("div", {
      key: index
    }, createElement("button", {
      onClick: function onClick() {
        var _option$value = option.value,
            newFrom = _option$value[0],
            newTo = _option$value[1];
        onFromChange(newFrom ? new Date(newFrom) : undefined);
        onToChange(newTo ? new Date(newTo) : undefined);
      },
      className: "pu-text-sm pu-w-full pu-p-3 pu-text-left focus-visible-ring",
      type: "button"
    }, option.label));
  })), createElement("div", {
    className: "pu-flex-1"
  }, createElement("div", {
    className: "pu-block pu-max-w-2xl pu-mx-auto pu-text-center lg:pu-hidden"
  }, createElement(DayPicker, {
    selectedDays: selectedDays,
    onChangeValue: handleDayClick,
    modifiers: {
      start: from,
      end: displayedTo
    },
    isRange: true,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate,
    toMonth: disableFuture ? DATES.today : undefined
  })), createElement(DayPicker, {
    numberOfMonths: 2,
    selectedDays: selectedDays,
    onChangeValue: handleDayClick,
    className: "pu-hidden lg:pu-block",
    modifiers: {
      start: from,
      end: displayedTo
    },
    isRange: true,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate,
    toMonth: disableFuture ? DATES.today : undefined,
    ref: forwardedRef
  }))));
});

var DateDisplayWrapper = function DateDisplayWrapper(props) {
  return createElement("section", {
    className: "pu-flex pu-justify-center"
  }, createElement("div", {
    className: "pu-space-y-2 md:pu-flex md:pu-space-x-2 md:pu-space-y-0 pu-w-full"
  }, props.children));
};

var DateDisplay = function DateDisplay(props) {
  return createElement("div", {
    className: cx('pu-relative', props.fullWidth ? 'pu-w-full' : 'lg:pu-w-36')
  }, createElement("div", {
    className: "pu-absolute pu-inset-y-0 pu-left-0 pu-px-1.5 pu-my-1 pu-ml-1 pu-rounded-full pu-flex pu-items-center pu-pointer-events-none",
    "aria-hidden": true
  }, createElement(CalendarIcon, {
    className: "pu-w-4 pu-h-4 pu-text-gray-400"
  })), createElement(TextInput, {
    value: props.value,
    placeholder: props.placeholder,
    className: "pu-w-full pu-pl-9 pu-bg-white focus:pu-shadow-none focus:pu-border-gray-300",
    readOnly: true,
    tabIndex: -1
  }));
};

function extractDayInfo(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    date: date.getDate()
  };
}

function isDifferentDay(date1, date2) {
  if (!date1) {
    return date2 ? true : false;
  }

  if (!date2) {
    return true;
  }

  return !DateUtils.isSameDay(date1, date2);
}

var DateRangeModal = function DateRangeModal(props) {
  var _useDescendantsInit = useDescendantsInit(),
      selects = _useDescendantsInit[0],
      setSelects = _useDescendantsInit[1];

  return createElement(DialogOverlay, {
    isOpen: props.isOpen,
    onDismiss: props.onDismiss,
    dangerouslyBypassFocusLock: selects.length > 0
  }, createElement(DialogContent$1, {
    "aria-label": "Select Start and End Date",
    className: "pu-max-w-4xl pu-mx-auto pu-bg-white pu-rounded-lg pu-overflow-hidden pu-relative",
    "data-setel-modal-content": true
  }, createElement("div", {
    className: "pu-absolute pu-top-0 pu-right-0 pu-pt-5 pu-pr-4 sm:pu-pr-7"
  }, createElement(IconButton, {
    onClick: props.onDismiss,
    "aria-label": "Close"
  }, createElement(CrossIcon, {
    className: "pu-w-6 pu-h-6 pu-text-lightgrey"
  }))), createElement(DescendantProvider, {
    context: ModalSelectDescentdantContext,
    items: selects,
    set: setSelects
  }, props.isOpen && createElement(DateRangeModalContent, Object.assign({}, props)))));
};
var modalContextValue = {
  size: 'standard'
};

var DateRangeModalContent = function DateRangeModalContent(props) {
  var _React$useState = useState(function () {
    return props.initialFrom;
  }),
      from = _React$useState[0],
      setFrom = _React$useState[1];

  var _React$useState2 = useState(function () {
    return props.initialTo;
  }),
      to = _React$useState2[0],
      setTo = _React$useState2[1];

  var dayDifference = useMemo(function () {
    return from && to && dayDiff(addMs(to, 1), from);
  }, [from, to]);
  return createElement("form", {
    onSubmit: function onSubmit(ev) {
      ev.preventDefault();

      if (from && to) {
        props.onApply(from, to);
      }
    }
  }, createElement(ModalContext.Provider, {
    value: modalContextValue
  }, createElement("div", {
    className: "pu-pt-7"
  }, createElement(DateRangePicker, {
    from: from,
    onFromChange: setFrom,
    to: to,
    onToChange: setTo,
    dayOnly: props.dayOnly,
    disableFuture: props.disableFuture,
    minDate: props.minDate,
    maxDate: props.maxDate,
    options: props.options,
    _inModal: true
  }))), createElement(ModalFooter, {
    className: "pu-flex pu-justify-between pu-items-center"
  }, createElement("div", {
    className: "pu-text-sm"
  }, isDefined(dayDifference) && dayDifference + " day" + (dayDifference > 1 ? 's' : '')), createElement("div", {
    className: "pu-space-x-2"
  }, createElement(Button, {
    onClick: props.onDismiss,
    variant: "outline"
  }, "CANCEL"), createElement(Button, {
    type: "submit",
    variant: "primary",
    disabled: !from || !to
  }, "APPLY"))));
};

var _excluded$o = ["from", "onFromChange", "to", "onToChange", "value", "onChangeValue", "dayOnly", "customRangeFormatType", "disableFuture", "minDate", "maxDate", "wrapperClass", "status", "label", "layout", "forceShrink", "helpText", "extendedOptions", "options", "_cacheKey"];
/**
 * `<DateRangeDropdown />` allows user to select a date range from a dropdown or select a custom range.
 *
 */

var DateRangeDropdown = function DateRangeDropdown(_ref) {
  var _ref$from = _ref.from,
      providedFrom = _ref$from === void 0 ? '' : _ref$from,
      _ref$onFromChange = _ref.onFromChange,
      onFromChange = _ref$onFromChange === void 0 ? noop : _ref$onFromChange,
      _ref$to = _ref.to,
      providedTo = _ref$to === void 0 ? '' : _ref$to,
      _ref$onToChange = _ref.onToChange,
      onToChange = _ref$onToChange === void 0 ? noop : _ref$onToChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [providedFrom, providedTo] : _ref$value,
      _ref$onChangeValue = _ref.onChangeValue,
      _onChangeValue = _ref$onChangeValue === void 0 ? noop : _ref$onChangeValue,
      dayOnly = _ref.dayOnly,
      customRangeFormatType = _ref.customRangeFormatType,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      wrapperClass = _ref.wrapperClass,
      status = _ref.status,
      label = _ref.label,
      layout = _ref.layout,
      forceShrink = _ref.forceShrink,
      helpText = _ref.helpText,
      extendedOptions = _ref.extendedOptions,
      _ref$options = _ref.options,
      providedOptions = _ref$options === void 0 ? extendedOptions ? DATE_RANGE_OPTIONS_EXTENDED : DATE_RANGE_DROPDOWN_DEFAULT_OPTIONS : _ref$options,
      selectProps = _objectWithoutPropertiesLoose(_ref, _excluded$o);

  var from = value[0];
  var to = value[1];

  var _React$useState = useState(false),
      showDialog = _React$useState[0],
      setShowDialog = _React$useState[1];

  var options = useMemo(function () {
    return normalizeDateRangeOptions(providedOptions);
  }, [providedOptions]);
  var selectedOption = options.find(function (option) {
    return option.value[0] === from && option.value[1] === to;
  });
  var isCustomRange = !selectedOption;
  var fromDate = useMemo(function () {
    return from ? new Date(from) : undefined;
  }, [from]);
  var toDate = useMemo(function () {
    return to ? new Date(to) : undefined;
  }, [to]);
  var displayedTo = useMemo(function () {
    return getDisplayedTo(toDate, dayOnly);
  }, [toDate, dayOnly]);
  var customRangeLabel = useMemo(function () {
    if (!isCustomRange || !from || !displayedTo) {
      return '';
    }

    if (customRangeFormatType) {
      return formatDate(from, {
        formatType: customRangeFormatType
      }) + " - " + formatDate(displayedTo, {
        formatType: customRangeFormatType
      });
    }

    return formatDateRange(new Date(from), displayedTo, dayOnly);
  }, [from, displayedTo, customRangeFormatType, dayOnly, isCustomRange]);
  var dateOptions = useMemo(function () {
    return options.concat({
      label: 'Custom range',
      value: CUSTOM_RANGE
    });
  }, [isCustomRange, options]);
  var optionsWithValue = useMemo(function () {
    return options.filter(function (opt) {
      return opt.value[0] !== '' && opt.value[1] !== '';
    });
  }, [options]);
  return createElement(Fragment, null, createElement(FieldContainer, {
    className: wrapperClass,
    label: label,
    status: status,
    layout: layout,
    helpText: helpText,
    forceShrink: forceShrink
  }, createElement(DropdownSelect, Object.assign({
    value: selectedOption ? selectedOption.value : undefined,
    options: dateOptions,
    onChangeValue: function onChangeValue(newValue, newOptionLabel) {
      if (newValue === CUSTOM_RANGE) {
        setShowDialog(true);
      } else {
        onFromChange(newValue[0], newOptionLabel);
        onToChange(newValue[1], '');

        _onChangeValue(newValue, newOptionLabel);
      }
    }
  }, selectProps, {
    placeholder: customRangeLabel || selectProps.placeholder
  }))), createElement(DateRangeModal, {
    isOpen: showDialog,
    onDismiss: function onDismiss() {
      return setShowDialog(false);
    },
    options: optionsWithValue,
    onApply: function onApply(from, to) {
      var displayedTo = getDisplayedTo(to, dayOnly);
      var newOptionLabel = customRangeFormatType ? formatDate(from, {
        formatType: customRangeFormatType
      }) + " - " + formatDate(to, {
        formatType: customRangeFormatType
      }) : formatDateRange(from, displayedTo, dayOnly);
      var newFrom = formatDateUtc(from);
      var newTo = formatDateUtc(to);
      onFromChange(newFrom, newOptionLabel);
      onToChange(newTo, '');

      _onChangeValue([newFrom, newTo], newOptionLabel);

      setShowDialog(false);
    },
    dayOnly: dayOnly,
    disableFuture: disableFuture,
    initialFrom: fromDate,
    initialTo: toDate,
    minDate: minDate,
    maxDate: maxDate
  }));
};
var CUSTOM_RANGE = ['__REACT_SETEL_CUSTOM_RANGE__', ''];

var _excluded$p = ["wrapperClass"];
var groupProps = function groupProps(props) {
  var _pickAndOmit = pickAndOmit(props, fieldKeys),
      _pickAndOmit$picked = _pickAndOmit.picked,
      wrapperClass = _pickAndOmit$picked.wrapperClass,
      fieldProps = _objectWithoutPropertiesLoose(_pickAndOmit$picked, _excluded$p),
      omitted = _pickAndOmit.omitted;

  return {
    fieldProps: _extends({}, fieldProps, {
      className: wrapperClass
    }),
    controlProps: omitted
  };
};
var fieldKeys = ['status', 'helpText', 'label', 'layout', 'labelAlign', 'wrapperClass', 'forceShrink'];

var _excluded$q = ["type", "variant", "className", "size"];
/**
 * `<InputButton />` is a button disguised as input. LOL.
 */

var InputButton = /*#__PURE__*/forwardRef(function InputButton(_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'input' : _ref$variant,
      className = _ref.className,
      size = _ref.size,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$q);

  return createElement("button", Object.assign({
    type: type
  }, buttonProps, {
    className: cx(variant === 'input' ? 'form-input' : 'form-select', 'pu-flex pu-items-center pu-min-w-0', size === 'compact' && 'pu-h-9 pu-py-0', !hasUtilClass(className, 'pu-w-') && 'pu-w-40', buttonProps.disabled ? 'pu-bg-gray-200 pu-text-lightgrey pu-cursor-default' : ['pu-bg-transparent', !hasUtilClass('active:pu-') && 'active:pu-shadow-outline'], className),
    ref: ref
  }));
});

var DayPickerPopover = /*#__PURE__*/forwardRef(function DayPickerPopover(props, ref) {
  return createElement(Popover, {
    targetRef: props.targetRef,
    ref: ref,
    isOpen: props.isOpen,
    className: "pu-mt-0.5"
  }, props.isOpen && createElement("div", {
    className: cx('pu-rounded-md pu-shadow-xs'),
    onKeyDown: function onKeyDown(ev) {
      if (ev.key === 'Escape') {
        props.onDismiss();
      }
    }
  }, createElement(DayPicker, {
    selectedDays: props.value === null ? undefined : props.value,
    onChangeValue: function onChangeValue(newDate) {
      props.onChangeValue(newDate, newDate ? formatDate(newDate, {
        formatType: 'dateOnly'
      }) : '');
      props.onDismiss();
    },
    disableFuture: props.disableFuture,
    minDate: props.minDate,
    maxDate: props.maxDate,
    showMonthYearDropdown: props.showMonthYearDropdown
  })));
});

var _excluded$r = ["value", "onChangeValue", "disableFuture", "disabled", "minDate", "maxDate", "emptyValue", "onPopoverClose", "showMonthYearDropdown", "className"];
/**
 * A button that allows you to select date from a popover.
 *
 * Unlisted props will be spreaded to the underlying button element
 */

var DaySelector = function DaySelector(_ref) {
  var value = _ref.value,
      onChangeValue = _ref.onChangeValue,
      disableFuture = _ref.disableFuture,
      disabled = _ref.disabled,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      _ref$emptyValue = _ref.emptyValue,
      emptyValue = _ref$emptyValue === void 0 ? 'Select date' : _ref$emptyValue,
      onPopoverClose = _ref.onPopoverClose,
      showMonthYearDropdown = _ref.showMonthYearDropdown,
      className = _ref.className,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$r);

  var _React$useState = useState(false),
      calendarShown = _React$useState[0],
      setCalendarShown = _React$useState[1];

  var buttonRef = useRef(null);
  var popoverRef = useRef(null);
  var fieldState = useFieldControlContext(buttonProps.id);
  var displayValue = useMemo(function () {
    return value instanceof Date ? formatDate(value, {
      formatType: 'dateOnly'
    }) : '';
  }, [value]);

  var dismissPopover = function dismissPopover() {
    setCalendarShown(false);

    if (buttonRef.current) {
      buttonRef.current.focus();
    }

    if (onPopoverClose) {
      onPopoverClose();
    }
  };

  var onPopoverCloseCb = useStableCallback(onPopoverClose);
  var prevCalendarShown = usePrevious(calendarShown);
  useEffect(function () {
    if (calendarShown) {
      var listenClickOutside = function listenClickOutside(event) {
        if (popoverRef.current && event.target) {
          var isInPopover = popoverRef.current.contains(event.target);
          var isInButton = buttonRef.current && buttonRef.current.contains(event.target);

          if (!isInPopover && !isInButton) {
            setCalendarShown(false);
          }
        }
      };

      if (popoverRef.current) {
        focusFirstTabbable(popoverRef.current);
      }

      window.addEventListener('mousedown', listenClickOutside);
      return function () {
        return window.removeEventListener('mousedown', listenClickOutside);
      };
    }
  }, [prevCalendarShown, calendarShown, onPopoverCloseCb]);
  return createElement(Fragment, null, createElement(InputButton, Object.assign({
    disabled: disabled
  }, buttonProps, {
    ref: buttonRef,
    className: cx(fieldState.status && borderByStatus[fieldState.status], className),
    onClick: callAll(buttonProps.onClick, function () {
      return setCalendarShown(!calendarShown);
    }),
    id: fieldState.inputId
  }), createElement(CalendarIcon, {
    className: "pu-w-4 pu-h-4 pu-mr-3 pu-text-gray-400 "
  }), createElement("span", {
    className: "pu-h-5"
  }, displayValue || createElement("span", {
    className: "pu-text-gray-400"
  }, emptyValue))), createElement(DayPickerPopover, {
    targetRef: buttonRef,
    ref: popoverRef,
    isOpen: calendarShown,
    onDismiss: dismissPopover,
    value: value,
    onChangeValue: onChangeValue,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate,
    showMonthYearDropdown: showMonthYearDropdown
  }));
};

var _excluded$s = ["_cacheKey"];
/**
 * `<DayField />` is just a composition of `FieldContainer` and `DaySelector`.
 *
 * Props not specified will be spreaded to `DaySelector` element.
 *
 * If you need more control, compose them yourself.
 */

var DayField = function DayField(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$s);

  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(DaySelector, Object.assign({}, controlProps)));
};

var _excluded$t = ["status", "isTextarea"],
    _excluded2$2 = ["size", "isTextarea", "weight"];
var MultiInputImp = /*#__PURE__*/forwardRef(function MultiInputImp(props, ref) {
  return createElement("input", Object.assign({}, props, {
    className: cx('pu-flex-1 pu-my-2 pu-min-w-24 focus:pu-outline-none', props.className),
    ref: ref
  }));
});
var MultiInputImplWrapper = /*#__PURE__*/forwardRef(function MultiInputImplWrapper(_ref, ref) {
  var status = _ref.status,
      isTextarea = _ref.isTextarea,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  return createElement("div", Object.assign({}, props, {
    className: cx('pu-flex pu-items-start pu-content-start pu-flex-wrap form-input pu-cursor-text pu-overflow-x-auto pu-py-0.25', isTextarea && 'pu-min-h-24 pu-resize-y pu-overflow-y-auto', status && borderByStatus[status], !hasUtilClass(props.className, 'focus-within:pu-') && 'focus-within:pu-ring-1 focus-within:pu-ring-brand-500 focus-within:pu-ring-opacity-50 focus-within:pu-border-brand-200', props.className),
    ref: ref
  }));
});
var MultiInputBadge = /*#__PURE__*/forwardRef(function MultiInputBadge(_ref2, ref) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'large' : _ref2$size,
      isTextarea = _ref2.isTextarea,
      _ref2$weight = _ref2.weight,
      weight = _ref2$weight === void 0 ? 'normal' : _ref2$weight,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);

  return createElement(Badge, Object.assign({}, props, {
    weight: weight,
    size: size,
    className: cx('pu-select-none pu-cursor-default pu-my-1', isTextarea ? 'pu-mr-2' : 'pu-mr-1', props.className),
    rounded: "full",
    compact: true,
    ref: ref
  }));
});

var _excluded$u = ["values", "onChangeValues", "badgeColor", "id", "className", "options", "allowSelectAll", "selectAllLabel", "onInputValueChange", "onFocus", "placeholder", "showSelected", "noResultText", "_cacheKey"];
/**
 * DropdownMultiSelect allows you to select multiple values from
 * a dropdown options.
 */

var DropdownMultiSelect = function DropdownMultiSelect(_ref) {
  var values = _ref.values,
      onChangeValues = _ref.onChangeValues,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'grey' : _ref$badgeColor,
      id = _ref.id,
      className = _ref.className,
      options = _ref.options,
      allowSelectAll = _ref.allowSelectAll,
      _ref$selectAllLabel = _ref.selectAllLabel,
      selectAllLabel = _ref$selectAllLabel === void 0 ? 'Select all' : _ref$selectAllLabel,
      onInputValueChange = _ref.onInputValueChange,
      onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      _ref$showSelected = _ref.showSelected,
      showSelected = _ref$showSelected === void 0 ? true : _ref$showSelected,
      _ref$noResultText = _ref.noResultText,
      noResultText = _ref$noResultText === void 0 ? 'No results found.' : _ref$noResultText,
      _ref$_cacheKey = _ref._cacheKey,
      _cacheKey = _ref$_cacheKey === void 0 ? id : _ref$_cacheKey,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$u);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var _useOptionCache = useOptionCache({
    queryKey: _cacheKey || inputId
  }),
      cachedSelectedItems = _useOptionCache.data,
      addItemsToCache = _useOptionCache.addData;

  var _React$useState = useState(''),
      textInputValue = _React$useState[0],
      setTextInputValue = _React$useState[1];

  var trimmedInput = textInputValue.trim();

  var onInputChange = function onInputChange(value) {
    setTextInputValue(value);

    if (onInputValueChange) {
      onInputValueChange(value.trim());
    }
  };

  var validCachedItems = cachedSelectedItems.filter(function (item) {
    return values.includes(item.value);
  });
  var optionData = useMemo(function () {
    var removedOptions = validCachedItems.filter(function (item) {
      return !options || options.every(function (option) {
        if (option.type === 'group') {
          return option.options.every(function (opt) {
            return opt.value !== item.value;
          });
        } else {
          return option.value !== item.value;
        }
      });
    });

    var additionalFilter = function additionalFilter(opt) {
      return !values.includes(opt.value);
    };

    if (!options) {
      return removedOptions.length > 0 ? sortOptions(removedOptions, trimmedInput, false, additionalFilter) : undefined;
    }

    var sorted = sortOptions(options.concat(removedOptions), trimmedInput, allowSelectAll, additionalFilter);
    return sorted;
  }, [options, trimmedInput, allowSelectAll, validCachedItems, values]);
  var selectedItems = useMemo(function () {
    return optionData ? values.map(function (v) {
      return optionData.allItems.find(function (opt) {
        return opt.value === v;
      });
    }).filter(isDefined) : [];
  }, [values, optionData]);

  var _useMultipleSelection = useMultipleSelection({
    selectedItems: selectedItems,
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    onSelectedItemsChange: function onSelectedItemsChange(_ref2) {
      var selectedItems = _ref2.selectedItems;

      if (selectedItems) {
        var items = selectedItems;
        addItemsToCache(items);
        onChangeValues(items.map(function (i) {
          return i.value;
        }), items.map(function (i) {
          return i.label;
        }).join(', '));
      }
    }
  }),
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem,
      setSelectedItems = _useMultipleSelection.setSelectedItems;

  var _useCombobox = useCombobox({
    inputValue: textInputValue,
    selectedItem: null,
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    items: optionData ? optionData.items : [],
    inputId: inputId,
    stateReducer: function stateReducer(state, _ref3) {
      var type = _ref3.type,
          changes = _ref3.changes;

      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.ItemClick) {
        var nextHighlightedIndex = optionData && optionData.items.length === state.highlightedIndex + 1 ? state.highlightedIndex - 1 : state.highlightedIndex;
        return _extends({}, changes, {
          isOpen: state.isOpen,
          highlightedIndex: nextHighlightedIndex
        });
      }

      return changes;
    },
    onStateChange: function onStateChange(_ref4) {
      var inputValue = _ref4.inputValue,
          type = _ref4.type,
          selectedItem = _ref4.selectedItem;

      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          onInputChange(inputValue || '');
          break;

        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            onInputChange('');

            if (selectedItem.value === SELECT_ALL) {
              if (optionData) {
                var result = selectedItems.slice();
                optionData.items.forEach(function (item) {
                  if (item.value !== SELECT_ALL && !result.includes(item)) {
                    result.push(item);
                  }
                });
                setSelectedItems(result);
              }
            } else {
              addSelectedItem(selectedItem);
            }
          }

          break;
      }
    }
  }),
      isOpen = _useCombobox.isOpen,
      getInputProps = _useCombobox.getInputProps,
      getItemProps = _useCombobox.getItemProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getMenuProps = _useCombobox.getMenuProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      openMenu = _useCombobox.openMenu;

  var divRef = useRef(null);
  return createElement(Fragment, null, createElement(MultiInputImplWrapper, Object.assign({
    status: status,
    isTextarea: false
  }, getComboboxProps({
    className: className,
    ref: divRef
  })), showSelected && selectedItems.map(function (selectedItem, index) {
    return createElement(MultiInputBadge, Object.assign({
      key: "selectedItem-" + index,
      onDismiss: function onDismiss(ev) {
        ev.stopPropagation();
        removeSelectedItem(selectedItem);

        if (!isOpen) {
          openMenu();
        }
      }
    }, getSelectedItemProps({
      selectedItem: selectedItem,
      index: index,
      color: badgeColor
    })), selectedItem.label);
  }), createElement(MultiInputImp, Object.assign({}, getInputProps(getDropdownProps(_extends({
    onFocus: callAll(onFocus, function () {
      if (!isOpen) {
        openMenu();
      }
    }),
    placeholder: selectedItems.length === 0 ? placeholder : undefined
  }, inputProps)))))), createElement(Popover, {
    targetRef: divRef,
    position: positionMatchWidth,
    isOpen: isOpen,
    className: "pu-mt-1"
  }, createElement("div", Object.assign({}, getMenuProps({
    className: 'portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-52 pu-overflow-auto'
  }, {
    suppressRefError: true
  })), isOpen && (optionData && options ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, noResultText) : optionData.displayedItems.map(function (group, gIndex) {
    return createElement(Fragment, {
      key: gIndex
    }, group.groupLabel && createElement(OptGroupLabel, null, group.groupLabel), group.options.map(function (option) {
      if (option.value === SELECT_ALL) {
        return createElement(Option, Object.assign({
          key: option.value + "-" + option.index
        }, getItemProps({
          item: option,
          index: option.index,
          disabled: option.disabled
        }), {
          highlighted: option.index === highlightedIndex,
          label: selectAllLabel,
          className: "pu-border-b pu-border-offwhite"
        }));
      }

      return createElement(Option, Object.assign({
        key: option.value + "-" + option.index
      }, getItemProps({
        item: option,
        index: option.index,
        disabled: option.disabled
      }), {
        leftIcon: option.icon,
        highlighted: option.index === highlightedIndex,
        label: createElement(TextHighlight, {
          textToHighlight: option.label,
          searchWords: [trimmedInput]
        }),
        description: option.description && createElement(TextHighlight, {
          textToHighlight: option.description,
          searchWords: [trimmedInput]
        })
      }));
    }));
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }))))));
};

/**
 * `<DropdownSelectField />` is just a composition of `FieldContainer`, and `DropdownSelect`.
 *
 * Props not specified will be spreaded to `DropdownSelect` element.
 *
 * If you need more control, compose them yourself.
 */

var DropdownMultiSelectField = function DropdownMultiSelectField(props) {
  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(DropdownMultiSelect, Object.assign({}, controlProps)));
};

var Connectors = /*#__PURE__*/memo(function Connectors(_ref) {
  var nullableDescendants = _ref.descendants,
      className = _ref.className,
      anchor = _ref.anchor,
      _ref$padTop = _ref.padTop,
      padTop = _ref$padTop === void 0 ? 0 : _ref$padTop;
  var descendants = nullableDescendants.filter(function (x) {
    return !isNil(x.element);
  });

  if (descendants.length === 0) {
    return null;
  }

  var anchorRect = anchor.current && anchor.current.getBoundingClientRect();

  if (!anchorRect) {
    return null;
  }

  var kids = descendants.map(function (kid) {
    return kid.element.getBoundingClientRect();
  });
  var lastChild = kids[kids.length - 1];
  var bottom = lastChild.top + lastChild.height / 2;
  var anchorBottom = anchorRect.bottom;
  var height = bottom - anchorBottom;
  return createElement("svg", {
    className: className,
    height: height + padBottom,
    viewBox: "0 0 32 " + (height + padBottom),
    style: {
      top: anchorRect.height + padTop
    }
  }, kids.map(function (rec, i) {
    if (rec === lastChild) {
      return null;
    }

    var y = rec.top + rec.height / 2 - anchorBottom;
    return createElement("line", {
      x1: "16",
      y1: y,
      x2: "24",
      y2: y,
      fill: "none",
      strokeWidth: "1",
      stroke: "currentColor",
      key: i
    });
  }), createElement("polyline", {
    points: "16,0 16," + height + " 24," + height,
    fill: "none",
    strokeWidth: "1",
    stroke: "currentColor"
  }));
});
var padBottom = 8;

var _excluded$v = ["values", "onChangeValues", "badgeColor", "id", "className", "options", "size", "multiple", "noResultText"];
/**
 * DropdownNestedSelect allows you to select values from
 * a dropdown options with hierarchical relationship.
 */

var DropdownNestedSelect = function DropdownNestedSelect(_ref) {
  var values = _ref.values,
      onChangeValues = _ref.onChangeValues,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'grey' : _ref$badgeColor,
      id = _ref.id,
      className = _ref.className,
      options = _ref.options,
      size = _ref.size,
      multiple = _ref.multiple,
      _ref$noResultText = _ref.noResultText,
      noResultText = _ref$noResultText === void 0 ? 'No results found.' : _ref$noResultText,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$v);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var _React$useReducer = useReducer(nestedOptionReducer, {
    expandedKeys: []
  }),
      nestedState = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var optionData = useMemo(function () {
    return mapNestedOptions(options, values, nestedState);
  }, [options, nestedState, values]);
  var selectedItems = useMemo(function () {
    return optionData ? values.map(function (v) {
      return optionData.allItems.find(function (opt) {
        return opt.value === v;
      });
    }).filter(isDefined) : [];
  }, [values, optionData]);

  var _useMultipleSelection = useMultipleSelection({
    selectedItems: selectedItems,
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    onSelectedItemsChange: function onSelectedItemsChange(_ref2) {
      var selectedItems = _ref2.selectedItems;

      if (selectedItems) {
        var items = selectedItems;
        onChangeValues(items.map(function (i) {
          return i.value;
        }), items.map(function (i) {
          return i.label;
        }).join(', '));
      }
    }
  }),
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      setSelectedItems = _useMultipleSelection.setSelectedItems,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem;

  var _useSelect = useSelect({
    selectedItem: null,
    toggleButtonId: inputId,
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    items: optionData ? optionData.items : [],
    stateReducer: function stateReducer(state, _ref3) {
      var type = _ref3.type,
          changes = _ref3.changes;

      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          return multiple ? _extends({}, changes, {
            isOpen: state.isOpen,
            highlightedIndex: state.highlightedIndex
          }) : changes;
      }

      return changes;
    },
    onStateChange: function onStateChange(_ref4) {
      var type = _ref4.type,
          selectedItem = _ref4.selectedItem;

      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          if (selectedItem) {
            setSelectedItems(multiple ? deriveNextValues(selectedItem, selectedItems) : [selectedItem]);
          }

          break;
      }
    }
  }),
      isOpen = _useSelect.isOpen,
      getItemProps = _useSelect.getItemProps,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      setHighlightedIndex = _useSelect.setHighlightedIndex,
      openMenu = _useSelect.openMenu;

  var divRef = useRef(null); // when multiple

  var toggleBtnRef = useRef(null); // when not multiple

  return createElement(Fragment, null, multiple ? createElement(MultiInputImplWrapper, {
    status: status,
    isTextarea: false,
    className: cx(isOpen && 'pu-ring-1 pu-ring-brand-500 pu-ring-opacity-50 pu-border-brand-200', className),
    ref: divRef
  }, selectedItems.map(function (selectedItem, index) {
    return createElement(MultiInputBadge, Object.assign({
      key: "selectedItem-" + index,
      onDismiss: function onDismiss(ev) {
        ev.stopPropagation();
        removeSelectedItem(selectedItem);

        if (!isOpen) {
          openMenu();
        }
      }
    }, getSelectedItemProps({
      selectedItem: selectedItem,
      index: index,
      color: badgeColor
    })), selectedItem.label);
  }), createElement(InputButton, Object.assign({}, getToggleButtonProps(getDropdownProps(_extends({
    className: 'pu-flex-1 pu-border-none active:pu-outline-none focus:pu-ring-0 pu-w-full pu-h-8 pu-my-0.5'
  }, buttonProps))), {
    size: size
  }))) : createElement("button", Object.assign({}, getToggleButtonProps(getDropdownProps(_extends({
    type: 'button'
  }, buttonProps, {
    className: cx('form-select pu-block pu-text-left pu-transition pu-ease-in-out pu-duration-150', status && borderByStatus[status], buttonProps.disabled && 'pu-bg-gray-200 pu-cursor-default', isOpen && 'pu-ring-1 pu-ring-brand-500 pu-ring-opacity-50 pu-border-brand-200', !hasUtilClass(className, 'pu-w-') && 'pu-w-full', !hasUtilClass(className, 'focus:pu-') && 'focus-visible-ring', className),
    ref: toggleBtnRef
  })))), createElement("span", {
    className: "pu-block pu-truncate"
  }, selectedItems.length > 0 ? selectedItems[0].label : createElement("div", {
    className: "pu-w-full pu-h-5"
  }))), createElement(Popover, {
    targetRef: multiple ? divRef : toggleBtnRef,
    position: positionMatchWidth,
    isOpen: isOpen,
    className: "pu-mt-1"
  }, createElement("div", Object.assign({}, getMenuProps({
    className: 'portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-52 pu-overflow-auto focus:pu-outline-none',
    onKeyDown: function onKeyDown(ev) {
      var highlightedItem = optionData.items[highlightedIndex];

      if (highlightedItem) {
        var key = normalizeArrowKey(ev);

        if (key === 'ArrowLeft') {
          if (isDefined(highlightedItem.isExpanded) && highlightedItem.isExpanded) {
            dispatch({
              type: 'collapse',
              keys: getPathToOption(highlightedItem)
            });
          } else if (highlightedItem.parent) {
            setHighlightedIndex(highlightedItem.parent.index);
            dispatch({
              type: 'collapse',
              keys: getPathToOption(highlightedItem.parent)
            });
          }
        } else if (key === 'ArrowRight') {
          if (isDefined(highlightedItem.isExpanded)) {
            if (highlightedItem.isExpanded) {
              if (highlightedItem.children && highlightedItem.children.length > 0) {
                setHighlightedIndex(highlightedItem.children[0].index);
              }
            } else {
              dispatch({
                type: 'expand',
                keys: getPathToOption(highlightedItem)
              });
            }
          }
        }
      }
    }
  }, {
    suppressRefError: true
  })), isOpen && (optionData && options ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, noResultText) : optionData.displayedItems.map(function (option, gIndex) {
    return createElement(RecursiveOption, {
      option: option,
      key: gIndex,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      dispatch: dispatch,
      hasCheckbox: !!multiple
    });
  }) : null))));
};

function RecursiveOption(_ref5) {
  var option = _ref5.option,
      highlightedIndex = _ref5.highlightedIndex,
      getItemProps = _ref5.getItemProps,
      dispatch = _ref5.dispatch,
      hasCheckbox = _ref5.hasCheckbox;
  var currentRef = useRef(null);

  var _useDescendantsInit = useDescendantsInit(),
      kids = _useDescendantsInit[0],
      setKids = _useDescendantsInit[1];

  useDescendant({
    element: currentRef.current
  }, DescendantContext);
  var expandable = isDefined(option.isExpanded);
  var toggle = useCallback(function (expand, keys) {
    dispatch(expand ? {
      type: 'expand',
      keys: keys
    } : {
      type: 'collapse',
      keys: keys
    });
  }, [dispatch]);
  return createElement("div", {
    className: cx('pu-relative', option.parent ? option.parent.icon ? 'pu-ml-17' : 'pu-ml-6' : 'pu-border-b pu-border-gray-200')
  }, createElement("div", {
    className: "pu-flex pu-items-center"
  }, createElement(Option, Object.assign({
    highlighted: highlightedIndex === option.index,
    label: option.label,
    description: option.description,
    leftIcon: hasCheckbox ? createElement("div", {
      ref: currentRef,
      className: "flex items-center"
    }, option.checked === 'mixed' ? createElement(MinusIcon, {
      className: "pu-w-4 pu-h-4 pu-text-white pu-bg-brand-500 pu-rounded"
    }) : option.checked ? createElement(CheckIcon, {
      className: "pu-w-4 pu-h-4 pu-text-white pu-bg-brand-500 pu-rounded"
    }) : createElement("div", {
      className: "pu-w-4 pu-h-4 pu-bg-white pu-border-controlborder pu-border-2 pu-rounded"
    }), option.icon && createElement("div", {
      className: "pu-py-3 pu--mr-1 pu-pl-3"
    }, createElement("div", {
      className: "pu-w-10 pu-h-10"
    }, option.icon))) : option.icon && createElement("div", {
      className: "pu-py-3 pu--mr-1"
    }, createElement("div", {
      className: "pu-w-10 pu-h-10"
    }, option.icon))
  }, getItemProps({
    item: option,
    index: option.index,
    className: 'pu-flex-1 pu-w-0',
    ref: hasCheckbox ? undefined : currentRef
  }))), expandable && createElement(IconButton, {
    onClick: function onClick() {
      return toggle(!option.isExpanded, getPathToOption(option));
    },
    className: "pu-px-2"
  }, createElement(ExpandMoreIcon, {
    className: cx('pu-w-4 pu-h-4 pu-text-gray-400 pu-transform pu-transition-transform pu-duration-200', option.isExpanded && 'pu-rotate-180')
  }), createElement("span", {
    className: "pu-sr-only"
  }, option.isExpanded ? 'Collapse' : 'Expand'))), option.children && createElement(DescendantProvider, {
    context: DescendantContext,
    items: kids,
    set: setKids
  }, option.children.length > 0 && createElement(Fragment, null, option.children.map(function (childOption) {
    return createElement(RecursiveOption, {
      key: childOption.value + "-" + childOption.index,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      option: childOption,
      dispatch: dispatch,
      hasCheckbox: hasCheckbox
    });
  }), createElement(Connectors, {
    descendants: kids,
    className: cx('pu-absolute pu-w-8 pu-text-gray-300 pu-pointer-events-none', option.icon ? 'pu-left-13' : 'pu-left-2'),
    anchor: currentRef,
    padTop: hasCheckbox && !option.icon ? 10 : 0
  }))));
}

var DescendantContext = /*#__PURE__*/createDescendantContext('NestedSelectDescendant');

var _excluded$w = ["_cacheKey"];
/**
 * `<DropdownNestedSelectField />` is just a composition of `FieldContainer`, and `DropdownNestedSelect`.
 *
 * Props not specified will be spreaded to `DropdownNestedSelect` element.
 *
 * If you need more control, compose them yourself.
 */

var DropdownNestedSelectField = function DropdownNestedSelectField(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(DropdownNestedSelect, Object.assign({}, controlProps)));
};

var _excluded$x = ["_cacheKey"];
/**
 * `<DropdownSelectField />` is just a composition of `FieldContainer`, and `DropdownSelect`.
 *
 * Props not specified will be spreaded to `DropdownSelect` element.
 *
 * If you need more control, compose them yourself.
 */

var DropdownSelectField = function DropdownSelectField(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$x);

  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(DropdownSelect, Object.assign({}, controlProps)));
};

var _excluded$y = ["initialValues", "badgeColor", "onChangeValues", "id", "validateBeforeAdd", "includeDraft", "className", "variant", "values", "placeholder"];
/**
 * MultiInput allows user to specify multiple values in a single input.
 *
 * Input value will be added as another value when user performs any of the following actions:
 * - type comma (`,`) character
 * - press [Enter] when there is input value. When there is no input value, default input behavior will take place (e.g. submit form)
 * - press [Tab] when there is input value. When there is no input value, default behavior will take place (focus to next focusable element)
 *
 * When there are values selected:
 * - press [Backspace] will delete last item
 * - Arrow key can be used to focus previous item. When an item is focused, pressing [Delete] or [Backspace] will remove it
 */

var MultiInput = /*#__PURE__*/forwardRef(function MultiInput(_ref, forwardedRef) {
  var _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? [] : _ref$initialValues,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'grey' : _ref$badgeColor,
      _ref$onChangeValues = _ref.onChangeValues,
      onChangeValues = _ref$onChangeValues === void 0 ? noop : _ref$onChangeValues,
      id = _ref.id,
      validateBeforeAdd = _ref.validateBeforeAdd,
      includeDraft = _ref.includeDraft,
      className = _ref.className,
      variant = _ref.variant,
      providedValues = _ref.values,
      placeholder = _ref.placeholder,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$y);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var inputRef = useRef(null);
  var mergedRef = useForkedRef(inputRef, forwardedRef);

  var _React$useState = useState(''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var _React$useMemo = useMemo(function () {
    var values = [];
    var colors = [];
    providedValues.forEach(function (v, index) {
      if (includeDraft && index === providedValues.length - 1 && v === inputValue.trim()) {
        return;
      }

      if (isString(v)) {
        values.push(v);
        colors.push(badgeColor);
      } else {
        var value = v.value,
            _v$color = v.color,
            color = _v$color === void 0 ? badgeColor : _v$color;
        values.push(value);
        colors.push(color);
      }
    });
    return {
      values: values,
      colors: colors
    };
  }, [providedValues, badgeColor, includeDraft, inputValue]),
      values = _React$useMemo.values,
      colors = _React$useMemo.colors;

  var _useMultipleSelection = useMultipleSelection({
    initialSelectedItems: initialValues,
    selectedItems: values,
    onSelectedItemsChange: function onSelectedItemsChange(_ref2) {
      var selectedItems = _ref2.selectedItems;

      if (selectedItems) {
        onChangeValues(selectedItems, selectedItems.join(', '));
      }
    }
  }),
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      selectedItems = _useMultipleSelection.selectedItems;

  var removeSelectedItem = function removeSelectedItem(itemIndex) {
    var result = selectedItems.filter(function (_, index) {
      return index !== itemIndex;
    });
    onChangeValues(result, result.join(', '));
  };

  var addItem = function addItem(value) {
    var val = value.trim();

    if (val && (!validateBeforeAdd || validateBeforeAdd(val))) {
      addSelectedItem(val);
      setInputValue('');
    }
  };

  var handleInputChange = function handleInputChange(ev) {
    var value = ev.target.value;

    if (!/^,+$/.test(value) && value[value.length - 1] === ',') {
      addItem(value.slice(0, -1));
    } else {
      setInputValue(value);

      if (includeDraft) {
        var trimmedInput = value.trim();
        var result = trimmedInput ? selectedItems.concat(trimmedInput) : selectedItems;
        onChangeValues(result, result.join(', '));
      }
    }
  };

  var handleKeyDown = function handleKeyDown(ev) {
    if ((ev.key === 'Tab' || ev.key === 'Enter') && inputValue) {
      ev.preventDefault();
      addItem(inputValue);
    }
  };

  var isTextarea = variant === 'textarea';
  return createElement(MultiInputImplWrapper, {
    className: className,
    isTextarea: isTextarea,
    status: status,
    onClick: function onClick(ev) {
      if (ev.target === ev.currentTarget) {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    }
  }, selectedItems.map(function (value, index) {
    return createElement(MultiInputBadge, Object.assign({
      key: "selectedItem-" + index,
      isTextarea: isTextarea,
      color: colors ? colors[index] : badgeColor,
      onDismiss: function onDismiss() {
        return removeSelectedItem(index);
      }
    }, getSelectedItemProps({
      selectedItem: value,
      index: index
    })), value);
  }), createElement(MultiInputImp, Object.assign({}, getDropdownProps(_extends({
    id: inputId,
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    value: inputValue,
    placeholder: selectedItems.length === 0 ? placeholder : undefined
  }, inputProps, {
    ref: mergedRef
  })))));
});

var _excluded$z = ["_cacheKey"];
/**
 * MultiInputField is just a composition of `FieldContainer` and `MultiInput`.
 *
 * Props not specified will be spreaded to `MultiInput` element, including `ref`.
 *
 * If you need more control, compose them yourself.
 */

var MultiInputField = /*#__PURE__*/forwardRef(function MultiInputField(_ref, ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$z);

  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(MultiInput, Object.assign({}, controlProps, {
    ref: ref
  })));
});

var _excluded$A = ["onChangeValue", "className", "wrapperClass", "value", "trimValue", "onKeyDown"];
/**
 * SearchTextInput allows you to enter some search value and applying the search key by pressing Enter or clicking the search button.
 *
 * Its use case is different from `<SearchInput />`, which will provide search result as user types.
 */

var SearchTextInput = /*#__PURE__*/forwardRef(function SearchTextInput(_ref, forwardedRef) {
  var _ref$onChangeValue = _ref.onChangeValue,
      onChangeValue = _ref$onChangeValue === void 0 ? noop : _ref$onChangeValue,
      className = _ref.className,
      wrapperClass = _ref.wrapperClass,
      parentValue = _ref.value,
      _ref$trimValue = _ref.trimValue,
      trimValue = _ref$trimValue === void 0 ? true : _ref$trimValue,
      onKeyDown = _ref.onKeyDown,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$A);

  var _React$useState = useState(parentValue || ''),
      value = _React$useState[0],
      setValue = _React$useState[1];

  var searchInputRef = useRef(null);
  var inputRef = useForkedRef(searchInputRef, forwardedRef);
  useEffect(function () {
    if (isDefined(parentValue)) {
      setValue(parentValue);
    }
  }, [parentValue]);

  var handleValueChange = function handleValueChange(newValue) {
    var finalValue = trimValue ? newValue.trim() : newValue;
    setValue(finalValue);
    onChangeValue(finalValue);
  };

  return createElement("div", {
    className: wrapperClass
  }, createElement("div", {
    className: "pu-flex"
  }, createElement("div", {
    className: "pu-flex-1 pu-relative"
  }, createElement(TextInput, Object.assign({
    value: value,
    onChangeValue: setValue,
    className: cx('pu-rounded-l-md pu-rounded-r-none', className),
    onKeyDown: callAll(function (ev) {
      if (ev.key === 'Enter' && value) {
        ev.stopPropagation();
        handleValueChange(value);
      } else if (ev.key === 'Escape' && value) {
        ev.stopPropagation();
        handleValueChange('');
      }
    }, onKeyDown)
  }, props, {
    ref: inputRef
  })), value && createElement("div", {
    className: "pu-absolute pu-right-0 pu-inset-y-0 pu-pr-1 pu-flex pu-items-center"
  }, createElement(IconButton, {
    onClick: function onClick() {
      handleValueChange('');

      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Clear"), createElement(CrossInCircleIcon, {
    className: "pu-w-5 pu-h-5 pu-text-gray-400"
  })))), createElement("button", {
    type: "button",
    onClick: function onClick() {
      return onChangeValue(value);
    },
    className: "pu-w-10 pu-flex pu-items-center pu-justify-center pu-rounded-l-none pu-rounded-r-md pu-bg-brand-500 pu-text-white hover:pu-bg-brand-800 pu-focus-visible-ring pu-transform active:pu-translate-y-px",
    disabled: props.disabled
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Search"), createElement(SearchIcon, {
    className: "pu-w-6 pu-h-6"
  }))));
});

var _excluded$B = ["_cacheKey"];
/**
 * `<SearchTextField />` is just a composition of `FieldContainer`, and `SearchTextInput`.
 *
 * Props not specified will be spreaded to `SearchTextInput` element.
 *
 * If you need more control, compose them yourself.
 */

var SearchTextField = function SearchTextField(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$B);

  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(SearchTextInput, Object.assign({}, controlProps)));
};

/**
 * `<SearchableDropdownField />` is just a composition of `FieldContainer`, and `SearchableDropdown`.
 *
 * Props not specified will be spreaded to `SearchableDropdown` element.
 *
 * If you need more control, compose them yourself.
 */

var SearchableDropdownField = function SearchableDropdownField(props) {
  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(SearchableDropdown, Object.assign({}, controlProps)));
};

var FILTER_CONTROL_MAPPING = {
  daterange: DateRangeDropdown,
  day: DayField,
  nestedselect: DropdownNestedSelectField,
  search: SearchTextField,
  select: DropdownSelectField,
  multiselect: DropdownMultiSelectField,
  multiinput: MultiInputField,
  searchableselect: SearchableDropdownField
};

var FilterComponent = function FilterComponent(props) {
  switch (props.component.type) {
    case 'daterange':
      {
        var Component = FILTER_CONTROL_MAPPING.daterange;
        return createElement(Component, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          value: props.value,
          onChangeValue: props.onChange
        }));
      }

    case 'day':
      {
        var _Component = FILTER_CONTROL_MAPPING.day;
        return createElement(_Component, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          value: props.value,
          onChangeValue: props.onChange
        }));
      }

    case 'nestedselect':
      {
        var _Component2 = FILTER_CONTROL_MAPPING.nestedselect;
        return createElement(_Component2, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          values: props.value,
          onChangeValues: props.onChange
        }));
      }

    case 'search':
      {
        var _Component3 = FILTER_CONTROL_MAPPING.search;
        return createElement(_Component3, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          value: props.value,
          onChangeValue: function onChangeValue(val) {
            return props.onChange(val, val);
          }
        }));
      }

    case 'select':
      {
        var _Component4 = FILTER_CONTROL_MAPPING.select;
        return createElement(_Component4, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          value: props.value,
          onChangeValue: props.onChange
        }));
      }

    case 'multiselect':
      {
        var _Component5 = FILTER_CONTROL_MAPPING.multiselect;
        return createElement(_Component5, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          values: props.value,
          onChangeValues: props.onChange
        }));
      }

    case 'multiinput':
      {
        var _Component6 = FILTER_CONTROL_MAPPING.multiinput;
        return createElement(_Component6, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          values: props.value,
          onChangeValues: props.onChange
        }));
      }

    case 'searchableselect':
      {
        var _Component7 = FILTER_CONTROL_MAPPING.searchableselect;
        return createElement(_Component7, Object.assign({
          layout: props.defaultLayout
        }, props.component.props, {
          value: props.value,
          onChangeValue: props.onChange
        }));
      }

    default:
      {
        if (process.env.NODE_ENV !== 'production') {
          console.error("Unsupported filter component config: " + JSON.stringify(props.component, null, 2));
        }

        return null;
      }
  }
};

var _excluded$C = ["withWrapper", "type", "heading", "pagination", "responsive", "striped", "isLoading", "isFetching", "skeletonRowNum", "sortable", "onSortEnd", "useDragHandle", "sortableClass", "native", "filter", "expandable", "defaultIsOpen", "isOpen", "onToggleOpen", "preContent"],
    _excluded2$3 = ["children", "columnName", "columnType", "onSort", "sortOrder", "isSortKey"];
/**
 * DataTable accepts all props a `div` element would accept.
 *
 * By default, `<DataTable />` and its descendants renders `<div>` because it is hard to fully comply to the html table structure (table > tbody > tr > td),
 * e.g. it is common to render a whole row as a link.
 *
 * However, you can opt out of this behavior (probably because you want native table feature like colSpan) by setting `native={true}` props.
 */

var DataTableImpl = function DataTable(_ref) {
  var _ref$withWrapper = _ref.withWrapper,
      withWrapper = _ref$withWrapper === void 0 ? true : _ref$withWrapper,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? withWrapper ? 'primary' : 'secondary' : _ref$type,
      heading = _ref.heading,
      pagination = _ref.pagination,
      responsive = _ref.responsive,
      _ref$striped = _ref.striped,
      striped = _ref$striped === void 0 ? true : _ref$striped,
      isLoading = _ref.isLoading,
      isFetching = _ref.isFetching,
      _ref$skeletonRowNum = _ref.skeletonRowNum,
      skeletonRowNum = _ref$skeletonRowNum === void 0 ? 5 : _ref$skeletonRowNum,
      sortable = _ref.sortable,
      onSortEnd = _ref.onSortEnd,
      useDragHandle = _ref.useDragHandle,
      _ref$sortableClass = _ref.sortableClass,
      sortableClass = _ref$sortableClass === void 0 ? 'pu-shadow-md' : _ref$sortableClass,
      _native = _ref["native"],
      filter = _ref.filter,
      expandable = _ref.expandable,
      defaultIsOpen = _ref.defaultIsOpen,
      isOpen = _ref.isOpen,
      onToggleOpen = _ref.onToggleOpen,
      preContent = _ref.preContent,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$C);

  var tableRef = useRef(null);

  var _useDescendantsInit = useDescendantsInit(),
      headingNodes = _useDescendantsInit[0],
      setHeadingNodes = _useDescendantsInit[1];

  var _React$useState = useState([]),
      headings = _React$useState[0],
      setHeadings = _React$useState[1];

  var _React$useState2 = useState([]),
      headingsAlign = _React$useState2[0],
      setHeadingsAlign = _React$useState2[1]; // eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(function () {
    if (tableRef.current) {
      var latestHeadings = [];
      var latestHeadingsAlign = [];
      headingNodes.forEach(function (node) {
        if (node.element) {
          latestHeadings.push(node.element.textContent);
          latestHeadingsAlign.push(getComputedStyle(node.element, 'text-align'));
        }
      });

      if (!isSimilarArray(latestHeadings, headings)) {
        setHeadings(latestHeadings);
      }

      if (!isSimilarArray(latestHeadingsAlign, headingsAlign)) {
        setHeadingsAlign(latestHeadingsAlign);
      }
    }
  });
  var hasTitle = !!heading || !!filter;
  var contextValue = useMemo(function () {
    return {
      responsive: responsive,
      hasTitle: hasTitle,
      headings: headings,
      striped: striped,
      isLoading: isLoading,
      skeletonRowNum: skeletonRowNum,
      headingsAlign: headingsAlign,
      sortable: sortable,
      onSortEnd: onSortEnd,
      useDragHandle: useDragHandle,
      sortableClass: sortableClass,
      "native": _native
    };
  }, [responsive, hasTitle, headings, striped, isLoading, skeletonRowNum, headingsAlign, sortable, onSortEnd, useDragHandle, sortableClass, _native]);
  var Component = _native ? 'table' : 'div';
  var table = createElement(DescendantProvider, {
    context: DataTableDescendantContext,
    items: headingNodes,
    set: setHeadingNodes
  }, createElement(DataTableContext.Provider, {
    value: contextValue
  }, createElement(Component, Object.assign({
    role: "grid"
  }, props, {
    className: cx('portal-ui-table pu-min-w-full pu-table', isFetching && 'pu-animate-pulse pu-opacity-75', props.className),
    ref: tableRef
  }))));
  return type === 'primary' ? createElement(Card, {
    expandable: expandable,
    defaultIsOpen: defaultIsOpen,
    isOpen: isOpen,
    onToggleOpen: onToggleOpen,
    className: "pu-align-middle"
  }, heading, createElement(CardCollapsible, null, filter && createElement(DataTableFilterComponents, {
    filter: filter
  }), preContent, createElement("div", {
    className: cx('pu-overflow-x-auto portal-ui-scrollbar', !!preContent && 'pu-border-t pu-border-gray-200')
  }, table), pagination && (isValidElement(pagination) ? cloneElement(pagination, {
    className: cx('pu-p-4 pu-border-t pu-border-lightergrey', hasTitle && 'sm:pu-px-7', pagination.props.className),
    isFetching: isFetching
  }) : pagination))) : table;
};

var DataTableFilterComponents = function DataTableFilterComponents(_ref2) {
  var _ref2$filter = _ref2.filter,
      result = _ref2$filter[0],
      actions = _ref2$filter[1],
      components = _ref2$filter[2];

  if (!Array.isArray(components) || components.length === 0) {
    return null;
  }

  var isSingleFilter = components.length === 1;
  return createElement(FilterContext.Provider, {
    value: true
  }, createElement("div", {
    className: cx('pu-grid pu-gap-5 pu-items-end pu-px-4 pu-py-5 sm:pu-px-7 pu-border-b pu-border-gray-200', isSingleFilter ? 'portal-ui-table-filter' : 'portal-ui-filter')
  }, components.map(function (comp) {
    return createElement(FilterComponent, {
      component: comp,
      value: result.values[comp.key],
      onChange: actions.setValueCurry(comp.key),
      defaultLayout: isSingleFilter ? 'horizontal' : 'vertical',
      key: comp.key,
      "pu-": true
    });
  })));
};

var tooltipByColumnType = {
  number: {
    asc: 'ascending',
    desc: 'descending'
  },
  alphabet: {
    asc: 'alphabetical',
    desc: 'reverse-alphabetical'
  },
  date: {
    asc: 'most to least recent',
    desc: 'least to most recent'
  }
};

var inferColumnType = function inferColumnType(name) {
  if (name) {
    if (/(created at)|(date)/i.test(name)) {
      return 'date';
    }

    if (/name/i.test(name)) {
      return 'alphabet';
    }
  }

  return 'number';
};

function Th(_ref3) {
  var children = _ref3.children,
      _ref3$columnName = _ref3.columnName,
      columnName = _ref3$columnName === void 0 ? isString(children) ? children.trim() : undefined : _ref3$columnName,
      _ref3$columnType = _ref3.columnType,
      columnType = _ref3$columnType === void 0 ? inferColumnType(columnName) : _ref3$columnType,
      onSort = _ref3.onSort,
      sortOrder = _ref3.sortOrder,
      isSortKey = _ref3.isSortKey,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2$3);

  var sortBtn = onSort && createElement("button", {
    type: "button",
    className: "pu-absolute pu-top-1/2 pu-transform pu--translate-y-1/2 pu-right-3 pu-p-1 pu-rounded-full focus-visible-ring",
    "aria-label": columnName ? "Sort by " + columnName : 'Sort'
  }, isSortKey ? sortOrder === 'asc' ? createElement(MiniDescendingIcon, {
    className: "pu-text-lightgrey pu-w-4 pu-h-4"
  }) : createElement(MiniAscendingIcon, {
    className: "pu-text-lightgrey pu-w-4 pu-h-4"
  }) : createElement(MiniUnsortedIcon, {
    className: "pu-text-lightgrey pu-w-4 pu-h-4"
  }));
  return createElement(DataTableCell, Object.assign({}, props, {
    className: cx(onSort && 'pu-relative pu-cursor-pointer pu-select-none pu-pr-10', props.className),
    onClick: callAll(props.onClick, onSort),
    "aria-sort": onSort && isSortKey ? sortOrder === 'asc' ? 'ascending' : 'descending' : undefined
  }), children, onSort && (sortOrder && isSortKey ? createElement(Tooltip, {
    label: tooltipByColumnType[columnType][sortOrder]
  }, sortBtn) : sortBtn));
}

var DataTable = /*#__PURE__*/Object.assign(DataTableImpl, {
  Caption: DataTableCaption,
  Tr: DataTableRow,
  Cell: DataTableCell,
  Td: DataTableCell,
  Th: Th,
  RowGroup: DataTableRowGroup,
  Thead: function Thead(props) {
    return createElement(DataTableRowGroup, Object.assign({}, props, {
      groupType: "thead"
    }));
  },
  Tbody: DataTableRowGroup
});

/**
 * `<DataTableExpandButton />` is used within a `<DataTableExpandableGroup />`.
 *
 * It accepts all props a `button` element accepts.
 */

var DataTableExpandButton = /*#__PURE__*/forwardRef(function DataTableExpandButton(props, ref) {
  var context = useContext(DataTableExpandableContext);
  var isInteractive = context.expandControl === 'button';
  return createElement(IconButton, Object.assign({}, props, {
    className: cx(props.className, 'pu-p-1 pu--my-2.5 pu--ml-2 pu-relative pu-top-1 active:pu-translate-y-0'),
    onClick: callAll(props.onClick, isInteractive ? context.toggleExpand : undefined),
    // when expandControl is not button, then just render a div
    render: isInteractive ? undefined : function (btnProps) {
      return createElement("div", Object.assign({}, btnProps));
    },
    ref: ref
  }), createElement("span", {
    className: "pu-sr-only"
  }, context.isExpanded ? 'Collapse' : 'Expand'), createElement(ExpandMoreIcon, {
    className: cx('pu-w-5 pu-h-5 pu-text-gray-400 pu-transform pu-transition-transform pu-duration-200', context.isExpanded ? 'pu-rotate-180' : 'pu-rotate-0')
  }));
});

/**
 * `<DataTableExpandableGroup />` defines an area with expandable summary row with expandable section.
 *
 * Summary row should renders a `<DataTableExpandButton />` component while the expandable section should be wrapped
 * with `<DataTAbleExpandableSection />`.
 *
 * This component renders nothing other than its children.
 */

var DataTableExpandableGroup = function DataTableExpandableGroup(_ref) {
  var children = _ref.children,
      _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? false : _ref$defaultExpanded,
      _ref$expandControl = _ref.expandControl,
      expandControl = _ref$expandControl === void 0 ? 'button' : _ref$expandControl;
  var mainRowRef = useRef(null);

  var _React$useState = useState(defaultExpanded),
      isExpanded = _React$useState[0],
      setIsExpanded = _React$useState[1];

  var toggleExpand = useCallback(function () {
    return setIsExpanded(function (o) {
      return !o;
    });
  }, []);
  return createElement(DataTableExpandableContext.Provider, {
    value: useMemo(function () {
      return {
        isExpanded: isExpanded,
        toggleExpand: toggleExpand,
        expandControl: expandControl
      };
    }, [isExpanded, toggleExpand, expandControl])
  }, createElement(DataTableMainRowRefContext.Provider, {
    value: mainRowRef
  }, children));
};

/**
 * `<DataTableExpandableRow />` is used within a `<DataTableExpandableGroup />` to show a full width row with a panel.
 *
 * It is only supported in `<DataTable native />`.
 */

var DataTableExpandableRow = function DataTableExpandableRow(props) {
  var _React$useContext = useContext(DataTableContext),
      _native = _React$useContext["native"];

  var _React$useContext2 = useContext(DataTableExpandableContext),
      isExpanded = _React$useContext2.isExpanded;

  var headings = useDescendants(DataTableDescendantContext);

  if (process.env.NODE_ENV !== 'production') {
    if (!_native) {
      console.error('DataTableExpandableRow is only supported in <DataTable native />');
    }
  }

  return _native && isExpanded ? createElement(DataTableRow, {
    _excludeRow: true
  }, createElement("td", {
    className: cx('pu-pl-9 pu-pr-4 pu-py-3 pu-whitespace-no-wrap', classes.body, props.wrapperClass),
    colSpan: headings.length
  }, createElement("div", Object.assign({}, props, {
    className: cx('pu-p-5 pu-rounded-lg pu-border-gray-200 pu-border', props.className)
  })))) : null;
};

/**
 * `<DataTableExpandableSection />` is used within a `<DataTableExpandableGroup />` to hide the content when the group is not expanded.
 */

var DataTableExpandableSection = function DataTableExpandableSection(props) {
  var context = useContext(DataTableExpandableContext);
  var currentLevel = useContext(DataTableExpandLevel);
  return context.isExpanded ? createElement(DataTableExpandLevel.Provider, {
    value: currentLevel + 1
  }, createElement(DataTableExpandableContext.Provider, {
    value: DataTableExpandableContextDefault
  }, props.children)) : null;
};

var _excluded$D = ["onReset", "className", "children", "labelText", "filter"];
/**
 * Used with `<Badge />` component to render list of applied filter.
 *
 * Works well with `useFilter` custom hook.
 */

var Filter = function Filter(_ref) {
  var onReset = _ref.onReset,
      className = _ref.className,
      children = _ref.children,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? 'Results for:' : _ref$labelText,
      filter = _ref.filter,
      containerProps = _objectWithoutPropertiesLoose(_ref, _excluded$D);

  if (filter && filter[0].applied.length === 0) {
    return null;
  }

  return createElement(FilterContext.Provider, {
    value: true
  }, createElement("div", Object.assign({
    className: cx('pu-flex pu-flex-wrap pu-space-x-2 pu-items-center', className)
  }, containerProps), createElement("span", {
    className: "pu-text-sm pu-text-black"
  }, labelText), filter && filter[0].applied.map(function (item) {
    return createElement(Badge, {
      className: "pu-my-0.5",
      onDismiss: item.resetValue,
      rounded: "full",
      compact: true,
      key: item.prop
    }, item.label);
  }), children, createElement(BareButton, {
    onClick: filter ? filter[1].reset : onReset,
    className: "pu-text-brand-500"
  }, "CLEAR ALL")));
};

var _excluded$E = ["className", "children", "filter"],
    _excluded2$4 = ["props"];
/**
 * Wrap form controls that will be used as filter for `<DataTable />`.
 *
 * This component will styles the form controls width to follow design convention. (Minimum 220px, and fill up the extra space if available)
 */

var FilterControls = function FilterControls(_ref) {
  var className = _ref.className,
      children = _ref.children,
      filter = _ref.filter,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$E);

  var _React$useState = useState(false),
      isOpen = _React$useState[0],
      setIsOpen = _React$useState[1];

  var components = filter && filter[2];
  var mobileComponents = useMemo(function () {
    return components && components.map(function (_ref2) {
      var props = _ref2.props,
          comp = _objectWithoutPropertiesLoose(_ref2, _excluded2$4);

      return _extends({}, comp, {
        props: props.id ? _extends({}, props, {
          id: props.id + "-mobile",
          _cacheKey: props.id
        }) : props
      });
    });
  }, [components]);
  return createElement(FilterContext.Provider, {
    value: true
  }, createElement(Disclosure, {
    open: isOpen,
    onChange: function onChange() {
      return setIsOpen(!isOpen);
    }
  }, createElement("div", {
    className: "pu-block sm:pu-hidden pu-bg-white pu-rounded-lg"
  }, createElement("div", {
    className: "pu-flex pu-justify-between pu-items-center pu-p-3"
  }, createElement("div", {
    className: "pu-flex pu-items-center pu-px-1"
  }, createElement(FilterIcon, {
    className: "pu-w-5 pu-h-5 pu-text-gray-800 pu-mr-3"
  }), createElement("span", {
    className: "pu-font-medium"
  }, "Search & filters")), createElement(DisclosureButton, {
    as: IconButton,
    className: "pu-ml-2 active:pu-translate-y-0"
  }, createElement(ExpandMoreIcon, {
    className: cx('pu-w-5 pu-h-5 pu-text-gray-400 pu-transform pu-transition-transform pu-duration-200', isOpen ? 'pu-rotate-180' : 'pu-rotate-0')
  }))), createElement(AnimateHeight, {
    height: isOpen ? 'auto' : 0,
    easing: "ease-in-out"
  }, createElement(DisclosurePanel, {
    className: "pu-block focus:pu-outline-none focus-visible:pu-shadow-outline-gray"
  }, createElement("div", {
    className: "pu-grid pu-grid-cols-1 pu-gap-y-5 pu-px-4 pu-pb-4"
  }, filter && createElement(FilterComponents, {
    filter: mobileComponents ? [filter[0], filter[1], mobileComponents] : filter
  }), children))))), createElement(Card, Object.assign({
    className: cx('pu-hidden sm:pu-grid pu-gap-5 portal-ui-filter', !hasUtilClass(className, 'pu-p-') && 'pu-p-5', !hasUtilClass(className, 'pu-items-') && 'pu-items-end', className)
  }, props), filter && createElement(FilterComponents, {
    filter: filter
  }), children));
};

var FilterComponents = function FilterComponents(_ref3) {
  var _ref3$filter = _ref3.filter,
      result = _ref3$filter[0],
      actions = _ref3$filter[1],
      components = _ref3$filter[2];

  if (!Array.isArray(components) || components.length === 0) {
    return null;
  }

  return createElement(Fragment, null, components.map(function (comp) {
    return createElement(FilterComponent, {
      component: comp,
      value: result.values[comp.key],
      onChange: actions.setValueCurry(comp.key),
      key: comp.key
    });
  }));
};

var _excluded$F = ["isLoading", "smallLoadingIcon", "children", "onClick", "bgClass"];
var PaginationButton = function PaginationButton(_ref) {
  var isLoading = _ref.isLoading,
      smallLoadingIcon = _ref.smallLoadingIcon,
      children = _ref.children,
      onClick = _ref.onClick,
      _ref$bgClass = _ref.bgClass,
      bgClass = _ref$bgClass === void 0 ? 'pu-bg-white' : _ref$bgClass,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$F);

  return createElement("button", Object.assign({
    type: "button"
  }, props, {
    onClick: isLoading ? undefined : onClick,
    className: cx('pu-inline-flex pu-items-center pu-py-1.5 pu-border pu-tracking-1 focus:pu-z-10 pu-transition-colors pu-ease-in-out pu-duration-150 focus-visible-ring pu-transform', bgClass, isLoading ? 'pu-text-transparent' // making the text tranparent instead of not showing it so that the button size will not change when isLoading
    : props.disabled ? 'pu-text-offwhite' : 'pu-text-mediumgrey', isLoading || props.disabled ? 'pu-cursor-default' : 'active:pu-translate-y-px', props.disabled ? 'pu-border-offwhite' : 'pu-border-gray-300', props.className)
  }), children, isLoading && createElement("div", {
    className: cx('pu-absolute pu-left-1/2 pu-transform', smallLoadingIcon ? 'pu--translate-x-2' : 'pu--translate-x-2.5' // using left + translate hack to center it
    )
  }, createElement(PortalSpinIcon, {
    className: cx('pu-animate-spin pu-text-mediumgrey', smallLoadingIcon ? 'pu-w-4 pu-h-4' : 'pu-w-5 pu-h-5')
  })));
};

var _excluded$G = ["currentPage", "lastPage", "pageSize", "onChangePage", "onChangePageSize", "variant", "rowName", "pageSizeOptions", "hideIfSinglePage", "onGoToLast", "isFetching"];
var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      lastPage = _ref.lastPage,
      pageSize = _ref.pageSize,
      onChangePage = _ref.onChangePage,
      onChangePageSize = _ref.onChangePageSize,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'page-list' : _ref$variant,
      _ref$rowName = _ref.rowName,
      rowName = _ref$rowName === void 0 ? 'records' : _ref$rowName,
      _ref$pageSizeOptions = _ref.pageSizeOptions,
      pageSizeOptions = _ref$pageSizeOptions === void 0 ? DEFAULT_PAGE_SIZE_OPTIONS : _ref$pageSizeOptions,
      _ref$hideIfSinglePage = _ref.hideIfSinglePage,
      hideIfSinglePage = _ref$hideIfSinglePage === void 0 ? true : _ref$hideIfSinglePage,
      _ref$onGoToLast = _ref.onGoToLast,
      onGoToLast = _ref$onGoToLast === void 0 ? noop : _ref$onGoToLast,
      isFetching = _ref.isFetching,
      divProps = _objectWithoutPropertiesLoose(_ref, _excluded$G);

  var _React$useState = useState(null),
      lastSelected = _React$useState[0],
      setLastSelected = _React$useState[1];

  if (hideIfSinglePage && lastPage <= 1) {
    return null;
  }

  var goNext = function goNext() {
    onChangePage(currentPage + 1);
    setLastSelected('next');
  };

  var disableNext = currentPage === lastPage;

  var goPrev = function goPrev() {
    onChangePage(currentPage - 1);
    setLastSelected('prev');
  };

  var disablePrev = currentPage <= 1;
  return createElement("div", Object.assign({}, divProps), lastPage > 1 && createElement("div", {
    className: "pu-flex pu-justify-between sm:pu-hidden"
  }, createElement(PaginationButton, {
    onClick: goPrev,
    className: "pu-text-xs pu-px-4 pu-rounded-md",
    disabled: disablePrev,
    isLoading: isFetching && lastSelected === 'prev',
    smallLoadingIcon: true
  }, "PREVIOUS"), createElement(PaginationButton, {
    onClick: goNext,
    className: "pu-text-xs pu-px-4 pu-rounded-md",
    disabled: disableNext,
    isLoading: isFetching && lastSelected === 'next',
    smallLoadingIcon: true
  }, "NEXT")), createElement("div", {
    className: "pu-hidden sm:pu-flex sm:pu-flex-wrap sm:pu-justify-between sm:pu-items-center"
  }, createElement(Field, {
    className: "pu-inline-flex pu-items-center"
  }, createElement(Label, {
    className: "pu-mb-0 pu-flex-none pu-mr-2"
  }, isString(rowName) ? titleCase(rowName) : rowName, " to display:"), createElement(DropdownSelect, {
    value: pageSize,
    onChangeValue: function onChangeValue(newPageSize) {
      onChangePageSize(newPageSize);
      setLastSelected(null);
    },
    options: pageSizeOptions,
    className: "pu-py-1.5 pu-font-medium pu-text-darkgrey"
  })), variant === 'page-list' ? lastPage > 1 && createElement("div", {
    className: "pu-inline-flex pu-shadow-sm"
  }, createElement(PaginationButton, {
    onClick: function onClick() {
      onChangePage(1);
      setLastSelected('first');
    },
    className: "pu-text-sm pu-px-1.5 pu-rounded-l-md",
    disabled: disablePrev,
    "aria-label": "First",
    isLoading: isFetching && lastSelected === 'first'
  }, createElement(ChevronDoubleRightIcon, {
    className: "pu-h-4 pu-w-4 pu-transform pu-rotate-180"
  })), createElement(PaginationButton, {
    onClick: goPrev,
    className: "pu-text-sm pu--ml-px pu-pl-1.75 pu-pr-1.5",
    disabled: disablePrev,
    "aria-label": "Previous",
    isLoading: isFetching && lastSelected === 'prev'
  }, createElement(ChevronRightIcon, {
    className: "pu-h-4 pu-w-4 pu-transform pu-rotate-180"
  })), getPageOptions(currentPage, lastPage).map(function (page) {
    return createElement(PaginationButton, {
      onClick: function onClick() {
        if (page !== currentPage) {
          onChangePage(page);
          setLastSelected(page);
        }
      },
      className: "pu-text-sm pu--ml-px pu-w-9 pu-justify-center pu-inline-flex",
      bgClass: page === currentPage ? 'pu-bg-gray-100' : undefined,
      isLoading: isFetching && lastSelected === page,
      key: page
    }, page);
  }), createElement(PaginationButton, {
    onClick: goNext,
    className: cx('pu-text-sm pu-pr-1.5', disableNext ? 'pu-pl-1.5' : 'pu--ml-px pu-pl-1.75'),
    disabled: disableNext,
    isLoading: isFetching && lastSelected === 'next',
    "aria-label": "Next"
  }, createElement(ChevronRightIcon, {
    className: "pu-h-4 pu-w-4"
  })), createElement(PaginationButton, {
    onClick: function onClick() {
      onGoToLast();
      setLastSelected('last');
    },
    className: "pu-text-sm pu--ml-px pu-pl-1.75 pu-pr-1.5 pu-rounded-r-md",
    disabled: disableNext,
    "aria-label": "Last",
    isLoading: isFetching && lastSelected === 'last'
  }, createElement(ChevronDoubleRightIcon, {
    className: "pu-h-4 pu-w-4"
  }))) : createElement("div", {
    className: "pu-inline-flex pu-items-center"
  }, createElement(PaginationButton, {
    onClick: goPrev,
    className: "pu-text-xs pu-px-3 sm:pu-py-2 pu-rounded-md pu-mr-2 pu-font-bold",
    disabled: disablePrev,
    isLoading: isFetching && lastSelected === 'prev',
    smallLoadingIcon: true
  }, "PREVIOUS"), createElement(PaginationButton, {
    onClick: goNext,
    className: "pu-text-xs pu-px-3 sm:pu-py-2 pu-rounded-md pu-font-bold",
    disabled: disableNext,
    isLoading: isFetching && lastSelected === 'next',
    smallLoadingIcon: true
  }, "NEXT"))));
};
var DEFAULT_PAGE_SIZE_OPTIONS = [20, 50, 100];
var MAX_OPTIONS_COUNT = 5;

var mapOption = function mapOption(_, index) {
  return index + 1;
};

var half = /*#__PURE__*/Math.floor(MAX_OPTIONS_COUNT / 2);

var getPageOptions = function getPageOptions(current, max) {
  if (max <= MAX_OPTIONS_COUNT) {
    return createArray(max).map(mapOption);
  }

  if (current <= MAX_OPTIONS_COUNT - half) {
    return createArray(MAX_OPTIONS_COUNT).map(mapOption);
  }

  if (max - current <= half) {
    return createArray(MAX_OPTIONS_COUNT).map(function (_, index) {
      return max - index;
    }).reverse();
  }

  return createArray(MAX_OPTIONS_COUNT).map(function (_, index) {
    return current + index - half;
  });
};

var _excluded$H = ["data", "total", "currentPage", "perPage", "onChangePage"];
/**
 * `<PaginationNavigation />` is legacy component that requires API to returns total row count.
 *
 * Migrate to `<Pagination />` component which does not requires such computation.
 */

var PaginationNavigation = function PaginationNavigation(_ref) {
  var data = _ref.data,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? data ? data.total : 0 : _ref$total,
      _ref$currentPage = _ref.currentPage,
      currentPage = _ref$currentPage === void 0 ? data ? data.page : 0 : _ref$currentPage,
      _ref$perPage = _ref.perPage,
      perPage = _ref$perPage === void 0 ? data ? data.perPage : 15 : _ref$perPage,
      onChangePage = _ref.onChangePage,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$H);

  var pageCount = Math.ceil(total / perPage);
  var lastPage = useMemo(function () {
    if (currentPage <= 3) {
      return Math.min(pageCount, 5);
    }

    return Math.min(pageCount + 2, pageCount);
  }, [pageCount, currentPage]);
  return createElement(Pagination, Object.assign({
    currentPage: currentPage,
    onChangePage: onChangePage,
    pageSize: perPage,
    onGoToLast: function onGoToLast() {
      return onChangePage(pageCount);
    },
    lastPage: lastPage,
    hideIfSinglePage: total <= DEFAULT_PAGE_SIZE_OPTIONS[0]
  }, props));
};

var _excluded$I = ["from", "to", "onChangeValue", "placeholder", "onPickerClose", "dayOnly", "className", "disableFuture", "minDate", "maxDate"];
/**
 * A button that allows you to select date range from a modal.
 *
 * Unlisted props will be spreaded to the underlying button element
 */

var DateRangeSelector = function DateRangeSelector(_ref) {
  var from = _ref.from,
      to = _ref.to,
      onChangeValue = _ref.onChangeValue,
      placeholder = _ref.placeholder,
      onPickerClose = _ref.onPickerClose,
      dayOnly = _ref.dayOnly,
      className = _ref.className,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$I);

  // we allow user to pass `null` to support use case like `formik`
  var fromValue = from === null ? undefined : from;
  var toValue = to === null ? undefined : to;

  var _React$useState = useState(false),
      pickerShown = _React$useState[0],
      setPickerShown = _React$useState[1];

  var _React$useContext = useContext(FieldContext),
      status = _React$useContext.status;

  var displayValue = useMemo(function () {
    return formatDateRange(fromValue, toValue, dayOnly);
  }, [dayOnly, fromValue, toValue]);

  var dismissPicker = function dismissPicker() {
    setPickerShown(false);

    if (onPickerClose) {
      onPickerClose();
    }
  };

  return createElement(Fragment, null, createElement(InputButton, Object.assign({
    className: cx(!hasUtilClass(className, 'pu-w-') && (dayOnly ? 'pu-w-72' : 'pu-w-full'), status && borderByStatus[status], className)
  }, buttonProps, {
    onClick: callAll(buttonProps.onClick, function () {
      return setPickerShown(true);
    })
  }), createElement(CalendarIcon, {
    className: "pu-w-4 pu-h-4 pu-mr-3 pu-text-gray-400 "
  }), createElement("span", {
    className: "pu-h-5 pu-flex-1 pu-truncate pu-text-left"
  }, displayValue || createElement("span", {
    className: "pu-text-lightgrey"
  }, placeholder))), createElement(DateRangeModal, {
    isOpen: pickerShown,
    onDismiss: dismissPicker,
    initialFrom: fromValue,
    initialTo: toValue,
    onApply: callAll(function (from, to) {
      return onChangeValue(from, getDisplayedTo(to, dayOnly));
    }, dismissPicker),
    dayOnly: dayOnly,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate
  }));
};

var _excluded$J = ["value", "onChangeValue", "wrapperClass", "dayClass", "timeClass"];
/**
 * `<DateTimeInput />` is a composition of `DaySelector` and `TimeInput`.
 */

var DateTimeInput = function DateTimeInput(_ref) {
  var value = _ref.value,
      _onChangeValue = _ref.onChangeValue,
      wrapperClass = _ref.wrapperClass,
      dayClass = _ref.dayClass,
      timeClass = _ref.timeClass,
      dayProps = _objectWithoutPropertiesLoose(_ref, _excluded$J);

  var currentHour = value ? value.getHours() : 0;
  var currentMinute = value ? value.getMinutes() : 0;
  return createElement("div", {
    className: cx('pu-flex pu-gap-3', wrapperClass)
  }, createElement(DaySelector, Object.assign({
    value: value,
    className: cx(dayClass, 'pu-w-40'),
    onChangeValue: function onChangeValue(newDay) {
      _onChangeValue(newDay && setDate(newDay, {
        hours: currentHour,
        minutes: currentMinute
      }));
    }
  }, dayProps)), createElement(TimeInput, {
    hours: currentHour,
    minutes: currentMinute,
    disabled: dayProps.disabled || !value,
    onChangeValue: function onChangeValue(changes) {
      return _onChangeValue(setDate(value, changes));
    },
    className: timeClass
  }));
};

var _excluded$K = ["value", "onChangeValue", "disableFuture", "disabled", "wrapperClass", "emptyValue", "onPickerHide", "minDate", "maxDate"];
/**
 * use `<DaySelector />` instead.
 *
 * @deprecated
 */

var DayPickerInput = /*#__PURE__*/forwardRef(function DayPickerInput(_ref, ref) {
  var value = _ref.value,
      onChangeValue = _ref.onChangeValue,
      disableFuture = _ref.disableFuture,
      disabled = _ref.disabled,
      wrapperClass = _ref.wrapperClass,
      _ref$emptyValue = _ref.emptyValue,
      emptyValue = _ref$emptyValue === void 0 ? '' : _ref$emptyValue,
      _ref$onPickerHide = _ref.onPickerHide,
      onPickerHide = _ref$onPickerHide === void 0 ? noop : _ref$onPickerHide,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$K);

  var _React$useState = useState(false),
      pickerShown = _React$useState[0],
      setPickerShown = _React$useState[1];

  var displayValue = useMemo(function () {
    return value instanceof Date ? formatDate(value, {
      formatType: 'dateOnly'
    }) : emptyValue;
  }, [value, emptyValue]);
  var componentRef = useRef(null);
  var pickerRef = useRef(null);
  var buttonRef = useRef(null);
  var onPickerHideCb = useStableCallback(onPickerHide);
  var dismissPicker = useCallback(function () {
    setPickerShown(false);

    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);
  var prevPickerShown = usePrevious(pickerShown);
  useEffect(function () {
    if (pickerShown) {
      var listenClickOutside = function listenClickOutside(event) {
        if (pickerRef.current && event.target) {
          var isInPicker = pickerRef.current.contains(event.target);
          var isInButton = buttonRef.current && buttonRef.current.contains(event.target);

          if (!isInPicker && !isInButton) {
            setPickerShown(false);
          }
        }
      };

      if (pickerRef.current) {
        focusFirstTabbable(pickerRef.current);
      }

      window.addEventListener('mousedown', listenClickOutside);
      return function () {
        return window.removeEventListener('mousedown', listenClickOutside);
      };
    } else {
      if (prevPickerShown === true) {
        onPickerHideCb();
      }
    }
  }, [prevPickerShown, pickerShown, onPickerHideCb]);
  return createElement(Fragment, null, createElement("div", {
    className: cx('pu-relative', wrapperClass),
    ref: componentRef
  }, createElement("div", {
    className: "pu-absolute pu-inset-y-0 pu-left-0 pu-pl-1.5 pu-flex pu-items-center"
  }, createElement(IconButton, {
    onClick: pickerShown ? dismissPicker : function () {
      return setPickerShown(true);
    },
    type: "button",
    className: "pu-p-2",
    disabled: disabled,
    "aria-label": displayValue ? "Choose Date, selected date is " + displayValue : 'Choose Date',
    ref: buttonRef
  }, createElement(CalendarIcon, {
    className: "pu-w-4 pu-h-4 pu-text-gray-400 pu-inline-block"
  }))), createElement(TextInput, Object.assign({
    value: displayValue,
    onClick: function onClick() {
      return setPickerShown(true);
    },
    tabIndex: -1,
    readOnly: true
  }, inputProps, {
    disabled: disabled,
    className: cx('pu-pl-11', disabled ? 'pu-bg-gray-200' : 'pu-bg-transparent', inputProps.className),
    ref: ref
  }))), createElement(DayPickerPopover, {
    isOpen: pickerShown,
    onDismiss: dismissPicker,
    targetRef: componentRef,
    ref: pickerRef,
    value: value,
    onChangeValue: onChangeValue,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate
  }));
});

var MonthPicker = function MonthPicker(props) {
  var minDate = props.minDate,
      maxDate = props.maxDate;

  var _React$useState = useState(function () {
    return (props.value || new Date()).getFullYear();
  }),
      displayedYear = _React$useState[0],
      setDisplayedYear = _React$useState[1];

  var onChange = useStableCallback(function (month) {
    if (props.onChangeValue) {
      props.onChangeValue(new Date(displayedYear, month));
    }
  });
  var getMonthIsDisabled = useCallback(function (month) {
    if (minDate) {
      var minDateYear = minDate.getFullYear();
      var minDateMonth = minDate.getMonth();

      if (minDateYear > displayedYear || minDateYear === displayedYear && minDateMonth > month) {
        return true;
      }
    }

    if (maxDate) {
      var maxDateYear = maxDate.getFullYear();
      var maxDateMonth = maxDate.getMonth();

      if (maxDateYear < displayedYear || maxDateYear === displayedYear && maxDateMonth < month) {
        return true;
      }
    }

    return false;
  }, [displayedYear, minDate, maxDate]);
  var valueYear = props.value && props.value.getFullYear();
  var valueMonth = props.value && props.value.getMonth();
  var prevIsDisabled = !!(minDate && minDate.getFullYear() > displayedYear - 1);
  var nextIsDisabled = !!(maxDate && maxDate.getFullYear() < displayedYear + 1);
  return createElement("div", {
    className: cx('pu-month-picker pu-px-2', props.className)
  }, createElement("div", {
    className: "pu-flex pu-justify-between pu-items-center pu-px-1 pu-pb-2 pu-pt-5"
  }, createElement(IconButton, {
    onClick: function onClick() {
      return setDisplayedYear(function (y) {
        return y - 1;
      });
    },
    "aria-label": "Previous year",
    disabled: prevIsDisabled
  }, createElement(ChevronRightIcon, {
    className: cx('pu-transform pu-rotate-180', prevIsDisabled ? 'pu-text-grey-700 pu-opacity-50' : 'pu-text-lightgrey')
  })), createElement("span", {
    className: "pu-text-lg"
  }, displayedYear), createElement(IconButton, {
    onClick: function onClick() {
      return setDisplayedYear(function (y) {
        return y + 1;
      });
    },
    "aria-label": "Next year",
    disabled: nextIsDisabled
  }, createElement(ChevronRightIcon, {
    className: cx(nextIsDisabled ? 'pu-text-grey-700 pu-opacity-50' : 'pu-text-lightgrey')
  }))), createElement("div", {
    className: "pu-px-1"
  }, createElement("div", {
    className: "pu-table pu-w-full pu-text-center"
  }, createElement("div", {
    className: "pu-table-row-group"
  }, MONTHS.map(function (monRow, i) {
    return createElement("div", {
      className: "pu-table-row",
      key: i
    }, monRow.map(function (month, mIndex) {
      return createElement("div", {
        className: "pu-table-cell pu-p-3",
        key: mIndex
      }, createElement(Month, {
        month: month,
        onClick: onChange,
        isActive: valueYear === displayedYear && valueMonth === month.value,
        disabled: getMonthIsDisabled(month.value)
      }));
    }));
  })))));
};

var Month = function Month(_ref) {
  var month = _ref.month,
      isActive = _ref.isActive,
      _onClick = _ref.onClick,
      disabled = _ref.disabled;
  return createElement("button", {
    type: "button",
    className: cx('pu-inline-flex pu-items-center pu-justify-center pu-month-picker--month pu-text-sm pu-rounded-full focus-visible-ring', isActive ? 'pu-bg-brand-500 pu-text-white' : disabled ? 'pu-text-grey-700' : 'hover:pu-bg-grey-200'),
    onClick: function onClick() {
      return _onClick(month.value);
    },
    disabled: disabled
  }, month.label);
};

var MONTHS = [[{
  label: MONTHS_LABELS[0],
  value: 0
}, {
  label: MONTHS_LABELS[1],
  value: 1
}, {
  label: MONTHS_LABELS[2],
  value: 2
}, {
  label: MONTHS_LABELS[3],
  value: 3
}], [{
  label: MONTHS_LABELS[4],
  value: 4
}, {
  label: MONTHS_LABELS[5],
  value: 5
}, {
  label: MONTHS_LABELS[6],
  value: 6
}, {
  label: MONTHS_LABELS[7],
  value: 7
}], [{
  label: MONTHS_LABELS[8],
  value: 8
}, {
  label: MONTHS_LABELS[9],
  value: 9
}, {
  label: MONTHS_LABELS[10],
  value: 10
}, {
  label: MONTHS_LABELS[11],
  value: 11
}]];

var _excluded$L = ["value", "onChangeValue", "disableFuture", "minDate", "maxDate", "disabled", "emptyValue", "className", "onPopoverClose"];
var MonthSelector = function MonthSelector(_ref) {
  var value = _ref.value,
      onChangeValue = _ref.onChangeValue,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      _ref$maxDate = _ref.maxDate,
      maxDate = _ref$maxDate === void 0 ? disableFuture ? DATES.today : undefined : _ref$maxDate,
      _ref$emptyValue = _ref.emptyValue,
      emptyValue = _ref$emptyValue === void 0 ? 'Select month' : _ref$emptyValue,
      className = _ref.className,
      onPopoverClose = _ref.onPopoverClose,
      btnProps = _objectWithoutPropertiesLoose(_ref, _excluded$L);

  var _React$useState = useState(false),
      calendarShown = _React$useState[0],
      setCalendarShown = _React$useState[1];

  var buttonRef = useRef(null);
  var popoverRef = useRef(null);
  var fieldState = useFieldControlContext(btnProps.id);
  var displayValue = useMemo(function () {
    if (value instanceof Date) {
      var firstDayOfMonth = startOfMonth(value);
      var lastDayOfMonth = endOfMonth(value);
      var firstDay = minDate && minDate > firstDayOfMonth ? minDate : firstDayOfMonth;
      var lastDay = maxDate && maxDate < lastDayOfMonth ? maxDate : lastDayOfMonth;
      return firstDay.getDate() + " - " + lastDay.getDate() + " " + MONTHS_LABELS[value.getMonth()] + " " + value.getFullYear();
    }

    return '';
  }, [value, minDate, maxDate]);

  var dismissPopover = function dismissPopover() {
    setCalendarShown(false);

    if (buttonRef.current) {
      buttonRef.current.focus();
    }

    if (onPopoverClose) {
      onPopoverClose();
    }
  };

  var onPopoverCloseCb = useStableCallback(onPopoverClose);
  var prevCalendarShown = usePrevious(calendarShown);
  useEffect(function () {
    if (calendarShown) {
      var listenClickOutside = function listenClickOutside(event) {
        if (popoverRef.current && event.target) {
          var isInPopover = popoverRef.current.contains(event.target);
          var isInButton = buttonRef.current && buttonRef.current.contains(event.target);

          if (!isInPopover && !isInButton) {
            setCalendarShown(false);
          }
        }
      };

      if (popoverRef.current) {
        focusFirstTabbable(popoverRef.current);
      }

      window.addEventListener('mousedown', listenClickOutside);
      return function () {
        return window.removeEventListener('mousedown', listenClickOutside);
      };
    }
  }, [prevCalendarShown, calendarShown, onPopoverCloseCb]);
  return createElement(Fragment, null, createElement(InputButton, Object.assign({
    variant: "select"
  }, btnProps, {
    onClick: callAll(btnProps.onClick, function () {
      return setCalendarShown(!calendarShown);
    }),
    className: cx(fieldState.status && borderByStatus[fieldState.status], className),
    id: fieldState.inputId,
    ref: buttonRef
  }), displayValue || createElement("span", {
    className: "pu-text-gray-400"
  }, emptyValue)), createElement(Popover, {
    isOpen: calendarShown,
    targetRef: buttonRef,
    ref: popoverRef,
    className: "pu-mt-0.5"
  }, calendarShown && createElement("div", {
    className: "pu-rounded-md pu-shadow-xs",
    onKeyDown: function onKeyDown(ev) {
      if (ev.key === 'Escape') {
        dismissPopover();
      }
    }
  }, createElement(MonthPicker, {
    value: value,
    onChangeValue: callAll(onChangeValue, dismissPopover),
    minDate: minDate,
    maxDate: maxDate
  }))));
};

var DescContext = /*#__PURE__*/createNamedContext('DescContext', {
  isLoading: false
});

/**
 * `<DescItem />` display key-value. It should be used as direct children of `<DescList />`.
 */

var DescItem = function DescItem(props) {
  var context = useContext(DescContext);
  return createElement(Fragment, null, createElement("dt", {
    className: cx('pu-text-sm pu-text-mediumgrey pu-mt-2 sm:pu-mt-0 first:pu-mt-0', props.labelClassName)
  }, props.label), createElement("dd", {
    className: cx('pu-text-sm pu-text-black pu-break-words', props.valueClassName)
  }, !isNil(props.value) ? props.value : context.isLoading && createElement(Skeleton, {
    width: "medium",
    heightClass: "pu-h-5",
    className: "pu-animate-pulse"
  })));
};

var TimelineDescendantContext = /*#__PURE__*/createDescendantContext('Timeline');
var IsInTimelineContext = /*#__PURE__*/createNamedContext('IsInTimeline', false);

var _excluded$M = ["isLoading"];
/**
 * `<DescList />` accepts all props a `dl` element accepts.
 */

var DescListImpl = function DescList(_ref) {
  var isLoading = _ref.isLoading,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$M);

  var isInTimeline = useContext(IsInTimelineContext);
  return createElement(DescContext.Provider, {
    value: useMemo(function () {
      return {
        isLoading: isLoading
      };
    }, [isLoading])
  }, createElement("dl", Object.assign({}, props, {
    className: cx('portal-ui-desc-list sm:pu-grid lg:pu-gap-x-10', isInTimeline ? 'sm:pu-gap-2' : 'sm:pu-gap-5', props.className)
  })));
};

var DescList = /*#__PURE__*/Object.assign(DescListImpl, {
  Item: DescItem
});

var _excluded$N = ["isOpen", "onDismiss", "leastDestructiveRef", "overlayClassName"];
/**
 * A `<Dialog />` usually used to provide critical information or ask for a decision.
 *
 * `Dialog` interrupts user workflow to get a response. This is different than a `Modal`
 * as `Dialog` requires some user response, like "Save" or "Cancel" etc.
 *
 */

var Dialog = function Dialog(_ref) {
  var isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      leastDestructiveRef = _ref.leastDestructiveRef,
      overlayClassName = _ref.overlayClassName,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$N);

  return createElement(AlertDialogOverlay, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    leastDestructiveRef: leastDestructiveRef,
    className: cx(!hasUtilClass(overlayClassName, 'pu-px-') && 'pu-px-5', overlayClassName)
  }, createElement(AlertDialogContent, Object.assign({}, props, {
    "data-setel-dialog-content": true,
    className: cx('pu-bg-white pu-font-sans', !hasUtilClass(props.className, 'pu-rounded') && 'pu-rounded-md pu-overflow-hidden', !hasUtilClass(props.className, 'pu-max-w-') && 'pu-max-w-2xl', props.className)
  })));
};

var _excluded$O = ["children", "header"];
/**
 * Content of the dialog.
 *
 * This is required to render a `<Dialog />`
 */

var DialogContent = function DialogContent(_ref) {
  var children = _ref.children,
      header = _ref.header,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$O);

  return createElement("div", Object.assign({}, props, {
    className: cx(!hasUtilClass(props.className, 'pu-px-') && 'pu-px-4 md:pu-px-6 lg:pu-px-8', !hasUtilClass(props.className, 'pu-py-') && 'pu-py-6', props.className)
  }), createElement(AlertDialogLabel, {
    className: cx('pu-mb-4', classes.h2)
  }, header), children && createElement(AlertDialogDescription, {
    className: classes.h4
  }, children));
};

var _excluded$P = ["align"];
var DialogFooter = function DialogFooter(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'right' : _ref$align,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$P);

  return createElement("div", Object.assign({}, props, {
    className: cx('pu-space-x-3', 'pu-px-4 md:pu-px-6 lg:pu-px-8 pu-bg-gray-50 pu-py-4', align === 'right' && 'pu-text-right', props.className)
  }));
};

var Dialog$1 = /*#__PURE__*/Object.assign(Dialog, {
  Content: DialogContent,
  Footer: DialogFooter
});

/**
 * handle to reorder item for `<DataTable />` when `sortable` and `useDragHandle`.
 *
 * If you wish to have your own handle, use the `SortableHandle` HOC that are also available from this package.
 */

var DragHandle = /*#__PURE__*/SortableHandle(function (props) {
  return createElement(IconButton, Object.assign({}, props), createElement(MenuIcon, {
    className: "pu-w-5 pu-h-5 pu-text-gray-200"
  }), createElement("span", {
    className: "pu-sr-only"
  }, "Reorder"));
});

var DropdownItem = function DropdownItem(props) {
  var allProps = _extends({}, props, {
    className: cx('pu-flex pu-items-center pu-py-2', !hasUtilClass(props.className, 'pu-px-') && 'pu-px-4', props.disabled ? 'pu-text-grey-700' : 'pu-text-mediumgrey', props.className)
  });

  return createElement(MenuItem, Object.assign({}, allProps));
};

var _excluded$Q = ["width", "getPosition", "popoverClass"];
var DropdownMenuItems = function DropdownMenuItems(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      _ref$getPosition = _ref.getPosition,
      getPosition = _ref$getPosition === void 0 ? width === 'auto' ? defaultGetPosition : positionMatchWidth : _ref$getPosition,
      popoverClass = _ref.popoverClass,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Q);

  return createElement(MenuPopover, {
    className: popoverClass,
    position: getPosition
  }, createElement(MenuItems, {
    className: cx('pu-rounded-md pu-shadow-lg pu-overflow-hidden', width === 'auto' && 'pu-whitespace-no-wrap')
  }, createElement("div", Object.assign({}, props, {
    className: cx('portal-ui-scrollbar pu-py-1 pu-font-sans pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-border pu-border-gray-100', props.className)
  }))));
};

var defaultGetPosition = function defaultGetPosition(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }

  var _getCollisions = getCollisions(targetRect, popoverRect),
      directionRight = _getCollisions.directionRight,
      directionUp = _getCollisions.directionUp;

  return {
    left: directionRight ? targetRect.right - popoverRect.width + window.pageXOffset + "px" : targetRect.left + window.pageXOffset + "px",
    top: directionUp ? targetRect.top - popoverRect.height + window.pageYOffset - spacing + "px" : targetRect.top + targetRect.height + window.pageYOffset + spacing + "px"
  };
};

var spacing = 4;

var _excluded$R = ["label", "children", "variant", "leftIcon", "rightIcon", "minWidth", "size", "isLoading"];
/**
 * `<DropdownMenu />` renders a button that allows you to open a menu.
 *
 * The menu is rendered with `<DropdownMenuItems />` while each option is rendered with `<DropdownItem />`.
 *
 * Unspecified props will be spreaded to the underlying <button /> element.
 */

var DropdownMenuImpl = function DropdownMenu(_ref) {
  var label = _ref.label,
      children = _ref.children,
      variant = _ref.variant,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 'none' : _ref$minWidth,
      size = _ref.size,
      isLoading = _ref.isLoading,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$R);

  var btnRef = useRef(null);
  useDescendant({
    element: btnRef.current
  }, ModalSelectDescentdantContext);
  return createElement(Menu, null, function (_ref2) {
    var isExpanded = _ref2.isExpanded;
    return createElement(Fragment, null, variant === 'icon' ? createElement(MenuButton, Object.assign({
      as: IconButton
    }, props, {
      className: cx('active:pu-translate-y-0', props.className),
      ref: btnRef
    }), isFunction(label) ? label({
      isExpanded: isExpanded
    }) : label) : createElement(Button, {
      variant: variant,
      disabled: props.disabled,
      minWidth: minWidth,
      className: cx('active:pu-translate-y-0', props.className),
      size: size,
      isLoading: isLoading,
      leftIcon: leftIcon,
      rightIcon: isDefined(rightIcon) ? rightIcon : createElement(ExpandMoreIcon, {
        className: cx('pu-transform pu-transition-transform pu-duration-200', variant && iconBgByVariant[variant], isExpanded ? 'pu-rotate-180' : 'pu-rotate-0')
      }),
      render: function render(buttonProps) {
        return createElement(MenuButton, Object.assign({}, props, buttonProps, {
          ref: btnRef
        }));
      }
    }, isFunction(label) ? label({
      isExpanded: isExpanded
    }) : label), children);
  });
};

var iconBgByVariant = {
  carbon: 'pu-rounded pu-bg-carbon-200'
};
var DropdownMenu = /*#__PURE__*/Object.assign(DropdownMenuImpl, {
  Items: DropdownMenuItems,
  Item: DropdownItem
});

var CheckboxContext = /*#__PURE__*/createNamedContext('CheckboxContext', undefined);

var _excluded$S = ["label", "onChangeValue", "labelClass", "wrapperClass"];
var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(_ref, ref) {
  var label = _ref.label,
      onChangeValue = _ref.onChangeValue,
      labelClass = _ref.labelClass,
      wrapperClass = _ref.wrapperClass,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$S);

  var groupContext = useContext(CheckboxContext);
  var inputId = useId(props.id);
  var isChecked = groupContext && props.value ? groupContext.value.includes(props.value) : props.checked;
  var checkboxName = groupContext ? groupContext.name : props.name;
  var checkboxEl = createElement(MixedCheckbox, Object.assign({}, props, {
    checked: isChecked,
    name: checkboxName,
    type: "checkbox",
    className: cx('form-checkbox pu-h-4 pu-w-4 pu-transition pu-duration-100 pu-ease-in-out', props.disabled ? 'pu-text-carbon-100' : 'pu-text-brand-500', props.className),
    id: inputId,
    onChange: callAll(props.onChange, onChangeValue && function (ev) {
      return onChangeValue(ev.target.checked);
    }, groupContext && function (ev) {
      return groupContext.onChangeValue(ev.target.checked ? groupContext.value.concat(props.value) : groupContext.value.filter(function (v) {
        return v !== props.value;
      }));
    }),
    ref: ref
  }));
  return label ? createElement("div", {
    className: cx('pu-flex pu-items-center', groupContext && !hasUtilClass(wrapperClass, 'pu-mt-') && 'pu-mt-2', wrapperClass)
  }, checkboxEl, createElement("label", {
    htmlFor: inputId,
    className: cx('pu-ml-2 pu-block pu-text-sm pu-leading-5 pu-text-black', labelClass)
  }, label)) : checkboxEl;
});

/**
 * `<CheckboxGroup />` groups all `<Checkbox />` components into single control.
 */

var CheckboxGroup = function CheckboxGroup(props) {
  var contextValue = useMemo(function () {
    return {
      value: props.value,
      name: props.name,
      onChangeValue: props.onChangeValue
    };
  }, [props.value, props.name, props.onChangeValue]);
  return createElement(CheckboxContext.Provider, {
    value: contextValue
  }, props.children);
};

var _excluded$T = ["className", "decimalPlaces", "onChangeValue", "allowTrailingZero", "allowNegative", "max"];
/**
 * DecimalInput allows user to enter number that is formatted with fixed number of decimal places.
 * The value will be displayed with thousand separators.
 *
 * It accepts all props that an `<input />` element accepts except `type`.
 */

var DecimalInputImpl = function DecimalInput(_ref) {
  var className = _ref.className,
      _ref$decimalPlaces = _ref.decimalPlaces,
      decimalPlaces = _ref$decimalPlaces === void 0 ? 2 : _ref$decimalPlaces,
      _ref$onChangeValue = _ref.onChangeValue,
      onChangeValue = _ref$onChangeValue === void 0 ? noop : _ref$onChangeValue,
      allowTrailingZero = _ref.allowTrailingZero,
      allowNegative = _ref.allowNegative,
      max = _ref.max,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$T);

  var _useRifm = useRifm({
    value: inputProps.value,
    onChange: function onChange(newVal) {
      return onChangeValue(parseNumber(newVal, decimalPlaces === 0, max, allowNegative));
    },
    accept: /[\d.-]/g,
    format: function format(val) {
      return formatFixedPointNumber(val, decimalPlaces, max, allowTrailingZero, allowNegative);
    }
  }),
      value = _useRifm.value,
      onChange = _useRifm.onChange;

  return createElement(TextInput, Object.assign({
    className: cx(!hasUtilClass(className, 'pu-text-left') && 'pu-text-right', className)
  }, inputProps, {
    value: value,
    onChange: callAll(onChange, inputProps.onChange)
  }));
};

var getNumberValue = function getNumberValue(value) {
  if (value === '' || value === '-') {
    return undefined;
  }

  var numValue = Number(value);
  return isNaN(numValue) ? undefined : numValue;
};

var DecimalInput = /*#__PURE__*/Object.assign(DecimalInputImpl, {
  getNumberValue: getNumberValue
});
var numberAccept = /[\d.]+/g;
var negativeNumberAccept = /[\d.-]+/g;
var integerAccept = /[\d]+/g;
var negativeIntegerAccept = /[\d-]]+/g;
var MAX_SAFE_LENGTH = 16; // length of Number.MAX_SAFE_INTEGER

var parseNumber = function parseNumber(string, isInteger, max, allowNegative) {
  var result = (string.match(allowNegative ? isInteger ? negativeIntegerAccept : negativeNumberAccept : isInteger ? integerAccept : numberAccept) || []).join('').substring(0, MAX_SAFE_LENGTH);

  if (isDefined(max) && Number(result) > max) {
    var finalResult = '';

    for (var index = 0; index < result.length; index++) {
      var _char = result.charAt(index);

      var newResult = "" + finalResult + _char;

      if (Number(newResult) > max) {
        return finalResult;
      }

      finalResult = newResult;
    }

    return finalResult;
  }

  return result;
};

var formatFixedPointNumber = function formatFixedPointNumber(value, decimalPlaces, max, allowTrailingZero, allowNegative) {
  var parsed = parseNumber(value, decimalPlaces === 0, max, allowNegative);

  if (parsed === '-') {
    return '-';
  }

  var _parsed$split = parsed.split('.'),
      head = _parsed$split[0],
      tail = _parsed$split[1]; // Avoid rounding errors at toLocaleString as when user enters 1.239 and maxDigits=2 we
  // must not to convert it to 1.24, it must stay 1.23


  var scaledTail = tail != null ? tail.slice(0, decimalPlaces) : '';
  var number = Number.parseFloat(head + "." + scaledTail);

  if (Number.isNaN(number)) {
    return '';
  }

  var formatted = formatMoney(number, {
    decimalPlaces: scaledTail.length
  });

  if (parsed.includes('.')) {
    var _formatted$split = formatted.split('.'),
        formattedHead = _formatted$split[0]; // skip zero at digits position for non fixed floats
    // as at digits 2 for non fixed floats numbers like 1.50 has no sense, just 1.5 allowed
    // but 1.0 has sense as otherwise you will not be able to enter 1.05 for example


    var formattedTail = scaledTail !== '' && scaledTail[decimalPlaces - 1] === '0' && !allowTrailingZero ? scaledTail.slice(0, -1) : scaledTail;
    return formattedHead + "." + formattedTail;
  }

  return formatted;
};

var _excluded$U = ["size", "onChangeValue", "onChange", "options", "className", "children", "id", "allowEmpty"];
/**
 * `Dropdown` is a wrapper around `select` element.
 *
 * It accepts all props an `select` element in addition of the stated props.
 *
 * `ref` will be forwarded to the underlying `select` element.
 *
 * Most of the time you want to wrap this within `Field` component so it will provides
 * contextual styling and good defaults on props
 *
 * If there are many options, consider using `<SearchableDropdown />`
 *
 * @deprecated use `<DropdownSelect />`
 */

var Dropdown = /*#__PURE__*/forwardRef(function Dropdown(_ref, ref) {
  var onChangeValue = _ref.onChangeValue,
      onChange = _ref.onChange,
      options = _ref.options,
      className = _ref.className,
      children = _ref.children,
      id = _ref.id,
      _ref$allowEmpty = _ref.allowEmpty,
      allowEmpty = _ref$allowEmpty === void 0 ? true : _ref$allowEmpty,
      selectProps = _objectWithoutPropertiesLoose(_ref, _excluded$U);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      hasHelpText = _useFieldControlConte.hasHelpText,
      status = _useFieldControlConte.status;

  var currentOnChangeValue = useStableCallback(onChangeValue);
  var onChangeValueHandler = useCallback(function (ev) {
    var value = ev.target.value;
    var index = ev.target.selectedIndex;
    var label = index > -1 ? ev.target[index].textContent : '';
    currentOnChangeValue(value, isNil(label) ? '' : label);
  }, [currentOnChangeValue]);
  return createElement("select", Object.assign({
    className: cx('pu-block form-select pu-border focus:pu-outline-none focus:pu-border-brand-200 focus:pu-shadow-outline-brand', !hasUtilClass(className, 'pu-w-') && 'pu-w-full', status && borderByStatus[status], className),
    id: inputId,
    "aria-describedby": hasHelpText ? inputId + "-help" : undefined,
    onChange: callAll(onChange, onChangeValueHandler)
  }, selectProps, {
    ref: ref
  }), allowEmpty && !selectProps.multiple && createElement("option", {
    value: ""
  }, selectProps.placeholder), options && options.map(function (option, index) {
    return createElement("option", {
      value: option.value,
      key: index
    }, option.label);
  }), children);
});

/**
 * DropdownField is just a composition of `FieldContainer` and `Dropdown`.
 *
 * Props not specified will be spreaded to `Dropdown` element, including `ref`.
 *
 * If you need more control, compose them yourself.
 *
 * @deprecated use `<DropdownSelectField />` instead.
 */

var DropdownField = /*#__PURE__*/forwardRef(function DropdownField(props, ref) {
  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(Dropdown, Object.assign({}, controlProps, {
    ref: ref
  })));
});

var _excluded$V = ["legend", "children", "borderTop", "responsive"];
var Fieldset = function Fieldset(_ref) {
  var legend = _ref.legend,
      children = _ref.children,
      borderTop = _ref.borderTop,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? true : _ref$responsive,
      fieldsetProps = _objectWithoutPropertiesLoose(_ref, _excluded$V);

  return createElement("fieldset", Object.assign({}, fieldsetProps), createElement("div", {
    className: cx(responsive ? 'md:pu-flex md:pu-space-x-3' : 'pu-flex pu-space-x-3', borderTop && 'pu-border-t pu-border-gray-200 md:pu-pt-5')
  }, createElement("div", {
    className: cx('pu-py-3', responsive ? 'md:pu-w-24 lg:pu-w-36 md:pu-flex-none' : 'pu-w-36 pu-flex-none')
  }, createElement("legend", {
    className: "pu-text-lightgrey pu-text-xs pu-font-semibold pu-tracking-1"
  }, legend)), createElement("div", {
    className: responsive ? 'md:pu-flex-1' : 'pu-flex-1'
  }, children)));
};

/**
 *
 * Use `<TextInput />` instead.
 *
 * @deprecated
 */

var Input = /*#__PURE__*/forwardRef(function Input(props, ref) {
  return createElement(TextInput, Object.assign({}, props, {
    ref: ref
  }));
});

var _excluded$W = ["currency", "className", "wrapperClass", "widthClass"];
/**
 * MoneyInput allows user to enter financial amount. The value will be displayed
 * in always 2 decimal places with thousand separators.
 *
 * It use `DecimalInput` under the hood.
 */

var MoneyInputImpl = function MoneyInput(_ref) {
  var _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'RM' : _ref$currency,
      className = _ref.className,
      wrapperClass = _ref.wrapperClass,
      _ref$widthClass = _ref.widthClass,
      widthClass = _ref$widthClass === void 0 ? 'pu-w-32' : _ref$widthClass,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$W);

  return createElement("div", {
    className: cx('pu-relative', widthClass, wrapperClass)
  }, createElement("div", {
    className: "pu-absolute pu-inset-y-0 pu-left-0 pu-text-mediumgrey pu-inline-flex pu-items-center pu-pl-3"
  }, currency), createElement(DecimalInput, Object.assign({
    allowTrailingZero: true,
    className: cx('pu-pl-11', className)
  }, inputProps)));
};

var MoneyInput = /*#__PURE__*/Object.assign(MoneyInputImpl, {
  getNumberValue: DecimalInput.getNumberValue
});

var _excluded$X = ["initialValues", "badgeColor", "onChangeValues", "id", "includeDraft", "validateBeforeAdd", "className", "suggestions", "onInputValueChange", "allowSelectAll", "selectAllLabel", "variant", "values", "placeholder"];
/**
 * MultiInputWithSuggestions works just like `<MultiInput />`,
 * with the additional functionality of providing user suggestions
 */

var MultiInputWithSuggestions = /*#__PURE__*/forwardRef(function MultiInputWithSuggestions(_ref, ref) {
  var _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? [] : _ref$initialValues,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'grey' : _ref$badgeColor,
      _ref$onChangeValues = _ref.onChangeValues,
      onChangeValues = _ref$onChangeValues === void 0 ? noop : _ref$onChangeValues,
      id = _ref.id,
      includeDraft = _ref.includeDraft,
      validateBeforeAdd = _ref.validateBeforeAdd,
      className = _ref.className,
      suggestions = _ref.suggestions,
      _ref$onInputValueChan = _ref.onInputValueChange,
      onInputValueChange = _ref$onInputValueChan === void 0 ? noop : _ref$onInputValueChan,
      allowSelectAll = _ref.allowSelectAll,
      _ref$selectAllLabel = _ref.selectAllLabel,
      selectAllLabel = _ref$selectAllLabel === void 0 ? 'Select all' : _ref$selectAllLabel,
      variant = _ref.variant,
      providedValues = _ref.values,
      placeholder = _ref.placeholder,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$X);

  var SELECT_ALL = '__REACT_SETEL_SELECT_ALL__';

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var displayedSuggestions = useMemo(function () {
    if (allowSelectAll && suggestions && suggestions.length > 1) return [SELECT_ALL].concat(suggestions);
    return suggestions;
  }, [allowSelectAll, suggestions]);

  var _React$useState = useState(''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var _React$useMemo = useMemo(function () {
    var values = [];
    var colors = [];
    providedValues.forEach(function (v, index) {
      if (includeDraft && index === providedValues.length - 1 && v === inputValue.trim()) {
        return;
      }

      if (isString(v)) {
        values.push(v);
        colors.push(badgeColor);
      } else {
        var value = v.value,
            _v$color = v.color,
            color = _v$color === void 0 ? badgeColor : _v$color;
        values.push(value);
        colors.push(color);
      }
    });
    return {
      values: values,
      colors: colors
    };
  }, [providedValues, badgeColor, includeDraft, inputValue]),
      values = _React$useMemo.values,
      colors = _React$useMemo.colors;

  var _useMultipleSelection = useMultipleSelection({
    initialSelectedItems: initialValues,
    selectedItems: values,
    onSelectedItemsChange: function onSelectedItemsChange(_ref2) {
      var selectedItems = _ref2.selectedItems;
      onChangeValues(selectedItems);
    }
  }),
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      selectedItems = _useMultipleSelection.selectedItems;

  var addSelectedItem = function addSelectedItem(value) {
    onChangeValues(selectedItems.concat(value));
  };

  var removeSelectedItem = function removeSelectedItem(value) {
    onChangeValues(selectedItems.filter(function (val) {
      return val !== value;
    }));
  };

  var addItem = function addItem(value) {
    var val = value.trim();

    if (val === SELECT_ALL) {
      if (suggestions) {
        onChangeValues(selectedItems.concat(suggestions.filter(function (suggestion) {
          return !validateBeforeAdd || validateBeforeAdd(suggestion);
        })));
      }

      setInputValue('');
    } else if (val && (!validateBeforeAdd || validateBeforeAdd(val))) {
      addSelectedItem(val);
      setInputValue('');
    }
  };

  var handleInputChange = function handleInputChange(value) {
    if (isDefined(value)) {
      if (!/^,+$/.test(value) && value[value.length - 1] === ',') {
        addItem(value.slice(0, -1));
      } else {
        setInputValue(value);

        if (includeDraft) {
          var trimmedVal = value.trim();
          onChangeValues(trimmedVal ? selectedItems.concat(trimmedVal) : selectedItems);
        }
      }
    }
  };

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    selectedItem: null,
    items: displayedSuggestions || [],
    inputId: inputId,
    onStateChange: function onStateChange(_ref3) {
      var inputValue = _ref3.inputValue,
          type = _ref3.type,
          selectedItem = _ref3.selectedItem;

      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          handleInputChange(inputValue);
          onInputValueChange(inputValue || '');
          break;

        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputBlur:
          if (selectedItem === SELECT_ALL) {
            addItem(SELECT_ALL);
          } else if (selectedItem) {
            addItem(selectedItem);
          }

          break;
      }
    }
  }),
      isOpen = _useCombobox.isOpen,
      getInputProps = _useCombobox.getInputProps,
      getItemProps = _useCombobox.getItemProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getMenuProps = _useCombobox.getMenuProps,
      highlightedIndex = _useCombobox.highlightedIndex;

  var divRef = useRef(null);

  var handleKeyDown = function handleKeyDown(ev) {
    if (ev.key === 'Tab' && inputValue) {
      ev.preventDefault();
      addItem(inputValue);
    } else if (ev.key === 'Enter' && inputValue && highlightedIndex === -1) {
      ev.preventDefault();
      addItem(inputValue);
    }
  };

  var isTextarea = variant === 'textarea';
  return createElement(Fragment, null, createElement(MultiInputImplWrapper, Object.assign({
    status: status,
    isTextarea: isTextarea
  }, getComboboxProps({
    className: className,
    ref: divRef
  })), selectedItems.map(function (selectedItem, index) {
    return createElement(MultiInputBadge, Object.assign({
      key: "selectedItem-" + index,
      onDismiss: function onDismiss() {
        return removeSelectedItem(selectedItem);
      },
      isTextarea: isTextarea
    }, getSelectedItemProps({
      selectedItem: selectedItem,
      index: index,
      color: colors[index]
    })), selectedItem);
  }), createElement(MultiInputImp, Object.assign({}, getInputProps(getDropdownProps(_extends({
    onKeyDown: handleKeyDown,
    placeholder: selectedItems.length === 0 ? placeholder : undefined
  }, inputProps, {
    ref: ref
  })))))), createElement(Popover, {
    targetRef: divRef,
    position: positionMatchWidth,
    isOpen: isOpen && !!inputValue,
    className: "pu-mt-1"
  }, createElement("div", Object.assign({}, getMenuProps({
    className: 'portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-52 pu-overflow-auto'
  }, {
    suppressRefError: true
  })), isOpen && inputValue && (displayedSuggestions ? displayedSuggestions.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, "No results found.") : displayedSuggestions.map(function (suggestion, index) {
    return createElement("div", Object.assign({
      key: suggestion + "-" + index
    }, getItemProps({
      item: suggestion,
      index: index,
      className: cx('pu-px-4 pu-py-2', index === highlightedIndex && 'pu-text-brand-800 pu-bg-brand-100', suggestion === SELECT_ALL && 'pu-px-4 pu-py-3 pu-border-b')
    })), suggestion === SELECT_ALL ? selectAllLabel : suggestion);
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }))))));
});

var _excluded$Y = ["children", "label", "wrapperClass"];
/**
 * `<TreeOption />` allows you to display option in a tree structure.
 *
 * Other than the specified props, it also accepts all props that is accepted by `<button />` element.
 *
 * If you want to show the options in a Modal, consider using `<OptionPicker />`.
 *
 * If you want to show the options in a popover, consider using `<DropdownNestedSelect />`.
 */

var TreeOption = /*#__PURE__*/forwardRef(function TreeOption(_ref, ref) {
  var children = _ref.children,
      label = _ref.label,
      wrapperClass = _ref.wrapperClass,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$Y);

  var currentRef = useRef(null);

  var _useDescendantsInit = useDescendantsInit(),
      kids = _useDescendantsInit[0],
      setKids = _useDescendantsInit[1];

  useDescendant({
    element: currentRef.current
  }, DescendantContext$1);
  var combinedRef = useForkedRef(ref, currentRef);
  var isRoot = useContext(IsRootContext);
  return createElement("div", {
    className: cx('pu-relative', !isRoot && 'pu-ml-4', wrapperClass)
  }, createElement("button", Object.assign({}, buttonProps, {
    className: cx('pu-w-full pu-text-left pu-text-sm pu-leading-5 pu-px-4 pu-py-3.5 pu-text-black pu-truncate hover:pu-bg-gray-200 active:pu-bg-gray-300 focus:pu-outline-none focus-visible:pu-shadow-outline-gray', buttonProps.className),
    ref: combinedRef
  }), label), createElement(DescendantProvider, {
    context: DescendantContext$1,
    items: kids,
    set: setKids
  }, createElement(IsRootContext.Provider, {
    value: false
  }, children)), createElement(Connectors, {
    descendants: kids,
    className: "pu-absolute pu-w-8 pu-left-0 pu-text-gray-300 pu-pointer-events-none",
    anchor: currentRef
  }));
});
var DescendantContext$1 = /*#__PURE__*/createDescendantContext('TreeDescentdant');
var IsRootContext = /*#__PURE__*/createNamedContext('IsRoot', true);

var _excluded$Z = ["title", "onSelect", "onSearchTermChange", "options", "isOpen", "onDismiss"];
/**
 * `<OptionPicker />` allows user to choose option from a Modal.
 *
 * The options can be a tree structure.
 *
 * Unspecified props will be spreaded to the `<input />` element
 */

var OptionPicker = function OptionPicker(_ref) {
  var title = _ref.title,
      onSelect = _ref.onSelect,
      onSearchTermChange = _ref.onSearchTermChange,
      options = _ref.options,
      isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$Z);

  var optionData = useMemo(function () {
    return options && mapOptions$1(options);
  }, [options]);

  var _useCombobox = useCombobox({
    isOpen: isOpen,
    items: optionData ? optionData.items : [],
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    onSelectedItemChange: function onSelectedItemChange(changes) {
      if (changes.selectedItem) {
        onSelect(changes.selectedItem.value, changes.selectedItem.label);
        selectItem(null); // reset back to null

        // reset back to null
        setInputValue('');
        onDismiss();
      }
    }
  }),
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getMenuProps = _useCombobox.getMenuProps,
      getItemProps = _useCombobox.getItemProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      setHighlightedIndex = _useCombobox.setHighlightedIndex,
      selectItem = _useCombobox.selectItem,
      setInputValue = _useCombobox.setInputValue;

  useEffect(function () {
    if (isOpen && !onSearchTermChange) {
      setHighlightedIndex(0);
    }
  }, [isOpen, setHighlightedIndex, onSearchTermChange]);
  return createElement(Modal$1, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    "aria-label": title,
    className: "pu-max-w-2xl"
  }, createElement(ModalHeader, null, title), createElement("div", Object.assign({}, getComboboxProps(undefined, override), {
    className: cx('pu-p-4 pu-border-b pu-border-gray-200', !onSearchTermChange && 'pu-sr-only')
  }), createElement(SearchTextInput, Object.assign({
    onChangeValue: onSearchTermChange
  }, getInputProps(inputProps, override)))), createElement("div", Object.assign({}, getMenuProps({
    className: 'portal-ui-scrollbar pu-max-h-80 pu-overflow-auto'
  }, override)), optionData ? optionData.displayedItems.map(function (option, i) {
    return createElement(ModalPickerOption, {
      option: option,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      key: i + "-" + option.label
    });
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }), createElement("span", {
    className: "pu-sr-only"
  }, "Loading..."))));
};

var mapOptions$1 = function mapOptions(options) {
  var items = [];
  var displayedItems = [];
  var index = 0;

  function collect(item, mutableList) {
    var mappedChildren = [];

    var mappedItem = _extends({}, item, {
      children: item.children ? mappedChildren : undefined,
      index: index++
    });

    items.push(mappedItem);

    if (mutableList) {
      mutableList.push(mappedItem);
    } else {
      displayedItems.push(mappedItem);
    }

    if (item.children) {
      item.children.forEach(function (child) {
        return collect(child, mappedChildren);
      });
    }
  }

  options.forEach(function (option) {
    return collect(option);
  });
  return {
    items: items,
    displayedItems: displayedItems
  };
};

var ModalPickerOption = function ModalPickerOption(_ref2) {
  var option = _ref2.option,
      getItemProps = _ref2.getItemProps,
      highlightedIndex = _ref2.highlightedIndex;
  return createElement(TreeOption, Object.assign({
    label: option.label
  }, getItemProps({
    item: option,
    index: option.index,
    className: option.index === highlightedIndex ? 'pu-bg-gray-200' : undefined
  })), option.children && option.children.map(function (child, i) {
    return createElement(ModalPickerOption, {
      option: child,
      getItemProps: getItemProps,
      highlightedIndex: highlightedIndex,
      key: i + "-" + child.label
    });
  }));
};

var override = {
  suppressRefError: true
};

var RadioContext = /*#__PURE__*/createNamedContext('RadioContext', undefined); // intentionally don't provide a default so it is easily known if consumer is wrapped

var _excluded$_ = ["children", "onChangeValue", "wrapperClass", "labelClass", "checked", "name"];
/**
 * `<Radio />` renders a single radio option. You probably want to use it with `<RadioGroup />`.
 */

var Radio = /*#__PURE__*/forwardRef(function Radio(_ref, ref) {
  var children = _ref.children,
      onChangeValue = _ref.onChangeValue,
      wrapperClass = _ref.wrapperClass,
      labelClass = _ref.labelClass,
      checked = _ref.checked,
      name = _ref.name,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$_);

  var inputId = useId(inputProps.id);
  var radioGroupContext = useContext(RadioContext);
  var isChecked = radioGroupContext ? radioGroupContext.value === inputProps.value : checked;
  var radioName = radioGroupContext ? radioGroupContext.name : name;
  return createElement("div", {
    className: cx('pu-flex pu-items-center', !hasUtilClass(wrapperClass, 'pu-mt-') && 'pu-mt-2.5', wrapperClass)
  }, createElement("input", Object.assign({}, inputProps, {
    onChange: callAll(inputProps.onChange, onChangeValue && function (ev) {
      return onChangeValue(ev.target.checked);
    }, radioGroupContext && function () {
      return radioGroupContext.onChangeValue(inputProps.value);
    }),
    name: radioName,
    checked: isChecked,
    id: inputId,
    type: "radio",
    className: cx('form-radio', inputProps.disabled ? 'pu-text-carbon-100' : 'pu-text-brand-500', inputProps.className),
    ref: ref
  })), createElement("label", {
    htmlFor: inputId,
    className: cx('pu-ml-2 pu-block pu-text-sm pu-leading-5 pu-text-black', labelClass)
  }, children));
});

/**
 * `<RadioGroup />` groups all `<Radio />` components into single control.
 */

var RadioGroup = function RadioGroup(props) {
  var contextValue = useMemo(function () {
    return {
      value: props.value,
      name: props.name,
      onChangeValue: props.onChangeValue
    };
  }, [props.value, props.name, props.onChangeValue]);
  return createElement(RadioContext.Provider, {
    value: contextValue
  }, props.children);
};

var _excluded$$ = ["onSelect", "results", "onInputValueChange", "id", "wrapperClass", "className", "allowSelectAll", "selectAllLabel", "noResultText", "onSelectValues"];
/**
 * SearchInput shows list of results and highlights the results.
 *
 * Results are sorted using [`match-sorter`](https://github.com/kentcdodds/match-sorter).
 *
 * When result is selected, input value will be cleared.
 *
 * Unspecified props will be spreaded to the underlying `input` element.
 */

var SearchInput = function SearchInput(_ref) {
  var _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? noop : _ref$onSelect,
      results = _ref.results,
      onInputValueChange = _ref.onInputValueChange,
      id = _ref.id,
      wrapperClass = _ref.wrapperClass,
      className = _ref.className,
      allowSelectAll = _ref.allowSelectAll,
      _ref$selectAllLabel = _ref.selectAllLabel,
      selectAllLabel = _ref$selectAllLabel === void 0 ? 'Select all' : _ref$selectAllLabel,
      _ref$noResultText = _ref.noResultText,
      noResultText = _ref$noResultText === void 0 ? 'No results found.' : _ref$noResultText,
      _ref$onSelectValues = _ref.onSelectValues,
      onSelectValues = _ref$onSelectValues === void 0 ? noop : _ref$onSelectValues,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$$);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var _React$useState = useState(''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var trimmedInput = inputValue.trim();
  var optionData = useMemo(function () {
    return results && sortOptions(results, trimmedInput, allowSelectAll);
  }, [results, trimmedInput, allowSelectAll]);

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    selectedItem: null,
    items: optionData ? optionData.items : [],
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    inputId: inputId,
    onSelectedItemChange: function onSelectedItemChange(_ref2) {
      var selectedItem = _ref2.selectedItem;

      if (selectedItem) {
        if (selectedItem.value === SELECT_ALL) {
          if (optionData) {
            var result = [];
            optionData.items.forEach(function (item) {
              if (item.value !== SELECT_ALL) {
                result.push(item.value);
                onSelect && onSelect(item.value);
              }
            });
            onSelectValues(result);
          }
        } else {
          onSelect(selectedItem.value);
          onSelectValues([selectedItem.value]);
        }
      } else {
        onSelect(null);
        onSelectValues([]);
      }

      setInputValue('');
    }
  }),
      isOpen = _useCombobox.isOpen,
      highlightedIndex = _useCombobox.highlightedIndex,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps;

  var divRef = useRef(null);
  return createElement(Fragment, null, createElement("div", Object.assign({}, getComboboxProps({
    className: cx('pu-relative', wrapperClass),
    ref: divRef
  })), createElement(TextInput, Object.assign({
    onChangeValue: callAll(onInputValueChange && function (val) {
      return onInputValueChange(val.trim());
    }, setInputValue)
  }, getInputProps(_extends({
    value: inputValue,
    className: cx(status && borderByStatus[status], className)
  }, inputProps))))), createElement(Popover, {
    targetRef: divRef,
    position: positionMatchWidth,
    isOpen: isOpen,
    className: "pu-mt-0.5"
  }, createElement("div", Object.assign({}, getMenuProps({
    className: 'portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-72 pu-overflow-auto'
  }, {
    suppressRefError: true
  })), isOpen && (optionData ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, noResultText) : optionData.displayedItems.map(function (group, gIndex) {
    return createElement(Fragment, {
      key: gIndex
    }, group.groupLabel && createElement(OptGroupLabel, null, group.groupLabel), group.options.map(function (result) {
      return createElement(Option, Object.assign({
        key: result.value + "-" + result.index
      }, getItemProps({
        item: result,
        index: result.index,
        disabled: result.disabled
      }), {
        leftIcon: result.icon,
        highlighted: result.index === highlightedIndex,
        disabled: result.disabled,
        label: result.value === SELECT_ALL ? selectAllLabel : createElement(TextHighlight, {
          searchWords: [trimmedInput],
          textToHighlight: result.label
        }),
        description: result.description && createElement(TextHighlight, {
          textToHighlight: result.description,
          searchWords: [trimmedInput]
        }),
        className: result.value === SELECT_ALL ? 'pu-border-b pu-border-offwhite' : undefined
      }));
    }));
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }))))));
};

function RecursiveOption$1(_ref) {
  var option = _ref.option,
      highlightedIndex = _ref.highlightedIndex,
      searchValue = _ref.searchValue,
      getItemProps = _ref.getItemProps;
  var currentRef = useRef(null);

  var _useDescendantsInit = useDescendantsInit(),
      kids = _useDescendantsInit[0],
      setKids = _useDescendantsInit[1];

  useDescendant({
    element: currentRef.current
  }, DescendantContext$2);
  return createElement("div", {
    className: cx('pu-relative', option.parent ? option.parent.icon ? 'pu-ml-17' : 'pu-ml-6' : 'pu-border-b pu-border-gray-200 last:pu-border-transparent')
  }, createElement("div", {
    className: "pu-flex pu-items-center"
  }, createElement(Option, Object.assign({
    highlighted: highlightedIndex === option.index,
    label: createElement(TextHighlight, {
      searchWords: [searchValue],
      textToHighlight: option.label
    }),
    description: option.description && createElement(TextHighlight, {
      searchWords: [searchValue],
      textToHighlight: option.description
    }),
    leftIcon: option.icon && createElement("div", {
      className: "pu-py-3 pu--mr-1"
    }, createElement("div", {
      className: "pu-w-10 pu-h-10"
    }, option.icon))
  }, getItemProps({
    item: option,
    index: option.index,
    className: 'pu-flex-1 pu-w-0',
    ref: currentRef
  })))), option.children && createElement(DescendantProvider, {
    context: DescendantContext$2,
    items: kids,
    set: setKids
  }, option.children.length > 0 && createElement(Fragment, null, option.children.map(function (childOption) {
    return createElement(RecursiveOption$1, {
      key: childOption.value + "-" + childOption.index,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      searchValue: searchValue,
      option: childOption
    });
  }), createElement(Connectors, {
    descendants: kids,
    className: cx('pu-absolute pu-w-8 pu-text-gray-300 pu-pointer-events-none', option.icon ? 'pu-left-13' : 'pu-left-2'),
    anchor: currentRef
  }))));
}
var DescendantContext$2 = /*#__PURE__*/createDescendantContext('NestedSelectDescendant');

var _excluded$10 = ["value", "onChangeValue", "options", "wrapperClass", "id", "className", "onFocus", "onInputValueChange", "initialLabel", "popoverPosition", "description", "noResultText", "_cacheKey"];
/**
 * SearchableNestedDropdown allows you to select value from
 * a dropdown options with hierarchical relationship and filter the options with search text.
 */

var SearchableNestedDropdown = function SearchableNestedDropdown(_ref) {
  var value = _ref.value,
      onChangeValue = _ref.onChangeValue,
      options = _ref.options,
      wrapperClass = _ref.wrapperClass,
      id = _ref.id,
      className = _ref.className,
      onFocus = _ref.onFocus,
      onInputValueChange = _ref.onInputValueChange,
      _ref$initialLabel = _ref.initialLabel,
      initialLabel = _ref$initialLabel === void 0 ? value : _ref$initialLabel,
      _ref$popoverPosition = _ref.popoverPosition,
      popoverPosition = _ref$popoverPosition === void 0 ? positionMatchWidth : _ref$popoverPosition,
      description = _ref.description,
      _ref$noResultText = _ref.noResultText,
      noResultText = _ref$noResultText === void 0 ? 'No results found.' : _ref$noResultText,
      _ref$_cacheKey = _ref._cacheKey,
      _cacheKey = _ref$_cacheKey === void 0 ? id : _ref$_cacheKey,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$10);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var _React$useState = useState(value || ''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var trimmedInput = inputValue.trim();

  var _useOptionCache = useOptionCache({
    queryKey: _cacheKey || inputId,
    initialData: value ? [{
      value: value,
      label: initialLabel
    }] : undefined
  }),
      _useOptionCache$data = _useOptionCache.data,
      cachedRoot = _useOptionCache$data[0],
      addToCache = _useOptionCache.addData;

  var validCachedRoot = useMemo(function () {
    if (!cachedRoot) {
      return undefined;
    }

    return hasValue(cachedRoot, value) ? cachedRoot : undefined;
  }, [cachedRoot, value]); // we don't filter or sort options filter if component user pass onInputValueChange
  // which we can infer that options are already filtered by API.

  var optionFilterKey = onInputValueChange ? '' : trimmedInput;
  var optionData = useMemo(function () {
    var removedRoot = function findRemovedRoot() {
      if (!validCachedRoot) {
        return undefined;
      }

      if (!options) {
        return validCachedRoot;
      }

      for (var index = 0; index < options.length; index++) {
        var rootOption = options[index];

        if (hasValue(rootOption, value)) {
          return undefined;
        }
      }

      return validCachedRoot;
    }();

    var allOptionsToProcessed = removedRoot ? options ? [removedRoot].concat(options) : [removedRoot] : options;
    return mapNestedOptionsWithSearch(allOptionsToProcessed, optionFilterKey);
  }, [options, optionFilterKey, validCachedRoot]);
  var selectedItem = useMemo(function () {
    if (!value || !optionData) {
      return null;
    }

    return optionData.allItems.find(function (o) {
      return o.value === value;
    }) || null;
  }, [value, optionData]);
  var displayedValue = useMemo(function () {
    if (!optionData) {
      return '';
    }

    var selectedOption = optionData.allItems.find(function (item) {
      return item.value === value;
    });
    return selectedOption ? selectedOption.label : '';
  }, [optionData, value]);
  useEffect(function () {
    setInputValue(displayedValue);
  }, [displayedValue]);

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    selectedItem: selectedItem,
    items: optionData && optionData.items || [],
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    inputId: inputId,
    onSelectedItemChange: function onSelectedItemChange(changes) {
      var selectedItem = changes.selectedItem;

      if (selectedItem) {
        onChangeValue(selectedItem.value, selectedItem.label);

        (function addRootOfSelectedItemToCache(item) {
          var current = item;

          while (current.parent !== null) {
            current = current.parent;
          }

          addToCache([sanitizeOptionData(current)], {
            replace: true
          });
        })(selectedItem);
      } else {
        onChangeValue('', '');
      }
    },
    onStateChange: function onStateChange(_ref2) {
      var type = _ref2.type;

      if (type === useCombobox.stateChangeTypes.InputBlur || type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
        if (inputValue !== displayedValue) {
          setInputValue(displayedValue);
        }
      }
    }
  }),
      isOpen = _useCombobox.isOpen,
      openMenu = _useCombobox.openMenu,
      highlightedIndex = _useCombobox.highlightedIndex,
      getToggleButtonProps = _useCombobox.getToggleButtonProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps,
      selectItem = _useCombobox.selectItem;

  var divRef = useRef(null);
  return createElement(Fragment, null, createElement("div", Object.assign({}, getComboboxProps({
    className: cx('pu-relative', wrapperClass),
    ref: divRef
  })), createElement(TextInput, Object.assign({
    onChangeValue: callAll(onInputValueChange && function (val) {
      return onInputValueChange(val.trim());
    }, setInputValue, function (newVal) {
      if (newVal === '' && selectedItem) {
        selectItem(null);
      }
    })
  }, getInputProps(_extends({
    value: inputValue,
    onFocus: callAll(onFocus, function () {
      if (!isOpen) {
        openMenu();
      }
    }),
    className: cx(status && borderByStatus[status], description && 'pu-pb-6', className)
  }, inputProps)))), description && createElement("div", Object.assign({}, getToggleButtonProps({
    className: 'pu-absolute pu-bottom-0 pu-inset-x-0 pu-text-xs pu-px-3 pu-pt-1 pu-pb-2.25 pu-text-lightgrey pu-truncate focus:pu-outline-none pu-border pu-border-transparent',
    disabled: inputProps.disabled
  })), description)), createElement(Popover, {
    targetRef: divRef,
    position: popoverPosition,
    isOpen: isOpen,
    className: "pu-mt-1"
  }, createElement("div", Object.assign({}, getMenuProps({}, {
    suppressRefError: true
  }), {
    className: "portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-52 pu-overflow-auto focus:pu-outline-none"
  }), isOpen && (optionData && options ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, noResultText) : optionData.displayedItems.map(function (option, gIndex) {
    return createElement(RecursiveOption$1, {
      option: option,
      key: gIndex,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      searchValue: trimmedInput
    });
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }))))));
};

function hasValue(option, value) {
  if (option.value === value) {
    return true;
  }

  return Array.isArray(option.children) && option.children.some(function (child) {
    return hasValue(child, value);
  });
}
/**
 * sanitize the data to avoid recursive ref from crashing react-query
 */


function sanitizeOptionData(optionData) {
  return {
    label: optionData.label,
    value: optionData.value,
    description: optionData.description,
    icon: optionData.icon,
    children: optionData.children.map(sanitizeOptionData)
  };
}

var _excluded$11 = ["values", "onChangeValues", "options", "id", "className", "onFocus", "onInputValueChange", "popoverPosition", "placeholder", "noResultText"];
/**
 * SearchableNestedMultiSelect allows you to select values from
 * a dropdown options with hierarchical relationship and filter the options with search text.
 */

var SearchableNestedMultiSelect = function SearchableNestedMultiSelect(_ref) {
  var values = _ref.values,
      onChangeValues = _ref.onChangeValues,
      options = _ref.options,
      id = _ref.id,
      className = _ref.className,
      onFocus = _ref.onFocus,
      onInputValueChange = _ref.onInputValueChange,
      _ref$popoverPosition = _ref.popoverPosition,
      popoverPosition = _ref$popoverPosition === void 0 ? positionMatchWidth : _ref$popoverPosition,
      placeholder = _ref.placeholder,
      _ref$noResultText = _ref.noResultText,
      noResultText = _ref$noResultText === void 0 ? 'No results found.' : _ref$noResultText,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$11);

  var _useFieldControlConte = useFieldControlContext(id),
      inputId = _useFieldControlConte.inputId,
      status = _useFieldControlConte.status;

  var _React$useState = useState(''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var trimmedInput = inputValue.trim();

  var onInputChange = function onInputChange(value) {
    setInputValue(value);

    if (onInputValueChange) {
      onInputValueChange(value.trim());
    }
  }; // we assume the options are dynamic if the component user pass onInputValueChange


  var isDynamicOptions = !!onInputValueChange; // if the options are dynamic, we don't do further sorting/filtering

  var optionFilterKey = isDynamicOptions ? '' : trimmedInput;
  var optionData = useMemo(function () {
    return mapNestedOptionsWithSearch(options, optionFilterKey);
  }, [options, optionFilterKey]);

  var _useMultipleSelection = useMultipleSelection({
    selectedItems: values,
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    onSelectedItemsChange: function onSelectedItemsChange(_ref2) {
      var selectedItems = _ref2.selectedItems;

      if (selectedItems) {
        onChangeValues(selectedItems);
      }
    }
  }),
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem;

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    selectedItem: null,
    items: optionData && optionData.items || [],
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    inputId: inputId,
    stateReducer: function stateReducer(state, _ref3) {
      var type = _ref3.type,
          changes = _ref3.changes;

      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.ItemClick) {
        return _extends({}, changes, {
          isOpen: state.isOpen
        });
      }

      return changes;
    },
    onStateChange: function onStateChange(_ref4) {
      var type = _ref4.type,
          inputValue = _ref4.inputValue,
          selectedItem = _ref4.selectedItem;

      if (type === useCombobox.stateChangeTypes.InputChange) {
        onInputChange(inputValue || '');
        return;
      }

      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.ItemClick) {
        if (selectedItem) {
          onInputChange('');
          addSelectedItem(selectedItem);
        }

        return;
      }
    }
  }),
      isOpen = _useCombobox.isOpen,
      openMenu = _useCombobox.openMenu,
      highlightedIndex = _useCombobox.highlightedIndex,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps;

  var divRef = useRef(null);
  return createElement(Fragment, null, createElement(MultiInputImplWrapper, Object.assign({}, getComboboxProps({
    className: className,
    ref: divRef
  })), values.map(function (selectedItem, index) {
    return createElement(MultiInputBadge, Object.assign({
      key: "selectedItem-" + index,
      onDismiss: function onDismiss(ev) {
        ev.stopPropagation();
        removeSelectedItem(selectedItem);

        if (!isOpen) {
          openMenu();
        }
      }
    }, getSelectedItemProps({
      selectedItem: selectedItem,
      index: index
    })), selectedItem.label);
  }), createElement(MultiInputImp, Object.assign({}, getInputProps(getDropdownProps(_extends({
    value: inputValue,
    onFocus: callAll(onFocus, function () {
      if (!isOpen) {
        openMenu();
      }
    }),
    className: status && borderByStatus[status],
    placeholder: values && values.length > 0 ? undefined : placeholder
  }, inputProps)))))), createElement(Popover, {
    targetRef: divRef,
    position: popoverPosition,
    isOpen: isOpen,
    className: "pu-mt-1"
  }, createElement("div", Object.assign({}, getMenuProps({}, {
    suppressRefError: true
  }), {
    className: "portal-ui-scrollbar pu-text-sm pu-rounded-md pu-bg-white pu-shadow-xs pu-max-h-52 pu-overflow-auto focus:pu-outline-none"
  }), isOpen && (optionData && options ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2"
  }, noResultText) : optionData.displayedItems.map(function (option, gIndex) {
    return createElement(RecursiveOption$1, {
      option: option,
      key: gIndex,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      searchValue: trimmedInput
    });
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  }))))));
};

/**
 * TextField is just a composition of `FieldContainer` and `TextInput`.
 *
 * Props not specified will be spreaded to `TextInput` element, including `ref`.
 *
 * If you need more control, compose them yourself.
 */

var TextField = /*#__PURE__*/forwardRef(function TextField(props, ref) {
  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({}, fieldProps), createElement(TextInput, Object.assign({}, controlProps, {
    ref: ref
  })));
});

var _excluded$12 = ["onChangeValue", "minRows"];
var Textarea = /*#__PURE__*/forwardRef(function TextareaImpl(_ref, forwardedRef) {
  var onChangeValue = _ref.onChangeValue,
      _ref$minRows = _ref.minRows,
      minRows = _ref$minRows === void 0 ? 2 : _ref$minRows,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$12);

  var _useFieldControlConte = useFieldControlContext(props.id),
      inputId = _useFieldControlConte.inputId,
      hasHelpText = _useFieldControlConte.hasHelpText,
      status = _useFieldControlConte.status;

  return createElement(TextareaAutosize, Object.assign({
    "aria-describedby": hasHelpText ? inputId + "-help" : undefined,
    id: inputId,
    minRows: minRows
  }, props, {
    className: cx('form-textarea pu-block pu-w-full pu-min-w-0 pu-leading-6', !hasUtilClass(props.className, 'focus:pu-') && 'focus:pu-border-brand-200', status && borderByStatus[status], (props.readOnly || props.disabled) && !hasUtilClass(props.className, 'pu-bg-') && 'pu-bg-gray-200 pu-text-lightgrey', props.className),
    onChange: callAll(props.onChange, onChangeValue && function (ev) {
      return onChangeValue(ev.target.value);
    }),
    // outdated @types/react-textarea-autosize definition which is included by one of the dependency
    ref: forwardedRef
  }));
});

/**
 * TextareaField is just a composition of `FieldContainer` and `Textarea`.
 *
 * Props not specified will be spreaded to `Textarea` element, including `ref`.
 *
 * If you need more control, compose them yourself.
 */

var TextareaField = /*#__PURE__*/forwardRef(function TextareaField(props, ref) {
  var _groupProps = groupProps(props),
      fieldProps = _groupProps.fieldProps,
      controlProps = _groupProps.controlProps;

  return createElement(FieldContainer, Object.assign({
    labelAlign: "start"
  }, fieldProps), createElement(Textarea, Object.assign({}, controlProps, {
    ref: ref
  })));
});

var _excluded$13 = ["on", "onChangeValue", "className"];
/**
 * Toggle represents on/off values.
 *
 * It accepts all props supported by an `<input type="checkbox" />` element.
 */

var Toggle = function Toggle(_ref) {
  var on = _ref.on,
      onChangeValue = _ref.onChangeValue,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$13);

  var _useFieldControlConte = useFieldControlContext(props.id),
      inputId = _useFieldControlConte.inputId;

  var _React$useState = useState(false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  return createElement("label", {
    className: cx('pu-relative pu-inline-flex pu-flex-shrink-0 pu-h-6 pu-w-11 pu-border-2 pu-border-transparent pu-rounded-full pu-transition-colors pu-ease-in-out pu-duration-200', !props.disabled && 'pu-cursor-pointer', on ? 'pu-bg-brand-500' : 'pu-bg-gray-200', focused && 'pu-shadow-outline', className),
    htmlFor: inputId
  }, createElement("input", Object.assign({
    checked: on,
    className: "pu-sr-only"
  }, props, {
    id: inputId,
    type: "checkbox",
    onChange: callAll(function (ev) {
      return onChangeValue(ev.target.checked);
    }, props.onChange),
    onFocus: callAll(props.onFocus, function () {
      return setFocused(true);
    }),
    onBlur: callAll(props.onBlur, function () {
      return setFocused(false);
    })
  })), createElement("span", {
    "aria-hidden": "true",
    className: cx('pu-inline-block pu-h-5 pu-w-5 pu-rounded-full pu-bg-white pu-shadow pu-transform pu-transition pu-ease-in-out pu-duration-200', on ? 'pu-translate-x-5' : 'pu-translate-x-0')
  }));
};

var _excluded$14 = ["status", "label", "wrapperClass"];
/**
 * ToggleField is just a composition of `Field`, `Toggle`, and `Label`.
 *
 * Props not specified will be spreaded to `Toggle` element.
 *
 * If you need more control, compose them yourself.
 */

var ToggleField = function ToggleField(_ref) {
  var status = _ref.status,
      label = _ref.label,
      wrapperClass = _ref.wrapperClass,
      toggleProps = _objectWithoutPropertiesLoose(_ref, _excluded$14);

  return createElement(Field, {
    className: cx('pu-flex pu-items-center', wrapperClass),
    status: status
  }, createElement(Toggle, Object.assign({}, toggleProps, {
    className: cx('pu-mr-3', toggleProps.className)
  })), label && createElement(Label, {
    size: "normal",
    className: "pu-mb-0"
  }, label));
};

var _excluded$15 = ["color", "className", "icon"];
/**
 * `<Indicator />` provides visual hint to the status of an element by using color.
 *
 * Note that you should provide supportive description to ensure color-blind user still
 * able to use the UI.
 */

var Indicator = /*#__PURE__*/forwardRef(function Indicator(_ref, ref) {
  var color = _ref.color,
      className = _ref.className,
      icon = _ref.icon,
      spanProps = _objectWithoutPropertiesLoose(_ref, _excluded$15);

  return createElement("span", Object.assign({}, spanProps, {
    className: cx('pu-inline-flex pu-justify-center pu-items-center pu-font-medium focus:pu-outline-none pu-rounded-full', color && (icon ? wrapperClassByColor$1[color] : wrapperClassByColorWithoutIcon[color]), !hasUtilClass(className, 'pu-[h|w]-') && (icon ? 'pu-h-4 pu-w-4' : 'pu-h-2.5 pu-w-2.5'), className),
    ref: ref
  }), icon && isValidElement(icon) && cloneElement(icon, {
    className: cx('pu-w-2 pu-h-2', icon.props.className)
  }));
});
var wrapperClassByColor$1 = {
  blue: 'pu-bg-blue-100 pu-text-blue-800',
  brand: 'pu-bg-brand-100 pu-text-brand-800',
  error: 'pu-bg-red-100 pu-text-error-500',
  grey: 'pu-bg-gray-200 pu-text-mediumgrey',
  info: 'pu-bg-info-100 pu-text-info-500',
  lemon: 'pu-bg-lemon-100 pu-text-lemon-800',
  purple: 'pu-bg-purple-100 pu-text-purple-800',
  success: 'pu-bg-green-100 pu-text-success-500',
  turquoise: 'pu-bg-turquoise-100 pu-text-turquoise-800',
  warning: 'pu-bg-yellow-100 pu-text-warning-500'
};
var wrapperClassByColorWithoutIcon = {
  blue: 'pu-bg-blue-200',
  brand: 'pu-bg-brand-200',
  error: 'pu-bg-red-500',
  grey: 'pu-bg-mediumgrey',
  info: 'pu-bg-info-500',
  lemon: 'pu-bg-lemon-500',
  purple: 'pu-bg-purple-800',
  success: 'pu-bg-green-500',
  turquoise: 'pu-bg-turquoise-800',
  warning: 'pu-bg-yellow-500'
};

function JsonCodeViewer(_ref) {
  var json = _ref.json,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? true : _ref$root,
      comma = _ref.comma,
      _ref$bracket = _ref.bracket,
      bracket = _ref$bracket === void 0 ? true : _ref$bracket;

  if (!json) {
    return null;
  }

  return createElement("div", {
    className: cx(root && 'pu-p-4 md:pu-px-6 pu-bg-gray-900 pu-font-mono pu-text-sm')
  }, bracket && createElement("div", {
    className: "pu-text-info-500"
  }, '{'), createElement("div", {
    className: "pu-pl-3 md:pu-pl-6"
  }, Object.entries(json).map(function (_ref2, index, allVal) {
    var key = _ref2[0],
        value = _ref2[1];
    return createElement(JsonRecord, {
      label: key,
      value: value,
      key: index,
      comma: index !== allVal.length - 1
    });
  })), createElement("div", {
    className: "pu-text-info-500"
  }, bracket && '}', comma && ','));
}

var JsonRecord = function JsonRecord(_ref3) {
  var label = _ref3.label,
      value = _ref3.value,
      comma = _ref3.comma;

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return createElement("div", {
        className: "pu-flex pu-items-start"
      }, createElement("div", {
        className: "pu-text-info-500 pu-inline-block pu-mr-2"
      }, "\"", label, "\":"), createElement("div", {
        className: "pu-inline-block"
      }, createElement("div", {
        className: "pu-text-info-500"
      }, "[]", comma && ',')));
    }

    return createElement(Fragment, null, createElement("div", {
      className: "pu-flex pu-items-start"
    }, createElement("div", {
      className: "pu-text-info-500 pu-inline-block pu-mr-2"
    }, "\"", label, "\":"), createElement("div", {
      className: "pu-inline-block"
    }, createElement("div", {
      className: "pu-text-info-500"
    }, "["))), createElement("div", {
      className: "pu-pl-3 md:pu-pl-6"
    }, value.map(function (val, index, allVal) {
      return createElement("div", {
        className: "pu-flex pu-items-start",
        key: index
      }, createElement(JsonValue, {
        value: val,
        comma: index !== allVal.length - 1
      }));
    })), createElement("div", {
      className: "pu-text-info-500"
    }, "]", comma && ','));
  }

  return value && typeof value === 'object' ? isEmptyObject(value) ? createElement("div", {
    className: "pu-text-info-500 pu-inline-block pu-mr-2"
  }, "\"", label, "\": ", '{}', comma && ',') : createElement(Fragment, null, createElement("div", {
    className: "pu-text-info-500 pu-inline-block pu-mr-2"
  }, "\"", label, "\": ", '{'), createElement(JsonCodeViewer, {
    json: value,
    root: false,
    bracket: false
  }), createElement("div", {
    className: "pu-text-info-500"
  }, '}', comma && ',')) : createElement("div", {
    className: "pu-flex pu-items-start"
  }, createElement("div", {
    className: "pu-text-info-500 pu-inline-block pu-mr-2"
  }, "\"", label, "\":"), createElement("div", {
    className: "pu-inline-block"
  }, createElement(JsonValue, {
    value: value,
    comma: comma
  })));
};

var JsonValue = function JsonValue(_ref4) {
  var value = _ref4.value,
      comma = _ref4.comma;
  var commaNode = comma && createElement("span", {
    className: "pu-text-info-500"
  }, ",");
  var valType = typeof value;

  if (isNil(value)) {
    return createElement("span", {
      className: "pu-text-white"
    }, value === null ? 'null' : 'undefined', commaNode);
  }

  switch (valType) {
    case 'string':
      return createElement("span", {
        className: "pu-text-turquoise-200"
      }, "\"", value, "\"", commaNode);

    case 'number':
      return createElement("span", {
        className: "pu-text-lemon-200"
      }, value, commaNode);

    case 'boolean':
      return createElement("span", {
        className: "pu-text-purple-100"
      }, String(value), commaNode);

    case 'object':
      {
        if (Array.isArray(value)) {
          return value.length === 0 ? createElement("span", {
            className: "pu-text-info-500"
          }, "[]", commaNode) : createElement(Fragment, null, createElement("div", {
            className: "pu-inline-block"
          }, createElement("div", {
            className: "pu-text-info-500"
          }, "["), createElement("div", {
            className: "pu-pl-3 md:pu-pl-6"
          }, value.map(function (item, index, allItems) {
            return createElement("div", {
              key: index
            }, createElement(JsonValue, {
              value: item,
              comma: index !== allItems.length - 1
            }));
          })), createElement("div", {
            className: "pu-text-info-500"
          }, "]", commaNode)));
        }

        return isEmptyObject(value) ? createElement("span", {
          className: "pu-text-info-500"
        }, '{}', commaNode) : createElement(JsonCodeViewer, {
          json: value,
          root: false,
          comma: comma
        });
      }

    default:
      return createElement("span", {
        className: "pu-text-white"
      }, value, commaNode);
  }
};

var isValue = function isValue(value) {
  return !value || isPrimitive(value);
};

var formatJson = function formatJson(value, expandedPaths) {
  if (isValue(value)) {
    return [];
  }

  var result = [];
  var itemIndex = 0;

  function collect(output, value, parentPath, level) {
    if (Array.isArray(value)) {
      value.forEach(function (item, index) {
        var label = "Item " + (index + 1);
        var path = parentPath + "." + label;
        var parsed = parseValue$1(item);

        if (parsed.hasMore) {
          var expanded = expandedPaths.includes(path);
          var children = [];
          output.push({
            label: label,
            path: path,
            value: parsed.value,
            index: itemIndex++,
            children: children,
            expanded: expanded,
            level: level
          });

          if (expanded) {
            collect(children, item, path, level + 1);
          }
        } else {
          output.push({
            label: label,
            value: parsed.value,
            index: itemIndex++,
            path: path,
            level: level
          });
        }
      });
    } else {
      Object.entries(value).forEach(function (_ref) {
        var key = _ref[0],
            val = _ref[1];
        var label = prettifyLabel(key);
        var path = parentPath + "." + label;
        var parsed = parseValue$1(val);

        if (parsed.hasMore) {
          var expanded = expandedPaths.includes(path);
          var children = [];
          output.push({
            label: label,
            value: parsed.value,
            index: itemIndex++,
            path: path,
            children: children,
            expanded: expanded,
            level: level
          });

          if (expanded) {
            collect(children, val, path, level + 1);
          }
        } else {
          output.push({
            label: label,
            value: parsed.value,
            index: itemIndex++,
            path: path,
            level: level
          });
        }
      });
    }
  }

  collect(result, value, '', 0);
  return result;
};
/**
 * @see https://stackoverflow.com/a/35953318/7150387
 */

var prettifyLabel = function prettifyLabel(camelCaseText) {
  if (!camelCaseText || typeof camelCaseText !== 'string') {
    return camelCaseText;
  }

  if (camelCaseText === 'id' || camelCaseText === '_id') {
    return 'ID';
  }

  var sentence = camelCaseText.replace(/([a-z])([A-Z][a-z])/g, '$1 $2') // "To Get YourGEDIn TimeASong About The26ABCs IsOf The Essence ButAPersonalIDCard For User456In Room26AContainingABC26Times IsNot AsEasy As123ForC3POOrR2D2Or2R2D"
  .replace(/([A-Z][a-z])([A-Z])/g, '$1 $2') // "To Get YourGEDIn TimeASong About The26ABCs Is Of The Essence ButAPersonalIDCard For User456In Room26AContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
  .replace(/([a-z])([A-Z]+[a-z])/g, '$1 $2') // "To Get Your GEDIn Time ASong About The26ABCs Is Of The Essence But APersonal IDCard For User456In Room26AContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
  .replace(/([A-Z]+)([A-Z][a-z][a-z])/g, '$1 $2') // "To Get Your GEDIn Time A Song About The26ABCs Is Of The Essence But A Personal ID Card For User456In Room26A ContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
  .replace(/([a-z]+)([A-Z0-9]+)/g, '$1 $2') // "To Get Your GEDIn Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC26Times Is Not As Easy As 123For C3POOr R2D2Or 2R2D"
  // Note: the next regex includes a special case to exclude plurals of acronyms, e.g. "ABCs"
  .replace(/([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, '$1 $2') // "To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC26Times Is Not As Easy As 123For C3PO Or R2D2Or 2R2D"
  .replace(/([0-9])([A-Z][a-z]+)/g, '$1 $2') // "To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC 26Times Is Not As Easy As 123For C3PO Or R2D2Or 2R2D"
  // Note: the next two regexes use {2,} instead of + to add space on phrases like Room26A and 26ABCs but not on phrases like R2D2 and C3PO"
  .replace(/([A-Z]{2,})([0-9]{2,})/g, '$1 $2') // "To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
  .replace(/([0-9]{2,})([A-Z]{2,})/g, '$1 $2').trim();
  return sentence && sentence.charAt(0).toUpperCase() + sentence.substring(1).toLowerCase();
};

var parseValue$1 = function parseValue(value) {
  if (isEmpty(value)) {
    return {
      value: '-',
      hasMore: false
    };
  }

  if (Array.isArray(value)) {
    if (value.length === 0 || value.every(isEmpty)) {
      return {
        value: '-',
        hasMore: false
      };
    }

    if (value.every(isPrimitive)) {
      return {
        value: value.map(function (item) {
          return typeof item === 'boolean' ? titleCase(String(item)) : item;
        }).join(', '),
        hasMore: false
      };
    }

    return {
      value: '',
      hasMore: true
    };
  }

  var valType = typeof value;

  switch (valType) {
    case 'string':
    case 'number':
      return {
        value: value,
        hasMore: false
      };

    case 'boolean':
      return {
        value: titleCase(String(value)),
        hasMore: false
      };

    case 'object':
      return {
        value: '',
        hasMore: true
      };

    default:
      return {
        value: '',
        hasMore: false
      };
  }
};

var isEmpty = function isEmpty(value) {
  return isNil(value) || value === '' || isEmptyObject(value);
};

function JsonPrettyViewer(_ref) {
  var json = _ref.json,
      _ref$formatDate = _ref.formatDate,
      formatDate = _ref$formatDate === void 0 ? false : _ref$formatDate;
  var rerender = useForceUpdate();

  var _React$useReducer = useReducer(stateReducer, []),
      pathsToExpand = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var formattedJson = useMemo(function () {
    return formatJson(json, pathsToExpand);
  }, [json, pathsToExpand]);

  if (!json) {
    return null;
  }

  return createElement(RerenderContext.Provider, {
    value: rerender
  }, createElement(DispatchToggleContext.Provider, {
    value: dispatch
  }, createElement("div", {
    className: "pu-bg-white"
  }, createElement("div", {
    className: "pu-flex"
  }, createElement(PrettyCell, {
    className: "pu-pl-7",
    type: "label",
    heading: true
  }, "NAME"), createElement(PrettyCell, {
    type: "value",
    heading: true
  }, "VALUE")), formattedJson.map(function (item) {
    return createElement(PrettyJsonNode, {
      node: item,
      formatDate: formatDate,
      key: item.path
    });
  }))));
}
var PrettyJsonNode = function PrettyJsonNode(_ref2) {
  var node = _ref2.node,
      formatDate = _ref2.formatDate;
  var isStriped = node.index % 2 === 1;
  var toggle = useContext(DispatchToggleContext);
  var currentRef = useRef(null);
  useDescendant({
    element: currentRef.current,
    isButton: isDefined(node.expanded)
  }, DescendantContext$3);

  var _useDescendantsInit = useDescendantsInit(),
      kids = _useDescendantsInit[0],
      setKids = _useDescendantsInit[1];

  var rerender = useContext(RerenderContext);
  useLayoutEffect(function () {
    if (isDefined(node.expanded)) {
      // force rerender in order for the connector calculation to be correct
      rerender();
    }
  }, [node.expanded, rerender]);
  return isDefined(node.expanded) ? createElement("div", {
    className: "pu-relative"
  }, createElement("button", {
    onClick: function onClick() {
      return toggle(node.path);
    },
    className: cx('pu-w-full hover:pu-bg-gray-100 focus:pu-outline-none focus-visible:pu-shadow-outline-gray', isStriped ? 'pu-bg-lightergrey' : 'pu-bg-white'),
    type: "button"
  }, createElement("div", {
    className: cx('pu-flex', padByLevel[node.level])
  }, createElement(PrettyCell, {
    className: "pu-pl-7",
    type: "label"
  }, createElement("div", {
    className: "pu-flex pu-items-center"
  }, createElement("div", {
    className: cx('pu-mr-1 pu--my-px sm:pu-mr-3 pu-text-white pu-bg-gray-400 pu-rounded', node.level > 0 && 'pu-ml-2'),
    ref: currentRef
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Toggle"), createElement(ToggleIcon, {
    icon: node.expanded ? 'minus' : 'plus',
    className: "pu-w-5 pu-h-5"
  })), node.label)), createElement(PrettyCell, {
    type: "value",
    className: offsetPadding[node.level]
  }, formatDate ? formatIfDate(node.value) : node.value))), createElement(DescendantProvider, {
    context: DescendantContext$3,
    items: kids,
    set: setKids
  }, node.expanded && node.children && createElement(Fragment, null, node.children.map(function (child) {
    return createElement(PrettyJsonNode, {
      node: child,
      formatDate: formatDate,
      key: child.path
    });
  }), createElement("div", {
    className: cx('pu-absolute pu-top-9 pu-pointer-events-none', node.level > 0 ? 'pu-left-2' : 'pu-left-0', padByLevel[node.level])
  }, createElement(Connectors$1, {
    descendants: kids,
    anchor: currentRef,
    className: "pu-text-lightgrey"
  }))))) : createElement("div", {
    className: cx('hover:pu-bg-gray-100', isStriped ? 'pu-bg-lightergrey' : 'pu-bg-white')
  }, createElement("div", {
    className: cx('pu-flex', padByLevel[node.level])
  }, createElement(PrettyCell, {
    type: "label",
    className: cx(node.level > 0 ? 'pu-pl-9' : 'pu-pl-7')
  }, createElement("div", {
    ref: currentRef
  }, node.label)), createElement(PrettyCell, {
    type: "value",
    className: cx(offsetPadding[node.level])
  }, formatDate ? formatIfDate(node.value) : node.value)));
};

function Connectors$1(_ref3) {
  var nullableDescendants = _ref3.descendants,
      className = _ref3.className,
      anchor = _ref3.anchor;
  var descendants = nullableDescendants.filter(function (x) {
    return !isNil(x.element);
  });

  if (descendants.length === 0) {
    return null;
  }

  var anchorRect = anchor.current && anchor.current.getBoundingClientRect();

  if (!anchorRect) {
    return null;
  }

  var kids = descendants.map(function (kid) {
    return {
      rect: kid.element.getBoundingClientRect(),
      isButton: kid.isButton
    };
  });
  var lastChild = kids[kids.length - 1];
  var bottom = lastChild.rect.top + lastChild.rect.height / 2;
  var anchorBottom = anchorRect.bottom;
  var anchorRight = anchorRect.right;
  var height = bottom - anchorBottom;
  var width = 70;
  var xMid = (width - padRight - padLeft) / 2 + padLeft;
  var endRight = width - 4;
  return createElement("svg", {
    className: className,
    height: height + padBottom$1,
    viewBox: "0 0 " + width + " " + (height + padBottom$1),
    style: {
      top: anchorRect.height,
      width: width
    }
  }, kids.map(function (kid, i) {
    if (kid === lastChild) {
      return null;
    }

    var y = kid.rect.top + kid.rect.height / 2 - anchorBottom;
    return createElement("line", {
      x1: xMid,
      y1: y,
      x2: endRight - (kid.isButton ? 18 : 26) + (kid.rect.left - anchorRight),
      y2: y,
      fill: "none",
      strokeWidth: "1",
      stroke: "currentColor",
      strokeDasharray: "2 4",
      key: i
    });
  }), createElement("polyline", {
    points: xMid + ",0 " + xMid + "," + height + " " + (endRight - (lastChild.isButton ? 18 : 26) + (lastChild.rect.left - anchorRight)) + "," + height,
    fill: "none",
    strokeWidth: "1",
    stroke: "currentColor",
    strokeDasharray: "2 4"
  }));
}

var padBottom$1 = 8;
var padRight = 22;
var padLeft = 28;
var padByLevel = ['', 'pu-pl-8', 'pu-pl-16', 'pu-pl-24', 'pu-pl-32', 'pu-pl-40', 'pu-pl-48'];
var offsetPadding = ['', 'pu--ml-8', 'pu--ml-16', 'pu--ml-24', 'pu--ml-32', 'pu--ml-40', 'pu--ml-48'];

var stateReducer = function stateReducer(state, pathToToggle) {
  return state.includes(pathToToggle) ? state.filter(function (i) {
    return i !== pathToToggle;
  }) : state.concat(pathToToggle);
};

var DispatchToggleContext = /*#__PURE__*/createNamedContext('DispatchToggle', noop);
var DescendantContext$3 = /*#__PURE__*/createDescendantContext('TreeDescentdant');
var RerenderContext = /*#__PURE__*/createNamedContext('Rerender', noop);

var PrettyCell = function PrettyCell(props) {
  return createElement("div", {
    className: cx('pu-text-gray-500', props.type === 'label' ? 'pu-w-36 md:pu-w-72 pu-pr-4' : 'pu-flex-1 pu-pl-4 pu-pr-7 pu-text-right md:pu-text-left', props.heading ? ['pu-py-3 pu-border-b pu-border-gray-200 pu-text-xs pu-bg-gray-50', classes.label] : ['pu-py-4 pu-whitespace-no-wrap', classes.body], props.className)
  }, props.children);
};

var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

var formatIfDate = function formatIfDate(value) {
  return isString(value) && datePattern.test(value) ? formatDate(value) : value;
};

var JsonViewer = /*#__PURE__*/memo(function JsonViewer(_ref) {
  var json = _ref.json,
      pretty = _ref.pretty,
      initialExpanded = _ref.initialExpanded,
      _ref$formatDate = _ref.formatDate,
      formatDate = _ref$formatDate === void 0 ? true : _ref$formatDate;

  if (!json) {
    return null;
  }

  return pretty ? createElement(JsonPrettyViewer, {
    json: json,
    formatDate: formatDate,
    initialExpanded: initialExpanded
  }) : createElement(JsonCodeViewer, {
    json: json
  });
});

var _excluded$16 = ["json", "defaultOpen", "allowToggleFormat", "initialExpanded", "defaultIsPretty", "title", "formatDate"];
var JsonPanel = function JsonPanel(_ref) {
  var json = _ref.json,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$allowToggleForma = _ref.allowToggleFormat,
      allowToggleFormat = _ref$allowToggleForma === void 0 ? false : _ref$allowToggleForma,
      initialExpanded = _ref.initialExpanded,
      _ref$defaultIsPretty = _ref.defaultIsPretty,
      defaultIsPretty = _ref$defaultIsPretty === void 0 ? allowToggleFormat : _ref$defaultIsPretty,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'JSON' : _ref$title,
      formatDate = _ref.formatDate,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$16);

  var _React$useState = useState(defaultIsPretty),
      isPretty = _React$useState[0],
      setIsPretty = _React$useState[1];

  var _React$useState2 = useState(defaultOpen),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  return createElement(Card, Object.assign({
    expandable: true,
    isOpen: isOpen,
    onToggleOpen: function onToggleOpen() {
      return setIsOpen(function (o) {
        return !o;
      });
    }
  }, props), createElement(CardHeading, {
    title: title
  }, allowToggleFormat && createElement("div", {
    className: cx('pu-inline-block pu-transition-opacity pu-duration-200', isOpen ? 'pu-opacity-100' : 'pu-opacity-0')
  }, createElement(Button, {
    onClick: function onClick() {
      return setIsPretty(true);
    },
    variant: isPretty ? 'primary' : 'outline',
    className: "sm:pu-leading-none pu-rounded-l-md pu-rounded-r-none pu-border pu-border-brand-500"
  }, "PREVIEW"), createElement(Button, {
    onClick: function onClick() {
      return setIsPretty(false);
    },
    variant: isPretty ? 'outline' : 'primary',
    className: "sm:pu-leading-none pu-rounded-r-md pu-rounded-l-none pu-border pu-border-brand-500"
  }, "CODE"))), createElement(CardContent, {
    className: "pu-p-0"
  }, createElement(JsonViewer, {
    json: json,
    pretty: isPretty,
    initialExpanded: initialExpanded,
    formatDate: formatDate
  })));
};

var _excluded$17 = ["file", "onDismiss", "wrapperClass", "alt", "src", "children", "imageRef"];
/**
 * `<ImageViewer />` display image both from local and remote.
 *
 * It accept either `file` props or `src` props.
 *
 * It accept all props an `<img />` element accepts.
 *
 * If you want to associate actions for a particular image, use `<ImageViewer />`.
 *
 * If you want to display image as part of file upload, use `<FileItem />`.
 */

var ImageViewer = /*#__PURE__*/forwardRef(function ImageViewer(_ref, ref) {
  var file = _ref.file,
      onDismiss = _ref.onDismiss,
      wrapperClass = _ref.wrapperClass,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'Preview' : _ref$alt,
      src = _ref.src,
      children = _ref.children,
      imageRef = _ref.imageRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$17);

  var _React$useState = useState(''),
      previewUrl = _React$useState[0],
      setPreviewUrl = _React$useState[1];

  var _React$useState2 = useState(false),
      isSvg = _React$useState2[0],
      setIsSvg = _React$useState2[1];

  useEffect(function () {
    if (file) {
      var preview = URL.createObjectURL(file);
      setPreviewUrl(preview);

      if (file.name && file.name.endsWith('.svg')) {
        setIsSvg(true);
      }

      return function () {
        URL.revokeObjectURL(preview);
      };
    }
  }, [file]);
  var imgSrc = src || file && previewUrl;
  return imgSrc ? createElement("div", {
    className: cx('pu-relative pu-inline-block', wrapperClass),
    ref: ref
  }, createElement("img", Object.assign({}, props, {
    src: imgSrc,
    alt: alt,
    className: cx(!hasUtilClass(props.className, 'pu-rounded') && 'pu-rounded', isSvg && 'pu-w-12', props.className),
    ref: imageRef
  })), children, onDismiss && createElement("div", {
    className: "pu-absolute pu-top-0 pu-right-0 pu--mt-1.5 pu--mr-2"
  }, createElement(IconButton, {
    className: "pu-p-1 pu-bg-brand-500",
    onClick: onDismiss,
    "aria-label": "Dismiss " + alt
  }, createElement(CrossIcon, {
    className: "pu-w-4 pu-text-white"
  })))) : null;
});

var ImagePreview = function ImagePreview(props) {
  var imgDimensions = useImageDimensions(props.imgRef, {
    dependencies: props.isOpen ? 'true' : 'false'
  });
  var isSmallImage = !!(imgDimensions && imgDimensions.height < SMALL_IMAGE_THRESHOLD);
  return createElement(Modal$1, {
    isOpen: props.isOpen,
    onDismiss: props.onDismiss,
    "aria-label": "Image Zoom",
    overlayClassName: "text-center",
    className: "pu-inline-block",
    allowPinchZoom: true,
    size: isSmallImage ? 'tiny' : 'standard',
    dismissBtnVariant: "semitransparent",
    initialFocus: "content",
    _noScroll: true
  }, props.isOpen && createElement(ImageViewer, {
    file: props.file,
    src: props.src,
    alt: props.alt,
    wrapperClass: cx('pu-max-h-inherit', isSmallImage && 'pu-px-6 pu-bg-offwhite'),
    className: cx('pu-inline-block pu-max-h-inherit pu-object-contain', isSmallImage && 'pu-rounded-none')
  }));
};
var SMALL_IMAGE_THRESHOLD = 250;

var _excluded$18 = ["progress"];
var Progress = function Progress(_ref) {
  var progress = _ref.progress,
      divProps = _objectWithoutPropertiesLoose(_ref, _excluded$18);

  return createElement("div", Object.assign({}, divProps, {
    className: cx(!hasUtilClass(divProps.className, 'pu-py-') && 'pu-py-2', divProps.className)
  }), createElement("div", {
    className: "pu-h-1 pu-shadow-inner pu-rounded-lg pu-overflow-hidden pu-bg-grey-500"
  }, createElement("div", {
    className: cx('pu-h-1 pu-bg-brand-200 pu-transform pu-origin-left pu-transition-transform', progress >= 1 && 'pu-animate-pulse'),
    style: {
      transform: "scaleX(" + progress + ")"
    }
  })));
};

var _excluded$19 = ["file", "imageSrc", "fileName", "imageThumbnailUrl", "isImage", "isStarred", "onStar", "onRemove", "compact", "uploadStatus", "uploadProgress", "completeMessage", "errorMessage", "onRetry"],
    _excluded2$5 = ["fileName", "onRemove"];
var FileItem = function FileItem(_ref) {
  var file = _ref.file,
      imageSrc = _ref.imageSrc,
      _ref$fileName = _ref.fileName,
      fileName = _ref$fileName === void 0 ? file ? file.name : imageSrc || '' : _ref$fileName,
      _ref$imageThumbnailUr = _ref.imageThumbnailUrl,
      imageThumbnailUrl = _ref$imageThumbnailUr === void 0 ? imageSrc : _ref$imageThumbnailUr,
      _ref$isImage = _ref.isImage,
      isImage = _ref$isImage === void 0 ? imageSrc ? true : file ? file.type.indexOf('image') === 0 : false : _ref$isImage,
      isStarred = _ref.isStarred,
      onStar = _ref.onStar,
      onRemove = _ref.onRemove,
      compact = _ref.compact,
      _ref$uploadStatus = _ref.uploadStatus,
      uploadStatus = _ref$uploadStatus === void 0 ? 'completed' : _ref$uploadStatus,
      _ref$uploadProgress = _ref.uploadProgress,
      uploadProgress = _ref$uploadProgress === void 0 ? 0.5 : _ref$uploadProgress,
      _ref$completeMessage = _ref.completeMessage,
      completeMessage = _ref$completeMessage === void 0 ? 'Uploaded' : _ref$completeMessage,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? 'Fail to upload. Please try again.' : _ref$errorMessage,
      onRetry = _ref.onRetry,
      containerProps = _objectWithoutPropertiesLoose(_ref, _excluded$19);

  var _React$useState = useState(false),
      showZoomModal = _React$useState[0],
      setShowZoomModal = _React$useState[1];

  var imgRef = useRef(null);

  if (compact) {
    return createElement(CompactFileItem, Object.assign({
      fileName: fileName,
      onRemove: onRemove
    }, containerProps));
  }

  var isPending = uploadStatus !== 'completed';
  return createElement("div", Object.assign({}, containerProps, {
    className: cx('pu-flex pu-items-center pu-py-2 pu-rounded-lg pu-bg-grey-200', isImage ? 'pu-px-2' : 'pu-px-3', containerProps.className)
  }), isImage ? createElement(ImageViewer, {
    file: file,
    src: imageThumbnailUrl,
    className: "pu-w-12 pu-h-12 pu-object-contain pu-border pu-bg-offwhite pu-border-grey-700",
    imageRef: imgRef
  }) : createElement("div", {
    className: cx('pu-relative pu-flex pu-justify-center pu-items-center pu-bottom-2')
  }, createElement(DocIcon, {
    className: "pu-w-5 pu-h-5 pu-text-lightgrey pu-transform"
  })), createElement("div", {
    className: cx('pu-flex pu-flex-1 pu-flex-col sm:pu-flex-row sm:pu-items-center pu-overflow-hidden', isImage ? 'pu-pl-3' : 'pu-pl-2')
  }, createElement("div", {
    className: cx('pu-text-sm sm:pu-flex-1 sm:pu-w-0 pu-py-1', isImage ? 'sm:pu-pr-3' : 'sm:pu-pr-2')
  }, createElement("span", {
    className: cx('pu-block pu-truncate', isPending && 'pu-text-lightgrey')
  }, fileName), createElement(StatusResult, {
    status: uploadStatus,
    uploadProgress: uploadProgress,
    completeMessage: completeMessage,
    errorMessage: errorMessage
  })), createElement("div", {
    className: "pu-flex pu-items-center pu-space-x-1"
  }, onStar ? createElement(IconButton, {
    onClick: onStar,
    className: "pu-p-1"
  }, isStarred ? createElement(FilledStarIcon, {
    className: "pu-w-5 pu-h-5 pu-text-brand-500 pu-transform pu-scale-110"
  }) : createElement(StarIcon, {
    className: "pu-w-5 pu-h-5 pu-text-lightgrey"
  })) : isStarred ? createElement("div", {
    className: "pu-inline-block pu-p-1"
  }, createElement(FilledStarIcon, {
    className: "pu-w-5 pu-h-5 pu-text-brand-500 pu-transform pu-scale-110"
  })) : undefined, isImage && createElement(Fragment, null, createElement(Tooltip, {
    label: "Preview"
  }, createElement(IconButton, {
    onClick: function onClick() {
      return setShowZoomModal(true);
    },
    className: "pu-p-1"
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Preview"), createElement(PreviewIcon, {
    className: "pu-w-5 pu-h-5 pu-text-lightgrey"
  }))), createElement(ImagePreview, {
    isOpen: showZoomModal,
    onDismiss: function onDismiss() {
      return setShowZoomModal(false);
    },
    file: file,
    src: imageSrc,
    imgRef: imgRef
  })), uploadStatus === 'error' && onRetry && createElement(IconButton, {
    onClick: onRetry,
    "aria-label": "Retry"
  }, createElement(ReloadIcon, {
    className: "pu-w-5 pu-h-5 pu-text-lightgrey"
  })), createElement(IconButton, {
    onClick: onRemove,
    className: "p-1"
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Remove"), createElement(TrashIcon, {
    className: "pu-w-5 pu-h-5 pu-text-error-500 pu-opacity-75"
  })))));
};

var CompactFileItem = function CompactFileItem(_ref2) {
  var fileName = _ref2.fileName,
      onRemove = _ref2.onRemove,
      containerProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$5);

  return createElement("div", Object.assign({}, containerProps, {
    className: cx('pu-flex pu-items-center pu-bg-white pu-border-b pu-border-gray-200', containerProps.className)
  }), createElement("div", {
    className: "pu-relative pu-flex pu-justify-center pu-items-center"
  }, createElement(DocIcon, {
    className: "pu-w-5 pu-h-5 pu-text-lightgrey pu-transform"
  })), createElement("div", {
    className: cx('pu-flex pu-flex-1 pu-items-center pu-pl-2')
  }, createElement("div", {
    className: cx('pu-py-2 pu-text-sm pu-flex-1 sm:pu-pr-2')
  }, fileName), createElement("div", {
    className: "pu-flex pu-items-center pu-space-x-1"
  }, createElement(BareButton, {
    className: "pu-text-error-500",
    onClick: onRemove
  }, "DELETE"))));
};

var StatusResult = function StatusResult(props) {
  if (props.status === 'completed') {
    return createElement("span", {
      className: "pu-block pu-text-sm pu-text-success-500"
    }, props.completeMessage);
  }

  if (props.status === 'error') {
    return createElement("span", {
      className: "pu-block pu-text-sm pu-text-error-500"
    }, props.errorMessage);
  }

  return createElement(Progress, {
    progress: props.uploadProgress
  });
};

var _excluded$1a = ["onFilesSelected", "className", "fileType", "accept", "description", "file"];
/**
 * `FileSelector` allows user to select file by selecting manually or drag and drop.
 *
 * Unspecified props will be spreaded to the underlying `<input type="file" />` while `className`
 * will be applied to the wrapper
 */

var FileSelector = function FileSelector(_ref) {
  var onFilesSelected = _ref.onFilesSelected,
      className = _ref.className,
      fileType = _ref.fileType,
      _ref$accept = _ref.accept,
      accept = _ref$accept === void 0 ? fileType === 'image' ? 'image/*' : fileType === 'csv' ? '.csv' : undefined : _ref$accept,
      description = _ref.description,
      file = _ref.file,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$1a);

  var _useFieldControlConte = useFieldControlContext(inputProps.id),
      inputId = _useFieldControlConte.inputId;

  var _React$useState = useState(false),
      isDragOver = _React$useState[0],
      setIsDragOver = _React$useState[1];

  var _React$useState2 = useState(false),
      isFocused = _React$useState2[0],
      setIsFocused = _React$useState2[1];

  return createElement("div", {
    className: cx('pu-relative pu-p-1', className)
  }, createElement("input", Object.assign({
    type: "file",
    value: ""
  }, inputProps, {
    accept: accept,
    className: "pu-sr-only",
    id: inputId,
    onChange: function onChange(ev) {
      if (ev.target.files) {
        onFilesSelected(transformFileList(ev.target.files));
      }
    },
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onClick: function onClick() {
      return setIsFocused(false);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    }
  })), createElement("label", {
    className: cx('pu-flex pu-justify-center pu-items-center pu-p-4 sm:pu-p-6 pu-h-48 pu-rounded-lg pu-border-dashed pu-border-2 pu-cursor-pointer', isDragOver ? 'pu-bg-brand-500 pu-bg-opacity-5 pu-border-brand-500' : isFocused ? 'pu-bg-gray-100' : 'pu-bg-white', !isDragOver && 'pu-border-carbon-100'),
    htmlFor: inputId,
    onDragEnter: function onDragEnter(ev) {
      ev.preventDefault();
      setIsDragOver(true);
    },
    onDragLeave: function onDragLeave(ev) {
      ev.preventDefault();
      setIsDragOver(false);
    },
    onDragOver: function onDragOver(ev) {
      return ev.preventDefault();
    },
    onDrop: function onDrop(ev) {
      ev.preventDefault();

      if (ev.dataTransfer.files) {
        onFilesSelected(transformFileList(ev.dataTransfer.files));
      }

      setIsDragOver(false);
    }
  }, createElement("div", {
    className: "pu-text-sm pu-text-center pu-max-w-full pu-pointer-events-none"
  }, createElement(UploadIcon, {
    className: "pu-inline-block pu-w-8 pu-h-8 pu-text-lightgrey pu-mb-4"
  }), file ? createElement("p", null, createElement("span", {
    className: "pu-break-words"
  }, file.name), ' ', createElement("span", {
    className: "pu-text-brand-500"
  }, "change file")) : createElement("p", null, createElement("span", {
    className: "pu-text-brand-500 pu-font-medium"
  }, inputProps.multiple ? 'Upload multiple files' : 'Upload a file'), createElement("span", null, " or drag and drop")), description && createElement("p", {
    className: "pu-text-lightgrey pu-text-xs pu-mt-1"
  }, description))));
};

var transformFileList = function transformFileList(fileList) {
  var result = [];
  forEach(fileList, function (file) {
    return result.push(file);
  });
  return result;
};

var _excluded$1b = ["text", "widthClass", "className", "lineClamp"];
/**
 * TextEllipsis truncate the content when it overflow and show all the text in the tooltip that appears when hovered.
 */

var TextEllipsis = function TextEllipsis(_ref) {
  var text = _ref.text,
      widthClass = _ref.widthClass,
      className = _ref.className,
      lineClamp = _ref.lineClamp,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1b);

  var ref = useRef(null);

  var _React$useState = useState(false),
      isEllipsis = _React$useState[0],
      setIsEllipsis = _React$useState[1];

  useEffect(function () {
    if (ref.current) {
      setIsEllipsis(lineClamp ? ref.current.scrollHeight > ref.current.clientHeight : ref.current.offsetWidth !== ref.current.scrollWidth);
    }
  }, [lineClamp]);
  var classes = cx(widthClass, lineClamp ? lineClampClass[lineClamp] : 'pu-truncate', className);
  return isEllipsis ? createElement(Tooltip, {
    label: createElement("div", {
      className: "pu-break-words pu-max-w-xs pu-whitespace-pre-line"
    }, text)
  }, createElement("div", Object.assign({
    ref: ref,
    className: cx(classes, 'portal-ui-ellipsis')
  }, props), text)) : createElement("div", Object.assign({
    ref: ref,
    className: classes
  }, props), text);
};
var lineClampClass = ['', '', 'pu-line-clamp-2', 'pu-line-clamp-3', 'pu-line-clamp-4'];

var ImageInfo = function ImageInfo(props) {
  var imageInfo = [props.size, props.dimensions].filter(Boolean).join(' / ');

  var _extractExtension = extractExtension(props.name),
      fileName = _extractExtension.fileName,
      ext = _extractExtension.ext;

  return createElement("div", {
    className: "pu-relative pu-p-3"
  }, createElement("div", {
    className: cx('flex', props.children && 'pu-pr-3')
  }, createElement(TextEllipsis, {
    text: fileName,
    className: "pu-text-sm pu-text-darkgrey",
    widthClass: "pu-flex-initial"
  }), ext && createElement("div", {
    className: "pu-flex-grow pu-flex-shrink-0 pu-text-sm pu-text-darkgrey"
  }, ext)), createElement("div", {
    className: "pu-text-xs pu-text-lightgrey"
  }, imageInfo || createElement(Skeleton, {
    className: "pu-animate-pulse"
  })), props.children);
};

var extractExtension = function extractExtension(oriFileName) {
  var match = /^(.*)(\.\w+)$/.exec(oriFileName);

  if (!match) {
    return {
      fileName: oriFileName,
      ext: undefined
    };
  }

  return {
    fileName: match[1],
    ext: match[2]
  };
};

var ImageSelectionContext = /*#__PURE__*/createNamedContext('ImageSelectionContext', {
  type: 'none'
});
var useImageSelection = function useImageSelection(value) {
  var context = useContext(ImageSelectionContext);

  if (context.type === 'none' || !isDefined(value)) {
    return undefined;
  }

  var values = context.values,
      onSelect = context.onSelect,
      _onRemove = context.onRemove;
  return {
    type: context.type,
    name: context.name,
    isActive: values.includes(value),
    onToggle: function onToggle() {
      return onSelect(value);
    },
    onRemove: function onRemove() {
      return _onRemove(value);
    }
  };
};
var ImageSelectionContextProvider = ImageSelectionContext.Provider;

var _excluded$1c = ["imageName", "imageSizeInByte", "imageSize", "imageDimensions", "onDelete", "isDeleting", "value"];
var ImageCard = function ImageCard(_ref) {
  var providedImageName = _ref.imageName,
      imageSizeInByte = _ref.imageSizeInByte,
      _ref$imageSize = _ref.imageSize,
      imageSize = _ref$imageSize === void 0 ? isDefined(imageSizeInByte) ? formatFileSize(imageSizeInByte) : undefined : _ref$imageSize,
      imageDimensions = _ref.imageDimensions,
      onDelete = _ref.onDelete,
      isDeleting = _ref.isDeleting,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1c);

  var imgRef = useRef(null);
  var imageSelection = useImageSelection(value);
  var inferredDimensions = useImageDimensions(imgRef);
  var imgDimensionLabel = imageDimensions || (inferredDimensions ? inferredDimensions.width + "x" + inferredDimensions.height : '');

  var _React$useState = useState(false),
      showPreview = _React$useState[0],
      setShowPreview = _React$useState[1];

  var imageName = useMemo(function () {
    if (providedImageName) {
      return providedImageName;
    }

    var match = /\/((\w|\.)+)$/.exec(props.src);
    return match && match[1] || 'image';
  }, [props.src, providedImageName]);
  var image = createElement(ImageViewer, Object.assign({}, props, {
    className: "pu-inline-block pu-w-44 pu-h-44 pu-bg-offwhite pu-object-contain pu-rounded-t",
    imageRef: imgRef
  }));
  var isActive = imageSelection && imageSelection.isActive;
  return createElement("div", {
    className: cx('pu-inline-block pu-w-44 pu-border pu-border-grey-700 pu-border-t-0 pu-rounded pu-transition', isActive && 'pu-ring pu-ring-brand-500')
  }, isDeleting ? createElement("div", {
    className: "pu-relative"
  }, image, createElement("div", {
    className: "pu-absolute pu-inset-0 pu-flex pu-justify-center pu-items-center pu-bg-black pu-bg-opacity-60"
  }, createElement("p", {
    className: "pu-text-xs text-white"
  }, "Deleting"))) : imageSelection ? createElement("label", {
    className: "pu-relative pu-block"
  }, image, createElement("div", {
    className: "pu-absolute pu-left-4 pu-top-4 pu-flex"
  }, createElement("input", {
    type: imageSelection.type === 'multiple' ? 'checkbox' : 'radio',
    className: cx('block pu-h-5 pu-w-5 pu-text-brand-500', imageSelection.type === 'multiple' ? 'form-checkbox' : 'form-radio'),
    onChange: imageSelection.onToggle,
    checked: imageSelection.isActive,
    name: imageSelection.name
  }))) : image, createElement(ImageInfo, {
    name: imageName,
    size: imageSize,
    dimensions: imgDimensionLabel
  }, createElement(DropdownMenu, {
    variant: "icon",
    label: createElement(DotVerticalIcon, {
      className: "pu-w-5 pu-h-5 pu-text-mediumgrey"
    }),
    className: "pu-absolute pu-right-0 pu-top-1 pu-px-1 pu-pt-1.5 pu-pb-1",
    disabled: isDeleting
  }, createElement(DropdownMenu.Items, {
    getPosition: positionRight,
    className: "pu-min-w-44"
  }, createElement(DropdownMenu.Item, {
    valueText: "Preview",
    onSelect: function onSelect() {
      return setShowPreview(true);
    },
    className: "pu-px-3"
  }, createElement(ZoomInIcon, {
    className: "pu-w-4 pu-h-4 pu-text-lightgrey pu-mr-2"
  }), createElement("span", null, "Preview")), onDelete ? createElement(DropdownMenu.Item, {
    valueText: "Delete",
    onSelect: callAll(onDelete, imageSelection && imageSelection.onRemove),
    className: "pu-px-3"
  }, createElement(TrashIcon, {
    className: "pu-w-4 pu-h-4 pu-text-lightgrey pu-mr-2"
  }), createElement("span", null, "Delete")) : null))), createElement(ImagePreview, Object.assign({
    isOpen: showPreview,
    onDismiss: function onDismiss() {
      return setShowPreview(false);
    },
    imgRef: imgRef
  }, props)));
};

/**
 * `<ImageGrid />` is used to wrap multiple `<ImageCard />` and `<ImageUploadItem />` to form a grid.
 */

var ImageGrid = function ImageGrid(props) {
  return createElement("div", Object.assign({}, props, {
    className: cx('pu-grid pu-image-grid portal-ui-scrollbar portal-ui-scroll-overlay-y pu-justify-items-center pu-gap-5 pu-px-3 sm:pu-px-7 pu-py-7', props.className)
  }));
};

/**
 * `<ImageSelection />` makes all the descendant `<ImageCard />` to be selectable.
 */

var ImageSelection = function ImageSelection(props) {
  if (props.multiple) {
    var onChangeValues = props.onChangeValues,
        values = props.values;

    var onRemove = function onRemove(value) {
      return onChangeValues(values.filter(function (v) {
        return v !== value;
      }));
    };

    var contextValue = {
      type: 'multiple',
      onSelect: function onSelect(val) {
        if (values.includes(val)) {
          onRemove(val);
        } else {
          onChangeValues(values.concat(val));
        }
      },
      onRemove: onRemove,
      values: values,
      name: props.name
    };
    return createElement(ImageSelectionContextProvider, {
      value: contextValue
    }, props.children);
  } else {
    var onChangeValue = props.onChangeValue,
        value = props.value;
    var _contextValue = {
      type: 'single',
      onSelect: function onSelect(val) {
        if (val === value) {
          onChangeValue(undefined);
        } else {
          onChangeValue(val);
        }
      },
      onRemove: function onRemove(val) {
        if (val === value) {
          onChangeValue(undefined);
        }
      },
      values: value ? [value] : [],
      name: props.name
    };
    return createElement(ImageSelectionContextProvider, {
      value: _contextValue
    }, props.children);
  }
};

/**
 * Show actions when user hover.
 *
 * Children must be valid button element content because user need to click the children to open the menu,
 * so that this still works in Touch UI.
 *
 */

var OverlayActions = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      actions = _ref.actions,
      labelClass = _ref.labelClass,
      className = _ref.className,
      overlayClass = _ref.overlayClass,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'cover' : _ref$size,
      _ref$appearFrom = _ref.appearFrom,
      appearFrom = _ref$appearFrom === void 0 ? size === 'cover' ? 'center' : size === 'left-half' ? 'left' : 'bottom' : _ref$appearFrom,
      hideLabel = _ref.hideLabel;
  var elementRef = useRef(null);
  var buttonRef = useForkedRef(elementRef, forwardedRef);

  var _React$useState = useState(false),
      isOverButton = _React$useState[0],
      setIsOverButton = _React$useState[1];

  var _React$useState2 = useState(false),
      isOverMenu = _React$useState2[0],
      setIsOverMenu = _React$useState2[1];

  var _useSelect = useSelect({
    selectedItem: null,
    isOpen: isOverButton || isOverMenu,
    items: actions,
    itemToString: function itemToString(action) {
      return action ? action.label : '';
    },
    onSelectedItemChange: function onSelectedItemChange(_ref2) {
      var selectedItem = _ref2.selectedItem;

      if (selectedItem) {
        selectedItem.onSelect();
      }
    }
  }),
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getMenuProps = _useSelect.getMenuProps,
      getItemProps = _useSelect.getItemProps,
      isOpen = _useSelect.isOpen,
      highlightedIndex = _useSelect.highlightedIndex,
      setHighlightedIndex = _useSelect.setHighlightedIndex;

  return createElement(Fragment, null, createElement("button", Object.assign({}, getToggleButtonProps({
    ref: buttonRef,
    type: 'button',
    className: cx('focus:pu-outline-none focus-visible:pu-ring focus-visible:pu-ring-gray-200', className),
    onClick: function onClick() {
      return setIsOverMenu(true);
    },
    onMouseEnter: function onMouseEnter() {
      return setIsOverButton(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsOverButton(false);
    }
  })), children), createElement(ReachPopover, Object.assign({
    targetRef: elementRef,
    position: positionBySize[size]
  }, getMenuProps({
    className: cx('pu-flex pu-flex-col pu-bg-black pu-bg-opacity-25 pu-transform pu-transition pu-duration-200 focus:pu-outline-none pu-font-sans', isOpen ? shownByAppearFrom[appearFrom] : hideByAppearFrom[appearFrom], overlayClass),
    onKeyDown: function onKeyDown(ev) {
      var key = normalizeArrowKey(ev);

      if (key === 'ArrowLeft') {
        var prev = highlightedIndex - 1;
        setHighlightedIndex((prev + actions.length) % actions.length);
      } else if (key === 'ArrowRight') {
        var next = highlightedIndex + 1;
        setHighlightedIndex(next % actions.length);
      } else if (key === 'Escape') {
        setIsOverMenu(false);
      }
    },
    onMouseEnter: function onMouseEnter() {
      return setIsOverMenu(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsOverMenu(false);
    }
  }, {
    suppressRefError: true
  })), isOpen && createElement(Fragment, null, createElement("div", {
    className: "pu-flex-2 pu-px-2 pu-flex pu-justify-center pu-items-center"
  }, createElement("div", {
    className: "pu-inline-flex pu-space-x-2.5"
  }, actions && actions.map(function (action, index) {
    return createElement(IconButton, Object.assign({}, getItemProps({
      className: cx('pu-p-1 hover:pu-bg-brand-500 hover:pu-bg-opacity-100 pu-text-white', highlightedIndex === index ? 'pu-bg-brand-500' : 'pu-bg-black pu-bg-opacity-50'),
      item: action,
      index: index
    }), {
      key: action.label + "-" + index
    }), action.icon, createElement("span", {
      className: "pu-sr-only"
    }, action.label));
  }))), !hideLabel && createElement("div", {
    className: cx('pu-flex-1 pu-flex pu-justify-center pu-items-start pu-text-white', labelClass)
  }, highlightedIndex > -1 && actions[highlightedIndex].label))));
});
var shownByAppearFrom = {
  center: 'pu-scale-y-100 pu-scale-x-100 pu-opacity-100',
  left: 'pu-scale-x-100 pu-opacity-100 pu-origin-left',
  bottom: 'pu-scale-y-100 pu-opacity-100 pu-origin-bottom'
};
var hideByAppearFrom = {
  center: 'pu-scale-y-0 pu-scale-x-0 pu-opacity-25',
  left: 'pu-scale-x-0 pu-opacity-25 pu-origin-left',
  bottom: 'pu-scale-y-0 pu-opacity-25 pu-origin-bottom'
};
var positionBySize = {
  cover: function cover(targetRect) {
    if (targetRect) {
      return {
        top: targetRect.top + window.pageYOffset,
        left: targetRect.left + window.pageXOffset,
        width: targetRect.width,
        height: targetRect.height
      };
    }

    return {};
  },
  'left-half': function leftHalf(targetRect) {
    if (targetRect) {
      return {
        top: targetRect.top + window.pageYOffset,
        left: targetRect.left + window.pageXOffset,
        width: targetRect.width / 2,
        height: targetRect.height
      };
    }

    return {};
  },
  'bottom-half': function bottomHalf(targetRect) {
    if (targetRect) {
      return {
        top: targetRect.top + window.pageYOffset + targetRect.height / 2,
        left: targetRect.left + window.pageXOffset,
        width: targetRect.width,
        height: targetRect.height / 2
      };
    }

    return {};
  }
};

/**
 * Display image in small thumbnail. When hovered, actions allowed for the thumbnail will be displayed.
 *
 * You can either provide `file` or `src` props.
 *
 * When non of the actions (zoom, star, and delete) is allowed, `ImageThumbnail` works like a fixed size `<img />` tag.
 */

var ImageThumbnail = function ImageThumbnail(_ref) {
  var _ref$zoomLabel = _ref.zoomLabel,
      zoomLabel = _ref$zoomLabel === void 0 ? 'Zoom' : _ref$zoomLabel,
      _ref$allowZoom = _ref.allowZoom,
      allowZoom = _ref$allowZoom === void 0 ? true : _ref$allowZoom,
      onStar = _ref.onStar,
      _ref$starLabel = _ref.starLabel,
      starLabel = _ref$starLabel === void 0 ? 'Star' : _ref$starLabel,
      starred = _ref.starred,
      _ref$isStarred = _ref.isStarred,
      isStarred = _ref$isStarred === void 0 ? starred : _ref$isStarred,
      onDelete = _ref.onDelete,
      _ref$deleteLabel = _ref.deleteLabel,
      deleteLabel = _ref$deleteLabel === void 0 ? 'Delete' : _ref$deleteLabel,
      file = _ref.file,
      src = _ref.src,
      _ref$thumbnailSrc = _ref.thumbnailSrc,
      thumbnailSrc = _ref$thumbnailSrc === void 0 ? src : _ref$thumbnailSrc,
      alt = _ref.alt,
      hideOverlayLabel = _ref.hideOverlayLabel,
      className = _ref.className;

  var _React$useState = useState(false),
      showZoom = _React$useState[0],
      setShowZoom = _React$useState[1];

  var imgRef = useRef(null);
  var actions = [onStar && {
    label: starLabel,
    icon: createElement(StarIcon, {
      className: "pu-w-5 pu-h-5"
    }),
    onSelect: onStar
  }, allowZoom ? {
    label: zoomLabel,
    icon: createElement(ZoomInIcon, {
      className: "pu-w-5 pu-h-5"
    }),
    onSelect: function onSelect() {
      return setShowZoom(true);
    }
  } : undefined, onDelete && {
    label: deleteLabel,
    icon: createElement(TrashIcon, {
      className: "pu-w-5 pu-h-5"
    }),
    onSelect: onDelete
  }].filter(isDefined);
  var imageViewer = createElement(ImageViewer, {
    file: file,
    src: thumbnailSrc,
    alt: alt,
    imageRef: imgRef,
    className: "pu-inline-block pu-w-30 pu-h-30 pu-object-contain pu-bg-offwhite pu-border pu-border-grey-700"
  });
  var star = isStarred && createElement("div", {
    className: "pu-absolute pu-top-0 pu-left-0 pu-pl-2 pu-pt-2"
  }, createElement("div", {
    className: "pu-p-1 pu-flex pu-justify-center pu-items-center pu-bg-brand-500 pu-rounded-full"
  }, createElement(FilledStarIcon, {
    className: "pu-w-5 pu-h-5 pu-text-white"
  })));
  return actions.length === 0 ? createElement("div", {
    className: cx('pu-relative', className)
  }, imageViewer, star) : createElement(Fragment, null, createElement(OverlayActions, {
    actions: actions,
    className: cx('pu-relative', className),
    overlayClass: "pu-rounded-md",
    labelClass: classes.bodySecondary,
    hideLabel: hideOverlayLabel
  }, imageViewer, star), createElement(ImagePreview, {
    isOpen: showZoom,
    onDismiss: function onDismiss() {
      return setShowZoom(false);
    },
    imgRef: imgRef,
    file: file,
    src: src,
    alt: alt
  }));
};

/**
 * `<ImageUploadItem />` is used with `<FileSelector />` to support image upload.
 *
 * It can be wrapped by `<ImageGrid />`, together with `<ImageCard />`.
 */

var ImageUploadItem = function ImageUploadItem(_ref) {
  var file = _ref.file,
      _ref$fileName = _ref.fileName,
      fileName = _ref$fileName === void 0 ? file.name : _ref$fileName,
      uploadStatus = _ref.uploadStatus,
      uploadProgress = _ref.uploadProgress,
      onRemove = _ref.onRemove,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? 'Upload error. Please try again.' : _ref$errorMessage,
      onRetry = _ref.onRetry;
  var inferredDimensions = useImageFileDimensions(file);
  var isSmallImage = inferredDimensions ? inferredDimensions.height < 100 : false;
  return createElement("div", {
    className: cx('pu-inline-block pu-w-44 pu-border pu-border-grey-700 pu-border-t-0 pu-rounded pu-transition', uploadStatus === 'error' && 'pu-ring-1 pu-ring-error-500')
  }, createElement("div", {
    className: "pu-relative"
  }, createElement(ImageViewer, {
    file: file,
    alt: fileName,
    className: cx('pu-inline-block pu-w-44 pu-h-44 pu-bg-offwhite pu-rounded-t', isSmallImage ? 'pu-object-none' : 'pu-object-contain')
  }), uploadStatus === 'uploading' && createElement("div", {
    className: "pu-absolute pu-inset-0 pu-flex pu-justify-center pu-items-center pu-bg-black pu-bg-opacity-60"
  }, createElement("p", {
    className: "pu-text-xs text-white"
  }, "Uploading"), isDefined(uploadProgress) && createElement("div", {
    className: "pu-absolute pu-bottom-0 pu-inset-x-0"
  }, createElement(Progress, {
    progress: uploadProgress,
    className: "pu-py-0"
  }))), (!uploadStatus || uploadStatus === 'uploading') && createElement("div", {
    className: "pu-absolute pu-top-0 pu-right-0 pu-pt-4 pu-pr-4"
  }, createElement(IconButton, {
    onClick: onRemove,
    className: "pu-p-1 pu-bg-white pu-bg-opacity-75",
    "aria-label": "Remove"
  }, createElement(CrossIcon, {
    className: "pu-w-3 pu-h-3"
  }))), uploadStatus === 'error' && createElement("div", {
    className: "pu-absolute pu-inset-0 pu-flex pu-justify-center pu-items-center pu-bg-offwhite pu-bg-opacity-90"
  }, createElement("div", null, createElement("p", {
    className: "pu-text-xs pu-leading-5 pu-px-8 pu-py-3 pu-text-center pu-text-error-500"
  }, errorMessage), createElement("div", {
    className: "pu-text-center pu-px-3"
  }, createElement("div", {
    className: "pu-inline-flex pu-items-center pu-gap-3"
  }, onRetry && createElement(IconButton, {
    onClick: onRetry,
    className: "pu-p-1 pu-bg-black pu-bg-opacity-60 hover:pu-bg-brand-500 hover:pu-bg-opacity-100 pu-text-white",
    "aria-label": "Retry"
  }, createElement(ReloadIcon, {
    className: "pu-w-5 pu-h-5"
  })), createElement(IconButton, {
    onClick: onRemove,
    className: "pu-p-1 pu-bg-black pu-bg-opacity-60 hover:pu-bg-brand-500 hover:pu-bg-opacity-100 pu-text-white",
    "aria-label": "Remove"
  }, createElement(TrashIcon, {
    className: "pu-w-5 pu-h-5"
  }))))))), createElement(ImageInfo, {
    name: fileName,
    size: formatFileSize(file.size),
    dimensions: inferredDimensions && inferredDimensions.width + "x" + inferredDimensions.height
  }));
};

var _excluded$1d = ["render", "interactive"],
    _excluded2$6 = ["children"];

var defaultRender = function defaultRender(props) {
  return createElement("span", Object.assign({}, props));
};

var BreadcrumbText = function BreadcrumbText(_ref) {
  var _ref$render = _ref.render,
      render = _ref$render === void 0 ? defaultRender : _ref$render,
      interactive = _ref.interactive,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1d);

  return render(_extends({
    className: cx('pu-block pu-pt-3 pu-pb-2 pu-border-b-2 pu-border-transparent pu-text-lightgrey pu-truncate', interactive && 'hover:pu-text-mediumgrey hover:pu-border-brand-200', props.className)
  }, props));
};

var BreadcrumbsImpl = function Breadcrumbs(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$6);

  var childrenInArray = Children.toArray(children);
  var childrenCount = childrenInArray.length;
  var isLong = childrenCount > 3;
  var kids = childrenInArray.map(function (child, childIndex) {
    if (isLong && childIndex !== 0 && childIndex < childrenCount - 2) {
      return childIndex === 1 ? createElement(Fragment, {
        key: childIndex
      }, createElement(DotHorizontalIcon, {
        className: "pu-w-6 pu-h-6 pu-text-lightgrey"
      }), separator) : null;
    }

    if (isValidElement(child) && childIndex < childrenCount - 1) {
      return createElement(Fragment, {
        key: childIndex
      }, child, separator);
    }

    return child;
  });
  return createElement("div", Object.assign({}, props, {
    className: cx('pu-flex pu-items-center pu-text-sm pu-text-mediumgrey', props.className)
  }), kids);
};

var Breadcrumbs = /*#__PURE__*/Object.assign(BreadcrumbsImpl, {
  Text: BreadcrumbText
});
var separator = /*#__PURE__*/createElement(ChevronRightIcon, {
  className: "pu-w-4 pu-h-4 pu-mx-3 pu-text-lightgrey"
});

var SidebarGroupContext = /*#__PURE__*/createNamedContext('SidebarGroupContext', ['', noop]);
var SidebarGroupContextProvider = function SidebarGroupContextProvider(props) {
  var _React$useState = useState(''),
      focusedGroup = _React$useState[0],
      setFocusedGroup = _React$useState[1];

  var value = useMemo(function () {
    return [focusedGroup, setFocusedGroup];
  }, [focusedGroup]);
  return createElement(SidebarGroupContext.Provider, {
    value: value
  }, props.children);
};

var _excluded$1e = ["responsive", "isOpen", "onDismiss", "hidden"];
var Sidebar = /*#__PURE__*/forwardRef(function Sidebar(sidebarProps, forwardedRef) {
  var responsive = sidebarProps.responsive,
      isOpen = sidebarProps.isOpen,
      _sidebarProps$onDismi = sidebarProps.onDismiss,
      onDismiss = _sidebarProps$onDismi === void 0 ? noop : _sidebarProps$onDismi,
      hidden = sidebarProps.hidden,
      props = _objectWithoutPropertiesLoose(sidebarProps, _excluded$1e);

  var dismissBtnRef = useRef(null);
  var latestOnDismiss = useStableCallback(onDismiss);
  useEffect(function () {
    if (isOpen && featureCheck.matchMedia) {
      var mql = window.matchMedia('(min-width:768px)');

      var listener = function listener(mlist) {
        if (mlist.matches) {
          latestOnDismiss();
        }
      };

      var addEvListenerSupported = !!mql.addEventListener;

      if (addEvListenerSupported) {
        mql.addEventListener('change', listener);
      } else {
        mql.addListener(listener);
      }

      return function () {
        return addEvListenerSupported ? mql.removeEventListener('change', listener) : mql.removeListener(listener);
      };
    }
  }, [isOpen, latestOnDismiss]);
  return createElement(SidebarGroupContextProvider, null, createElement("div", {
    className: cx(responsive ? 'pu-hidden md:pu-flex md:pu-flex-shrink-0' : 'pu-flex pu-flex-shrink-0'),
    ref: forwardedRef
  }, createElement(Transition, {
    show: !hidden,
    enter: "pu-transition-all pu-ease-in-out pu-duration-300",
    enterFrom: "pu-w-0",
    enterTo: "pu-w-64",
    leave: "pu-transition-all pu-ease-in-out pu-duration-300",
    leaveFrom: "pu-w-64",
    leaveTo: "pu-w-0"
  }, createElement("div", {
    className: "pu-overflow-x-hidden"
  }, createElement("div", Object.assign({}, props, {
    className: cx('pu-relative pu-flex pu-flex-col pu-bg-carbon-700 pu-w-64 pu-h-screen', props.className)
  }))))), responsive && createElement(Transition, {
    show: !!isOpen
  }, createElement(DialogOverlay, {
    className: "md:pu-hidden",
    isOpen: isOpen,
    onDismiss: onDismiss
  }, createElement(DialogContent$1, {
    className: "pu-absolute pu-left-0 pu-inset-0",
    "aria-label": "sidebar"
  }, createElement("div", {
    className: "pu-flex pu-h-full"
  }, createElement(Transition.Child, {
    enter: "pu-transition-opacity pu-ease-linear pu-duration-300",
    enterFrom: "pu-opacity-0",
    enterTo: "pu-opacity-100",
    leave: "pu-transition-opacity pu-ease-linear pu-duration-300",
    leaveFrom: "pu-opacity-100",
    leaveTo: "pu-opacity-0"
  }, createElement("div", {
    onClick: onDismiss,
    className: "pu-absolute pu-inset-0 pu-bg-gray-600 pu-opacity-75"
  })), createElement(Transition.Child, {
    enter: "pu-transition pu-ease-in-out pu-duration-300 pu-transform",
    enterFrom: "pu--translate-x-full",
    enterTo: "pu-translate-x-0",
    leave: "pu-transition pu-ease-in-out pu-duration-300 pu-transform",
    leaveFrom: "pu-translate-x-0",
    leaveTo: "pu--translate-x-full"
  }, createElement("div", {
    className: "pu-relative pu-flex-1 pu-flex pu-flex-col pu-min-w-56 pu-max-w-xs pu-h-full pu-bg-carbon-700"
  }, createElement("div", {
    className: "pu-absolute pu-top-0 pu-right-0 pu--mr-14 pu-p-1"
  }, createElement(IconButton, {
    onClick: onDismiss,
    "aria-label": "Close sidebar",
    className: "pu-h-12 pu-w-12",
    ref: dismissBtnRef
  }, createElement(CrossIcon, {
    className: "pu-text-white pu-h-6 pu-w-6",
    "aria-hidden": true
  }))), createElement("div", {
    className: "pu-flex-1 pu-flex pu-flex-col pu-h-screen pu-pb-4"
  }, props.children))))))));
});

var _excluded$1f = ["children", "label"];
var SidebarGroup = function SidebarGroup(_ref) {
  var children = _ref.children,
      label = _ref.label,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1f);

  var _React$useState = useState(function () {
    return getId();
  }),
      id = _React$useState[0];

  var _React$useContext = useContext(SidebarGroupContext),
      focusedGroup = _React$useContext[0],
      setFocusGroup = _React$useContext[1];

  var active = focusedGroup === id;
  return createElement("div", Object.assign({}, props, {
    onClick: callAll(props.onClick, function () {
      return setFocusGroup(id);
    }),
    className: cx('pu-px-2 pu-py-2 pu-border-t pu-border-carbon-500 pu-transition-colors pu-duration-150', active && 'pu-bg-carbon-800', props.className)
  }), label && createElement("div", {
    className: "pu-text-lightgrey pu-font-bold pu-px-3 pu-py-2.5 pu-text-xs pu-leading-5 pu-tracking-widest pu-uppercase"
  }, label), children);
};

var SidebarHeader = function SidebarHeader(props) {
  return createElement("div", Object.assign({}, props, {
    className: cx('pu-flex-shrink-0 pu-text-white', props.className)
  }));
};

var _excluded$1g = ["render", "active", "children"];
var SidebarLink = function SidebarLink(_ref) {
  var render = _ref.render,
      active = _ref.active,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1g);

  if (render) {
    return render({
      baseClass: sidebarLinkClasses.base,
      defaultClass: sidebarLinkClasses["default"],
      activeClass: sidebarLinkClasses.active,
      children: children
    });
  }

  return createElement("a", Object.assign({}, props, {
    className: cx(sidebarLinkClasses.base, active ? sidebarLinkClasses.active : sidebarLinkClasses["default"], props.className)
  }), children);
};
var sidebarLinkClasses = {
  base: 'pu-group pu-flex pu-items-center pu-px-3 pu-py-2.5 pu-text-sm pu-leading-5 pu-rounded focus:pu-outline-none focus-visible:pu-shadow-outline-gray pu-transition pu-ease-in-out pu-duration-150',
  "default": 'pu-text-offwhite hover:pu-text-white hover:pu-bg-carbon-500',
  active: 'pu-text-white pu-bg-brand-500 focus:pu-bg-brand-700'
};

var _excluded$1h = ["icon", "label", "children", "isOpen", "onToggleOpen"];
var SidebarLinkGroup = function SidebarLinkGroup(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      children = _ref.children,
      isOpen = _ref.isOpen,
      onToggleOpen = _ref.onToggleOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1h);

  var _React$useState = useState(false),
      isSelfOpen = _React$useState[0],
      setIsSelfOpen = _React$useState[1];

  var isOpenState = isDefined(isOpen) ? isOpen : isSelfOpen;
  var onStateChangeHandler = isDefined(onToggleOpen) ? onToggleOpen : function () {
    return setIsSelfOpen(function (o) {
      return !o;
    });
  };
  var kids = Children.map(children, function (child) {
    if (isValidElement(child)) {
      return cloneElement(child, {
        className: cx(child.props.className, 'pu-pl-16 pu--ml-12')
      });
    }

    return null;
  });
  return createElement(Disclosure, {
    open: isOpenState,
    onChange: onStateChangeHandler
  }, createElement(DisclosureButton, Object.assign({}, props, {
    className: cx('pu-w-full', sidebarLinkClasses.base, sidebarLinkClasses["default"], props.className)
  }), icon && createElement("span", {
    className: "pu-h-6 pu-w-6 pu-ml-0.5 pu-mr-2 pu-text-lightgrey"
  }, icon), label, createElement("span", {
    className: "pu-ml-2"
  }, createElement(ExpandMoreIcon, {
    className: cx('pu-w-4 pu-h-4 pu-transform pu-transition-transform pu-duration-200', isOpenState ? 'pu-rotate-180' : 'pu-rotate-0')
  }))), createElement(AnimateHeight, {
    height: isOpenState ? 'auto' : 0
  }, createElement(DisclosurePanel, {
    className: "pu-block pu-border-l pu-border-carbon-200 pu-ml-5 pu-pl-6",
    tabIndex: -1
  }, kids)));
};

var SidebarNav = function SidebarNav(props) {
  return createElement("div", {
    className: "pu-flex-1 pu-flex pu-flex-col pu-overflow-y-auto",
    "data-react-setel-side-bar-nav": true
  }, createElement("nav", Object.assign({}, props, {
    className: cx('pu-flex-1', props.className)
  })));
};

var SidebarSlideMenu = function SidebarSlideMenu(_ref) {
  var children = _ref.children,
      heading = _ref.heading,
      isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      targetRef = _ref.targetRef;
  return isOpen ? createElement(ReachPopover, {
    targetRef: targetRef,
    position: getSlideMenuPosition,
    className: "pu-relative pu-overflow-hidden"
  }, createElement("div", {
    className: "pu-absolute pu-inset-0 pu-overflow-hidden pu-bg-gray-600 pu-bg-opacity-75",
    onClick: onDismiss,
    "data-react-setel-fade": true
  }), createElement("div", {
    className: "pu-fixed pu-inset-0 pu-h-screen pu-w-screen pu-flex pu-flex-col md:pu-relative md:pu-w-80 lg:pu-w-96 pu-bg-white",
    onKeyDown: function onKeyDown(ev) {
      var key = normalizeArrowKey(ev);

      if (key === 'Escape') {
        onDismiss();
      }
    }
  }, createElement("div", {
    className: "pu-flex pu-flex-row pu-items-center pu-px-4 pu-py-5 pu-border-b pu-border-gray-200"
  }, createElement(DismissButton, {
    onClick: onDismiss
  }), createElement("span", {
    className: "pu-pl-2 pu-block pu-text-xl pu-font-medium"
  }, heading)), createElement("div", {
    className: "portal-ui-scrollbar pu-flex-1 pu-overflow-y-auto pu-overscroll-contain"
  }, children))) : null;
};

var DismissButton = function DismissButton(props) {
  var btnRef = useRef(null);
  useEffect(function () {
    var later = window.setTimeout(function () {
      if (btnRef.current) {
        btnRef.current.focus();
      }
    }, 0);
    return function () {
      return window.clearTimeout(later);
    };
  }, []);
  return createElement(IconButton, Object.assign({
    autoFocus: true
  }, props, {
    ref: btnRef
  }), createElement(ArrowLeftIcon, {
    className: "pu-block pu-text-black pu-h-5 pu-w-5",
    "aria-hidden": true
  }), createElement("span", {
    className: "pu-sr-only"
  }, "Close"));
};

var getSlideMenuPosition = function getSlideMenuPosition(targetRect) {
  if (!targetRect) {
    return {
      left: 0,
      top: window.pageYOffset,
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  return {
    left: targetRect.left,
    top: targetRect.top + window.pageYOffset,
    width: targetRect.width,
    height: targetRect.height
  };
};

var _excluded$1i = ["className", "children", "renderContainer", "active"];
var SidebarSlideMenuItem = function SidebarSlideMenuItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      renderContainer = _ref.renderContainer,
      active = _ref.active,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1i);

  var containerClass = cx('pu-p-4 pu-text-sm pu-border-t pu-w-full focus:pu-outline-none focus:pu-shadow-outline-gray pu-text-left', active ? 'pu-border-transparent pu-bg-brand-500 pu-text-white pu-rounded' : 'pu-border-gray-200', className);
  var content = children;

  if (renderContainer) {
    return renderContainer({
      className: containerClass,
      children: content
    });
  }

  return createElement("button", Object.assign({
    className: containerClass
  }, props), content);
};

var _excluded$1j = ["heading", "children", "className"];
var SidebarSlideMenuSection = function SidebarSlideMenuSection(_ref) {
  var heading = _ref.heading,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1j);

  return createElement("div", Object.assign({}, props, {
    className: cx('pu-px-5 pu-mb-5', className)
  }), createElement("div", {
    className: "pu-text-xs pu-font-bold pu-text-lightgrey pu-py-4"
  }, heading), children);
};

var _excluded$1k = ["label", "status"],
    _excluded2$7 = ["onChange", "index", "disabled", "aria-label"],
    _excluded3$1 = ["activeIndex", "onChange", "children"];
var StepDescendantContext = /*#__PURE__*/createDescendantContext('StepDescendant');
var StepContext = /*#__PURE__*/createNamedContext('Step', {});

var Step = function Step(_ref) {
  var label = _ref.label,
      status = _ref.status,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1k);

  var rootRef = useRef(null);
  var stepper = useContext(StepContext);
  var stepIndex = useDescendant({
    element: rootRef.current,
    label: label,
    status: status
  }, StepDescendantContext);
  var isActive = stepIndex === stepper.activeIndex;
  return createElement(StepRoot, Object.assign({}, props, {
    index: stepIndex,
    onChange: stepper.onChange,
    className: cx('pu-flex-1 pu-flex pu-flex-col pu-items-stretch pu-pb-2 md:pu-py-5 pu-px-2 pu-text-left pu-rounded', props.className),
    "aria-label": label,
    "aria-current": isActive ? 'step' : undefined,
    ref: rootRef
  }), createElement("span", {
    className: cx('pu-hidden md:pu-block pu-text-xs pu-leading-5 pu-tracking-1 pu-font-bold', isActive ? 'pu-text-mediumgrey' : 'pu-text-gray-400')
  }, "STEP ", stepIndex + 1), createElement("span", {
    className: cx('pu-hidden md:flex-1 md:pu-flex pu-justify-between pu-items-start pu-gap-3', isActive ? 'pu-text-black' : status ? 'pu-text-mediumgrey' : 'pu-text-lightgrey')
  }, label, status && createElement("span", {
    className: "pu-inline-block pu-pt-1.25"
  }, status === 'done' ? createElement(CheckInCircleIcon, {
    className: "pu-flex-none pu-text-brand-500"
  }) : createElement(ExclamationIcon, {
    className: "pu-flex-none pu-text-error-500"
  }))), createElement("span", {
    className: cx('pu-block pu-h-1 pu-mt-3 pu-rounded-lg pu-transition-colors', getSeparatorClass(isActive, status))
  }));
};

var StepRoot = /*#__PURE__*/forwardRef(function StepRoot(_ref2, ref) {
  var onChange = _ref2.onChange,
      index = _ref2.index,
      disabled = _ref2.disabled,
      ariaLabel = _ref2['aria-label'],
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$7);

  if (onChange) {
    return createElement("button", Object.assign({
      onClick: function onClick() {
        return onChange(index);
      },
      type: "button",
      disabled: disabled
    }, props, {
      "aria-label": ariaLabel,
      className: cx(props.className, disabled ? 'pu-cursor-default' : 'hover:pu-bg-grey-100', 'focus-visible-ring'),
      ref: ref
    }));
  }

  return createElement("span", Object.assign({}, props, {
    ref: ref
  }));
});

var getSeparatorClass = function getSeparatorClass(isActive, status) {
  if (isActive) {
    return status === 'error' ? 'pu-bg-error-100' : 'pu-bg-brand-100';
  }

  return status ? status === 'done' ? 'pu-bg-brand-500' : 'pu-bg-error' : 'pu-bg-grey';
};

var StepperImpl = function Stepper(_ref3) {
  var activeIndex = _ref3.activeIndex,
      onChange = _ref3.onChange,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3$1);

  var _useDescendantsInit = useDescendantsInit(),
      items = _useDescendantsInit[0],
      set = _useDescendantsInit[1];

  var activeItem = isNumber(activeIndex) ? items[activeIndex] : undefined;
  return createElement(DescendantProvider, {
    items: items,
    set: set,
    context: StepDescendantContext
  }, createElement(StepContext.Provider, {
    value: {
      activeIndex: activeIndex,
      onChange: onChange
    }
  }, createElement("div", Object.assign({}, props), activeItem && createElement("div", {
    className: "md:pu-hidden pu-px-2 pu-pt-5"
  }, createElement("span", {
    className: "pu-block pu-text-xs pu-leading-5 pu-tracking-1 pu-font-bold pu-text-mediumgrey"
  }, "STEP ", activeItem.index + 1, " OF ", items.length), createElement("span", {
    className: "pu-flex pu-justify-between pu-items-start pu-text-block"
  }, activeItem.label, activeItem.status && createElement("span", {
    className: "pu-inline-block pu-pt-1.25"
  }, activeItem.status === 'done' ? createElement(CheckInCircleIcon, {
    className: "pu-text-brand-500"
  }) : createElement(ExclamationIcon, {
    className: "pu-text-error-500"
  })))), createElement("div", {
    className: "pu-flex"
  }, children))));
};

var Stepper = /*#__PURE__*/Object.assign(StepperImpl, {
  Step: Step
});

var MiniBadge = function MiniBadge(props) {
  return createElement("span", {
    className: cx('pu-inline-flex pu-items-center pu-h-5.5 pu-text-xxs pu-px-2 pu-rounded-xl pu-font-medium', props.active ? 'pu-text-brand-500 pu-bg-brand-100' : 'pu-text-darkgrey pu-bg-offwhite', props.className)
  }, props.children);
};

var _excluded$1l = ["as", "targetRef", "position", "parentRef"];
/**
 * This is just a shameless copy-paste from `@reach/popover` with the following modifications:
 *
 * - we no longer renders in Portal
 * - we needs a relativeParentToComputePosition
 */

var RelativePopover = /*#__PURE__*/forwardRef(function RelativePopover(_ref, forwardedRef) {
  var _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? 'div' : _ref$as,
      targetRef = _ref.targetRef,
      position = _ref.position,
      parentRef = _ref.parentRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1l);

  var popoverRef = useRef(null);
  var popoverRect = useRect(popoverRef, {
    observe: !props.hidden
  });
  var targetRect = useRect(targetRef, {
    observe: !props.hidden
  });
  var parentRect = useRect(parentRef, {
    observe: !props.hidden
  });
  var ref = useComposedRefs(popoverRef, forwardedRef);
  return createElement(Comp, Object.assign({
    "data-reach-popover": "",
    ref: ref
  }, props, {
    style: _extends({
      position: 'absolute'
    }, getStyles(position, targetRect, popoverRect, parentRect), props.style)
  }));
});

function getStyles(position, targetRect, popoverRect, parentRect) {
  return popoverRect ? position(targetRect, popoverRect, parentRect) : {
    visibility: 'hidden'
  };
}

var _excluded$1m = ["label", "badge", "_renderedIndex", "_providedIndex"],
    _excluded2$8 = ["children", "wrapperClass"],
    _excluded3$2 = ["items", "index", "onChange", "children"];
/**
 * Context to get all the refs for the tab buttons
 */

var TabButtonDescendantContext = /*#__PURE__*/createDescendantContext('TabButtonDescendantContext');
/**
 * Context to pass computed state and ref etc.
 */

var SetelTabContext = /*#__PURE__*/createNamedContext('TabContext', {
  tabListRef: {
    current: null
  },
  buttonRefs: [],
  showLimit: 1000,
  targetIndex: null,
  hasHiddenTab: false,
  onChange: noop
});
var Tab = /*#__PURE__*/forwardRef(function Tab(_ref, forwardedRef) {
  var label = _ref.label,
      badge = _ref.badge,
      _renderedIndex = _ref._renderedIndex,
      _providedIndex = _ref._providedIndex,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1m);

  var selfRef = useRef(null);

  var _useTabsContext = useTabsContext(),
      selectedIndex = _useTabsContext.selectedIndex;

  var _React$useContext = useContext(SetelTabContext),
      showLimit = _React$useContext.showLimit;

  useDescendant({
    element: selfRef.current,
    label: label
  }, TabButtonDescendantContext);
  var combinedRef = useComposedRefs(selfRef, forwardedRef);
  var isActive = _providedIndex === selectedIndex;
  return createElement(Tab$1, Object.assign({}, props, {
    className: cx('pu-px-3 pu-py-2 pu-flex-shrink-0 pu-inline-flex pu-items-center pu-text-sm pu-leading-5 pu-rounded-md', isActive ? 'pu-text-brand-500 pu-bg-teal-50 focus:pu-outline-none' : 'pu-text-black hover:pu-bg-gray-50', 'focus:pu-outline-none focus-visible:pu-ring-1 focus-visible:pu-ring-brand-200', _renderedIndex > showLimit && 'pu-invisible', props.className),
    ref: combinedRef
  }), label, !isNil(badge) ? createElement(MiniBadge, {
    active: isActive,
    className: "pu-ml-1"
  }, badge) : null);
});
var TabList = /*#__PURE__*/forwardRef(function TabList(_ref2, forwardedRef) {
  var children = _ref2.children,
      wrapperClass = _ref2.wrapperClass,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$8);

  var _React$useContext2 = useContext(SetelTabContext),
      tabListRef = _React$useContext2.tabListRef,
      buttonRefs = _React$useContext2.buttonRefs,
      hasHiddenTab = _React$useContext2.hasHiddenTab,
      targetIndex = _React$useContext2.targetIndex,
      showLimit = _React$useContext2.showLimit,
      onChange = _React$useContext2.onChange;

  var ref = useComposedRefs(tabListRef, forwardedRef);

  var _useTabsContext2 = useTabsContext(),
      selectedIndex = _useTabsContext2.selectedIndex;

  var canUseObserver = useConstant(function () {
    return featureCheck.intersectionObserver;
  });
  var wrapperRef = useRef(null);
  var items = [];
  Children.forEach(children, function (child) {
    if (isValidElement(child)) {
      items.push({
        child: child,
        label: child.props.label,
        badge: child.props.badge,
        index: items.length
      });
    }
  });

  var displayedTabs = function getDisplayedChildren() {
    if (!targetIndex) {
      return items;
    }

    return arrayMove(items, selectedIndex, targetIndex);
  }();

  var hiddenTabs = hasHiddenTab ? displayedTabs.slice(showLimit + 1) : [];
  var lastVisibleBtnRef = useRef(null);
  var combinedLastVisibleBtnRef = useComposedRefs(lastVisibleBtnRef, buttonRefs[showLimit]);
  return createElement("div", {
    className: cx(hasHiddenTab && 'pu-relative', wrapperClass),
    ref: wrapperRef
  }, createElement(TabList$1, Object.assign({}, props, {
    className: cx('portal-ui-scrollbar pu-flex pu-py-3 pu-space-x-2 pu-bg-white', !hasUtilClass(props.className, 'pu-p(x|l|r)-') && 'pu-px-4 sm:pu-px-7 ', !hasUtilClass(props.className, 'pu-border-') && 'pu-border-b pu-border-gray-200', // if IntersectionObserver not supported, we fallback to horizontal scroll
    canUseObserver ? 'pu-overflow-x-hidden' : 'pu-overflow-x-auto', props.className),
    ref: ref
  }), displayedTabs.map(function (item, itemIndex) {
    return cloneElement(item.child, {
      ref: itemIndex === showLimit ? combinedLastVisibleBtnRef : buttonRefs[itemIndex],
      _renderedIndex: itemIndex,
      _providedIndex: item.index,
      key: item.index
    });
  })), hasHiddenTab && createElement(RelativePopover, {
    targetRef: lastVisibleBtnRef,
    position: getTabMenuPosition,
    parentRef: wrapperRef
  }, createElement(TabMenu, null, createElement(DropdownMenuItems, {
    getPosition: positionRight,
    className: "portal-ui-tab-menu pu-min-w-48"
  }, hiddenTabs.map(function (tab) {
    return createElement(MenuItem, {
      onSelect: function onSelect() {
        return onChange(tab.index);
      },
      className: cx('pu-py-2 pu-px-4', tab.index === selectedIndex && 'pu-text-brand-500 pu-bg-teal-50', !isNil(tab.badge) && 'pu-flex pu-justify-between pu-items-center'),
      valueText: tab.label,
      key: tab.index
    }, tab.label, !isNil(tab.badge) ? createElement(MiniBadge, {
      active: tab.index === selectedIndex
    }, tab.badge) : null);
  })))));
});
var Panels = TabPanels;
var Panel = /*#__PURE__*/forwardRef(function Panel(props, forwardedProps) {
  return createElement(TabPanel, Object.assign({}, props, {
    className: cx('focus-visible-ring', props.className),
    ref: forwardedProps
  }));
});

var TabsImpl = function Tabs(_ref3) {
  var items = _ref3.items,
      providedIndex = _ref3.index,
      providedOnChange = _ref3.onChange,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3$2);

  var _useDescendantsInit = useDescendantsInit(),
      buttons = _useDescendantsInit[0],
      setButtons = _useDescendantsInit[1];

  var buttonRefs = useRefs(buttons.length);

  var _React$useState = useState(0),
      activeIndex = _React$useState[0],
      setActiveIndex = _React$useState[1];

  var index = isDefined(providedIndex) ? providedIndex : activeIndex;
  var onChange = useStableCallback(isDefined(providedOnChange) ? providedOnChange : setActiveIndex);
  var tabListRef = useRef(null);
  var maxIndex = buttons.length - 1;

  var _React$useState2 = useState(20),
      showLimit = _React$useState2[0],
      setShowLimit = _React$useState2[1]; // some random number


  useLayoutEffect(function () {
    if (buttons.length > 0) {
      setShowLimit(buttons.length);
    }
  }, [buttons.length]);
  var latestShowLimit = useRef(showLimit);
  latestShowLimit.current = showLimit;
  var hasHiddenTab = showLimit < maxIndex;
  var shouldReorderTab = hasHiddenTab && index > showLimit;
  var targetIndex = useMemo(function () {
    if (!shouldReorderTab) {
      return null;
    }

    if (tabListRef.current) {
      var tabListRect = tabListRef.current.getBoundingClientRect();

      for (var refIndex = 0; refIndex < buttonRefs.length; refIndex++) {
        var btn = buttonRefs[refIndex];

        if (btn.current) {
          var btnRect = btn.current.getBoundingClientRect();

          if (btnRect.right > tabListRect.right - RIGHT_PADDING - 32) {
            return refIndex - 1;
          }
        }
      }
    }

    return showLimit;
  }, [shouldReorderTab, showLimit, buttonRefs]);
  useEffect(function () {
    if (tabListRef.current && featureCheck.intersectionObserver) {
      var observer = new IntersectionObserver(function onIntersectionChange(entries) {
        // when button visibility change, adjust the show limit
        var finalShowLimit = -1;

        var _loop = function _loop(entryIndex) {
          var entry = entries[entryIndex];
          var observedBtnIndex = buttonRefs.findIndex(function (el) {
            return el.current === entry.target;
          });

          if (observedBtnIndex < 0) {
            return "continue";
          }

          if (entry.isIntersecting) {
            if ((observedBtnIndex > latestShowLimit.current || finalShowLimit !== -1) && observedBtnIndex > finalShowLimit) {
              finalShowLimit = observedBtnIndex;
            }
          } else {
            if (observedBtnIndex <= latestShowLimit.current && (finalShowLimit === -1 || observedBtnIndex - 1 < finalShowLimit)) {
              finalShowLimit = observedBtnIndex - 1;
            }
          }
        };

        for (var entryIndex = 0; entryIndex < entries.length; entryIndex++) {
          var _ret = _loop(entryIndex);

          if (_ret === "continue") continue;
        }

        if (finalShowLimit >= 0) {
          setShowLimit(finalShowLimit);
        }
      }, {
        root: tabListRef.current,
        rootMargin: "0px -" + RIGHT_PADDING + "px 0px 0px",
        threshold: 1.0
      });

      if (buttonRefs.length > 0) {
        buttonRefs.forEach(function (btn) {
          if (!isNil(btn.current)) {
            observer.observe(btn.current);
          }
        });
        return function () {
          return observer.disconnect();
        };
      }
    }
  }, [buttonRefs]);
  return createElement(Tabs$1, Object.assign({
    keyboardActivation: TabsKeyboardActivation.Manual,
    index: index,
    onChange: onChange
  }, props), createElement(DescendantProvider, {
    items: buttons,
    set: setButtons,
    context: TabButtonDescendantContext
  }, createElement(SetelTabContext.Provider, {
    value: useMemo(function () {
      return {
        tabListRef: tabListRef,
        showLimit: showLimit,
        targetIndex: targetIndex,
        hasHiddenTab: hasHiddenTab,
        onChange: onChange,
        buttonRefs: buttonRefs
      };
    }, [showLimit, targetIndex, hasHiddenTab, onChange, buttonRefs])
  }, items && createElement(Fragment, null, createElement(TabList, null, items.map(function (item, index) {
    return createElement(Tab, {
      label: item.label,
      key: index
    });
  })), createElement(Panels, null, items.map(function (item, index) {
    return createElement(Panel, {
      key: index
    }, item.content);
  }))), children)));
};

var Tabs = /*#__PURE__*/Object.assign(TabsImpl, {
  Tab: Tab,
  TabList: TabList,
  Panel: Panel,
  Panels: Panels
});

function TabMenu(props) {
  return createElement(Menu, null, function (menuState) {
    return createElement(Fragment, null, createElement(MenuButton, {
      className: cx('pu-h-9 pu-text-sm pu-inline-flex pu-items-center pu-px-3 focus-visible-ring', menuState.isExpanded && 'pu-text-brand-500', props.className)
    }, "More", createElement(ExpandMoreIcon, {
      className: cx('pu-w-4 pu-h-4 pu-ml-1.5 pu-flex-shrink-0 pu-transform pu-transition-transform pu-duration-200', menuState.isExpanded ? 'pu-rotate-180' : 'pu-rotate-0 pu-text-lightgrey')
    })), props.children);
  });
}

var RIGHT_PADDING = 80;

var getTabMenuPosition = function getTabMenuPosition(targetRect, _, parentRect) {
  if (!targetRect || !parentRect) {
    return {};
  }

  return {
    left: targetRect.right - parentRect.left + 8 + "px",
    top: targetRect.top - parentRect.top + "px",
    height: targetRect.height + "px"
  };
};

var IsInNotificationGroupContext = /*#__PURE__*/createNamedContext('IsInNotificationGroup', false);
var IsInNotificationPortalContext = /*#__PURE__*/createNamedContext('IsInNotificationContext', false);

/**
 * `<NotificationPortal />` allows `<Notification />` and `<NotificationGroup />` renders in the same context so they can be stacked
 * on top of each other instead of covering each other.
 */

var NotificationPortal = function NotificationPortal(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var isInPortal = useContext(IsInNotificationPortalContext);
  return isInPortal ? createElement(Fragment, null, children) : createElement(Portal, {
    type: "div"
  }, createElement("div", {
    className: cx('pu-fixed pu-top-0 pu-left-0 pu-right-0 pu-flex pu-flex-col pu-items-center pu-px-4 pu-py-6 pu-pointer-events-none sm:pu-p-6 sm:pu-items-end sm:pu-left-auto pu-space-y-4 pu-font-sans', !hasUtilClass(className, 'pu-p[x|l|r]?-') && 'pu-px-4', !hasUtilClass(className, 'pu-p[y|t|b]?-') && 'pu-py-6', className),
    "aria-live": "assertive"
  }, createElement(IsInNotificationPortalContext.Provider, {
    value: true
  }, children)));
};

/**
 * Show a Notification about system state.
 *
 * Use it with `useTransientState` to show it temporarily.
 */

var Notification = function Notification(_ref) {
  var variant = _ref.variant,
      _ref$Icon = _ref.Icon,
      Icon = _ref$Icon === void 0 ? variant ? iconByVariant$1[variant] : undefined : _ref$Icon,
      _ref$isShow = _ref.isShow,
      isShow = _ref$isShow === void 0 ? true : _ref$isShow,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      onDismiss = _ref.onDismiss,
      actions = _ref.actions,
      className = _ref.className;
  var iconClass = variant ? iconColorByVariant$1[variant] : 'pu-text-lightgrey';
  var isInGroup = useContext(IsInNotificationGroupContext);
  var disclosure = useDisclosureContext();
  var isShowValue = isInGroup ? disclosure.open : isShow;
  var ContentWrapper = isShowValue ? ReachAlert : 'div';
  var content = createElement("div", {
    className: cx(className, isInGroup ? 'pu-border-b last:pu-border-transparent' : 'pu-border pu-rounded-lg pu-shadow-sm pu-overflow-hidden', 'pu-border-offwhite')
  }, createElement("div", {
    className: cx('pu-py-4', !isInGroup && 'pu-px-4')
  }, createElement("div", {
    className: "pu-flex pu-items-start pu-space-x-2"
  }, Icon && createElement("div", {
    className: "pu-flex-shrink-0 pu-p-0.5"
  }, createElement(Icon, {
    className: cx('pu-h-4 pu-w-4', iconClass)
  })), createElement(ContentWrapper, {
    className: "pu-w-0 pu-flex-1"
  }, title && createElement("p", {
    className: "pu-text-sm pu-flex pu-items-center pu-font-medium pu-text-gray-900 pu-break-words"
  }, title), description && createElement("p", {
    className: "pu-text-sm pu-leading-5 pu-text-gray-500 pu-mt-1"
  }, description), children), (actions || onDismiss) && createElement("div", {
    className: "pu-flex-shrink-0 pu-flex sm:pu-min-w-20 pu-space-x-4 pu-justify-end"
  }, actions, onDismiss && createElement(IconButton, {
    className: "pu-text-error-500 pu-p-0",
    onClick: onDismiss
  }, createElement(MiniCloseIcon, {
    className: "pu-h-4 pu-w-4"
  }))))));
  return isInGroup ? content : createElement(NotificationPortal, null, createElement(Transition, {
    show: isShowValue,
    appear: true,
    enter: "pu-transform pu-ease-out pu-duration-300 pu-transition",
    enterFrom: "pu-translate-y-2 pu-opacity-0 sm:pu-translate-y-0 sm:pu-translate-x-2",
    enterTo: "pu-translate-y-0 pu-opacity-100 sm:pu-translate-x-0",
    leave: "pu-transition pu-ease-in pu-duration-100",
    leaveFrom: "pu-opacity-100",
    leaveTo: "pu-opacity-0",
    className: cx('pu-w-full sm:pu-w-96 pu-bg-white pu-shadow-lg pu-rounded-lg pu-pointer-events-auto')
  }, content));
};
var iconColorByVariant$1 = {
  error: 'pu-text-error-500',
  warning: 'pu-text-warning-500',
  success: 'pu-text-success-500',
  info: 'pu-text-info-500'
};
var iconByVariant$1 = {
  error: CrossInCircleIcon,
  warning: ExclamationIcon,
  success: CheckInCircleIcon,
  info: InfoIcon
};

var _excluded$1n = ["title", "children", "onDismiss", "isShow"];
/**
 * `<NotificationGroup />` can group a list of `<Notification />` into single panel.
 *
 * @todo support drag to anywhere
 */

var NotificationGroup = function NotificationGroup(_ref) {
  var title = _ref.title,
      children = _ref.children,
      onDismiss = _ref.onDismiss,
      isShow = _ref.isShow,
      divProps = _objectWithoutPropertiesLoose(_ref, _excluded$1n);

  var _React$useState = useState(true),
      isOpen = _React$useState[0],
      setIsOpen = _React$useState[1];

  var onToggleOpen = useCallback(function () {
    return setIsOpen(function (o) {
      return !o;
    });
  }, []);

  if (!children) {
    return null;
  }

  return createElement(NotificationPortal, null, createElement(Transition, {
    show: isShow,
    enter: "pu-transform pu-ease-out pu-duration-300 pu-transition",
    enterFrom: "pu-translate-y-2 pu-opacity-0 sm:pu-translate-y-0 sm:pu-translate-x-2",
    enterTo: "pu-translate-y-0 pu-opacity-100 sm:pu-translate-x-0",
    leave: "pu-transition pu-ease-in pu-duration-100",
    leaveFrom: "pu-opacity-100",
    leaveTo: "pu-opacity-0",
    className: cx('pu-w-full sm:pu-w-96 pu-bg-white pu-shadow-lg pu-rounded-lg pu-pointer-events-auto')
  }, createElement("div", Object.assign({}, divProps, {
    className: "pu-pt-4 pu-border pu-border-offwhite pu-bg-white pu-rounded pu-shadow-sm"
  }), createElement(Disclosure, {
    open: isOpen,
    onChange: onToggleOpen
  }, createElement("div", {
    className: "pu-h-10 pu-px-4"
  }, createElement("div", {
    className: "pu-flex pu-justify-between"
  }, createElement("div", {
    className: "pu-text-xl pu-font-medium"
  }, title), createElement("div", {
    className: "pu-space-x-4 pu-py-1"
  }, createElement(DisclosureButton, {
    as: IconButton,
    "aria-label": isOpen ? 'Collapse' : 'Expand',
    className: "pu-p-0 active:pu-translate-y-0"
  }, createElement(MiniChevronDownIcon, {
    className: cx('pu-w-4 pu-h-4 pu-text-lightgrey pu-transform pu-transition-transform pu-duration-200', isOpen ? 'pu-rotate-180' : 'pu-rotate-0')
  })), onDismiss && createElement(IconButton, {
    onClick: onDismiss,
    "aria-label": "Dismiss",
    className: "pu-p-0 active:pu-translate-y-0"
  }, createElement(MiniCloseIcon, {
    className: "pu-w-4 pu-h-4 pu-text-lightgrey"
  }))))), createElement(IsInNotificationGroupContext.Provider, {
    value: true
  }, createElement(AnimateHeight, {
    height: isOpen ? 'auto' : 0,
    easing: "ease-in-out"
  }, createElement(DisclosurePanel, {
    className: "portal-ui-scrollbar pu-block pu-px-4 pu-border-t pu-max-h-screen-40 pu-overflow-y-auto pu-border-offwhite focus:pu-outline-none"
  }, children)))))));
};

var _excluded$1o = ["results", "onInputValueChange", "onSelect", "isOpen", "onDismiss", "className", "searchHistories"];
var SearchModal = function SearchModal(_ref) {
  var results = _ref.results,
      onInputValueChange = _ref.onInputValueChange,
      onSelect = _ref.onSelect,
      isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      className = _ref.className,
      searchHistories = _ref.searchHistories,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$1o);

  var _React$useState = useState(''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var trimmedInput = inputValue.trim();
  var inputRef = useRef(null);
  var optionData = useMemo(function () {
    return results && sortOptions(results, trimmedInput, false);
  }, [results, trimmedInput]);
  var pastSearchOptions = useMemo(function () {
    return searchHistories && searchHistories.map(function (term, index) {
      return {
        value: term,
        label: term,
        index: index
      };
    });
  }, [searchHistories]);
  var hasSearchTerm = trimmedInput !== '';
  var menuRef = useRef(null);

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    selectedItem: null,
    isOpen: hasSearchTerm || !!pastSearchOptions && pastSearchOptions.length > 0,
    items: hasSearchTerm ? optionData ? optionData.items : [] : pastSearchOptions || [],
    itemToString: function itemToString(i) {
      return i ? i.label : '';
    },
    onSelectedItemChange: function onSelectedItemChange(changes) {
      if (hasSearchTerm) {
        onSelect(changes.selectedItem ? changes.selectedItem.value : null, trimmedInput);
        onDismiss();
      } else {
        if (changes.selectedItem) {
          setInputValue(changes.selectedItem.value);
        }
      }
    },
    onStateChange: function onStateChange(changes) {
      if ((changes.type === useCombobox.stateChangeTypes.InputKeyDownArrowUp || changes.type === useCombobox.stateChangeTypes.InputKeyDownArrowDown) && changes.highlightedIndex === 0 && menuRef.current) {
        menuRef.current.scrollTop = 0;
      }
    }
  }),
      isResultsShown = _useCombobox.isOpen,
      highlightedIndex = _useCombobox.highlightedIndex,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps;

  var menuContent = isResultsShown && (hasSearchTerm ? optionData ? optionData.displayedItems.length === 0 ? createElement("div", {
    className: "pu-px-4 pu-py-2 pu-text-sm"
  }, "No results found.") : optionData.displayedItems.map(function (group, gIndex) {
    return createElement(Fragment, {
      key: gIndex
    }, group.groupLabel && createElement(OptGroupLabel, null, group.groupLabel), group.options.map(function (result) {
      return createElement(Option, Object.assign({
        key: result.value + "-" + result.index
      }, getItemProps({
        item: result,
        index: result.index
      }), {
        leftIcon: result.icon,
        highlighted: result.index === highlightedIndex,
        label: createElement(TextHighlight, {
          searchWords: [trimmedInput],
          textToHighlight: result.label,
          highlightClassName: "pu-text-brand-500 pu-bg-transparent"
        }),
        description: result.description && createElement(TextHighlight, {
          textToHighlight: result.description,
          searchWords: [trimmedInput],
          highlightClassName: "pu-text-brand-500 pu-bg-transparent"
        }),
        fontSize: "large"
      }));
    }));
  }) : createElement("div", {
    className: "pu-text-center pu-p-3"
  }, createElement(PortalSpinIcon, {
    className: "pu-w-5 pu-h-5 pu-animate-spin pu-inline-block"
  })) : pastSearchOptions && createElement(Fragment, null, createElement(OptGroupLabel, null, "Recent Searches"), pastSearchOptions.map(function (option) {
    return createElement(Option, Object.assign({
      key: option.value + "-" + option.index
    }, getItemProps({
      item: option,
      index: option.index
    }), {
      highlighted: option.index === highlightedIndex,
      label: option.label,
      leftIcon: createElement(HistoryIcon, {
        className: "pu-w-5 pu-h-5 pu-text-gray-400"
      })
    }));
  })));
  return createElement(Modal$1, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    showCloseBtn: false,
    size: "small",
    "aria-label": "Search"
  }, createElement("div", Object.assign({}, getComboboxProps({
    className: 'pu-relative'
  }, getterOptions)), createElement("div", {
    className: "pu-absolute pu-inset-y-0 pu-left-0 pu-px-2 pu-my-1 pu-ml-1 pu-flex pu-items-center pu-pointer-events-none"
  }, createElement(SearchIcon, {
    className: "pu-w-6 pu-h-6 pu-text-lightgrey"
  })), createElement(TextInput, Object.assign({
    onChangeValue: callAll(onInputValueChange && function (val) {
      return onInputValueChange(val.trim());
    }, setInputValue)
  }, getInputProps(_extends({
    value: inputValue,
    className: cx('pu-pl-11 pu-text-sm pu-leading-7 pu-rounded-none focus:pu-outline-none focus:pu-border-gray-300 focus:pu-ring-0', className)
  }, inputProps, {
    ref: inputRef
  }), getterOptions))), inputValue && createElement("div", {
    className: "pu-absolute pu-right-0 pu-inset-y-0 pu-pr-2.5 pu-flex pu-items-center"
  }, createElement(IconButton, {
    onClick: function onClick() {
      setInputValue('');

      if (onInputValueChange) {
        onInputValueChange('');
      }

      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }, createElement("span", {
    className: "pu-sr-only"
  }, "Clear"), createElement(CrossInCircleIcon, {
    className: "pu-w-4 pu-h-4 pu-text-lightgrey"
  })))), createElement("div", Object.assign({}, getMenuProps({
    className: 'pu-max-h-96 pu-overflow-auto portal-ui-scrollbar',
    ref: menuRef
  }, getterOptions)), menuContent));
};
var getterOptions = {
  suppressRefError: true
};

var _excluded$1p = ["className", "children"];
var Section = function Section(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1p);

  return createElement("section", Object.assign({}, props, {
    className: cx('pu-pt-10 pu-border-t pu-mt-10 pu-border-gray-300', className)
  }), children);
};

var _excluded$1q = ["children", "title"];
var SectionHeading = function SectionHeading(_ref) {
  var children = _ref.children,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1q);

  return createElement("div", Object.assign({}, props, {
    className: cx('pu-flex pu-justify-between pu-items-center pu-mb-4 pu--mt-2', props.className)
  }), createElement("div", {
    className: cx(classes.h3, 'pu-text-mediumgrey')
  }, title), createElement("div", null, children));
};

/**
 * `<TabButtonGroup />` is used when you only want the `Tab` button but not the panels (e.g. when using the `Tab` button for filtering table).
 */

var TabButtonGroup = function TabButtonGroup(props) {
  var id = useId(props.id);
  var name = props.name || id;
  return createElement("div", {
    id: id,
    className: cx('portal-ui-scrollbar pu-flex pu-gap-2 pu-p-1 pu-bg-white pu-overflow-x-auto', props.className)
  }, props.options.map(function (option) {
    var isActive = option.value === props.value;
    return createElement("label", {
      className: cx('pu-flex-shrink-0 pu-inline-flex pu-items-center pu-relative pu-px-3 pu-py-2 pu-text-sm pu-leading-5 pu-rounded-md pu-cursor-pointer pu-select-none focus-within:pu-ring-1 focus-within:pu-ring-brand-200', isActive ? 'pu-text-brand-500 pu-bg-teal-50 focus:pu-outline-none' : 'pu-text-black hover:pu-bg-gray-50'),
      key: option.value
    }, createElement("input", {
      type: "radio",
      name: name,
      value: option.value,
      checked: isActive,
      className: "pu-sr-only",
      onChange: function onChange(ev) {
        if (ev.target.checked) {
          props.onChangeValue(option.value);
        }
      }
    }), option.label, !isNil(option.badge) && createElement(MiniBadge, {
      active: isActive,
      className: "pu-ml-1"
    }, option.badge));
  }));
};

var _excluded$1r = ["color", "render"];
var Text = function Text(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'darkgrey' : _ref$color,
      render = _ref.render,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1r);

  if (render) {
    return render({
      className: colorClasses[color]
    });
  }

  return createElement("p", Object.assign({}, props, {
    className: cx(colorClasses[color], props.className)
  }));
};
var colorClasses = {
  black: 'pu-text-black',
  darkgrey: 'pu-text-darkgrey',
  mediumgrey: 'pu-text-mediumgrey',
  lightgrey: 'pu-text-lightgrey',
  lightergrey: 'pu-text-lightergrey',
  offwhite: 'pu-text-offwhite',
  white: 'pu-text-white'
};

var _excluded$1s = ["title", "description", "color", "children", "indicatorClass"];
/**
 * `<TimelineItem />` is used to show the details at a particular time within a `<Timeline />`.
 */

var TimelineItem = function TimelineItem(_ref) {
  var title = _ref.title,
      description = _ref.description,
      color = _ref.color,
      children = _ref.children,
      indicatorClass = _ref.indicatorClass,
      divProps = _objectWithoutPropertiesLoose(_ref, _excluded$1s);

  var indicatorRef = useRef(null);
  useDescendant({
    element: indicatorRef.current
  }, TimelineDescendantContext);
  var hasChildren = !!children;
  return createElement("div", Object.assign({}, divProps), createElement("div", {
    className: cx('pu-flex pu-items-center pu-leading-snug', hasChildren && 'pu-font-medium')
  }, createElement(Indicator, {
    color: color,
    className: cx('pu-relative pu-h-3 pu-w-3 pu-mr-5', indicatorClass),
    ref: indicatorRef
  }), title), description && createElement("div", {
    className: "pu-text-sm pu-pl-8 pu-text-lightgrey"
  }, description), children && createElement("div", {
    className: "pu-pl-8 pu-pt-3"
  }, children));
};

var _excluded$1t = ["className", "children"];
/**
 * `<Timeline />` wraps a list of `<TimelineItem />` to show histories, usually in
 * reverse chronological order.
 */

var TimelineImpl = function Timeline(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1t);

  var _useDescendantsInit = useDescendantsInit(),
      dots = _useDescendantsInit[0],
      setDots = _useDescendantsInit[1];

  return createElement(IsInTimelineContext.Provider, {
    value: true
  }, createElement(DescendantProvider, {
    items: dots,
    set: setDots,
    context: TimelineDescendantContext
  }, createElement("div", Object.assign({}, props, {
    className: cx('pu-grid pu-gap-y-6 pu-relative', className)
  }), createElement(TimelineConnector, {
    dots: dots,
    className: "pu-absolute pu-top-4 pu-left-0 pu-text-lightgrey"
  }), children)));
};

var Timeline = /*#__PURE__*/Object.assign(TimelineImpl, {
  Item: TimelineItem
});

var TimelineConnector = function TimelineConnector(_ref2) {
  var nullableDots = _ref2.dots,
      className = _ref2.className;
  var dots = nullableDots.filter(function (d) {
    return !isNil(d.element);
  });

  if (dots.length <= 1) {
    return null;
  }

  var firstDotRect = dots[0].element.getBoundingClientRect();
  var lastDotRect = dots[dots.length - 1].element.getBoundingClientRect();
  var height = lastDotRect.top - firstDotRect.bottom;
  var width = 12;
  var xMid = width / 2;
  return createElement("svg", {
    className: className,
    height: height,
    viewBox: "0 0 " + width + " " + height
  }, createElement("line", {
    x1: xMid,
    y1: 0,
    x2: xMid,
    y2: height,
    fill: "none",
    strokeWidth: "1",
    stroke: "currentColor",
    strokeDasharray: "2 4"
  }));
};

var _excluded$1u = ["id"],
    _excluded2$9 = ["key", "props"];
/**
 * Custom hook to manage values for filters. You can see it like a simple `formik` but will provide you the
 * applied value (which only consists of value different from initial value).
 *
 * @param initialValues the initial values for the filters. Must be an object with all the `key` defined or a function that returns the object.
 * @param options options to customize the behavior
 * @param options.hideEmptyLabel whether the `applied` should include value with empty label. Default to true.
 * @param options.onChange callback when value of the filter changed.
 * @param options.baseValues the values when reset. Default to `initialValues`.
 * @param options.components the components configuration to render the filter.
 *
 * @returns tuple with value [stateValue, actions, components].
 *
 * `stateValue` consists of two properties:
 * - `values`: this is the object with the latest value
 * - `applied`: applied filters, which is computed based on diffing with `initialValues`.
 *
 * `actions` consists of 3 properties, each of it a function that you can call:
 * - `setValue`
 * - `setValueCurry`
 * - `reset`: reset all values to its initial value
 * - `resetValue`: reset a particular value to its base value
 * - `reinitialize`: reinitialize states. This is needed if your components is loaded asychronously
 */

var useFilter = function useFilter(initialValues, options) {
  if (options === void 0) {
    options = {};
  }

  var initValues = isFunction(initialValues) ? initialValues() : initialValues;
  var _options = options,
      _options$hideEmptyLab = _options.hideEmptyLabel,
      hideEmptyLabel = _options$hideEmptyLab === void 0 ? true : _options$hideEmptyLab,
      onChange = _options.onChange,
      _options$baseValues = _options.baseValues,
      baseValues = _options$baseValues === void 0 ? initValues : _options$baseValues,
      cacheKey = _options.cacheKey,
      _providedComponents = _options.components,
      propExcludedFromApplied = _options.propExcludedFromApplied;
  var idPrefix = useId(cacheKey);
  var getOptionCache = useGetOptionCache();
  var onChangeCb = useStableCallback(onChange);

  var _React$useReducer = useReducer(filterReducer, {
    initial: initValues,
    base: baseValues,
    getOptionCache: getOptionCache,
    components: isFunction(_providedComponents) ? _providedComponents(initValues) : _providedComponents
  }, initState),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var stateValue = state;
  var providedComponents = useMemo(function () {
    return _providedComponents && (isFunction(_providedComponents) ? _providedComponents(stateValue.values) : _providedComponents).map(function (_ref) {
      var key = _ref.key,
          _ref$props = _ref.props,
          _ref$props$id = _ref$props.id,
          id = _ref$props$id === void 0 ? "" + idPrefix + key : _ref$props$id,
          restProps = _objectWithoutPropertiesLoose(_ref$props, _excluded$1u),
          component = _objectWithoutPropertiesLoose(_ref, _excluded2$9);

      return _extends({}, component, {
        key: key,
        props: _extends({}, restProps, {
          id: id
        })
      });
    });
  }, [_providedComponents, idPrefix, stateValue.values]);
  useUpdateEffect(function () {
    onChangeCb(stateValue.values);
  }, [onChangeCb, stateValue.values]);
  var dispatchAction = dispatch;
  var result = useMemo(function () {
    var derivedApplied = function getLatestApplied() {
      // if components is provided, we will derive it during rendering, else we will use what has been stored in the state.
      if (providedComponents) {
        var excludedProps = propExcludedFromApplied || [];
        return stateValue.applied.filter(function (item) {
          return providedComponents.some(function (comp) {
            return comp.key === item.prop;
          }) && !excludedProps.includes(item.prop);
        }).map(function (item) {
          return _extends({}, item, {
            label: getFilterLabel(item.prop, item.value, getOptionCache, providedComponents)
          });
        });
      }

      return stateValue.applied;
    }();

    var appliedValues = hideEmptyLabel ? derivedApplied.filter(function (item) {
      return !!item.label;
    }) : derivedApplied;
    return {
      values: stateValue.values,
      applied: appliedValues.map(function (item) {
        return _extends({}, item, {
          resetValue: function resetValue() {
            return dispatchAction({
              type: 'resetValue',
              payload: item.prop
            });
          }
        });
      })
    };
  }, [stateValue.values, stateValue.applied, dispatchAction, hideEmptyLabel, providedComponents, propExcludedFromApplied]);
  var actions = useMemo(function () {
    return {
      setValue: function setValue(prop, value, label) {
        if (label === void 0) {
          label = String(value);
        }

        return dispatchAction({
          type: 'setValue',
          payload: {
            prop: prop,
            value: value,
            label: label
          }
        });
      },
      setValueCurry: function setValueCurry(prop) {
        return function (value, label) {
          if (label === void 0) {
            label = String(value);
          }

          return dispatchAction({
            type: 'setValue',
            payload: {
              prop: prop,
              value: value,
              label: label
            }
          });
        };
      },
      reset: function reset() {
        return dispatchAction({
          type: 'reset'
        });
      },
      resetValue: function resetValue(prop) {
        return dispatchAction({
          type: 'resetValue',
          payload: prop
        });
      },
      reinitialize: function reinitialize(_ref2) {
        var _ref2$initValues = _ref2.initValues,
            initValues = _ref2$initValues === void 0 ? stateValue.values : _ref2$initValues,
            _ref2$baseValues = _ref2.baseValues,
            providedBaseValues = _ref2$baseValues === void 0 ? baseValues : _ref2$baseValues,
            _ref2$components = _ref2.components,
            components = _ref2$components === void 0 ? providedComponents : _ref2$components;
        return dispatchAction({
          type: 'reinitialize',
          payload: initState({
            initial: initValues,
            base: providedBaseValues,
            getOptionCache: getOptionCache,
            components: components
          })
        });
      }
    };
  }, [dispatchAction]);
  return [result, actions, providedComponents];
};

var initState = function initState(init) {
  var applied = function getApplied() {
    if (init.base === init.initial) {
      return [];
    }

    var result = [];
    Object.entries(init.initial).forEach(function (_ref3) {
      var k = _ref3[0],
          value = _ref3[1];
      var key = k;

      if (!isSimilarValue(value, init.base[key])) {
        result.push({
          prop: key,
          value: value,
          label: getFilterLabel(key, value, init.getOptionCache, init.components)
        });
      }
    });
    return result;
  }();

  return {
    values: init.initial,
    base: init.base,
    applied: applied
  };
};

var getFilterLabel = function getFilterLabel(prop, value, getOptionCache, components) {
  var component = components && components.find(function (comp) {
    return comp.key === prop;
  });

  if (!component) {
    return String(value);
  }

  switch (component.type) {
    case 'daterange':
      {
        if (!Array.isArray(value) || value.length !== 2 || value[0] === '') {
          return '';
        }

        var _component$props = component.props,
            _component$props$opti = _component$props.options,
            options = _component$props$opti === void 0 ? DATE_RANGE_DROPDOWN_DEFAULT_OPTIONS : _component$props$opti,
            customRangeFormatType = _component$props.customRangeFormatType,
            dayOnly = _component$props.dayOnly;
        var selectedOption = normalizeDateRangeOptions(options).find(function (opt) {
          return opt.value[0] === value[0] && opt.value[1] === value[1];
        });

        if (selectedOption) {
          return selectedOption.label;
        }

        return customRangeFormatType ? formatDate(value[0], {
          formatType: customRangeFormatType
        }) + " - " + formatDate(value[1], {
          formatType: customRangeFormatType
        }) : formatDateRange(new Date(value[0]), getDisplayedTo(new Date(value[1]), dayOnly), dayOnly);
      }

    case 'day':
      return value instanceof Date ? formatDate(value, {
        formatType: 'dateOnly'
      }) : '';

    case 'nestedselect':
      {
        if (!Array.isArray(value) || value.length === 0) {
          return '';
        }

        var _options2 = component.props.options;
        var optionData = mapNestedOptions(_options2, value, {
          expandedKeys: []
        });
        return value.map(function (v) {
          var matchedOption = optionData.allItems.find(function (opt) {
            return opt.value === v;
          });
          return matchedOption && matchedOption.label;
        }).filter(isDefined).join(', ');
      }

    case 'multiselect':
      {
        if (!Array.isArray(value) || value.length === 0) {
          return '';
        }

        var _component$props2 = component.props,
            _options3 = _component$props2.options,
            id = _component$props2.id;
        var cachedOptions = getOptionCache(id);

        var _optionData = mapOptions((isDefined(_options3) ? _options3 : []).concat(cachedOptions));

        return value.map(function (v) {
          var matchedOption = _optionData.allItems.find(function (opt) {
            return opt.value === v;
          });

          return matchedOption && matchedOption.label;
        }).filter(isDefined).join(', ');
      }

    case 'multiinput':
      {
        if (!Array.isArray(value) || value.length === 0) {
          return '';
        }

        return value.join(', ');
      }

    case 'search':
      return value;

    case 'searchableselect':
    case 'select':
      {
        if (isNil(value)) {
          return '';
        }

        var _component$props3 = component.props,
            _options4 = _component$props3.options,
            _id = _component$props3.id;
        var optionCache = getOptionCache(_id);
        var selectedItem = mapOptions(normalizePrimitiveOptions(_options4 || []).concat(optionCache)).items.find(function (opt) {
          return opt.value === value;
        });
        return selectedItem ? selectedItem.label : '';
      }

    default:
      return String(value);
  }
};

var filterReducer = function filterReducer(state, action) {
  switch (action.type) {
    case 'setValue':
      {
        var _extends2;

        var _action$payload = action.payload,
            prop = _action$payload.prop,
            value = _action$payload.value,
            label = _action$payload.label;
        var nextApplied = state.applied.slice();
        var currentIndex = nextApplied.findIndex(function (applied) {
          return applied.prop === prop;
        });

        if (currentIndex > -1) {
          if (isSimilarValue(state.base[prop], value)) {
            nextApplied.splice(currentIndex, 1);
          } else {
            nextApplied[currentIndex].value = value;
            nextApplied[currentIndex].label = label;
          }
        } else {
          nextApplied.push(action.payload);
        }

        return _extends({}, state, {
          values: _extends({}, state.values, (_extends2 = {}, _extends2[prop] = value, _extends2)),
          applied: nextApplied
        });
      }

    case 'resetValue':
      {
        var _extends3;

        var _prop = action.payload;

        if (isSimilarValue(state.values[_prop], state.base[_prop])) {
          return state;
        }

        var _nextApplied = state.applied.slice();

        _nextApplied.splice(_nextApplied.findIndex(function (item) {
          return item.prop === _prop;
        }), 1);

        return _extends({}, state, {
          values: _extends({}, state.values, (_extends3 = {}, _extends3[_prop] = state.base[_prop], _extends3)),
          applied: _nextApplied
        });
      }

    case 'reset':
      return _extends({}, state, {
        values: state.base,
        applied: []
      });

    case 'reinitialize':
      return action.payload;

    default:
      return state;
  }
};

var isSimilarValue = function isSimilarValue(val1, val2) {
  if (Array.isArray(val1)) {
    return Array.isArray(val2) && isSimilarArray(val1, val2);
  }

  return val1 === val2;
};

var _excluded$1v = ["page", "perPage"];
var useDataTableState = function useDataTableState(initValues, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      hideEmptyLabel = _ref.hideEmptyLabel,
      excludes = _ref.excludes,
      components = _ref.components,
      _ref$initialPage = _ref.initialPage,
      initialPage = _ref$initialPage === void 0 ? 1 : _ref$initialPage,
      propExcludedFromApplied = _ref.propExcludedFromApplied,
      _ref$initialPerPage = _ref.initialPerPage,
      initialPerPage = _ref$initialPerPage === void 0 ? 20 : _ref$initialPerPage,
      baseValues = _ref.baseValues,
      _ref$queryParams = _ref.queryParams,
      providedQueryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams,
      _ref$setQueryParams = _ref.setQueryParams,
      setQueryParams = _ref$setQueryParams === void 0 ? noop : _ref$setQueryParams,
      _ref$initSort = _ref.initSort,
      initSort = _ref$initSort === void 0 ? {
    sortBy: '',
    order: 'desc'
  } : _ref$initSort;

  var queryPage = providedQueryParams.page,
      queryPerPage = providedQueryParams.perPage,
      queryParams = _objectWithoutPropertiesLoose(providedQueryParams, _excluded$1v);

  var pagination = usePaginationState({
    initialPage: queryPage ? parseInt(queryPage, 10) : initialPage,
    initialPerPage: queryPerPage ? parseInt(queryPerPage, 10) : initialPerPage,
    onChange: function onChange(newState) {
      _onChange(_extends({}, filter[0].values, newState));

      setQueryParams(_extends({}, serializeFilterValues(_extends({}, queryParams, filter[0].values), excludes), serializePagination(newState)), {
        merge: false
      });
    }
  });
  var filter = useFilter(function () {
    return initFilterValue(initValues, queryParams);
  }, {
    hideEmptyLabel: hideEmptyLabel,
    onChange: function onChange(newValues) {
      var newPagination = pagination;

      if (pagination.page !== initialPage) {
        pagination.setPage(initialPage);
        newPagination = _extends({}, pagination, {
          page: initialPage
        });
      }

      _onChange(_extends({}, newValues, newPagination));

      setQueryParams(_extends({}, serializeFilterValues(_extends({}, queryParams, newValues), excludes), serializePagination(newPagination)), {
        merge: false
      });
    },
    baseValues: baseValues || (isFunction(initValues) ? initValues() : initValues),
    components: components,
    propExcludedFromApplied: propExcludedFromApplied
  });
  var sortState = useSortState(initSort);

  var handleSort = function handleSort(sortBy, initialOrder) {
    pagination.setPage(initialPage);
    sortState.sort({
      sortBy: sortBy,
      initialOrder: initialOrder || initSort.order
    });
  };

  return {
    filter: filter,
    pagination: pagination,
    sort: _extends({}, sortState, {
      handleSort: handleSort
    })
  };
};

var serializeFilterValues = function serializeFilterValues(filterValues, excludes) {
  return Object.keys(filterValues).reduce(function (result, k) {
    var _extends2;

    var key = k;
    return !isEmptyValue(filterValues[key]) && (!excludes || !excludes.includes(key)) ? _extends({}, result, (_extends2 = {}, _extends2[key] = filterValues[key], _extends2)) : result;
  }, {});
};

var serializePagination = function serializePagination(paginationState) {
  return {
    page: String(paginationState.page),
    perPage: String(paginationState.perPage)
  };
};

var initFilterValue = function initFilterValue(initValues, queryParams) {
  var initV = isFunction(initValues) ? initValues() : _extends({}, initValues);

  for (var key in initV) {
    var queryValue = queryParams[key];

    if (isDefined(queryValue)) {
      var initialValue = initV[key];

      if (Array.isArray(initialValue)) {
        (function () {
          var isNumber = typeof initialValue[0] === 'number';
          initV[key] = flattenArray([queryValue]).map(function (v) {
            return isNumber ? Number(v) : v;
          });
        })();
      } else {
        var serializeValue = typeof initialValue === 'number' ? Number(queryValue) : queryValue;
        initV[key] = serializeValue;
      }
    }
  }

  return initV;
};

var createNoop = function createNoop() {
  return noop;
};

var NotificationContext = /*#__PURE__*/createNamedContext('NotificationContext', createNoop);
var LocalNotificationContext = /*#__PURE__*/createNamedContext('LocalNotificationContext', createNoop);
/*
Why we don't make the global scope always rendered in front?
Which can be achieved by using z-index or force remount `<NotificationPortal />` by passing `key={globalItems.length}`.

Not only the 2 options seems like hack, we also need to consider that the NotificationPortal also renders DownloadItems
(which can be taking a long time to complete). If we make entire NotificationPortal render in front, NotificationPortal may
block the Modal and make it not usable in mobile screen.
*/

var useNotification = function useNotification(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'global' : _ref$scope;

  var removeCbs = useConstant(function () {
    return [];
  });
  var addLocalMessage = useContext(LocalNotificationContext);
  var addLocalMsg = useCallback(function () {
    var removeCb = addLocalMessage.apply(void 0, arguments);
    removeCbs.push(removeCb);
  }, [addLocalMessage, removeCbs]);
  useEffect(function () {
    return function cleanup() {
      removeCbs.forEach(function (cb) {
        return cb();
      });
    };
  }, [removeCbs]);
  var addGlobalMessage = useContext(NotificationContext);
  return scope === 'global' ? addGlobalMessage : addLocalMsg;
};

/**
 * @alias `stringifyQueryString`
 *
 * @deprecated use `stringifyQueryString` instead.
 */

var stringifyParams = stringifyQueryString;
var TabFillSlot = /*#__PURE__*/createFillSlot();
var BreadcrumbFillSlot = /*#__PURE__*/createFillSlot();
var Card$1 = /*#__PURE__*/Object.assign(Card, {
  Heading: CardHeading,
  Content: CardContent
});

export { Alert, AlertMessages, Badge, BareButton, BreadcrumbFillSlot, Breadcrumbs, Button, Card$1 as Card, CardContent, CardHeading, CardPopover, Checkbox, CheckboxGroup, DATES, DATE_RANGES, DATE_RANGE_DROPDOWN_DEFAULT_OPTIONS, DATE_RANGE_OPTIONS_EXTENDED, DataTable, DataTableCaption, DataTableCell, DataTableExpandButton, DataTableExpandableGroup, DataTableExpandableRow, DataTableExpandableSection, DataTableRow, DataTableRowGroup, DateRangeDropdown, DateRangePicker, DateRangeSelector, DateTimeInput, DayField, DayPicker, DayPickerInput, DaySelector, DecimalInput, DescItem, DescList, Dialog$1 as Dialog, DialogContent, DialogFooter, DragHandle, Dropdown, DropdownField, DropdownItem, DropdownMenu, DropdownMenuItems, DropdownMultiSelect, DropdownMultiSelectField, DropdownNestedSelect, DropdownNestedSelectField, DropdownSelect, DropdownSelectField, Field, FieldContainer, FieldContext, Fieldset, FileItem, FileSelector, Filter, FilterControls, HelpText, IconButton, ImageCard, ImageGrid, ImageSelection, ImageThumbnail, ImageUploadItem, ImageViewer, Indicator, Input, InputButton, JsonPanel, JsonViewer, Label, LocalNotificationContext, Modal$1 as Modal, ModalBody, ModalFooter, ModalHeader, MoneyInput, MonthPicker, MonthSelector, MultiInput, MultiInputField, MultiInputWithSuggestions, Notification, NotificationContext, NotificationGroup, NotificationPortal, OptionPicker, OverlayActions, Pagination, PaginationNavigation, Popover, PortalAccountsIcons, PortalAcquirersIcon, PortalApiIcon, PortalAttributionIcon, PortalBadgeCampaignsIcon, PortalBannerIcon, PortalBillingsIcon, PortalBillsAndReloadIcons, PortalBudgetingIcon, PortalCardCategoriesIcon, PortalCardIssuingIcon, PortalCardholdersIcon, PortalCardsIcon, PortalCatalogueIcon, PortalCdpIcon, PortalCirclesIcon, PortalCompaniesIcon, PortalComplianceIcon, PortalCreditNotesIcon, PortalCustomersIcon, PortalDealCampaignsIcon, PortalDealOrdersIcon, PortalDealsIcon, PortalDevicesIcon, PortalDiscountsIcon, PortalDrawerSessionsIcon, PortalDriveIcon, PortalDropInIcon, PortalEcommerceIcon, PortalExperienceIcon, PortalFraudControlsIcon, PortalFuelOrdersIcon, PortalFuelTankActivitiesIcon, PortalFuelTankIcon, PortalFuellingIcon, PortalFulfillmentIcon, PortalGamificationIcon, PortalGatewayIcon, PortalGiftIcon, PortalGiftsIcon, PortalHome2Icon, PortalHomeIcon, PortalInventoryIcon, PortalInvoicesIcon, PortalItemCategoriesIcon, PortalItemModifiersIcon, PortalItemOptionsIcon, PortalItemsIcon, PortalLeadsIcon, PortalLinksIcon, PortalLocationIcon, PortalLoyaltyAffiliateIcon, PortalLoyaltyIcon, PortalMaintenanceIcon, PortalMerchantsIcon, PortalMileagesIcon, PortalMiniAppIcon, PortalMobileIcon, PortalOrdersIcon, PortalPaymentControllerIcon, PortalPaymentsIcon, PortalPointTransactionsIcon, PortalPosIcon, PortalPriceBookIcon, PortalPricingIcon, PortalPurchaseOrdersIcon, PortalReachIcon, PortalRefuellingIcon, PortalReloadVariationsIcon, PortalReportsIcon, PortalRetailIcon, PortalRewardsIcon, PortalRoutingIcon, PortalSettingsIcon, PortalSettlementSummariesIcon, PortalSettlementsIcon, PortalShiftsIcon, PortalShipmentsIcon, PortalShippingIcon, PortalSpinIcon, PortalStockActionsIcon, PortalStockIcons, PortalStockLocationsIcon, PortalStockTakesIcon, PortalStoreOrdersIcon, PortalSubsidyIcon, PortalSuppliersIcon, PortalTeamsIcon, PortalTerminalsIcon, PortalTransactionsIcon, PortalTreasuryIcon, PortalUsersIcon, PortalVehicleDirectoryIcon, PortalVehiclesIcon, PortalVoucherBatchesIcon, PortalVouchersIcon, PortalWalletIcon, PortalWebhooksIcon, Progress, Radio, RadioGroup, SearchInput, SearchModal, SearchTextField, SearchTextInput, SearchableDropdown, SearchableDropdownField, SearchableNestedDropdown, SearchableNestedMultiSelect, Section, SectionHeading, Sidebar, SidebarGroup, SidebarHeader, SidebarLink, SidebarLinkGroup, SidebarNav, SidebarSlideMenu, SidebarSlideMenuItem, SidebarSlideMenuSection, Skeleton, Stepper, TabButtonGroup, TabFillSlot, Tabs, Text, TextEllipsis, TextField, TextHighlight, TextInput, Textarea, TextareaField, TimeInput, Timeline, TimelineItem, Toggle, ToggleField, Tooltip, TreeOption, classes, positionTopCenter, stringifyParams, useDataTableState, useFieldControlContext, useFilter, useNotification };
//# sourceMappingURL=portal-ui.esm.js.map
